(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3852"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3852"] = parcelRequire;
}
parcelRequire.register("2EzGb", function(module, exports) {
(function(window1, factory) {
    var lazySizes = factory(window1, window1.document, Date);
    window1.lazySizes = lazySizes;
    if (0, module.exports) module.exports = lazySizes;
})(typeof window != "undefined" ? window : {}, /**
 * import("./types/global")
 * @typedef { import("./types/lazysizes-config").LazySizesConfigPartial } LazySizesConfigPartial
 */ function l(window1, document, Date1) {
    "use strict";
    /*jshint eqnull:true */ var lazysizes, /**
		 * @type { LazySizesConfigPartial }
		 */ lazySizesCfg;
    (function() {
        var prop;
        var lazySizesDefaults = {
            lazyClass: "lazyload",
            loadedClass: "lazyloaded",
            loadingClass: "lazyloading",
            preloadClass: "lazypreload",
            errorClass: "lazyerror",
            //strictClass: 'lazystrict',
            autosizesClass: "lazyautosizes",
            fastLoadedClass: "ls-is-cached",
            iframeLoadMode: 0,
            srcAttr: "data-src",
            srcsetAttr: "data-srcset",
            sizesAttr: "data-sizes",
            //preloadAfterLoad: false,
            minSize: 40,
            customMedia: {},
            init: true,
            expFactor: 1.5,
            hFac: 0.8,
            loadMode: 2,
            loadHidden: true,
            ricTimeout: 0,
            throttleDelay: 125
        };
        lazySizesCfg = window1.lazySizesConfig || window1.lazysizesConfig || {};
        for(prop in lazySizesDefaults)if (!(prop in lazySizesCfg)) lazySizesCfg[prop] = lazySizesDefaults[prop];
    })();
    if (!document || !document.getElementsByClassName) return {
        init: function() {},
        /**
			 * @type { LazySizesConfigPartial }
			 */ cfg: lazySizesCfg,
        /**
			 * @type { true }
			 */ noSupport: true
    };
    var docElem = document.documentElement;
    var supportPicture = window1.HTMLPictureElement;
    var _addEventListener = "addEventListener";
    var _getAttribute = "getAttribute";
    /**
	 * Update to bind to window because 'this' becomes null during SSR
	 * builds.
	 */ var addEventListener = window1[_addEventListener].bind(window1);
    var setTimeout = window1.setTimeout;
    var requestAnimationFrame = window1.requestAnimationFrame || setTimeout;
    var requestIdleCallback = window1.requestIdleCallback;
    var regPicture = /^picture$/i;
    var loadEvents = [
        "load",
        "error",
        "lazyincluded",
        "_lazyloaded"
    ];
    var regClassCache = {};
    var forEach = Array.prototype.forEach;
    /**
	 * @param ele {Element}
	 * @param cls {string}
	 */ var hasClass = function(ele, cls) {
        if (!regClassCache[cls]) regClassCache[cls] = new RegExp("(\\s|^)" + cls + "(\\s|$)");
        return regClassCache[cls].test(ele[_getAttribute]("class") || "") && regClassCache[cls];
    };
    /**
	 * @param ele {Element}
	 * @param cls {string}
	 */ var addClass = function(ele, cls) {
        if (!hasClass(ele, cls)) ele.setAttribute("class", (ele[_getAttribute]("class") || "").trim() + " " + cls);
    };
    /**
	 * @param ele {Element}
	 * @param cls {string}
	 */ var removeClass = function(ele, cls) {
        var reg;
        if (reg = hasClass(ele, cls)) ele.setAttribute("class", (ele[_getAttribute]("class") || "").replace(reg, " "));
    };
    var addRemoveLoadEvents = function(dom, fn, add) {
        var action = add ? _addEventListener : "removeEventListener";
        if (add) addRemoveLoadEvents(dom, fn);
        loadEvents.forEach(function(evt) {
            dom[action](evt, fn);
        });
    };
    /**
	 * @param elem { Element }
	 * @param name { string }
	 * @param detail { any }
	 * @param noBubbles { boolean }
	 * @param noCancelable { boolean }
	 * @returns { CustomEvent }
	 */ var triggerEvent = function(elem, name, detail, noBubbles, noCancelable) {
        var event = document.createEvent("Event");
        if (!detail) detail = {};
        detail.instance = lazysizes;
        event.initEvent(name, !noBubbles, !noCancelable);
        event.detail = detail;
        elem.dispatchEvent(event);
        return event;
    };
    var updatePolyfill = function(el, full) {
        var polyfill;
        if (!supportPicture && (polyfill = window1.picturefill || lazySizesCfg.pf)) {
            if (full && full.src && !el[_getAttribute]("srcset")) el.setAttribute("srcset", full.src);
            polyfill({
                reevaluate: true,
                elements: [
                    el
                ]
            });
        } else if (full && full.src) el.src = full.src;
    };
    var getCSS = function(elem, style) {
        return (getComputedStyle(elem, null) || {})[style];
    };
    /**
	 *
	 * @param elem { Element }
	 * @param parent { Element }
	 * @param [width] {number}
	 * @returns {number}
	 */ var getWidth = function(elem, parent, width) {
        width = width || elem.offsetWidth;
        while(width < lazySizesCfg.minSize && parent && !elem._lazysizesWidth){
            width = parent.offsetWidth;
            parent = parent.parentNode;
        }
        return width;
    };
    var rAF = function() {
        var running, waiting;
        var firstFns = [];
        var secondFns = [];
        var fns = firstFns;
        var run = function() {
            var runFns = fns;
            fns = firstFns.length ? secondFns : firstFns;
            running = true;
            waiting = false;
            while(runFns.length)runFns.shift()();
            running = false;
        };
        var rafBatch = function(fn, queue) {
            if (running && !queue) fn.apply(this, arguments);
            else {
                fns.push(fn);
                if (!waiting) {
                    waiting = true;
                    (document.hidden ? setTimeout : requestAnimationFrame)(run);
                }
            }
        };
        rafBatch._lsFlush = run;
        return rafBatch;
    }();
    var rAFIt = function(fn, simple) {
        return simple ? function() {
            rAF(fn);
        } : function() {
            var that = this;
            var args = arguments;
            rAF(function() {
                fn.apply(that, args);
            });
        };
    };
    var throttle = function(fn) {
        var running;
        var lastTime = 0;
        var gDelay = lazySizesCfg.throttleDelay;
        var rICTimeout = lazySizesCfg.ricTimeout;
        var run = function() {
            running = false;
            lastTime = Date1.now();
            fn();
        };
        var idleCallback = requestIdleCallback && rICTimeout > 49 ? function() {
            requestIdleCallback(run, {
                timeout: rICTimeout
            });
            if (rICTimeout !== lazySizesCfg.ricTimeout) rICTimeout = lazySizesCfg.ricTimeout;
        } : rAFIt(function() {
            setTimeout(run);
        }, true);
        return function(isPriority) {
            var delay;
            if (isPriority = isPriority === true) rICTimeout = 33;
            if (running) return;
            running = true;
            delay = gDelay - (Date1.now() - lastTime);
            if (delay < 0) delay = 0;
            if (isPriority || delay < 9) idleCallback();
            else setTimeout(idleCallback, delay);
        };
    };
    //based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
    var debounce = function(func) {
        var timeout, timestamp;
        var wait = 99;
        var run = function() {
            timeout = null;
            func();
        };
        var later = function() {
            var last = Date1.now() - timestamp;
            if (last < wait) setTimeout(later, wait - last);
            else (requestIdleCallback || run)(run);
        };
        return function() {
            timestamp = Date1.now();
            if (!timeout) timeout = setTimeout(later, wait);
        };
    };
    var loader = function() {
        var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;
        var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;
        var regImg = /^img$/i;
        var regIframe = /^iframe$/i;
        var supportScroll = "onscroll" in window1 && !/(gle|ing)bot/.test(navigator.userAgent);
        var shrinkExpand = 0;
        var currentExpand = 0;
        var isLoading = 0;
        var lowRuns = -1;
        var resetPreloading = function(e) {
            isLoading--;
            if (!e || isLoading < 0 || !e.target) isLoading = 0;
        };
        var isVisible = function(elem) {
            if (isBodyHidden == null) isBodyHidden = getCSS(document.body, "visibility") == "hidden";
            return isBodyHidden || !(getCSS(elem.parentNode, "visibility") == "hidden" && getCSS(elem, "visibility") == "hidden");
        };
        var isNestedVisible = function(elem, elemExpand) {
            var outerRect;
            var parent = elem;
            var visible = isVisible(elem);
            eLtop -= elemExpand;
            eLbottom += elemExpand;
            eLleft -= elemExpand;
            eLright += elemExpand;
            while(visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem){
                visible = (getCSS(parent, "opacity") || 1) > 0;
                if (visible && getCSS(parent, "overflow") != "visible") {
                    outerRect = parent.getBoundingClientRect();
                    visible = eLright > outerRect.left && eLleft < outerRect.right && eLbottom > outerRect.top - 1 && eLtop < outerRect.bottom + 1;
                }
            }
            return visible;
        };
        var checkElements = function() {
            var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal, beforeExpandVal, defaultExpand, preloadExpand, hFac;
            var lazyloadElems = lazysizes.elements;
            if ((loadMode = lazySizesCfg.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)) {
                i = 0;
                lowRuns++;
                for(; i < eLlen; i++){
                    if (!lazyloadElems[i] || lazyloadElems[i]._lazyRace) continue;
                    if (!supportScroll || lazysizes.prematureUnveil && lazysizes.prematureUnveil(lazyloadElems[i])) {
                        unveilElement(lazyloadElems[i]);
                        continue;
                    }
                    if (!(elemExpandVal = lazyloadElems[i][_getAttribute]("data-expand")) || !(elemExpand = elemExpandVal * 1)) elemExpand = currentExpand;
                    if (!defaultExpand) {
                        defaultExpand = !lazySizesCfg.expand || lazySizesCfg.expand < 1 ? docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370 : lazySizesCfg.expand;
                        lazysizes._defEx = defaultExpand;
                        preloadExpand = defaultExpand * lazySizesCfg.expFactor;
                        hFac = lazySizesCfg.hFac;
                        isBodyHidden = null;
                        if (currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden) {
                            currentExpand = preloadExpand;
                            lowRuns = 0;
                        } else if (loadMode > 1 && lowRuns > 1 && isLoading < 6) currentExpand = defaultExpand;
                        else currentExpand = shrinkExpand;
                    }
                    if (beforeExpandVal !== elemExpand) {
                        eLvW = innerWidth + elemExpand * hFac;
                        elvH = innerHeight + elemExpand;
                        elemNegativeExpand = elemExpand * -1;
                        beforeExpandVal = elemExpand;
                    }
                    rect = lazyloadElems[i].getBoundingClientRect();
                    if ((eLbottom = rect.bottom) >= elemNegativeExpand && (eLtop = rect.top) <= elvH && (eLright = rect.right) >= elemNegativeExpand * hFac && (eLleft = rect.left) <= eLvW && (eLbottom || eLright || eLleft || eLtop) && (lazySizesCfg.loadHidden || isVisible(lazyloadElems[i])) && (isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4) || isNestedVisible(lazyloadElems[i], elemExpand))) {
                        unveilElement(lazyloadElems[i]);
                        loadedSomething = true;
                        if (isLoading > 9) break;
                    } else if (!loadedSomething && isCompleted && !autoLoadElem && isLoading < 4 && lowRuns < 4 && loadMode > 2 && (preloadElems[0] || lazySizesCfg.preloadAfterLoad) && (preloadElems[0] || !elemExpandVal && (eLbottom || eLright || eLleft || eLtop || lazyloadElems[i][_getAttribute](lazySizesCfg.sizesAttr) != "auto"))) autoLoadElem = preloadElems[0] || lazyloadElems[i];
                }
                if (autoLoadElem && !loadedSomething) unveilElement(autoLoadElem);
            }
        };
        var throttledCheckElements = throttle(checkElements);
        var switchLoadingClass = function(e) {
            var elem = e.target;
            if (elem._lazyCache) {
                delete elem._lazyCache;
                return;
            }
            resetPreloading(e);
            addClass(elem, lazySizesCfg.loadedClass);
            removeClass(elem, lazySizesCfg.loadingClass);
            addRemoveLoadEvents(elem, rafSwitchLoadingClass);
            triggerEvent(elem, "lazyloaded");
        };
        var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
        var rafSwitchLoadingClass = function(e) {
            rafedSwitchLoadingClass({
                target: e.target
            });
        };
        var changeIframeSrc = function(elem, src) {
            var loadMode = elem.getAttribute("data-load-mode") || lazySizesCfg.iframeLoadMode;
            // loadMode can be also a string!
            if (loadMode == 0) elem.contentWindow.location.replace(src);
            else if (loadMode == 1) elem.src = src;
        };
        var handleSources = function(source) {
            var customMedia;
            var sourceSrcset = source[_getAttribute](lazySizesCfg.srcsetAttr);
            if (customMedia = lazySizesCfg.customMedia[source[_getAttribute]("data-media") || source[_getAttribute]("media")]) source.setAttribute("media", customMedia);
            if (sourceSrcset) source.setAttribute("srcset", sourceSrcset);
        };
        var lazyUnveil = rAFIt(function(elem, detail, isAuto, sizes, isImg) {
            var src, srcset, parent, isPicture, event, firesLoad;
            if (!(event = triggerEvent(elem, "lazybeforeunveil", detail)).defaultPrevented) {
                if (sizes) {
                    if (isAuto) addClass(elem, lazySizesCfg.autosizesClass);
                    else elem.setAttribute("sizes", sizes);
                }
                srcset = elem[_getAttribute](lazySizesCfg.srcsetAttr);
                src = elem[_getAttribute](lazySizesCfg.srcAttr);
                if (isImg) {
                    parent = elem.parentNode;
                    isPicture = parent && regPicture.test(parent.nodeName || "");
                }
                firesLoad = detail.firesLoad || "src" in elem && (srcset || src || isPicture);
                event = {
                    target: elem
                };
                addClass(elem, lazySizesCfg.loadingClass);
                if (firesLoad) {
                    clearTimeout(resetPreloadingTimer);
                    resetPreloadingTimer = setTimeout(resetPreloading, 2500);
                    addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
                }
                if (isPicture) forEach.call(parent.getElementsByTagName("source"), handleSources);
                if (srcset) elem.setAttribute("srcset", srcset);
                else if (src && !isPicture) {
                    if (regIframe.test(elem.nodeName)) changeIframeSrc(elem, src);
                    else elem.src = src;
                }
                if (isImg && (srcset || isPicture)) updatePolyfill(elem, {
                    src: src
                });
            }
            if (elem._lazyRace) delete elem._lazyRace;
            removeClass(elem, lazySizesCfg.lazyClass);
            rAF(function() {
                // Part of this can be removed as soon as this fix is older: https://bugs.chromium.org/p/chromium/issues/detail?id=7731 (2015)
                var isLoaded = elem.complete && elem.naturalWidth > 1;
                if (!firesLoad || isLoaded) {
                    if (isLoaded) addClass(elem, lazySizesCfg.fastLoadedClass);
                    switchLoadingClass(event);
                    elem._lazyCache = true;
                    setTimeout(function() {
                        if ("_lazyCache" in elem) delete elem._lazyCache;
                    }, 9);
                }
                if (elem.loading == "lazy") isLoading--;
            }, true);
        });
        /**
		 *
		 * @param elem { Element }
		 */ var unveilElement = function(elem) {
            if (elem._lazyRace) return;
            var detail;
            var isImg = regImg.test(elem.nodeName);
            //allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
            var sizes = isImg && (elem[_getAttribute](lazySizesCfg.sizesAttr) || elem[_getAttribute]("sizes"));
            var isAuto = sizes == "auto";
            if ((isAuto || !isCompleted) && isImg && (elem[_getAttribute]("src") || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesCfg.errorClass) && hasClass(elem, lazySizesCfg.lazyClass)) return;
            detail = triggerEvent(elem, "lazyunveilread").detail;
            if (isAuto) autoSizer.updateElem(elem, true, elem.offsetWidth);
            elem._lazyRace = true;
            isLoading++;
            lazyUnveil(elem, detail, isAuto, sizes, isImg);
        };
        var afterScroll = debounce(function() {
            lazySizesCfg.loadMode = 3;
            throttledCheckElements();
        });
        var altLoadmodeScrollListner = function() {
            if (lazySizesCfg.loadMode == 3) lazySizesCfg.loadMode = 2;
            afterScroll();
        };
        var onload = function() {
            if (isCompleted) return;
            if (Date1.now() - started < 999) {
                setTimeout(onload, 999);
                return;
            }
            isCompleted = true;
            lazySizesCfg.loadMode = 3;
            throttledCheckElements();
            addEventListener("scroll", altLoadmodeScrollListner, true);
        };
        return {
            _: function() {
                started = Date1.now();
                lazysizes.elements = document.getElementsByClassName(lazySizesCfg.lazyClass);
                preloadElems = document.getElementsByClassName(lazySizesCfg.lazyClass + " " + lazySizesCfg.preloadClass);
                addEventListener("scroll", throttledCheckElements, true);
                addEventListener("resize", throttledCheckElements, true);
                addEventListener("pageshow", function(e) {
                    if (e.persisted) {
                        var loadingElements = document.querySelectorAll("." + lazySizesCfg.loadingClass);
                        if (loadingElements.length && loadingElements.forEach) requestAnimationFrame(function() {
                            loadingElements.forEach(function(img) {
                                if (img.complete) unveilElement(img);
                            });
                        });
                    }
                });
                if (window1.MutationObserver) new MutationObserver(throttledCheckElements).observe(docElem, {
                    childList: true,
                    subtree: true,
                    attributes: true
                });
                else {
                    docElem[_addEventListener]("DOMNodeInserted", throttledCheckElements, true);
                    docElem[_addEventListener]("DOMAttrModified", throttledCheckElements, true);
                    setInterval(throttledCheckElements, 999);
                }
                addEventListener("hashchange", throttledCheckElements, true);
                //, 'fullscreenchange'
                [
                    "focus",
                    "mouseover",
                    "click",
                    "load",
                    "transitionend",
                    "animationend"
                ].forEach(function(name) {
                    document[_addEventListener](name, throttledCheckElements, true);
                });
                if (/d$|^c/.test(document.readyState)) onload();
                else {
                    addEventListener("load", onload);
                    document[_addEventListener]("DOMContentLoaded", throttledCheckElements);
                    setTimeout(onload, 20000);
                }
                if (lazysizes.elements.length) {
                    checkElements();
                    rAF._lsFlush();
                } else throttledCheckElements();
            },
            checkElems: throttledCheckElements,
            unveil: unveilElement,
            _aLSL: altLoadmodeScrollListner
        };
    }();
    var autoSizer = function() {
        var autosizesElems;
        var sizeElement = rAFIt(function(elem, parent, event, width) {
            var sources, i, len;
            elem._lazysizesWidth = width;
            width += "px";
            elem.setAttribute("sizes", width);
            if (regPicture.test(parent.nodeName || "")) {
                sources = parent.getElementsByTagName("source");
                for(i = 0, len = sources.length; i < len; i++)sources[i].setAttribute("sizes", width);
            }
            if (!event.detail.dataAttr) updatePolyfill(elem, event.detail);
        });
        /**
		 *
		 * @param elem {Element}
		 * @param dataAttr
		 * @param [width] { number }
		 */ var getSizeElement = function(elem, dataAttr, width) {
            var event;
            var parent = elem.parentNode;
            if (parent) {
                width = getWidth(elem, parent, width);
                event = triggerEvent(elem, "lazybeforesizes", {
                    width: width,
                    dataAttr: !!dataAttr
                });
                if (!event.defaultPrevented) {
                    width = event.detail.width;
                    if (width && width !== elem._lazysizesWidth) sizeElement(elem, parent, event, width);
                }
            }
        };
        var updateElementsSizes = function() {
            var i;
            var len = autosizesElems.length;
            if (len) {
                i = 0;
                for(; i < len; i++)getSizeElement(autosizesElems[i]);
            }
        };
        var debouncedUpdateElementsSizes = debounce(updateElementsSizes);
        return {
            _: function() {
                autosizesElems = document.getElementsByClassName(lazySizesCfg.autosizesClass);
                addEventListener("resize", debouncedUpdateElementsSizes);
            },
            checkElems: debouncedUpdateElementsSizes,
            updateElem: getSizeElement
        };
    }();
    var init = function() {
        if (!init.i && document.getElementsByClassName) {
            init.i = true;
            autoSizer._();
            loader._();
        }
    };
    setTimeout(function() {
        if (lazySizesCfg.init) init();
    });
    lazysizes = {
        /**
		 * @type { LazySizesConfigPartial }
		 */ cfg: lazySizesCfg,
        autoSizer: autoSizer,
        loader: loader,
        init: init,
        uP: updatePolyfill,
        aC: addClass,
        rC: removeClass,
        hC: hasClass,
        fire: triggerEvent,
        gW: getWidth,
        rAF: rAF
    };
    return lazysizes;
});

});


parcelRequire("2EzGb");
var $981aa12c4eb745a9$exports = {};

(function(window1, factory) {
    if (!window1) return;
    var globalInstall = function() {
        factory(window1.lazySizes);
        window1.removeEventListener("lazyunveilread", globalInstall, true);
    };
    factory = factory.bind(null, window1, window1.document);
    if (0, $981aa12c4eb745a9$exports) factory((parcelRequire("2EzGb")));
    else if (typeof define == "function" && define.amd) define([
        "lazysizes"
    ], factory);
    else if (window1.lazySizes) globalInstall();
    else window1.addEventListener("lazyunveilread", globalInstall, true);
})(typeof window != "undefined" ? window : 0, function(window1, document, lazySizes) {
    "use strict";
    if (!window1.addEventListener) return;
    var regDescriptors = /\s+(\d+)(w|h)\s+(\d+)(w|h)/;
    var regCssFit = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/;
    var regCssObject = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/;
    var regPicture = /^picture$/i;
    var cfg = lazySizes.cfg;
    var getCSS = function(elem) {
        return getComputedStyle(elem, null) || {};
    };
    var parentFit = {
        getParent: function(element, parentSel) {
            var parent = element;
            var parentNode = element.parentNode;
            if ((!parentSel || parentSel == "prev") && parentNode && regPicture.test(parentNode.nodeName || "")) parentNode = parentNode.parentNode;
            if (parentSel != "self") {
                if (parentSel == "prev") parent = element.previousElementSibling;
                else if (parentSel && (parentNode.closest || window1.jQuery)) parent = (parentNode.closest ? parentNode.closest(parentSel) : jQuery(parentNode).closest(parentSel)[0]) || parentNode;
                else parent = parentNode;
            }
            return parent;
        },
        getFit: function(element) {
            var tmpMatch, parentObj;
            var css = getCSS(element);
            var content = css.content || css.fontFamily;
            var obj = {
                fit: element._lazysizesParentFit || element.getAttribute("data-parent-fit")
            };
            if (!obj.fit && content && (tmpMatch = content.match(regCssFit))) obj.fit = tmpMatch[1];
            if (obj.fit) {
                parentObj = element._lazysizesParentContainer || element.getAttribute("data-parent-container");
                if (!parentObj && content && (tmpMatch = content.match(regCssObject))) parentObj = tmpMatch[1];
                obj.parent = parentFit.getParent(element, parentObj);
            } else obj.fit = css.objectFit;
            return obj;
        },
        getImageRatio: function(element) {
            var i, srcset, media, ratio, match, width, height;
            var parent = element.parentNode;
            var elements = parent && regPicture.test(parent.nodeName || "") ? parent.querySelectorAll("source, img") : [
                element
            ];
            for(i = 0; i < elements.length; i++){
                element = elements[i];
                srcset = element.getAttribute(cfg.srcsetAttr) || element.getAttribute("srcset") || element.getAttribute("data-pfsrcset") || element.getAttribute("data-risrcset") || "";
                media = element._lsMedia || element.getAttribute("media");
                media = cfg.customMedia[element.getAttribute("data-media") || media] || media;
                if (srcset && (!media || (window1.matchMedia && matchMedia(media) || {}).matches)) {
                    ratio = parseFloat(element.getAttribute("data-aspectratio"));
                    if (!ratio) {
                        match = srcset.match(regDescriptors);
                        if (match) {
                            if (match[2] == "w") {
                                width = match[1];
                                height = match[3];
                            } else {
                                width = match[3];
                                height = match[1];
                            }
                        } else {
                            width = element.getAttribute("width");
                            height = element.getAttribute("height");
                        }
                        ratio = width / height;
                    }
                    break;
                }
            }
            return ratio;
        },
        calculateSize: function(element, width) {
            var displayRatio, height, imageRatio, retWidth;
            var fitObj = this.getFit(element);
            var fit = fitObj.fit;
            var fitElem = fitObj.parent;
            if (fit != "width" && (fit != "contain" && fit != "cover" || !(imageRatio = this.getImageRatio(element)))) return width;
            if (fitElem) width = fitElem.clientWidth;
            else fitElem = element;
            retWidth = width;
            if (fit == "width") retWidth = width;
            else {
                height = fitElem.clientHeight;
                if ((displayRatio = width / height) && (fit == "cover" && displayRatio < imageRatio || fit == "contain" && displayRatio > imageRatio)) retWidth = width * (imageRatio / displayRatio);
            }
            return retWidth;
        }
    };
    lazySizes.parentFit = parentFit;
    document.addEventListener("lazybeforesizes", function(e) {
        if (e.defaultPrevented || e.detail.instance != lazySizes) return;
        var element = e.target;
        e.detail.width = parentFit.calculateSize(element, e.detail.width);
    });
});


function $899a0db0f252532f$var$e(e, o) {
    for(const t in o){
        const n = o[t];
        e.addEventListener(t, n.listener || n, n.options || void 0);
    }
}
const $899a0db0f252532f$var$o = "IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype, $899a0db0f252532f$var$t = /baidu|(?:google|bing|yandex|duckduck)bot/i.test(navigator.userAgent), $899a0db0f252532f$var$n = [
    "src",
    "poster"
];
function $899a0db0f252532f$var$r(e, o) {
    for (const t of $899a0db0f252532f$var$n)t in e.dataset && (e.setAttribute(t, e.dataset[t]), e.classList.contains(o) && e.classList.remove(o));
}
function $899a0db0f252532f$var$s(e, o, t, n) {
    if ("VIDEO" == e.nodeName) {
        const t = Array.from(e.querySelectorAll("source"));
        for (const e of t)$899a0db0f252532f$var$r(e, o);
        e.load();
    }
    $899a0db0f252532f$var$r(e, o);
    const s = e.classList;
    s.contains(t) && (s.remove(t), s.add(n));
}
function $899a0db0f252532f$export$80e34e3edbb862ab(n) {
    const r = n?.lazyClass || "lazy", i = n?.lazyBackgroundClass || "lazy-bg", c = n?.lazyBackgroundLoaded || "lazy-bg-loaded", a = n?.threshold || 200, l = n?.events || {}, d = n?.observeChanges || !1, f = n?.observeRootSelector || "body", u = n?.mutationObserverOptions || {
        childList: !0,
        subtree: !0
    }, b = `video.${r},.${i}`;
    let v = Array.from(document.querySelectorAll(b));
    for (const o of v)$899a0db0f252532f$var$e(o, l);
    if (!0 === $899a0db0f252532f$var$o && !1 === $899a0db0f252532f$var$t) {
        var y = new IntersectionObserver((e)=>{
            for (const o of e)if (o.isIntersecting || o.intersectionRatio) {
                const { target: e } = o;
                $899a0db0f252532f$var$s(e, r, i, c), y.unobserve(e), v = v.filter((o)=>o != e), 0 === v.length && !1 === d && y.disconnect();
            }
        }, {
            rootMargin: `${a}px 0%`
        });
        for (const e of v)y.observe(e);
        d && new MutationObserver(()=>{
            const n = document.querySelectorAll(b);
            for (const r of n)!1 === v.includes(r) && (v.push(r), $899a0db0f252532f$var$e(r, l), !0 === $899a0db0f252532f$var$o && !1 === $899a0db0f252532f$var$t && y.observe(r));
        }).observe(document.querySelector(f), u);
    } else if ($899a0db0f252532f$var$t) for (const e of v)$899a0db0f252532f$var$s(e, r, i, c);
}


const $39cc0c7b6faa7c44$export$a6ef6196533b655b = {
    SECTION_LOAD: "shopify:section:load",
    SECTION_UNLOAD: "shopify:section:unload",
    SECTION_SELECT: "shopify:section:select",
    SECTION_DESELECT: "shopify:section:deselect",
    SECTION_REORDER: "shopify:section:reorder",
    BLOCK_SELECT: "shopify:block:select",
    BLOCK_DESELECT: "shopify:block:deselect"
};
const $39cc0c7b6faa7c44$export$3f0d637ce77a8721 = {
    ARROW_LEFT_STRING_KEY: "ArrowLeft",
    ARROW_RIGHT_STRING_KEY: "ArrowRight",
    ARROW_LEFT_NUMBER_KEY: 37,
    ARROW_RIGHT_NUMBER_KEY: 39,
    ENTER_STRING_KEY: "Enter",
    ENTER_NUMBER_KEY: 13,
    ESCAPE_STRING_KEY: "Escape",
    ESCAPE_NUMBER_KEY: 27,
    SPACE_STRING_KEY: " ",
    SPACE_NUMBER_KEY: 32,
    TAB_STRING_KEY: "Tab",
    TAB_NUMBER_KEY: 9
};


class $3b008451037fbb88$var$ShopifyEditor {
    constructor(){
        this.listeners = {};
    }
    subscribe(eventName, listener) {
        if (!this.listeners[eventName]) this.listeners[eventName] = [];
        document.addEventListener((0, $39cc0c7b6faa7c44$export$a6ef6196533b655b)[eventName], listener);
        this.listeners[eventName].push(listener);
    }
    unsubscribe(eventName, removedListener) {
        if (!this.listeners[eventName]) return;
        document.removeEventListener((0, $39cc0c7b6faa7c44$export$a6ef6196533b655b)[eventName], removedListener);
        this.listeners[eventName] = this.listeners[eventName].filter((listener)=>listener !== removedListener);
    }
    destroy() {
        const events = Object.keys(this.listeners);
        events.forEach((event)=>{
            const listeners = this.listeners[event];
            listeners.forEach((listener)=>{
                this.unsubscribe(event, listener);
            });
        });
        this.listeners = {};
    }
}
var $3b008451037fbb88$export$2e2bcd8739ae039 = $3b008451037fbb88$var$ShopifyEditor;


const { Shopify: $f02dc8681ee02b75$var$Shopify } = window;
class $f02dc8681ee02b75$var$BaseComponent extends HTMLElement {
    constructor(){
        super();
        this.editor = new (0, $3b008451037fbb88$export$2e2bcd8739ae039)();
        this.isEditorMode = $f02dc8681ee02b75$var$Shopify.designMode;
        this.listeners = {};
    }
    subscribe(eventName, listener) {
        if (!this.listeners[eventName]) this.listeners[eventName] = [];
        this.listeners[eventName].push(listener);
    }
    unsubscribe(eventName, removedListener) {
        if (!this.listeners[eventName]) return;
        this.listeners[eventName] = this.listeners[eventName].filter((listener)=>listener !== removedListener);
    }
    emit(eventName, data) {
        if (!this.listeners[eventName]) return;
        this.listeners[eventName].forEach((listener)=>listener(data));
    }
}
var $f02dc8681ee02b75$export$2e2bcd8739ae039 = $f02dc8681ee02b75$var$BaseComponent;


class $a87b8ad43c6d62c5$var$LoginComponent extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleClick = (event)=>{
            const target = event.target;
            const isLoginFormButton = target.hasAttribute("data-login-form-button");
            if (isLoginFormButton) {
                const loginFormId = target.dataset.loginFormId || "";
                this.setFormVisibleById(loginFormId);
                this.updateFocus();
            }
        };
        this.forms = [
            ...this.querySelectorAll("[data-login-form]")
        ];
    }
    connectedCallback() {
        this.updateFocus();
        this.addEventListener("click", this.handleClick);
    }
    disconnectedCallback() {
        this.removeEventListener("click", this.handleClick);
    }
    setFormVisibleById(loginFormId) {
        this.forms.forEach((form)=>{
            const isTargetForm = form.getAttribute("data-login-form") === loginFormId;
            form.classList.toggle("hidden", !isTargetForm);
        });
    }
    updateFocus() {
        this.forms.forEach((form)=>{
            const isHidden = form.classList.contains("hidden");
            const emailInput = form.querySelector('[type="email"]');
            if (!isHidden && emailInput) emailInput.focus();
        });
    }
}
var $a87b8ad43c6d62c5$export$2e2bcd8739ae039 = $a87b8ad43c6d62c5$var$LoginComponent;



class $8ff44a91d1a822ea$var$RegisterComponent extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.formAttribute = "[data-register-form]";
        this.form = this.querySelector(this.formAttribute);
    }
    connectedCallback() {
        this.form?.addEventListener("submit", this.handleSubmit);
    }
    disconnectedCallback() {
        this.form?.removeEventListener("submit", this.handleSubmit);
    }
    handleSubmit() {
        localStorage.setItem("isRegistered", "true");
    }
}
var $8ff44a91d1a822ea$export$2e2bcd8739ae039 = $8ff44a91d1a822ea$var$RegisterComponent;


class $81fabf043eeb4cb2$var$BackToTopButton extends HTMLElement {
    constructor(){
        super();
        this.handleWindowScroll = ()=>{
            this.updateButtonVisible();
        };
        this.handleButtonClick = ()=>{
            this.scrollToTop();
        };
        this.button = this.querySelector("[data-back-to-top-button]");
    }
    connectedCallback() {
        if (this.button) this.button.addEventListener("click", this.handleButtonClick);
        window.addEventListener("scroll", this.handleWindowScroll);
    }
    disconnectedCallback() {
        if (this.button) this.button.removeEventListener("click", this.handleButtonClick);
        window.removeEventListener("scroll", this.handleWindowScroll);
    }
    updateButtonVisible() {
        if (!this.button) return;
        const isVisible = window.scrollY > window.innerHeight;
        this.button.toggleAttribute("visible", isVisible);
    }
    scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }
}
var $81fabf043eeb4cb2$export$2e2bcd8739ae039 = $81fabf043eeb4cb2$var$BackToTopButton;



class $30afc5db428ab66d$var$StickyCartButton extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleWindowScroll = ()=>{
            const header = document.querySelector(".shopify-section.shopify-section-header");
            if (header && this.button) {
                const headerRect = header.getBoundingClientRect();
                const isVisible = headerRect.bottom + this.button.offsetHeight < 0;
                this.button.toggleAttribute("visible", isVisible);
            }
        };
        this.button = this.querySelector("[data-cart-sticky-button]");
    }
    connectedCallback() {
        window.addEventListener("scroll", this.handleWindowScroll);
    }
    disconnectedCallback() {
        window.removeEventListener("scroll", this.handleWindowScroll);
    }
}
var $30afc5db428ab66d$export$2e2bcd8739ae039 = $30afc5db428ab66d$var$StickyCartButton;




const $6de5ff37caa957d8$export$9a00dee1beb8f576 = (word)=>{
    const firstSymbol = word.slice(0, 1);
    const restWordPart = word.slice(1);
    return firstSymbol.toUpperCase() + restWordPart;
};
const $6de5ff37caa957d8$export$1391212d75b2ee65 = (delay)=>{
    return new Promise((resolve, reject)=>{
        setTimeout(resolve, delay);
    });
};
const $6de5ff37caa957d8$var$setEventListener = (element, typeEvent, handler, action)=>{
    if (!handler || !element || !typeEvent) return;
    const eventListenerSetter = `${action}EventListener`;
    element[eventListenerSetter](typeEvent, handler);
};
const $6de5ff37caa957d8$export$72de9d21dee7d369 = (element, typeEvent, handler)=>{
    $6de5ff37caa957d8$var$setEventListener(element, typeEvent, handler, "add");
};
const $6de5ff37caa957d8$export$ff0ecb8d3a93845b = (element, typeEvent, handler)=>{
    $6de5ff37caa957d8$var$setEventListener(element, typeEvent, handler, "remove");
};
const $6de5ff37caa957d8$export$b9291b92670abfe3 = new IntersectionObserver((entries, _)=>{
    entries.forEach((entry)=>{
        const isInViewport = entry.isIntersecting;
        const isParentHidden = entry.target.closest('[aria-hidden="true"], .hidden');
        entry.target.classList.toggle("is-in-viewport", isInViewport && !isParentHidden);
    });
});
const $6de5ff37caa957d8$export$f2d94ec8507fd10b = ()=>{
    const targets = [
        "button",
        "[href]",
        "[data-focus-trap-target]",
        "a",
        "[tabindex]"
    ];
    return targets.map((target)=>`${target}:not([tabindex="-1"]):not([data-color-swatches-hidden-count]:empty)`).join(",");
};
const $6de5ff37caa957d8$export$402b71a6ab88771a = (customElement)=>{
    const customElementContainer = document.createElement("div");
    customElementContainer.classList.add("hidden");
    document.body.appendChild(customElementContainer);
    customElementContainer.appendChild(customElement);
    return customElementContainer;
};
const $6de5ff37caa957d8$export$6b8b061b59c6fc66 = (customElementContainer)=>{
    customElementContainer.remove();
};
const $6de5ff37caa957d8$export$95df08bae54cb4df = ()=>{
    // Chrome DevTools does not complain about navigator.vendor
    return /apple/i.test(navigator.vendor);
};
const $6de5ff37caa957d8$export$793b145c7f680179 = (key)=>key === (0, $39cc0c7b6faa7c44$export$3f0d637ce77a8721).ENTER_NUMBER_KEY || key === (0, $39cc0c7b6faa7c44$export$3f0d637ce77a8721).ENTER_STRING_KEY;
const $6de5ff37caa957d8$export$9b97ca6e83cec11e = (key)=>key === (0, $39cc0c7b6faa7c44$export$3f0d637ce77a8721).SPACE_NUMBER_KEY || key === (0, $39cc0c7b6faa7c44$export$3f0d637ce77a8721).SPACE_STRING_KEY;
const $6de5ff37caa957d8$export$39246f7a93d1f0fc = (key)=>key === (0, $39cc0c7b6faa7c44$export$3f0d637ce77a8721).ESCAPE_STRING_KEY || key === (0, $39cc0c7b6faa7c44$export$3f0d637ce77a8721).ESCAPE_NUMBER_KEY;
const $6de5ff37caa957d8$export$e2fe3643cb517b19 = (key)=>key === (0, $39cc0c7b6faa7c44$export$3f0d637ce77a8721).ARROW_RIGHT_NUMBER_KEY || key === (0, $39cc0c7b6faa7c44$export$3f0d637ce77a8721).ARROW_RIGHT_STRING_KEY;
const $6de5ff37caa957d8$export$703c582f38858004 = (key)=>key === (0, $39cc0c7b6faa7c44$export$3f0d637ce77a8721).ARROW_LEFT_NUMBER_KEY || key === (0, $39cc0c7b6faa7c44$export$3f0d637ce77a8721).ARROW_LEFT_STRING_KEY;
const $6de5ff37caa957d8$export$c7f540582081fbb7 = (key)=>key === (0, $39cc0c7b6faa7c44$export$3f0d637ce77a8721).TAB_NUMBER_KEY || key === (0, $39cc0c7b6faa7c44$export$3f0d637ce77a8721).TAB_STRING_KEY;
const $6de5ff37caa957d8$export$d39a5bbd09211389 = (children, parent)=>{
    let element = document.getElementById("Portal");
    element.appendChild(children);
    const target = parent && parent.appendChild ? parent : document.body;
    target.appendChild(element);
};
const $6de5ff37caa957d8$export$5faba83c1624a4ba = (styles)=>{
    const transitionDuration = parseFloat(styles["transitionDuration"]) * 1000;
    const transitionDelay = parseFloat(styles["transitionDelay"]) * 1000;
    return transitionDuration + transitionDelay;
};
const $6de5ff37caa957d8$export$b98882f166bb7ce2 = (href)=>{
    return !href.match(/^\//) && !href.includes(window.location.host);
};
const $6de5ff37caa957d8$export$47667ecde0defde2 = (href)=>{
    return href === window.location.href;
};
const $6de5ff37caa957d8$export$1229dd75ca8729a7 = (href)=>{
    const link = document.createElement("link");
    link.setAttribute("rel", "prefetch");
    link.setAttribute("href", href);
    document.head.appendChild(link);
};
const $6de5ff37caa957d8$export$8040e5ab996cd2a = ()=>{
    const observedVideos = [];
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.intersectionRatio <= 0) entry.target.pause();
            else entry.target.play();
            if (!observedVideos.find((el)=>el === entry.target)) observedVideos.push(entry.target);
        });
    });
    return {
        observedVideos: observedVideos,
        observer: observer
    };
};
const $6de5ff37caa957d8$export$4ac303db914d5b8 = ({ observedVideos: observedVideos, observer: observer })=>{
    const videos = Array.from(document.querySelectorAll("video[autoplay]")).filter((element)=>element.clientWidth > 0).filter((element)=>!observedVideos.find((el)=>el === element));
    if (videos.length > 0) videos.forEach((video)=>{
        observer.observe(video);
        video.play();
    });
};


class $e6fc11d3bb369f03$var$Quantity extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleBlur = (event)=>{
            if (this.input) {
                const target = event.target;
                const value = target.value || "0";
                this.input.value = value;
                this.updateButtonsDisabled();
                this.prevValue = value;
            }
        };
        this.handleKeydown = (event)=>{
            if (this.input) {
                const isEnterKey = (0, $6de5ff37caa957d8$export$793b145c7f680179)(event.key || event.keyCode);
                if (isEnterKey) {
                    event.preventDefault();
                    this.input.blur();
                }
            }
        };
        this.handleInput = (event)=>{
            if (this.input) {
                const target = event.target;
                const value = target.value;
                this.input.value = this.isMoreThanStock ? this.stockValue : value;
                this.updateButtonsDisabled();
                this.prevValue = value;
            }
        };
        this.input = this.querySelector("[data-quantity-input]");
        this.prevValue = this.value;
        this.stockValue = this.dataset.stock || "0";
    }
    connectedCallback() {
        this.updateButtonsDisabled();
        this.input.addEventListener("keypress", this.handleKeydown);
        this.input.addEventListener("input", this.handleInput);
        this.input.addEventListener("blur", this.handleBlur);
    }
    disconnectedCallback() {
        this.input.removeEventListener("keypress", this.handleKeydown);
        this.input.removeEventListener("input", this.handleInput);
        this.input.removeEventListener("blur", this.handleBlur);
    }
    inputChange(action) {
        if (this.input) {
            if (action === "minus") this.input.stepDown();
            else this.input.stepUp();
            if (+this.prevValue !== +this.value) this.input.dispatchEvent(new Event("change", {
                bubbles: true
            }));
            this.updateButtonsDisabled();
        }
    }
    updateButtonsDisabled() {
        this.updateButtonDisabled("minus", this.isLessThanMin);
        this.updateButtonDisabled("plus", this.isMoreThanStock);
    }
    setDisable(isDisabled) {
        this.updateButtonDisabled("minus", isDisabled);
        this.updateButtonDisabled("plus", isDisabled);
    }
    updateButtonDisabled(btnType, isDisabled) {
        const btn = this.querySelector(`quantity-btn[data-action="${btnType}"]`);
        if (btn) btn.toggleAttribute("disabled", isDisabled);
    }
    get value() {
        if (!this.input) return "0";
        return this.input.value;
    }
    get isLessThanMin() {
        if (!this.input) return false;
        return +this.value <= +this.input.min;
    }
    get isMoreThanStock() {
        return +this.value >= +this.stockValue;
    }
}
var $e6fc11d3bb369f03$export$2e2bcd8739ae039 = $e6fc11d3bb369f03$var$Quantity;




class $303f56e60938fd90$var$QuantityBtn extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleButtonClick = (event)=>{
            event.preventDefault();
            this.update();
        };
        this.handleKeyDown = (event)=>{
            const isEnterKey = (0, $6de5ff37caa957d8$export$793b145c7f680179)(event.key || event.keyCode);
            const target = event.target;
            if (isEnterKey && !target.hasAttribute("disabled")) {
                event.preventDefault();
                this.update();
            }
        };
        this.quantity = this.closest("quantity-component");
    }
    connectedCallback() {
        this.addEventListener("click", this.handleButtonClick);
        this.addEventListener("keydown", this.handleKeyDown);
    }
    disconnectedCallback() {
        this.removeEventListener("click", this.handleButtonClick);
        this.removeEventListener("keydown", this.handleKeyDown);
    }
    update() {
        const action = this.dataset.action;
        if (this.quantity && action) {
            this.quantity.inputChange(action);
            if (action === "minus") this.setDisabled();
        }
    }
    setDisabled() {
        if (this.quantity && this.quantity.input) {
            const isDisabled = this.quantity.input.value === "1";
            this.toggleAttribute("disabled", isDisabled);
        }
    }
}
var $303f56e60938fd90$export$2e2bcd8739ae039 = $303f56e60938fd90$var$QuantityBtn;



class $51c5cbd0597e116c$var$LocalizationSelector extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleClick = (event)=>{
            event.preventDefault();
            const target = event.target;
            if (!target.hasAttribute(`data-localization-item`)) return;
            if (!this.input || !this.form || !target.dataset.value) return;
            this.input.value = target.dataset.value;
            this.form.submit();
        };
        this.inputSelector = `[data-localization-input]`;
        this.formSelector = "form";
        this.input = this.querySelector(this.inputSelector);
        this.form = this.querySelector(this.formSelector);
    }
    connectedCallback() {
        this.addEventListener("click", this.handleClick);
    }
    disconnectedCallback() {
        this.removeEventListener("click", this.handleClick);
    }
}
var $51c5cbd0597e116c$export$2e2bcd8739ae039 = $51c5cbd0597e116c$var$LocalizationSelector;



class $79116199a8de4067$var$NotificationComponent extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleCloseButtonClick = ()=>{
            this.hide();
        };
        this.closeBtn = this.querySelector("[data-notification-close-button]");
        this.alert = this.querySelector("[data-notification-alert]");
        this.alertText = this.querySelector("[data-notification-alert-text]");
    }
    connectedCallback() {
        if (this.closeBtn) this.closeBtn.addEventListener("click", this.handleCloseButtonClick);
    }
    disconnectedCallback() {
        if (this.closeBtn) this.closeBtn.removeEventListener("click", this.handleCloseButtonClick);
    }
    show(errorText, variant, duration = 3000) {
        this.setAlert(errorText, variant || "warning");
        if (this.showTimeoutId) clearTimeout(this.showTimeoutId);
        this.setVisible(true);
        this.showTimeoutId = setTimeout(()=>{
            this.setVisible(false);
        }, duration);
    }
    hide() {
        this.setVisible(false);
    }
    setVisible(isVisible) {
        this.toggleAttribute("open", isVisible);
    }
    setAlert(errorText, variant) {
        if (this.alert && this.alertText) {
            this.alert.setAttribute("alert-type", variant);
            this.alertText.innerHTML = errorText;
        }
    }
}
var $79116199a8de4067$export$2e2bcd8739ae039 = $79116199a8de4067$var$NotificationComponent;




const $aa19cdf2f552e6e0$export$998191bfdf710c72 = (element)=>{
    if (element) element.classList.remove("hidden");
};
const $aa19cdf2f552e6e0$export$7669482c90f5c50f = (element)=>{
    if (element) element.classList.add("hidden");
};
const $aa19cdf2f552e6e0$export$d107df9a86338a09 = (element, property)=>{
    const styles = getComputedStyle(element);
    const value = styles[property];
    return value;
};
const $aa19cdf2f552e6e0$export$d4e734980dda982f = (template)=>{
    return template.content.cloneNode(true);
};
const $aa19cdf2f552e6e0$export$8ea4fc17cec6f158 = (template)=>{
    return template.content.firstElementChild.cloneNode(true);
};
const $aa19cdf2f552e6e0$export$f99c757f0e3e3773 = (variable, value)=>{
    document.documentElement.style.setProperty(`--gsc-${variable}`, value);
};
const $aa19cdf2f552e6e0$export$771cf8a539cd846f = (element, isForward)=>{
    if (element) element.classList.toggle("forward-transition", isForward);
};
const $aa19cdf2f552e6e0$export$8a49393be2d55148 = (html)=>{
    return new DOMParser().parseFromString(html, "text/html");
};


class $732e7110f4e35980$var$Tabs extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleTabNameClick = (event)=>{
            event.preventDefault();
            const target = event.target;
            if (target.dataset.id) this.selectTab(target.dataset.id);
        };
        this.handleKeyDown = (event)=>{
            const target = event.target;
            if (!target.dataset.id) return;
            const isEnterKey = (0, $6de5ff37caa957d8$export$793b145c7f680179)(event.key || event.keyCode);
            if (isEnterKey) {
                event.preventDefault();
                this.selectTab(target.dataset.id);
            }
        };
        this.containerSelector = `[data-tabs-container]`;
        this.templateSelector = `[data-tabs-elements-template]`;
        this.tabSelector = `tab-component, tab-with-dynamic-height`;
        this.tabNameSelector = `[data-tabs-name]`;
        this.container = this.querySelector(this.containerSelector);
        this.template = this.querySelector(this.templateSelector);
        this.templateContent = (0, $aa19cdf2f552e6e0$export$d4e734980dda982f)(this.template);
        this.tabNames = [
            ...this.querySelectorAll(this.tabNameSelector)
        ];
        this.tabMap = this.generateTabMap();
    }
    connectedCallback() {
        this.tabNames.forEach((tabName)=>{
            tabName.addEventListener("keydown", this.handleKeyDown);
            tabName.addEventListener("click", this.handleTabNameClick);
        });
    }
    disconnectedCallback() {
        this.tabNames.forEach((tabName)=>{
            tabName.removeEventListener("keydown", this.handleKeyDown);
            tabName.removeEventListener("click", this.handleTabNameClick);
        });
    }
    generateTabMap() {
        const tabs = [
            this.querySelector(this.tabSelector),
            ...this.templateContent.querySelectorAll(this.tabSelector)
        ];
        const tabMap = tabs.reduce((map, tab)=>{
            const tabId = tab.dataset.id;
            return tabId ? {
                ...map,
                [tabId]: tab
            } : map;
        }, {});
        return tabMap;
    }
    selectTab(tabId) {
        this.updateNameById(tabId);
        this.setTabById(tabId);
        this.emit("selectTab", tabId);
    }
    unmountTab(tab) {
        tab.remove();
    }
    mountTab(tab) {
        if (!this.container) return;
        this.container.appendChild(tab);
    }
    updateNameById(tabId) {
        this.tabNames.forEach((tabName)=>{
            const isSelected = tabId === tabName.getAttribute("data-id");
            tabName.classList.toggle("selected", isSelected);
        });
    }
    setTabById(tabId) {
        const nextTab = this.tabMap[tabId];
        const currentTab = this.tabMap[this.dataset.selectedTabId];
        if (!currentTab || !nextTab) return;
        this.showNextTab(nextTab);
        if (currentTab !== nextTab) this.hideCurrentTab(currentTab);
    }
    showNextTab(tab) {
        const id = tab.getAttribute("data-id");
        if (id) {
            this.mountTab(tab);
            tab.show();
            this.dataset.selectedTabId = id;
        }
    }
    hideCurrentTab(tab) {
        tab.hide().then(()=>{
            this.unmountTab(tab);
        });
    }
}
var $732e7110f4e35980$export$2e2bcd8739ae039 = $732e7110f4e35980$var$Tabs;





class $c6ed359ffece050f$var$List extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.collapse = ()=>{
            this.hideItems();
            (0, $aa19cdf2f552e6e0$export$7669482c90f5c50f)(this.collapseBtn);
            (0, $aa19cdf2f552e6e0$export$998191bfdf710c72)(this.expandBtn);
        };
        this.expand = ()=>{
            if (!this.initialHeight) this.setInitialHeight();
            this.showItems();
            this.tryHideExpandBtn();
            (0, $aa19cdf2f552e6e0$export$998191bfdf710c72)(this.collapseBtn);
            this.setMaxHeight();
        };
        this.itemSelector = `[data-list-item]`;
        this.expandBtnSelector = `list-btn[data-trigger="expand"]`;
        this.collapseBtnSelector = `list-btn[data-trigger="collapse"]`;
        this.visibleItemSelector = `${this.itemSelector}:not(.hidden)`;
        this.hiddenItemSelector = `${this.itemSelector}.hidden`;
        this.expandBtn = this.querySelector(this.expandBtnSelector);
        this.collapseBtn = this.querySelector(this.collapseBtnSelector);
        this.styles = getComputedStyle(this);
    }
    setInitialHeight() {
        this.initialHeight = this.offsetHeight;
        this.style.maxHeight = `${this.initialHeight}px`;
    }
    setMaxHeight() {
        this.maxHeight = this.scrollHeight;
        this.style.maxHeight = `${this.maxHeight}px`;
    }
    hideItems() {
        const visibleItems = this.querySelectorAll(this.visibleItemSelector);
        this.style.maxHeight = `${this.initialHeight}px`;
        setTimeout(()=>{
            visibleItems.forEach((node, index)=>{
                const initialCount = this.dataset.initialCount ? +this.dataset.initialCount : 0;
                const isOverIntitialCount = index + 1 > +initialCount;
                if (isOverIntitialCount) (0, $aa19cdf2f552e6e0$export$7669482c90f5c50f)(node);
            });
        }, (0, $6de5ff37caa957d8$export$5faba83c1624a4ba)(this.styles));
    }
    showItems() {
        const hiddenItems = this.querySelectorAll(this.hiddenItemSelector);
        hiddenItems.forEach((node, index)=>{
            const showCount = this.dataset.showCount ? this.dataset.showCount : 0;
            const isLessShowCount = index + 1 < +showCount;
            if (isLessShowCount) (0, $aa19cdf2f552e6e0$export$998191bfdf710c72)(node);
        });
        this.style.maxHeight = `${this.maxHeight}px`;
    }
    tryHideExpandBtn() {
        const hiddenItems = this.querySelectorAll(this.hiddenItemSelector);
        if (hiddenItems.length === 0) (0, $aa19cdf2f552e6e0$export$7669482c90f5c50f)(this.expandBtn);
    }
}
var $c6ed359ffece050f$export$2e2bcd8739ae039 = $c6ed359ffece050f$var$List;




class $7f4718d930c61166$var$ListBtn extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    connectedCallback() {
        this.addEventListener("keydown", this.handleKeyDown);
        this.addEventListener("click", this.handleButtonClick);
    }
    disconnectedCallback() {
        this.removeEventListener("keydown", this.handleKeyDown);
        this.removeEventListener("click", this.handleButtonClick);
    }
    update() {
        const list = this.closest("list-component");
        if (!list) return;
        if (this.dataset.trigger === "collapse") list.collapse();
        else list.expand();
    }
    constructor(...args){
        super(...args);
        this.handleButtonClick = ()=>{
            this.update();
        };
        this.handleKeyDown = (event)=>{
            const isEnterKey = (0, $6de5ff37caa957d8$export$793b145c7f680179)(event.key || event.keyCode);
            if (isEnterKey) {
                event.preventDefault();
                this.update();
            }
        };
    }
}
var $7f4718d930c61166$export$2e2bcd8739ae039 = $7f4718d930c61166$var$ListBtn;



const $a7db348ae76c097f$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $a7db348ae76c097f$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $a7db348ae76c097f$export$803cd8101b6c182b = /*#__PURE__*/ $a7db348ae76c097f$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $a7db348ae76c097f$export$27b07d8a310ed8b5[0], side + "-" + $a7db348ae76c097f$export$27b07d8a310ed8b5[1]), []);
const $a7db348ae76c097f$export$96ec731ed4dcb222 = Math.min;
const $a7db348ae76c097f$export$8960430cfd85939f = Math.max;
const $a7db348ae76c097f$export$2077e0241d6afd3c = Math.round;
const $a7db348ae76c097f$export$a3fe094919f356fd = Math.floor;
const $a7db348ae76c097f$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $a7db348ae76c097f$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $a7db348ae76c097f$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $a7db348ae76c097f$export$7d15b64cf5a3a4c4(start, value, end) {
    return $a7db348ae76c097f$export$8960430cfd85939f(start, $a7db348ae76c097f$export$96ec731ed4dcb222(value, end));
}
function $a7db348ae76c097f$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $a7db348ae76c097f$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $a7db348ae76c097f$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $a7db348ae76c097f$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $a7db348ae76c097f$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $a7db348ae76c097f$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($a7db348ae76c097f$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $a7db348ae76c097f$export$2b57e0052a6d6d4c(placement) {
    return $a7db348ae76c097f$export$8a000a963141ac32($a7db348ae76c097f$export$f28e8f882010718a(placement));
}
function $a7db348ae76c097f$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $a7db348ae76c097f$export$f0989780f32bfcda(placement);
    const alignmentAxis = $a7db348ae76c097f$export$2b57e0052a6d6d4c(placement);
    const length = $a7db348ae76c097f$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $a7db348ae76c097f$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $a7db348ae76c097f$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $a7db348ae76c097f$export$496432a3699e50b1(placement) {
    const oppositePlacement = $a7db348ae76c097f$export$9c5e28bad23365fa(placement);
    return [
        $a7db348ae76c097f$export$2b182c584985588b(placement),
        oppositePlacement,
        $a7db348ae76c097f$export$2b182c584985588b(oppositePlacement)
    ];
}
function $a7db348ae76c097f$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$a7db348ae76c097f$var$oppositeAlignmentMap[alignment]);
}
function $a7db348ae76c097f$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $a7db348ae76c097f$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $a7db348ae76c097f$export$f0989780f32bfcda(placement);
    let list = $a7db348ae76c097f$var$getSideList($a7db348ae76c097f$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($a7db348ae76c097f$export$2b182c584985588b));
    }
    return list;
}
function $a7db348ae76c097f$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$a7db348ae76c097f$var$oppositeSideMap[side]);
}
function $a7db348ae76c097f$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $a7db348ae76c097f$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $a7db348ae76c097f$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $a7db348ae76c097f$export$ee05aea0aeecbad4(rect) {
    return {
        ...rect,
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    };
}


function $91121656e03b27e0$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $a7db348ae76c097f$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $a7db348ae76c097f$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $a7db348ae76c097f$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $a7db348ae76c097f$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $a7db348ae76c097f$export$f0989780f32bfcda)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $91121656e03b27e0$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $91121656e03b27e0$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $91121656e03b27e0$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
            continue;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $91121656e03b27e0$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $a7db348ae76c097f$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $a7db348ae76c097f$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $a7db348ae76c097f$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        ...rects.floating,
        x: x,
        y: y
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $a7db348ae76c097f$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $91121656e03b27e0$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $a7db348ae76c097f$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $a7db348ae76c097f$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $a7db348ae76c097f$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $a7db348ae76c097f$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $a7db348ae76c097f$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $a7db348ae76c097f$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $a7db348ae76c097f$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $a7db348ae76c097f$export$f0989780f32bfcda)(placement) != null && center != offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $91121656e03b27e0$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $a7db348ae76c097f$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $a7db348ae76c097f$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $a7db348ae76c097f$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $a7db348ae76c097f$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $a7db348ae76c097f$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $91121656e03b27e0$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $a7db348ae76c097f$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $a7db348ae76c097f$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $a7db348ae76c097f$export$803cd8101b6c182b) ? $91121656e03b27e0$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $91121656e03b27e0$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $a7db348ae76c097f$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $a7db348ae76c097f$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $a7db348ae76c097f$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $a7db348ae76c097f$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $91121656e03b27e0$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $a7db348ae76c097f$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $a7db348ae76c097f$export$3c915306cb7fc97a)(placement);
            const isBasePlacement = (0, $a7db348ae76c097f$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $a7db348ae76c097f$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $a7db348ae76c097f$export$496432a3699e50b1)(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") fallbackPlacements.push(...(0, $a7db348ae76c097f$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $91121656e03b27e0$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $a7db348ae76c097f$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $91121656e03b27e0$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $91121656e03b27e0$var$isAnySideFullyClipped(overflow) {
    return (0, $a7db348ae76c097f$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $91121656e03b27e0$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $a7db348ae76c097f$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $91121656e03b27e0$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $91121656e03b27e0$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $91121656e03b27e0$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $91121656e03b27e0$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $91121656e03b27e0$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $91121656e03b27e0$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $91121656e03b27e0$var$getBoundingRect(rects) {
    const minX = (0, $a7db348ae76c097f$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $a7db348ae76c097f$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $a7db348ae76c097f$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $a7db348ae76c097f$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $91121656e03b27e0$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $a7db348ae76c097f$export$ee05aea0aeecbad4)($91121656e03b27e0$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $91121656e03b27e0$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $a7db348ae76c097f$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $91121656e03b27e0$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $a7db348ae76c097f$export$ee05aea0aeecbad4)($91121656e03b27e0$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $a7db348ae76c097f$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $a7db348ae76c097f$export$f28e8f882010718a)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $a7db348ae76c097f$export$3c915306cb7fc97a)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $a7db348ae76c097f$export$3c915306cb7fc97a)(placement) === "left";
                    const maxRight = (0, $a7db348ae76c097f$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $a7db348ae76c097f$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $91121656e03b27e0$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $a7db348ae76c097f$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $a7db348ae76c097f$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $a7db348ae76c097f$export$f28e8f882010718a)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $a7db348ae76c097f$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $91121656e03b27e0$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            const { x: x, y: y } = state;
            const diffCoords = await $91121656e03b27e0$var$convertValueToCoords(state, options);
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: diffCoords
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $91121656e03b27e0$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $a7db348ae76c097f$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $91121656e03b27e0$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $a7db348ae76c097f$export$f28e8f882010718a)((0, $a7db348ae76c097f$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $a7db348ae76c097f$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $a7db348ae76c097f$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $a7db348ae76c097f$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $91121656e03b27e0$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $a7db348ae76c097f$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $a7db348ae76c097f$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $a7db348ae76c097f$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $a7db348ae76c097f$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $a7db348ae76c097f$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $91121656e03b27e0$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $a7db348ae76c097f$export$fef61f332f2c0afc)(options, state);
            const overflow = await $91121656e03b27e0$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $a7db348ae76c097f$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $a7db348ae76c097f$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $a7db348ae76c097f$export$f28e8f882010718a)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const overflowAvailableHeight = height - overflow[heightSide];
            const overflowAvailableWidth = width - overflow[widthSide];
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) {
                const maximumClippingWidth = width - overflow.left - overflow.right;
                availableWidth = alignment || noShift ? (0, $a7db348ae76c097f$export$96ec731ed4dcb222)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            } else {
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                availableHeight = alignment || noShift ? (0, $a7db348ae76c097f$export$96ec731ed4dcb222)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            }
            if (noShift && !alignment) {
                const xMin = (0, $a7db348ae76c097f$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $a7db348ae76c097f$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $a7db348ae76c097f$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $a7db348ae76c097f$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $a7db348ae76c097f$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $a7db348ae76c097f$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $0031a7123259df2e$export$651544f548703224(node) {
    if ($0031a7123259df2e$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $0031a7123259df2e$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null ? void 0 : (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $0031a7123259df2e$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($0031a7123259df2e$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $0031a7123259df2e$export$8ee0fc9ee280b4ee(value) {
    return value instanceof Node || value instanceof $0031a7123259df2e$export$38b2d434cce3ea22(value).Node;
}
function $0031a7123259df2e$export$45a5e7f76e0caa8d(value) {
    return value instanceof Element || value instanceof $0031a7123259df2e$export$38b2d434cce3ea22(value).Element;
}
function $0031a7123259df2e$export$1b3bfaa9684536aa(value) {
    return value instanceof HTMLElement || value instanceof $0031a7123259df2e$export$38b2d434cce3ea22(value).HTMLElement;
}
function $0031a7123259df2e$export$af51f0f06c0f328a(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $0031a7123259df2e$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $0031a7123259df2e$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $0031a7123259df2e$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $0031a7123259df2e$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($0031a7123259df2e$export$651544f548703224(element));
}
function $0031a7123259df2e$export$d6c4e8150c35fed1(element) {
    const webkit = $0031a7123259df2e$export$78551043582a6a98();
    const css = $0031a7123259df2e$export$3735103072e4a80(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $0031a7123259df2e$export$940d8225183e1404(element) {
    let currentNode = $0031a7123259df2e$export$4e12058fc4d51d56(element);
    while($0031a7123259df2e$export$1b3bfaa9684536aa(currentNode) && !$0031a7123259df2e$export$d1162fb0b6d4cd51(currentNode)){
        if ($0031a7123259df2e$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else currentNode = $0031a7123259df2e$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $0031a7123259df2e$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $0031a7123259df2e$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($0031a7123259df2e$export$651544f548703224(node));
}
function $0031a7123259df2e$export$3735103072e4a80(element) {
    return $0031a7123259df2e$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $0031a7123259df2e$export$dc8fc79fa2800137(element) {
    if ($0031a7123259df2e$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $0031a7123259df2e$export$4e12058fc4d51d56(node) {
    if ($0031a7123259df2e$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $0031a7123259df2e$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $0031a7123259df2e$export$e495491855dc5418(node);
    return $0031a7123259df2e$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $0031a7123259df2e$export$7cd01a57c8ca906c(node) {
    const parentNode = $0031a7123259df2e$export$4e12058fc4d51d56(node);
    if ($0031a7123259df2e$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($0031a7123259df2e$export$1b3bfaa9684536aa(parentNode) && $0031a7123259df2e$export$989e911fa9af580a(parentNode)) return parentNode;
    return $0031a7123259df2e$export$7cd01a57c8ca906c(parentNode);
}
function $0031a7123259df2e$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $0031a7123259df2e$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $0031a7123259df2e$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $0031a7123259df2e$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? $0031a7123259df2e$export$3b57c1601291186b(win.frameElement) : []);
    return list.concat(scrollableAncestor, $0031a7123259df2e$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}


function $d9c5c13022e8d55b$var$getCssDimensions(element) {
    const css = (0, $0031a7123259df2e$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $0031a7123259df2e$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $a7db348ae76c097f$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $a7db348ae76c097f$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $d9c5c13022e8d55b$var$unwrapElement(element) {
    return !(0, $0031a7123259df2e$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $d9c5c13022e8d55b$var$getScale(element) {
    const domElement = $d9c5c13022e8d55b$var$unwrapElement(element);
    if (!(0, $0031a7123259df2e$export$1b3bfaa9684536aa)(domElement)) return (0, $a7db348ae76c097f$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $d9c5c13022e8d55b$var$getCssDimensions(domElement);
    let x = ($ ? (0, $a7db348ae76c097f$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $a7db348ae76c097f$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $d9c5c13022e8d55b$var$noOffsets = /*#__PURE__*/ (0, $a7db348ae76c097f$export$a397704b5e280835)(0);
function $d9c5c13022e8d55b$var$getVisualOffsets(element) {
    const win = (0, $0031a7123259df2e$export$38b2d434cce3ea22)(element);
    if (!(0, $0031a7123259df2e$export$78551043582a6a98)() || !win.visualViewport) return $d9c5c13022e8d55b$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $d9c5c13022e8d55b$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $0031a7123259df2e$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $d9c5c13022e8d55b$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $d9c5c13022e8d55b$var$unwrapElement(element);
    let scale = (0, $a7db348ae76c097f$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $0031a7123259df2e$export$45a5e7f76e0caa8d)(offsetParent)) scale = $d9c5c13022e8d55b$var$getScale(offsetParent);
        } else scale = $d9c5c13022e8d55b$var$getScale(element);
    }
    const visualOffsets = $d9c5c13022e8d55b$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $d9c5c13022e8d55b$var$getVisualOffsets(domElement) : (0, $a7db348ae76c097f$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $0031a7123259df2e$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $0031a7123259df2e$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $0031a7123259df2e$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentIFrame = win.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== win){
            const iframeScale = $d9c5c13022e8d55b$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $0031a7123259df2e$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentIFrame = (0, $0031a7123259df2e$export$38b2d434cce3ea22)(currentIFrame).frameElement;
        }
    }
    return (0, $a7db348ae76c097f$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $d9c5c13022e8d55b$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isOffsetParentAnElement = (0, $0031a7123259df2e$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $0031a7123259df2e$export$e495491855dc5418)(offsetParent);
    if (offsetParent === documentElement) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $a7db348ae76c097f$export$a397704b5e280835)(1);
    const offsets = (0, $a7db348ae76c097f$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
        if ((0, $0031a7123259df2e$export$651544f548703224)(offsetParent) !== "body" || (0, $0031a7123259df2e$export$989e911fa9af580a)(documentElement)) scroll = (0, $0031a7123259df2e$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $0031a7123259df2e$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $d9c5c13022e8d55b$var$getBoundingClientRect(offsetParent);
            scale = $d9c5c13022e8d55b$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $d9c5c13022e8d55b$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $d9c5c13022e8d55b$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $d9c5c13022e8d55b$var$getBoundingClientRect((0, $0031a7123259df2e$export$e495491855dc5418)(element)).left + (0, $0031a7123259df2e$export$dc8fc79fa2800137)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $d9c5c13022e8d55b$var$getDocumentRect(element) {
    const html = (0, $0031a7123259df2e$export$e495491855dc5418)(element);
    const scroll = (0, $0031a7123259df2e$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $a7db348ae76c097f$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $a7db348ae76c097f$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $d9c5c13022e8d55b$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $0031a7123259df2e$export$3735103072e4a80)(body).direction === "rtl") x += (0, $a7db348ae76c097f$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $d9c5c13022e8d55b$var$getViewportRect(element, strategy) {
    const win = (0, $0031a7123259df2e$export$38b2d434cce3ea22)(element);
    const html = (0, $0031a7123259df2e$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $0031a7123259df2e$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $d9c5c13022e8d55b$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $d9c5c13022e8d55b$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $0031a7123259df2e$export$1b3bfaa9684536aa)(element) ? $d9c5c13022e8d55b$var$getScale(element) : (0, $a7db348ae76c097f$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $d9c5c13022e8d55b$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $d9c5c13022e8d55b$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $d9c5c13022e8d55b$var$getDocumentRect((0, $0031a7123259df2e$export$e495491855dc5418)(element));
    else if ((0, $0031a7123259df2e$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $d9c5c13022e8d55b$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $d9c5c13022e8d55b$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $a7db348ae76c097f$export$ee05aea0aeecbad4)(rect);
}
function $d9c5c13022e8d55b$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $0031a7123259df2e$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $0031a7123259df2e$export$45a5e7f76e0caa8d)(parentNode) || (0, $0031a7123259df2e$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $0031a7123259df2e$export$3735103072e4a80)(parentNode).position === "fixed" || $d9c5c13022e8d55b$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $d9c5c13022e8d55b$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $0031a7123259df2e$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $0031a7123259df2e$export$45a5e7f76e0caa8d)(el) && (0, $0031a7123259df2e$export$651544f548703224)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $0031a7123259df2e$export$3735103072e4a80)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $0031a7123259df2e$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $0031a7123259df2e$export$45a5e7f76e0caa8d)(currentNode) && !(0, $0031a7123259df2e$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $0031a7123259df2e$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $0031a7123259df2e$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $0031a7123259df2e$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $d9c5c13022e8d55b$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $0031a7123259df2e$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $d9c5c13022e8d55b$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? $d9c5c13022e8d55b$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $d9c5c13022e8d55b$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $a7db348ae76c097f$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $a7db348ae76c097f$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $a7db348ae76c097f$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $a7db348ae76c097f$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $d9c5c13022e8d55b$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $d9c5c13022e8d55b$var$getDimensions(element) {
    return $d9c5c13022e8d55b$var$getCssDimensions(element);
}
function $d9c5c13022e8d55b$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $0031a7123259df2e$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $0031a7123259df2e$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $d9c5c13022e8d55b$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $a7db348ae76c097f$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $0031a7123259df2e$export$651544f548703224)(offsetParent) !== "body" || (0, $0031a7123259df2e$export$989e911fa9af580a)(documentElement)) scroll = (0, $0031a7123259df2e$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $d9c5c13022e8d55b$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $d9c5c13022e8d55b$var$getWindowScrollBarX(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}
function $d9c5c13022e8d55b$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $0031a7123259df2e$export$1b3bfaa9684536aa)(element) || (0, $0031a7123259df2e$export$3735103072e4a80)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $d9c5c13022e8d55b$var$getOffsetParent(element, polyfill) {
    const window = (0, $0031a7123259df2e$export$38b2d434cce3ea22)(element);
    if (!(0, $0031a7123259df2e$export$1b3bfaa9684536aa)(element)) return window;
    let offsetParent = $d9c5c13022e8d55b$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $0031a7123259df2e$export$71535ffaa902797f)(offsetParent) && (0, $0031a7123259df2e$export$3735103072e4a80)(offsetParent).position === "static")offsetParent = $d9c5c13022e8d55b$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && ((0, $0031a7123259df2e$export$651544f548703224)(offsetParent) === "html" || (0, $0031a7123259df2e$export$651544f548703224)(offsetParent) === "body" && (0, $0031a7123259df2e$export$3735103072e4a80)(offsetParent).position === "static" && !(0, $0031a7123259df2e$export$d6c4e8150c35fed1)(offsetParent))) return window;
    return offsetParent || (0, $0031a7123259df2e$export$940d8225183e1404)(element) || window;
}
const $d9c5c13022e8d55b$var$getElementRects = async function(_ref) {
    let { reference: reference, floating: floating, strategy: strategy } = _ref;
    const getOffsetParentFn = this.getOffsetParent || $d9c5c13022e8d55b$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    return {
        reference: $d9c5c13022e8d55b$var$getRectRelativeToOffsetParent(reference, await getOffsetParentFn(floating), strategy),
        floating: {
            x: 0,
            y: 0,
            ...await getDimensionsFn(floating)
        }
    };
};
function $d9c5c13022e8d55b$var$isRTL(element) {
    return (0, $0031a7123259df2e$export$3735103072e4a80)(element).direction === "rtl";
}
const $d9c5c13022e8d55b$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $d9c5c13022e8d55b$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $0031a7123259df2e$export$e495491855dc5418,
    getClippingRect: $d9c5c13022e8d55b$var$getClippingRect,
    getOffsetParent: $d9c5c13022e8d55b$var$getOffsetParent,
    getElementRects: $d9c5c13022e8d55b$var$getElementRects,
    getClientRects: $d9c5c13022e8d55b$var$getClientRects,
    getDimensions: $d9c5c13022e8d55b$var$getDimensions,
    getScale: $d9c5c13022e8d55b$var$getScale,
    isElement: $0031a7123259df2e$export$45a5e7f76e0caa8d,
    isRTL: $d9c5c13022e8d55b$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $d9c5c13022e8d55b$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $0031a7123259df2e$export$e495491855dc5418)(element);
    function cleanup() {
        clearTimeout(timeoutId);
        io && io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $a7db348ae76c097f$export$a3fe094919f356fd)(top);
        const insetRight = (0, $a7db348ae76c097f$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $a7db348ae76c097f$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $a7db348ae76c097f$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $a7db348ae76c097f$export$8960430cfd85939f)(0, (0, $a7db348ae76c097f$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 100);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $d9c5c13022e8d55b$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $d9c5c13022e8d55b$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $0031a7123259df2e$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $0031a7123259df2e$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $d9c5c13022e8d55b$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    resizeObserver && resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $d9c5c13022e8d55b$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $d9c5c13022e8d55b$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo && cleanupIo();
        resizeObserver && resizeObserver.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain CSS positioning
 * strategy.
 */ const $d9c5c13022e8d55b$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $d9c5c13022e8d55b$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $91121656e03b27e0$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};




class $ba8d1d53d2559b59$var$ProductBreadcrumbs extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.setCollectionPage = (collectionPage)=>{
            if (collectionPage) {
                const data = JSON.parse(collectionPage);
                if (this.collectionLink) {
                    this.collectionLink.href = data.url;
                    this.collectionLink.ariaLabel = data.title;
                    this.collectionLink.textContent = data.title;
                }
            }
        };
        this.collectionLink = this.querySelector("[data-collection-link]");
    }
}
var $ba8d1d53d2559b59$export$2e2bcd8739ae039 = $ba8d1d53d2559b59$var$ProductBreadcrumbs;


class $2baf4cc1d12f378d$var$Notification {
    constructor(element){
        this.notification = element;
    }
    show(text, variant, duration = 3000) {
        this.notification.show(text, variant, duration);
    }
}
var $2baf4cc1d12f378d$export$2e2bcd8739ae039 = $2baf4cc1d12f378d$var$Notification;



class $339187790c656b4d$var$BodyElement {
    constructor(){
        this.handleWindowScroll = ()=>{
            if (this.timeoutScrollId) {
                clearTimeout(this.timeoutScrollId);
                this.isScrolling = true;
            }
            this.timeoutScrollId = setTimeout(()=>{
                this.isScrolling = false;
            }, 300);
        };
        this.setBreadcrumbs = ()=>{
            const breadcrumbsElements = document.querySelectorAll("product-breadcrumbs");
            if (breadcrumbsElements.length) {
                const prevCollectionPage = localStorage.getItem("prevCollectionPage");
                breadcrumbsElements.forEach((el)=>{
                    el.setCollectionPage(prevCollectionPage);
                });
                localStorage.removeItem("prevCollectionPage");
            }
        };
        this.showRegistrationMessage = ()=>{
            const message = window.auroraThemeLocales.registrationMessage;
            const visibilityDuration = 10000;
            customElements.whenDefined("notification-component").then(()=>{
                this.notification.show(message, "success", visibilityDuration);
                localStorage.removeItem("isRegistered");
            });
        };
        this.handleLinkOver = (event)=>{
            const link = event.target?.closest("a[href]");
            const href = link?.href;
            if (!href) return;
            const wasPrefetched = this.prefetchedLinks.includes(href);
            const isNotPrefetchetable = (0, $6de5ff37caa957d8$export$b98882f166bb7ce2)(href) || (0, $6de5ff37caa957d8$export$47667ecde0defde2)(href);
            if (wasPrefetched || isNotPrefetchetable) return;
            (0, $6de5ff37caa957d8$export$1229dd75ca8729a7)(href);
            this.prefetchedLinks.push(href);
        };
        const notificationElement = document.getElementById("GlobalNotification");
        if (notificationElement) this.notification = new (0, $2baf4cc1d12f378d$export$2e2bcd8739ae039)(notificationElement);
        this.isScrolling = false;
        this.overlayId = "BodyOverlay";
        window.addEventListener("wheel", this.handleWindowScroll);
        this.overlayCalls = [];
        if (window.location.pathname.includes("products")) {
            customElements.define("product-breadcrumbs", (0, $ba8d1d53d2559b59$export$2e2bcd8739ae039));
            this.setBreadcrumbs();
        }
        const isCaptchaPage = window.location.pathname.includes("challenge");
        const isAccountPage = window.location.pathname.includes("account");
        if (!isCaptchaPage && !isAccountPage) {
            if (localStorage.getItem("isRegistered")) this.showRegistrationMessage();
        }
        this.prefetchedLinks = [];
        document.addEventListener("mouseover", this.handleLinkOver);
    }
    showOverlay(key, styles) {
        const defaultStyles = {
            zIndex: 3,
            backgroundColor: "var(--gsc-black-color-50)"
        };
        const bodyOverlay = document.getElementById(this.overlayId);
        if (!bodyOverlay) return;
        this.overlayCalls = [
            ...this.overlayCalls,
            {
                key: key,
                styles: styles
            }
        ];
        this.setBodyOverlayStyles({
            ...defaultStyles,
            ...styles
        });
        bodyOverlay.setAttribute("visible", "");
        this.setScrollLock();
    }
    hideOverlay(key) {
        const bodyOverlay = document.getElementById(this.overlayId);
        if (!bodyOverlay) return;
        const isVisible = bodyOverlay.hasAttribute("visible");
        if (!isVisible) return;
        this.overlayCalls = this.overlayCalls.filter((overlayCall)=>overlayCall.key !== key);
        const lastCall = this.overlayCalls[this.overlayCalls.length - 1];
        if (lastCall) this.setBodyOverlayStyles(lastCall.styles);
        else {
            bodyOverlay.removeAttribute("visible");
            bodyOverlay.setAttribute("style", "");
            this.unsetScrollLock();
        }
    }
    setScrollLock() {
        document.body.style.top = `-${window.scrollY || Math.abs(parseInt(document.body.style.top || "0"))}px`;
        document.body.setAttribute("scroll-y-off", "");
    }
    unsetScrollLock() {
        const scrollY = document.body.style.top;
        document.body.removeAttribute("scroll-y-off");
        document.body.style.top = "";
        window.scrollTo(0, parseInt(scrollY || "0") * -1);
    }
    setBodyOverlayStyles(styles) {
        const bodyOverlay = document.getElementById(this.overlayId);
        if (!bodyOverlay) return;
        if (styles) {
            const styleKeyList = Object.keys(styles);
            styleKeyList.forEach((key)=>{
                bodyOverlay.style[key] = styles[key];
            });
        }
    }
    get isFixed() {
        return document.body.hasAttribute("scroll-y-off");
    }
}
const $339187790c656b4d$export$e1122b4c4bd5b838 = new $339187790c656b4d$var$BodyElement();



class $0d174bbf17ec5209$var$FloatElement extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleScroll = ()=>{
            if (this.type === "tooltip") {
                this.hide();
                window.removeEventListener("wheel", this.handleScroll);
            }
        };
        this.handleBlockSelect = (event)=>{
            if (this.dataset.sectionId === event.detail.sectionId) {
                const target = this.element.querySelector(`[block-id="${event.detail.blockId}"]`);
                const blockId = this.getAttribute("block-id");
                const isTargetBlock = blockId === event.detail.blockId || target;
                if (!isTargetBlock) return;
                if (this.btn) this.btn.trigger();
                else this.hide();
            }
        };
        this.handleBlockDeselect = (event)=>{
            if (this.dataset.sectionId === event.detail.sectionId) {
                const target = this.element.querySelector(`[block-id="${event.detail.blockId}"]`);
                const blockId = this.getAttribute("block-id");
                const isTargetBlock = blockId === event.detail.blockId || target;
                if (!isTargetBlock) return;
                this.hide();
            }
        };
        this.init = ()=>{
            const floatingElement = document.getElementById(this.dataset.floatingElementId) || this.btn;
            if (!floatingElement) return;
            (0, $d9c5c13022e8d55b$export$deee3a793edee05f)(floatingElement, this, ()=>{
                (0, $d9c5c13022e8d55b$export$48a53dcb22e581d0)(floatingElement, this, this.getOptions()).then((data)=>{
                    if (this.dataset.placement !== data.placement) this.dataset.placement = data.placement;
                    this.updatePosition(data);
                    if (this.arrow) this.updateArrow(data);
                });
            });
        };
        this.show = ()=>{
            if (this.type === "tooltip" && (0, $339187790c656b4d$export$e1122b4c4bd5b838).isScrolling) return;
            const videos = this.element.querySelectorAll("video");
            videos.forEach((video)=>{
                video.play();
            });
            this.mount();
            this.setVisible(true);
            this.emit("show", {});
            window.addEventListener("wheel", this.handleScroll);
        };
        this.hide = ()=>{
            if (!this.isOpen) return;
            this.setVisible(false);
            this.unmount();
            this.emit("hide", {});
            this.dataset.placement = this.initialPlacement;
        };
        this.withOverlay = this.hasAttribute("data-with-overlay");
        const template = this.querySelector(`[data-float-element-template="${this.id}"]`);
        this.element = (0, $aa19cdf2f552e6e0$export$8ea4fc17cec6f158)(template);
        this.arrow = this.element.querySelector("[data-float-element-arrow]");
        this.withPortal = this.hasAttribute("with-portal");
        this.initialPlacement = this.dataset.placement;
        if (this.withPortal) (0, $6de5ff37caa957d8$export$d39a5bbd09211389)(this);
    }
    connectedCallback() {
        this.init();
        if (this.isEditorMode) {
            this.editor.subscribe("BLOCK_SELECT", this.handleBlockSelect);
            this.editor.subscribe("BLOCK_DESELECT", this.handleBlockDeselect);
        }
    }
    disconnectedCallback() {
        if (this.isEditorMode) this.editor.destroy();
        window.removeEventListener("wheel", this.handleScroll);
    }
    updatePosition({ x: x, y: y }) {
        Object.assign(this.style, {
            left: `${x}px`,
            top: `${y}px`
        });
    }
    getOptions() {
        return {
            placement: this.dataset.placement,
            middleware: this.getMiddleware(),
            strategy: this.strategy
        };
    }
    getMiddleware() {
        const alignmentAxis = this.dataset.alignmentAxisOffset || 0;
        const mainAxis = this.dataset.mainAxisOffset || 0;
        const middleware = [
            (0, $91121656e03b27e0$export$cc800923e997bb8)({
                alignmentAxis: +alignmentAxis,
                mainAxis: +mainAxis
            }),
            (0, $91121656e03b27e0$export$8a83211c878a3f1f)(),
            (0, $91121656e03b27e0$export$fba63a578e423eb)()
        ];
        if (this.arrow) middleware.push((0, $91121656e03b27e0$export$f2120bbfa5450bd2)({
            element: this.arrow
        }));
        return middleware;
    }
    checkCursorOutside(x, y) {
        const mainAxisOffset = this.dataset.mainAxisOffset || 0;
        const offset = +mainAxisOffset;
        const interactiveBorder = 2;
        const boundaries = this.getBoundingClientRect();
        const exceedsTop = boundaries.top - (y + offset) > interactiveBorder;
        const exceedsBottom = y - boundaries.bottom - offset > interactiveBorder;
        const exceedsLeft = boundaries.left - (x + offset) > interactiveBorder;
        const exceedsRight = x - boundaries.right - offset > interactiveBorder;
        return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
    }
    updateArrow({ placement: placement, middlewareData: middlewareData }) {
        if (!this.arrow) return;
        const { x: arrowX, y: arrowY } = middlewareData.arrow;
        const staticSide = {
            top: "bottom",
            right: "left",
            bottom: "top",
            left: "right"
        }[placement.split("-")[0]];
        Object.assign(this.arrow.style, {
            left: arrowX != null ? `${arrowX}px` : "",
            top: arrowY != null ? `${arrowY}px` : "",
            right: "",
            bottom: "",
            [staticSide]: "-5px"
        });
    }
    mount() {
        if (!this.contains(this.element)) this.appendChild(this.element);
    }
    unmount() {
        if (this.isOpen && this.withOverlay) (0, $339187790c656b4d$export$e1122b4c4bd5b838).hideOverlay(this.id);
        if (this.element) this.element.remove();
    }
    setVisible(isVisible) {
        this.setAttribute("aria-hidden", isVisible ? "false" : "true");
        if (this.btn) this.btn.setExpand(isVisible);
        if (this.withOverlay) {
            const withBlur = this.hasAttribute("data-overlay-with-blur");
            const styles = {
                backdropFilter: withBlur ? `blur(16.5px)` : "none"
            };
            this.isOpen ? (0, $339187790c656b4d$export$e1122b4c4bd5b838).showOverlay(this.id, styles) : (0, $339187790c656b4d$export$e1122b4c4bd5b838).hideOverlay(this.id);
        }
    }
    get btn() {
        return document.querySelector(`[data-float-element-id="${this.id}"], [data-tooltip-id="${this.id}"]`);
    }
    get isOpen() {
        return this.getAttribute("aria-hidden") === "false";
    }
    get strategy() {
        return this.dataset.strategy || "absolute";
    }
    get type() {
        return this.dataset.type;
    }
}
var $0d174bbf17ec5209$export$2e2bcd8739ae039 = $0d174bbf17ec5209$var$FloatElement;





const $e044e520ef36250c$var$isPointInPolygon = (point, polygon)=>{
    const [x, y] = point;
    let isInside = false;
    const length = polygon.length;
    for(let i = 0, j = length - 1; i < length; j = i++){
        const [xi, yi] = polygon[i] || [
            0,
            0
        ];
        const [xj, yj] = polygon[j] || [
            0,
            0
        ];
        const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
    }
    return isInside;
};
const $e044e520ef36250c$var$svgNs = "http://www.w3.org/2000/svg";
const $e044e520ef36250c$var$contains = (parent, child)=>{
    if (!parent || !child) return false;
    return parent.contains(child);
};
const $e044e520ef36250c$var$isElement = (value)=>{
    return value ? value instanceof (document.defaultView || window).Element : false;
};
const $e044e520ef36250c$var$createPolygonElement = (points, isRect)=>{
    const addVisualOffsets = (0, $6de5ff37caa957d8$export$95df08bae54cb4df)();
    const win = document.defaultView || window;
    const svg = document.createElementNS($e044e520ef36250c$var$svgNs, "svg");
    Object.assign(svg.style, {
        position: "fixed",
        left: `${addVisualOffsets ? win.visualViewport?.offsetLeft || 0 : 0}px`,
        top: `${addVisualOffsets ? win.visualViewport?.offsetTop || 0 : 0}px`,
        width: "100%",
        height: "100%",
        pointerEvents: "none",
        zIndex: 2147483647
    });
    svg.setAttribute("data-type", isRect ? "rect" : "triangle");
    const polygon = document.createElementNS($e044e520ef36250c$var$svgNs, "polygon");
    polygon.setAttribute("points", points.map(([x, y])=>`${x},${y}`).join(" "));
    Object.assign(polygon.style, {
        pointerEvents: "auto",
        fill: "transparent",
        opacity: 0
    });
    svg.appendChild(polygon);
    return svg;
};
const $e044e520ef36250c$export$ada5ccdc621e6e28 = (polygonRef)=>{
    if (polygonRef.current) {
        polygonRef.current.remove();
        polygonRef.current = null;
    }
};
const $e044e520ef36250c$export$7484214ab62358d2 = ({ restMs: restMs = 0, buffer: buffer = 0.5, blockPointerEvents: blockPointerEvents = true } = {})=>{
    let timeoutId;
    let isInsideRect = false;
    let hasLanded = false;
    const fn = ({ x: x, y: y, placement: placement, elements: elements, onClose: onClose, polygonRef: polygonRef })=>{
        return (event)=>{
            const close = ()=>{
                $e044e520ef36250c$export$ada5ccdc621e6e28(polygonRef);
                clearTimeout(timeoutId);
                onClose();
            };
            clearTimeout(timeoutId);
            if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) return;
            const { clientX: clientX, clientY: clientY } = event;
            const target = event.target;
            const isLeave = event.type === "mouseleave";
            const isOverReference = $e044e520ef36250c$var$contains(elements.domReference, target);
            const isOverFloating = $e044e520ef36250c$var$contains(elements.floating, target);
            if (!isLeave && isOverReference) {
                $e044e520ef36250c$export$ada5ccdc621e6e28(polygonRef);
                return;
            }
            if (!isLeave && (isOverReference || isInsideRect && $e044e520ef36250c$var$contains(polygonRef.current, target))) return;
            // Prevent overlapping floating element from being stuck in an open-close
            // loop: https://github.com/floating-ui/floating-ui/issues/1910
            if (isLeave && $e044e520ef36250c$var$isElement(event.relatedTarget) && $e044e520ef36250c$var$contains(elements.floating, event.relatedTarget)) return;
            // If any nested child is open, abort.
            const hasOpenedChildren = elements.floating.querySelector('float-element[aria-hidden="false"]');
            if (hasOpenedChildren) return;
            if (isOverFloating) hasLanded = true;
            // The cursor landed, so we destroy the polygon logic
            if (isOverFloating && !isLeave && polygonRef.current?.dataset.type !== "rect") {
                $e044e520ef36250c$export$ada5ccdc621e6e28(polygonRef);
                return;
            }
            const refRect = elements.domReference.getBoundingClientRect();
            const rect = elements.floating.getBoundingClientRect();
            const side = placement.split("-")[0];
            const cursorLeaveFromRight = x > rect.right - rect.width / 2;
            const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
            // If the pointer is leaving from the opposite side, the "buffer" logic
            // creates a point where the floating element remains open, but should be
            // ignored.
            // A constant of 1 handles floating point rounding errors.
            if (side === "top" && y >= refRect.bottom - 1 || side === "bottom" && y <= refRect.top + 1 || side === "left" && x >= refRect.right - 1 || side === "right" && x <= refRect.left + 1) return close();
            // Ignore when the cursor is within the rectangular trough between the
            // two elements. Since the triangle is created from the cursor point,
            // which can start beyond the ref element's edge, traversing back and
            // forth from the ref to the floating element can cause it to close. This
            // ensures it always remains open in that case.
            let rectPoly = [];
            switch(side){
                case "top":
                    rectPoly = [
                        [
                            rect.left,
                            refRect.top + 1
                        ],
                        [
                            rect.left,
                            rect.bottom - 1
                        ],
                        [
                            rect.right,
                            rect.bottom - 1
                        ],
                        [
                            rect.right,
                            refRect.top + 1
                        ]
                    ];
                    isInsideRect = clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= refRect.top + 1;
                    break;
                case "bottom":
                    rectPoly = [
                        [
                            rect.left,
                            rect.top + 1
                        ],
                        [
                            rect.left,
                            refRect.bottom - 1
                        ],
                        [
                            rect.right,
                            refRect.bottom - 1
                        ],
                        [
                            rect.right,
                            rect.top + 1
                        ]
                    ];
                    isInsideRect = clientX >= rect.left && clientX <= rect.right && clientY >= refRect.bottom - 1 && clientY <= rect.bottom;
                    break;
                case "left":
                    rectPoly = [
                        [
                            rect.right - 1,
                            rect.bottom
                        ],
                        [
                            rect.right - 1,
                            rect.top
                        ],
                        [
                            refRect.left + 1,
                            rect.top
                        ],
                        [
                            refRect.left + 1,
                            rect.bottom
                        ]
                    ];
                    isInsideRect = clientX >= rect.left && clientX <= refRect.left + 1 && clientY >= rect.top && clientY <= rect.bottom;
                    break;
                case "right":
                    rectPoly = [
                        [
                            refRect.right - 1,
                            rect.bottom
                        ],
                        [
                            refRect.right - 1,
                            rect.top
                        ],
                        [
                            rect.left + 1,
                            rect.top
                        ],
                        [
                            rect.left + 1,
                            rect.bottom
                        ]
                    ];
                    isInsideRect = clientX >= refRect.right - 1 && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom;
                    break;
            }
            const getPolygon = ([x, y])=>{
                const isFloatingWider = rect.width > refRect.width;
                const isFloatingTaller = rect.height > refRect.height;
                switch(side){
                    case "top":
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case "bottom":
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case "left":
                        {
                            const cursorPointOne = [
                                x + buffer + 1,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x + buffer + 1,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                ...commonPoints,
                                cursorPointOne,
                                cursorPointTwo
                            ];
                        }
                    case "right":
                        {
                            const cursorPointOne = [
                                x - buffer,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x - buffer,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                }
            };
            const poly = isInsideRect ? rectPoly : getPolygon([
                x,
                y
            ]);
            if (!polygonRef.current && blockPointerEvents && isLeave) {
                polygonRef.current = $e044e520ef36250c$var$createPolygonElement(poly, isInsideRect);
                document.body.appendChild(polygonRef.current);
            }
            if (isInsideRect) return;
            if (!$e044e520ef36250c$var$isPointInPolygon([
                clientX,
                clientY
            ], poly)) close();
            else if (restMs && !hasLanded) timeoutId = setTimeout(onClose, restMs);
        };
    };
    return fn;
};


class $b787065192d2690f$var$FloatElementBtn extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleBlur = ()=>{
            this.blurElementTimeoutId = setTimeout(()=>{
                if (!this.floatElement) return;
            // this.floatElement.hide() need refactoring whole component, bad work with click
            }, 0);
        };
        this.handleKeyUp = (evt)=>{
            const key = evt.key || evt.keyCode;
            if (!key && !(0, $6de5ff37caa957d8$export$c7f540582081fbb7)(key)) return;
            this.floatElement.show();
            this.setTargetListeners("add");
        };
        this.handleFirstTargetFocus = ()=>{
            clearTimeout(this.blurElementTimeoutId);
        };
        this.handleTargetFocus = ()=>{
            clearTimeout(this.blurLastTargetTimeoutId);
        };
        this.handleLastTargetBlur = ()=>{
            this.blurLastTargetTimeoutId = setTimeout(()=>{
                this.setTargetListeners("remove");
                this.floatElement.hide();
            }, 0);
        };
        this.handleMouseEnter = ()=>{
            this.mouseenterTimeout = setTimeout(()=>{
                this.trigger();
            }, 0);
        };
        this.handleElementClick = ()=>{
            this.trigger();
        };
        this.handleWindowClick = (event)=>{
            const isCursorOutside = this.floatElement.checkCursorOutside(event.clientX, event.clientX);
            const isOutsideFloatElements = this.isTargetOutsideFloatElements(event.target);
            if (isCursorOutside && isOutsideFloatElements) {
                window.removeEventListener("click", this.handleWindowClick);
                this.floatElement.hide();
            }
        };
        this.handleMouseLeave = (event)=>{
            clearTimeout(this.mouseenterTimeout);
            if (this.safePolygonFn) window.removeEventListener("mousemove", this.handleMouseMove);
            this.safePolygonFn = (0, $e044e520ef36250c$export$7484214ab62358d2)()({
                x: event.clientX,
                y: event.clientY,
                placement: this.floatElement.dataset.placement,
                onClose: ()=>{
                    window.removeEventListener("mousemove", this.handleMouseMove);
                    if (this.floatElement) this.floatElement.hide();
                    (0, $e044e520ef36250c$export$ada5ccdc621e6e28)(this.polygonRef);
                },
                elements: {
                    domReference: this.element,
                    floating: this.floatElement
                },
                polygonRef: this.polygonRef
            });
            this.safePolygonFn(event);
            window.addEventListener("mousemove", this.handleMouseMove);
        };
        this.handleMouseMove = (event)=>{
            this.safePolygonFn(event);
        };
        this.trigger = ()=>{
            if (this.triggerAction === "click") {
                this.floatElement.isOpen ? this.floatElement.hide() : this.floatElement.show();
                window.addEventListener("click", this.handleWindowClick);
            } else {
                this.floatElement.show();
                this.element.addEventListener("mouseleave", this.handleMouseLeave);
            }
        };
        this.triggerAction = this.dataset.trigger === "click" ? "click" : "mouseenter";
        this.element = this.getElement();
        this.polygonRef = {
            current: null
        };
    }
    connectedCallback() {
        this.element.addEventListener("keyup", this.handleKeyUp);
        this.element.addEventListener("blur", this.handleBlur);
        if (this.dataset.trigger === "click") {
            window.addEventListener("click", this.handleWindowClick);
            this.element.addEventListener("click", this.handleElementClick);
        } else {
            this.element.addEventListener("mouseleave", this.handleMouseLeave);
            this.element.addEventListener("mouseenter", this.handleMouseEnter);
        }
    }
    disconnectedCallback() {
        this.element.removeEventListener("keyup", this.handleKeyUp);
        this.element.removeEventListener("blur", this.handleBlur);
        if (this.dataset.trigger === "click") {
            window.removeEventListener("click", this.handleWindowClick);
            this.element.removeEventListener("click", this.handleElementClick);
        } else {
            this.element.removeEventListener("mouseleave", this.handleMouseLeave);
            this.element.removeEventListener("mouseenter", this.handleMouseEnter);
        }
    }
    setTargetListeners(action) {
        const { targets: targets, firstTarget: firstTarget, lastTarget: lastTarget } = this.getTargets();
        const setter = action === "add" ? (0, $6de5ff37caa957d8$export$72de9d21dee7d369) : (0, $6de5ff37caa957d8$export$ff0ecb8d3a93845b);
        setter(firstTarget, "focus", this.handleFirstTargetFocus);
        targets.forEach((target)=>{
            setter(target, "focus", this.handleTargetFocus);
        });
        setter(lastTarget, "blur", this.handleLastTargetBlur);
        setter(window, "click", this.handleWindowClick);
    }
    getElement() {
        const elementSelector = `[data-float-element-trigger="${this.dataset.floatElementId}"]`;
        return this.querySelector(elementSelector) || this;
    }
    getTargets() {
        const element = this.floatElement.element;
        const targets = [
            ...element.querySelectorAll((0, $6de5ff37caa957d8$export$f2d94ec8507fd10b)())
        ];
        const firstTarget = targets[0];
        const lastTarget = targets[targets.length - 1];
        return {
            targets: targets,
            firstTarget: firstTarget,
            lastTarget: lastTarget
        };
    }
    isTargetOutsideFloatElements(target) {
        const isInsideFloatElement = this.floatElement.contains(target);
        const isInsideFloatElementBtn = this.contains(target);
        return !isInsideFloatElement && !isInsideFloatElementBtn;
    }
    setExpand(isExpanded) {
        this.setAttribute("data-aria-expanded", isExpanded);
    }
    get floatElement() {
        if (!this.dataset.floatElementId) return;
        return document.getElementById(this.dataset.floatElementId);
    }
    get isOpen() {
        return this.floatElement.isOpen;
    }
}
var $b787065192d2690f$export$2e2bcd8739ae039 = $b787065192d2690f$var$FloatElementBtn;




class $ca59d86b67377171$var$HotspotsFloatElement extends (0, $0d174bbf17ec5209$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.styles = getComputedStyle(this);
    }
    unmount() {
        return (0, $6de5ff37caa957d8$export$1391212d75b2ee65)((0, $6de5ff37caa957d8$export$5faba83c1624a4ba)(this.styles)).then(()=>{
            super.unmount();
        });
    }
}
var $ca59d86b67377171$export$2e2bcd8739ae039 = $ca59d86b67377171$var$HotspotsFloatElement;




class $85330901f46d46b4$var$DropdownOpener extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleBlur = ()=>{
            const { targets: targets } = this.getTargets();
            this.blurElementTimeoutId = setTimeout(()=>{
                if (!targets.includes(document.activeElement)) {
                    if (!this.floatElement) return;
                    this.setTargetListeners("remove");
                    this.floatElement.hide();
                }
            }, 0);
        };
        this.handleDropdownShow = ()=>{
            window.addEventListener("keydown", this.handleDropdownKeyDown);
        };
        this.handleDropdownHide = ()=>{
            window.removeEventListener("keydown", this.handleDropdownKeyDown);
        };
        this.handleKeyUp = (event)=>{
            if (!this.floatElement) return;
            const key = event.key || event.keyCode;
            const isEnterKey = (0, $6de5ff37caa957d8$export$793b145c7f680179)(key);
            if (isEnterKey) {
                if (!this.floatElement.isOpen) {
                    this.floatElement.show();
                    this.setTargetListeners("add");
                }
                return;
            }
        };
        this.handleDropdownKeyDown = (event)=>{
            if (!this.floatElement) return;
            const key = event.key || event.keyCode;
            const isEscapeKey = (0, $6de5ff37caa957d8$export$39246f7a93d1f0fc)(key);
            if (!this.floatElement.isOpen) return;
            if (isEscapeKey) {
                this.element.focus();
                this.setTargetListeners("remove");
                this.floatElement.hide();
            }
        };
        this.handleFirstTargetFocus = ()=>{
            clearTimeout(this.blurElementTimeoutId);
        };
        this.handleTargetFocus = ()=>{
            clearTimeout(this.blurLastTargetTimeoutId);
        };
        this.handleLastTargetBlur = ()=>{
            this.blurLastTargetTimeoutId = setTimeout(()=>{
                if (!this.floatElement) return;
                this.setTargetListeners("remove");
                this.floatElement.hide();
            }, 0);
        };
        this.handleTrigger = (event)=>{
            event.preventDefault();
            this.trigger();
        };
        this.handleUntrigger = ({ clientX: x, clientY: y, target: target })=>{
            if (!this.floatElement) return;
            const isCursorOutside = this.floatElement.checkCursorOutside(x, y);
            const isOutsideFloatElements = this.isTargetOutsideFloatElements(target);
            if (isCursorOutside && isOutsideFloatElements) {
                this.floatElement.hide();
                window.removeEventListener("click", this.handleUntrigger);
            }
        };
        this.trigger = ()=>{
            if (!this.floatElement) return;
            this.floatElement.isOpen ? this.floatElement.hide() : this.floatElement.show();
            window.addEventListener("click", this.handleUntrigger);
        };
        this.element = this.getElement();
    }
    connectedCallback() {
        if (this.floatElement) {
            customElements.upgrade(this.floatElement) // https://developer.mozilla.org/en-US/docs/Web/API/CustomElementRegistry/upgrade
            ;
            this.floatElement.subscribe("show", this.handleDropdownShow);
            this.floatElement.subscribe("hide", this.handleDropdownHide);
        }
        this.element.addEventListener("blur", this.handleBlur);
        this.element.addEventListener("keyup", this.handleKeyUp);
        this.element.addEventListener("mousedown", this.handleTrigger);
    }
    disconnectedCallback() {
        if (this.floatElement) {
            customElements.upgrade(this.floatElement) // https://developer.mozilla.org/en-US/docs/Web/API/CustomElementRegistry/upgrade
            ;
            this.floatElement.unsubscribe("show", this.handleDropdownShow);
            this.floatElement.unsubscribe("hide", this.handleDropdownHide);
        }
        this.element.removeEventListener("blur", this.handleBlur);
        this.element.removeEventListener("keyup", this.handleKeyUp);
        this.element.removeEventListener("mousedown", this.handleTrigger);
        window.removeEventListener("click", this.handleUntrigger);
    }
    setTargetListeners(action) {
        const { targets: targets, firstTarget: firstTarget, lastTarget: lastTarget } = this.getTargets();
        const setter = action === "add" ? (0, $6de5ff37caa957d8$export$72de9d21dee7d369) : (0, $6de5ff37caa957d8$export$ff0ecb8d3a93845b);
        setter(firstTarget, "focus", this.handleFirstTargetFocus);
        targets.forEach((target)=>setter(target, "focus", this.handleTargetFocus));
        setter(lastTarget, "blur", this.handleLastTargetBlur);
        setter(window, "click", this.handleUntrigger);
    }
    getTargets() {
        if (!this.floatElement) return;
        const element = this.floatElement.element;
        const targets = [
            ...element.querySelectorAll((0, $6de5ff37caa957d8$export$f2d94ec8507fd10b)())
        ];
        const firstTarget = targets[0];
        const lastTarget = targets[targets.length - 1];
        return {
            targets: targets,
            firstTarget: firstTarget,
            lastTarget: lastTarget
        };
    }
    isTargetOutsideFloatElements(target) {
        if (!this.floatElement) return;
        const isInsideFloatElement = this.floatElement.contains(target);
        const isInsideFloatElementBtn = this.contains(target);
        return !isInsideFloatElement && !isInsideFloatElementBtn;
    }
    getElement() {
        const elementSelector = `[data-float-element-trigger="${this.dataset.floatElementId}"]`;
        return this.querySelector(elementSelector) || this;
    }
    setExpand(isExpanded) {
        this.setAttribute("data-aria-expanded", isExpanded);
    }
    get floatElement() {
        return document.getElementById(this.dataset.floatElementId);
    }
}
var $85330901f46d46b4$export$2e2bcd8739ae039 = $85330901f46d46b4$var$DropdownOpener;



class $c1acfb98f6a83318$var$TooltipTrigger extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    connectedCallback() {
        this.addEventListener("mouseenter", this.handleMouseEnter);
        this.addEventListener("mouseleave", this.handleMouseLeave);
    }
    disconnectedCallback() {
        this.removeEventListener("mouseenter", this.handleMouseEnter);
        this.removeEventListener("mouseleave", this.handleMouseLeave);
    }
    setExpand(isExpanded) {
        this.setAttribute("data-aria-expanded", isExpanded ? "true" : "false");
    }
    get floatElement() {
        if (!this.dataset.floatElementId) return null;
        return document.getElementById(this.dataset.floatElementId);
    }
    constructor(...args){
        super(...args);
        this.handleMouseEnter = ()=>{
            if (!this.floatElement) return;
            this.floatElement.show();
        };
        this.handleMouseLeave = ()=>{
            if (!this.floatElement) return;
            this.floatElement.hide();
        };
    }
}
var $c1acfb98f6a83318$export$2e2bcd8739ae039 = $c1acfb98f6a83318$var$TooltipTrigger;





class $05a8bfacff3e547e$var$Accordeon extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleContentResize = ()=>{
            this.updateMaxHeight();
        };
        this.handleBlockSelect = ({ detail: { sectionId: sectionId, blockId: blockId, load: load } })=>{
            const contentWrapper = this.querySelector(this.contentWrapperSelector);
            const isCurrentSection = this.dataset.sectionId === sectionId;
            const isCurrentBlock = this.dataset.blockId === blockId;
            const isTarget = isCurrentSection && isCurrentBlock;
            if (isTarget && !this.isExpanded) {
                (0, $aa19cdf2f552e6e0$export$771cf8a539cd846f)(contentWrapper, load);
                (0, $aa19cdf2f552e6e0$export$771cf8a539cd846f)(this, load);
                this.show().then(()=>{
                    (0, $aa19cdf2f552e6e0$export$771cf8a539cd846f)(contentWrapper, false);
                    (0, $aa19cdf2f552e6e0$export$771cf8a539cd846f)(this, false);
                });
            }
        };
        this.handleBlockDeselect = ({ detail: { sectionId: sectionId, blockId: blockId } })=>{
            const isTarget = this.dataset.sectionId === sectionId && this.dataset.blockId === blockId;
            if (isTarget && this.isExpanded) this.hide();
        };
        this.contentSelector = `[data-accordeon-content]`;
        this.contentWrapperSelector = `[data-accordeon-content-wrapper]`;
        this.content = this.querySelector(this.contentSelector);
        this.resizeObserver = new ResizeObserver(this.handleContentResize);
        if (this.content) this.resizeObserver.observe(this.content);
        this.styles = getComputedStyle(this);
    }
    connectedCallback() {
        this.updateMaxHeight();
        if (this.isEditorMode) {
            this.editor.subscribe("BLOCK_SELECT", this.handleBlockSelect);
            this.editor.subscribe("BLOCK_DESELECT", this.handleBlockDeselect);
        }
    }
    disconnectedCallback() {
        this.resizeObserver.disconnect();
        if (this.isEditorMode) this.editor.destroy();
    }
    hide() {
        this.setExpand(false);
        return (0, $6de5ff37caa957d8$export$1391212d75b2ee65)((0, $6de5ff37caa957d8$export$5faba83c1624a4ba)(this.styles));
    }
    show() {
        this.setExpand(true);
        return (0, $6de5ff37caa957d8$export$1391212d75b2ee65)((0, $6de5ff37caa957d8$export$5faba83c1624a4ba)(this.styles));
    }
    toggle() {
        this.setExpand(!this.isExpanded);
        this.emit("toggle", {
            blockId: this.dataset.blockId
        });
    }
    updateMaxHeight() {
        const accordeon = this.closest("accordeon-component");
        const content = this.querySelector(this.contentSelector);
        const contentWrapper = this.querySelector(this.contentWrapperSelector);
        if (accordeon && content && contentWrapper) {
            if (accordeon.isExpanded) this.removeAttribute("style");
            const height = Math.ceil(accordeon.isExpanded ? content.scrollHeight : 0);
            contentWrapper.style.maxHeight = `${height}px`;
        }
    }
    setExpand(isExpanded) {
        this.setAttribute("data-aria-expanded", isExpanded ? "true" : "false");
        this.updateMaxHeight();
    }
    get isExpanded() {
        return this.getAttribute("data-aria-expanded") === "true";
    }
}
var $05a8bfacff3e547e$export$2e2bcd8739ae039 = $05a8bfacff3e547e$var$Accordeon;




class $2710c8cc8c44fd68$var$AccordeonBtn extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    connectedCallback() {
        this.addEventListener("click", this.handleButtonClick);
        this.addEventListener("keydown", this.handleKeyDown);
    }
    disconnectedCallback() {
        this.removeEventListener("click", this.handleButtonClick);
        this.removeEventListener("keydown", this.handleKeyDown);
    }
    update() {
        const accordeon = this.closest("accordeon-component");
        if (accordeon) accordeon.toggle();
    }
    constructor(...args){
        super(...args);
        this.handleButtonClick = (event)=>{
            event.preventDefault();
            this.update();
        };
        this.handleKeyDown = (event)=>{
            event.preventDefault();
            const isEnterKey = (0, $6de5ff37caa957d8$export$793b145c7f680179)(event.key || event.keyCode);
            if (isEnterKey) this.update();
        };
    }
}
var $2710c8cc8c44fd68$export$2e2bcd8739ae039 = $2710c8cc8c44fd68$var$AccordeonBtn;



class $3af822ddcc0df1de$var$ProductMediaTabs extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleTabEnter = (event)=>{
            const tab = event.currentTarget;
            const img = this.productCard.querySelector(`[data-id="${tab.dataset.id}"]`);
            if (this.selected) this.reset();
            this.setTabSelect(tab, true);
            this.setImageVisible(img, true);
            this.setImageVisible(this.mainImage, false);
            this.selected = {
                tab: tab,
                img: img
            };
        };
        this.handleTabLeave = ()=>{
            if (this.selected) this.reset();
            this.setImageVisible(this.mainImage, true);
        };
        this.productCard = this.closest("product-card");
        this.mainImage = this.productCard.querySelector("[data-main-media]");
        this.tabs = [
            ...this.querySelectorAll("[data-product-media-tabs-item]")
        ];
        this.selected = null;
    }
    connectedCallback() {
        this.tabs.forEach((tab)=>{
            tab.addEventListener("mouseenter", this.handleTabEnter);
            tab.addEventListener("mouseleave", this.handleTabLeave);
        });
    }
    disconnectedCallback() {
        this.tabs.forEach((tab)=>{
            tab.removeEventListener("mouseenter", this.handleTabEnter);
            tab.removeEventListener("mouseleave", this.handleTabLeave);
        });
    }
    setTabSelect(tab, isSelected) {
        tab.classList.toggle("selected", isSelected);
    }
    setImageVisible(img, isVisible) {
        img.classList.toggle("product-card__img--visible", isVisible);
    }
    reset() {
        if (!this.selected) return;
        this.selected.img.classList.remove("product-card__img--visible");
        this.selected.tab.classList.remove("selected");
        this.selected = null;
    }
}
var $3af822ddcc0df1de$export$2e2bcd8739ae039 = $3af822ddcc0df1de$var$ProductMediaTabs;





class $4d09379d3f950286$var$ProductCardColorSwatches extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleSwatchEnter = (event)=>{
            if (!this.productCard) return;
            const target = event.target;
            const variantId = target.dataset.variantId;
            const image = this.productCard.querySelector(`[data-variant-id="${variantId}"]`);
            const color = target.dataset.color;
            if (!image || !this.mainImage || !color) return;
            this.updateLabel(color);
            this.setImageVisible(image, true);
            this.setImageVisible(this.mainImage, false);
            this.currentVisibleImage = image;
            this.setHoverStatus(true);
        };
        this.handleSwatchLeave = ()=>{
            this.updateLabel("");
            if (this.currentVisibleImage) this.setImageVisible(this.currentVisibleImage, false);
            if (this.mainImage) this.setImageVisible(this.mainImage, true);
            this.setHoverStatus(false);
        };
        this.hiddenCount = this.querySelector("[data-color-swatches-hidden-count]");
        this.label = this.querySelector("[data-color-swatches-label]");
        this.items = [
            ...this.querySelectorAll("[data-color-swatches-item]")
        ];
        this.productCard = this.closest("product-card");
        if (this.productCard) this.mainImage = this.productCard.querySelector("[data-main-media]");
    }
    connectedCallback() {
        this.initOffsets();
        this.update();
        this.items.forEach((item)=>{
            item.addEventListener("mouseenter", this.handleSwatchEnter);
            item.addEventListener("mouseleave", this.handleSwatchLeave);
        });
    }
    disconnectedCallback() {
        this.items.forEach((item)=>{
            item.removeEventListener("mouseenter", this.handleSwatchEnter);
            item.removeEventListener("mouseleave", this.handleSwatchLeave);
        });
    }
    update() {
        this.updateSwatchesVisible();
        this.updateCount();
        this.updateDetailsInner();
    }
    updateDetailsInner() {
        const detailsInner = this.closest("[data-product-details-inner]");
        if (!detailsInner) return;
        if (detailsInner.offsetHeight < this.offsetHeight) detailsInner.style.minHeight = `${this.offsetHeight}px`;
    }
    setImageVisible(img, isVisible) {
        img.classList.toggle("product-card__img--visible", isVisible);
    }
    updateSwatchesVisible() {
        if (!this.productCard) return;
        this.items.forEach((swatch)=>{
            const swatchRightPosition = swatch.offsetLeft + swatch.offsetWidth;
            const maxWidth = this.parentNode.offsetWidth - swatch.offsetWidth;
            const isOverflowed = swatchRightPosition > maxWidth;
            swatch.classList.toggle("hidden-swatch", isOverflowed);
        });
    }
    initOffsets() {
        this.items.forEach((swatch)=>{
            swatch.style.left = `${swatch.offsetLeft}px`;
        });
    }
    updateCount() {
        if (!this.hiddenCount) return;
        const notHiddenSwatches = this.items.filter((item)=>!item.classList.contains("hidden-swatch"));
        const count = +(this.dataset.count || 0) - notHiddenSwatches.length;
        const hiddenCountLabel = this.querySelector("[data-color-swatches-hidden-count-label]");
        if (!hiddenCountLabel) return;
        if (count > 0) {
            (0, $aa19cdf2f552e6e0$export$998191bfdf710c72)(this.hiddenCount);
            hiddenCountLabel.innerText = `+${count}`;
        } else {
            (0, $aa19cdf2f552e6e0$export$7669482c90f5c50f)(this.hiddenCount);
            hiddenCountLabel.innerText = "";
        }
    }
    updateLabel(color) {
        if (!this.label) return;
        this.label.innerText = color ? (0, $6de5ff37caa957d8$export$9a00dee1beb8f576)(color) : "";
    }
    setHoverStatus(isHover) {
        this.productCard?.classList.toggle("is-color-swatch-hover", isHover);
    }
}
var $4d09379d3f950286$export$2e2bcd8739ae039 = $4d09379d3f950286$var$ProductCardColorSwatches;






class $1eaff675051c24fc$var$Modal extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleKeydown = (event)=>{
            if (this.hasAttribute("data-ignore-esc-key")) return;
            const key = event.key || event.keyCode;
            const isEscape = (0, $6de5ff37caa957d8$export$39246f7a93d1f0fc)(key);
            if (isEscape) this.hide();
        };
        this.handleOutsideClick = (event)=>{
            const overlay = document.getElementById("BodyOverlay");
            const overlayZIndex = parseFloat((0, $aa19cdf2f552e6e0$export$d107df9a86338a09)(overlay, "zIndex"));
            const zIndex = parseFloat(this.styles.zIndex) - 1;
            const isOverlay = event.target === overlay;
            const isOutsideClick = isOverlay && overlayZIndex <= zIndex;
            if (isOutsideClick && this.isOpen) this.hide();
        };
        this.template = this.querySelector(`[data-modal-template="${this.id}"]`);
        this.element = (0, $aa19cdf2f552e6e0$export$8ea4fc17cec6f158)(this.template);
        this.template?.remove();
        this.styles = getComputedStyle(this);
    }
    async show() {
        this.mount();
        await this.setOpenState(true);
        const videos = this.element?.querySelectorAll("video");
        videos?.forEach((video)=>{
            video.play();
        });
        if (!this.isEditorMode) this.focus();
        await this.setOpenState(true);
        this.isOpen = true;
    }
    async hide() {
        await this.setOpenState(false);
        await (0, $6de5ff37caa957d8$export$1391212d75b2ee65)((0, $6de5ff37caa957d8$export$5faba83c1624a4ba)(this.styles)).then(()=>{
            this.unmount();
            this.isOpen = false;
        });
    }
    toggle() {
        if (this.isOpen) this.hide();
        else this.show();
    }
    mount() {
        this.replaceChildren(this.element);
    }
    unmount() {
        this.replaceChildren();
    }
    async setOpenState(isOpen) {
        const withOverlay = this.hasAttribute("data-with-overlay");
        if (withOverlay) {
            const isImportant = this.hasAttribute("data-overlay-important");
            const overlayOpacity = this.getAttribute("data-overlay-opacity") || 50;
            const styles = {
                zIndex: isImportant ? parseFloat(this.styles.zIndex) - 1 : 3,
                backgroundColor: `var(--gsc-black-color-${overlayOpacity})`
            };
            isOpen ? (0, $339187790c656b4d$export$e1122b4c4bd5b838).showOverlay(this.id, styles) : await (0, $6de5ff37caa957d8$export$1391212d75b2ee65)((0, $6de5ff37caa957d8$export$5faba83c1624a4ba)(this.styles)).then(()=>{
                (0, $339187790c656b4d$export$e1122b4c4bd5b838).hideOverlay(this.id);
            });
        }
        this.setVisible(isOpen);
        this.setListeners(isOpen ? "add" : "remove");
        this.emit(isOpen ? "show" : "hide", {});
    }
    setVisible(isVisible) {
        this.toggleAttribute("open", isVisible);
    }
    setListeners(action) {
        const withOutsideClick = this.hasAttribute("data-with-close-on-outside");
        const eventListenerSetter = `${action}EventListener`;
        if (withOutsideClick) window[eventListenerSetter]("click", this.handleOutsideClick);
        window[eventListenerSetter]("keydown", this.handleKeydown);
    }
}
var $1eaff675051c24fc$export$2e2bcd8739ae039 = $1eaff675051c24fc$var$Modal;



class $41c33abd6aa351e9$var$PasswordModal extends (0, $1eaff675051c24fc$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.passwordInput = this.querySelector("[password-modal-input]");
    }
    show() {
        super.show();
        if (this.passwordInput) this.passwordInput.focus();
    }
}
var $41c33abd6aa351e9$export$2e2bcd8739ae039 = $41c33abd6aa351e9$var$PasswordModal;




class $7f0e8e1e1a260e5d$var$CartNotificationPopup extends (0, $1eaff675051c24fc$export$2e2bcd8739ae039) {
    showProductFromParsedState(parsedState, productId) {
        const section = parsedState.sections["cart-notification-popup-content"];
        const sectionHTML = (0, $aa19cdf2f552e6e0$export$8a49393be2d55148)(section);
        if (this.element) {
            const targetProduct = sectionHTML.querySelector(`#CartNotificationPopupItem-${productId}`);
            const content = this.element.querySelector("[data-cart-notification-popup]");
            if (content && targetProduct) {
                const clonedTargetProduct = targetProduct.cloneNode(true);
                content.replaceChildren(clonedTargetProduct);
            }
            this.updateCartCountInHeader(parsedState);
            this.show();
        }
    }
    updateCartCountInHeader(parsedState) {
        const section = parsedState.sections["cart-count"];
        const sectionHTML = (0, $aa19cdf2f552e6e0$export$8a49393be2d55148)(section);
        const count = document.getElementById("CartCount");
        const stickyCount = document.getElementById("StickyCartCount");
        const newCount = sectionHTML.getElementById("CartCount");
        if (!newCount) return;
        const clonedNewCount = newCount?.cloneNode(true);
        if (stickyCount) stickyCount.replaceChildren(...clonedNewCount.childNodes);
        if (count) count.replaceChildren(...clonedNewCount.childNodes);
    }
}
var $7f0e8e1e1a260e5d$export$2e2bcd8739ae039 = $7f0e8e1e1a260e5d$var$CartNotificationPopup;




class $90627309f9e09618$var$ModalOpener extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    connectedCallback() {
        this.addEventListener("keydown", this.handleKeyDown);
        this.addEventListener("click", this.handleButtonClick);
    }
    disconnectedCallback() {
        this.removeEventListener("keydown", this.handleKeyDown);
        this.removeEventListener("click", this.handleButtonClick);
    }
    showModal() {
        const modal = document.querySelector(this.dataset.modal);
        if (modal) modal.show();
    }
    constructor(...args){
        super(...args);
        this.handleButtonClick = ()=>{
            this.showModal();
            this.emit("click", {});
        };
        this.handleKeyDown = (event)=>{
            const isEnterKey = (0, $6de5ff37caa957d8$export$793b145c7f680179)(event.key || event.keyCode);
            if (isEnterKey) {
                event.preventDefault();
                const modal = document.querySelector(this.dataset.modal);
                if (modal) modal.toggle();
            }
        };
    }
}
var $90627309f9e09618$export$2e2bcd8739ae039 = $90627309f9e09618$var$ModalOpener;



class $c3ad08cea9273c7d$var$PasswordModalOpener extends (0, $90627309f9e09618$export$2e2bcd8739ae039) {
    connectedCallback() {
        super.connectedCallback();
        this.focus();
    }
}
var $c3ad08cea9273c7d$export$2e2bcd8739ae039 = $c3ad08cea9273c7d$var$PasswordModalOpener;




class $1b92c34bc5eaadc5$var$ModalCloseBtn extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    connectedCallback() {
        this.addEventListener("keydown", this.handleKeyDown);
        this.addEventListener("click", this.handleButtonClick);
    }
    disconnectedCallback() {
        this.removeEventListener("keydown", this.handleKeyDown);
        this.removeEventListener("click", this.handleButtonClick);
    }
    hide() {
        const modal = document.querySelector(this.dataset.modal);
        if (modal) modal.hide();
    }
    constructor(...args){
        super(...args);
        this.handleButtonClick = ()=>{
            this.hide();
        };
        this.handleKeyDown = (event)=>{
            const isEnterKey = (0, $6de5ff37caa957d8$export$793b145c7f680179)(event.key || event.keyCode);
            if (isEnterKey) {
                event.preventDefault();
                this.hide();
            }
        };
    }
}
var $1b92c34bc5eaadc5$export$2e2bcd8739ae039 = $1b92c34bc5eaadc5$var$ModalCloseBtn;




class $acdb0ba51c71b753$var$SidebarBtn extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleButtonClick = (event)=>{
            event.preventDefault();
        };
        this.handleButtonMouseDown = (event)=>{
            event.preventDefault();
            const carouselParent = this.closest("carousel-component");
            const dotsCarouselParent = this.closest("carousel-dots");
            this.isDraggingInCarousel = !!(carouselParent || dotsCarouselParent);
            if (this.isDraggingInCarousel) {
                this.setMoveStartPoint(event.clientX, event.clientY);
                this.toggleAfterDraggingInCarousel = true;
            } else this.toggle();
        };
        this.handleButtonMouseMove = (event)=>{
            if (this.isDraggingInCarousel) {
                const threshold = 24;
                const distanceX = Math.abs(this.startPointX - event.clientX);
                const distanceY = Math.abs(this.startPointY - event.clientY);
                const isAboveThanThreshold = distanceX > threshold || distanceY > threshold;
                if (isAboveThanThreshold) this.toggleAfterDraggingInCarousel = false;
            }
        };
        this.handleButtonMouseUp = ()=>{
            if (this.isDraggingInCarousel) {
                if (this.toggleAfterDraggingInCarousel) this.toggle();
                this.isDraggingInCarousel = false;
                this.toggleAfterDraggingInCarousel = false;
                this.setMoveStartPoint(0, 0);
            }
        };
        this.handleKeyDown = (event)=>{
            const isEnterKey = (0, $6de5ff37caa957d8$export$793b145c7f680179)(event.key || event.keyCode);
            if (isEnterKey) {
                event.preventDefault();
                this.toggle();
            }
        };
        this.buttonSelector = `[data-sidebar-button]`;
        this.button = this.querySelector(this.buttonSelector);
    }
    connectedCallback() {
        if (this.button) {
            this.button.addEventListener("click", this.handleButtonClick);
            this.button.addEventListener("keydown", this.handleKeyDown);
            this.button.addEventListener("mousedown", this.handleButtonMouseDown);
            this.button.addEventListener("mousemove", this.handleButtonMouseMove);
            this.button.addEventListener("mouseup", this.handleButtonMouseUp);
        }
    }
    disconnectedCallback() {
        if (this.button) {
            this.button.removeEventListener("click", this.handleButtonClick);
            this.button.removeEventListener("keydown", this.handleKeyDown);
            this.button.removeEventListener("mousedown", this.handleButtonMouseDown);
            this.button.removeEventListener("mousemove", this.handleButtonMouseMove);
            this.button.removeEventListener("mouseup", this.handleButtonMouseUp);
        }
    }
    setMoveStartPoint(x, y) {
        this.startPointX = x;
        this.startPointY = y;
    }
    toggle() {
        if (this.button) {
            const sidebarId = this.button.dataset.sidebarId || "";
            const sidebar = document.getElementById(sidebarId);
            if (sidebar) {
                sidebar.toggle();
                this.update();
            }
        }
    }
    update() {
        if (this.button) {
            const sidebarId = this.button.dataset.sidebarId || "";
            const sidebar = document.getElementById(sidebarId);
            if (sidebar) this.button.setAttribute("data-aria-expanded", sidebar.isOpen ? "true" : "false");
        }
    }
}
var $acdb0ba51c71b753$export$2e2bcd8739ae039 = $acdb0ba51c71b753$var$SidebarBtn;






class $a31366d6d865bd48$var$Sidebar extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleSectionLoad = ()=>{
            if (!this.isSection) this.hide();
        };
        this.handleSectionSelect = ({ detail: { sectionId: sectionId } })=>{
            if (this.isSection && this.dataset.sectionId === sectionId) this.open();
        };
        this.handleSectionDeselect = ({ detail: { sectionId: sectionId } })=>{
            if (this.isSection && this.dataset.sectionId === sectionId) this.hide();
        };
        this.handleOutsideClick = (event)=>{
            const overlay = document.getElementById("BodyOverlay");
            const overlayZIndex = parseFloat((0, $aa19cdf2f552e6e0$export$d107df9a86338a09)(overlay, "zIndex"));
            const zIndex = parseFloat(this.styles["zIndex"]) - 1;
            const isOverlay = event.target === overlay;
            const isOutsideClick = isOverlay && overlayZIndex <= zIndex;
            if (isOutsideClick && this.isOpen) this.hide();
        };
        this.handleTouchStart = (event)=>{
            this.touchStartX = event.targetTouches[0].clientX;
            this.touchStartY = event.targetTouches[0].clientY;
        };
        this.handleTouchMove = (event)=>{
            this.touchEndX = event.targetTouches[0].clientX;
            this.touchEndY = event.targetTouches[0].clientY;
        };
        this.handleTouchEnd = (event)=>{
            const X_DIRECTION_THRESHOLD = 96;
            const Y_DIRECTION_THRESHOLD = 48;
            const distanceX = Math.abs(this.touchStartX - this.touchEndX);
            const distanceY = Math.abs(this.touchStartY - this.touchEndY);
            const isCarousel = event.target.closest("[data-carousel-viewport]");
            if (isCarousel) return;
            if (this.touchEndX === 0) return;
            if (distanceY > Y_DIRECTION_THRESHOLD) return;
            const isTrigger = this.dataset.openDirection === "right" ? this.touchStartX < this.touchEndX : this.touchStartX > this.touchEndX;
            if (this.isOpen && distanceX > X_DIRECTION_THRESHOLD && isTrigger) this.hide();
            this.cleanTouchPoints();
        };
        this.handleKeydown = (event)=>{
            const key = event.key || event.keyCode;
            const withCloseOnEscape = this.hasAttribute("data-with-close-on-escape");
            const isEscape = (0, $6de5ff37caa957d8$export$39246f7a93d1f0fc)(key);
            if (withCloseOnEscape && isEscape) this.hide();
        };
        if (this.isOpenOnInit) {
            this.template = null;
            this.element = this.querySelector("[data-sidebar-body]");
        } else {
            this.template = this.querySelector(`[data-sidebar-template="${this.id}"]`);
            this.element = (0, $aa19cdf2f552e6e0$export$8ea4fc17cec6f158)(this.template);
            this.template?.remove();
        }
        this.buttonSelector = `[data-sidebar-button][data-sidebar-id="${this.id}"]`;
        this.styles = getComputedStyle(this);
    }
    connectedCallback() {
        this.addEventListener("touchstart", this.handleTouchStart);
        this.addEventListener("touchmove", this.handleTouchMove);
        this.addEventListener("touchend", this.handleTouchEnd);
        if (this.isEditorMode) {
            this.editor.subscribe("SECTION_LOAD", this.handleSectionLoad);
            this.editor.subscribe("SECTION_SELECT", this.handleSectionSelect);
            this.editor.subscribe("SECTION_DESELECT", this.handleSectionDeselect);
        }
    }
    disconnectedCallback() {
        this.removeEventListener("touchstart", this.handleTouchStart);
        this.removeEventListener("touchmove", this.handleTouchMove);
        this.removeEventListener("touchend", this.handleTouchEnd);
        if (this.isEditorMode) this.editor.destroy();
    }
    cleanTouchPoints() {
        this.touchStartX = 0;
        this.touchEndX = 0;
        this.touchStartY = 0;
        this.touchEndY = 0;
    }
    async open() {
        this.mount();
        await this.setOpenState(true);
        await (0, $6de5ff37caa957d8$export$1391212d75b2ee65)((0, $6de5ff37caa957d8$export$5faba83c1624a4ba)(this.styles));
        this.setAttribute("tabindex", "-1");
        this.focus();
    }
    hide(isInstant) {
        this.setOpenState(false);
        if (isInstant) this.unmount();
        else return (0, $6de5ff37caa957d8$export$1391212d75b2ee65)((0, $6de5ff37caa957d8$export$5faba83c1624a4ba)(this.styles)).then(()=>{
            this.unmount();
        });
    }
    toggle() {
        if (this.isOpen) this.hide();
        else this.open();
    }
    mount() {
        this.replaceChildren(this.element);
    }
    unmount() {
        this.replaceChildren();
    }
    updateTemplate(template) {
        this.element = (0, $aa19cdf2f552e6e0$export$8ea4fc17cec6f158)(template);
        this.replaceChildren(this.element);
    }
    setOpenState(isOpen) {
        const withOverlay = this.hasAttribute("data-with-overlay");
        const buttons = document.querySelectorAll(this.buttonSelector);
        this.setVisible(isOpen);
        this.setListeners(isOpen ? "add" : "remove");
        if (withOverlay) {
            const isImportant = this.hasAttribute("data-overlay-important");
            const withBlur = this.hasAttribute("data-overlay-with-blur");
            const overlayOpacity = +(this.getAttribute("data-overlay-opacity") || 50);
            const styles = {
                zIndex: isImportant ? parseFloat(this.styles["zIndex"]) - 1 : 3,
                backdropFilter: withBlur ? `blur(16.5px)` : "none",
                backgroundColor: `var(--gsc-black-color-${overlayOpacity})`
            };
            isOpen ? (0, $339187790c656b4d$export$e1122b4c4bd5b838).showOverlay(this.id, styles) : (0, $6de5ff37caa957d8$export$1391212d75b2ee65)((0, $6de5ff37caa957d8$export$5faba83c1624a4ba)(this.styles)).then(()=>{
                (0, $339187790c656b4d$export$e1122b4c4bd5b838).hideOverlay(this.id);
            });
        }
        buttons.forEach((button)=>{
            button.setAttribute("data-aria-expanded", isOpen ? "true" : "false");
        });
    }
    setVisible(isVisible) {
        this.setAttribute("data-aria-expanded", isVisible ? "true" : "false");
    }
    setListeners(action) {
        const withOutsideClick = this.hasAttribute("data-with-close-on-outside");
        const eventListenerSetter = `${action}EventListener`;
        if (withOutsideClick) window[eventListenerSetter]("click", this.handleOutsideClick);
        window[eventListenerSetter]("keydown", this.handleKeydown);
    }
    get isSection() {
        return this.hasAttribute("data-sidebar-section");
    }
    get isOpen() {
        return this.getAttribute("data-aria-expanded") === "true";
    }
    get isOpenOnInit() {
        return this.hasAttribute("is-open-on-init");
    }
}
var $a31366d6d865bd48$export$2e2bcd8739ae039 = $a31366d6d865bd48$var$Sidebar;


const $336348f90f7c8f21$export$e7a5aad9bb00dd62 = ()=>{
    const mediaQuery = "(max-width: 768px)";
    const isMobile = matchMedia(mediaQuery).matches;
    return isMobile;
};
const $336348f90f7c8f21$export$601dcf7c5dad8f97 = ()=>{
    const mediaQuery = "(prefers-reduced-motion: reduce)";
    const isAnimationReduce = matchMedia(mediaQuery).matches;
    return isAnimationReduce;
};



class $b02959299c5ae1fb$var$SearchSidebar extends (0, $a31366d6d865bd48$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleClick = (event)=>{
            const target = event.target;
            const isMobile = (0, $336348f90f7c8f21$export$e7a5aad9bb00dd62)();
            const isInput = target === this.searchInput;
            const isLink = target.tagName === "A";
            const queryElement = target.closest("[data-sidebar-search-query]");
            if (this.searchInput && queryElement) {
                const event = new Event("input", {
                    bubbles: true
                });
                this.searchInput.value = `${queryElement.getAttribute("data-sidebar-search-query")}`;
                this.searchInput.dispatchEvent(event);
                this.searchInput.focus();
            }
            if (isMobile && isInput) this.isInputFocused = true;
            if (!isInput && this.isInputFocused) {
                if (isLink) event.preventDefault();
                this.isInputFocused = false;
            }
        };
        this.handleInputFocus = ()=>{
            const isMobile = (0, $336348f90f7c8f21$export$e7a5aad9bb00dd62)();
            if (isMobile) this.isInputFocused = true;
        };
        this.handleSearchSidebarTouchEnd = (event)=>{
            const THRESHOLD = 12;
            const target = event.target;
            const distanceX = Math.abs(this.touchStartX - this.touchEndX);
            const distanceY = Math.abs(this.touchStartY - this.touchEndY);
            const isDistanceOverThreshold = distanceX > THRESHOLD || distanceY > THRESHOLD;
            const isLink = target.tagName === "A";
            if (this.isInputFocused && isDistanceOverThreshold && this.searchInput) {
                if (isLink) event.preventDefault();
                this.searchInput.blur();
                this.isInputFocused = false;
            }
            this.cleanTouchPoints();
        };
        this.handleContentResultsResize = ()=>{
            this.updateViewport();
        };
        this.handleContentScroll = ()=>{
            if (this.content) {
                const isContentOverflow = this.checkContentOverflow();
                const isScrolled = this.content.scrollTop > 0;
                this.toggleAttribute("header-shadow-visible", isContentOverflow && isScrolled);
            }
        };
        this.searchInputSelector = `[data-sidebar-search-input]`;
        this.searchInputComponentSelector = `[data-sidebar-search-input-component]`;
        this.contentSelector = `[data-sidebar-search-content]`;
        this.contentResultsSelector = `[data-sidebar-search-content-results]`;
        this.content = this.element.querySelector(this.contentSelector);
        this.contentResults = this.element.querySelector(this.contentResultsSelector);
        this.searchInputComponent = this.element.querySelector(this.searchInputComponentSelector);
        this.searchInput = this.element.querySelector(this.searchInputSelector);
        this.resizeObserver = new ResizeObserver(this.handleContentResultsResize);
        if (this.contentResults) this.resizeObserver.observe(this.contentResults);
        this.defaultStateElement = document;
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.content) this.content.addEventListener("scroll", this.handleContentScroll);
        this.addEventListener("click", this.handleClick);
        this.addEventListener("touchend", this.handleSearchSidebarTouchEnd);
        if (this.searchInput) this.searchInput.addEventListener("focus", this.handleInputFocus);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this.content) this.content.removeEventListener("scroll", this.handleContentScroll);
        this.removeEventListener("click", this.handleClick);
        this.removeEventListener("touchend", this.handleSearchSidebarTouchEnd);
        if (this.searchInput) this.searchInput.removeEventListener("focus", this.handleInputFocus);
        this.resizeObserver.disconnect();
    }
    updateViewport() {
        const isContentOverflow = this.checkContentOverflow();
        this.toggleAttribute("footer-shadow-visible", isContentOverflow);
    }
    open() {
        return super.open().then(()=>{
            if (this.searchInput && !this.isEditorMode) this.searchInput.focus();
        });
    }
    checkContentOverflow() {
        if (!this.contentResults || !this.content) return false;
        return this.contentResults.offsetHeight > this.content.offsetHeight;
    }
}
var $b02959299c5ae1fb$export$2e2bcd8739ae039 = $b02959299c5ae1fb$var$SearchSidebar;





class $86cd3420253cdced$var$RecentlyViewed extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    static #_ = (()=>{
        this.localStorageSelector = "AuroraTheme-RecentlyViewed";
    })();
    static #_1 = (()=>{
        this.defaultLimit = 50;
    })();
    constructor(){
        super();
        this.fetchItems = async ()=>{
            const { origin: origin } = window.location;
            const currentSavedProducts = JSON.parse(localStorage.getItem(this.localStorageSelector))?.slice(0, this.cardLimit);
            if (!currentSavedProducts) return;
            try {
                for (const handle of currentSavedProducts){
                    const section = await fetch(`${origin}/products/${handle}?sections=product-card-template`).then((res)=>res.json());
                    const node = this.createNodeByString(section[this.cardTemplateSelector]);
                    console.log(node);
                    if (node) this.products.push(node);
                }
            } catch (error) {
                console.log(error);
            }
        };
        this.setItems = ()=>{
            this.containers.forEach((container)=>{
                const products = this.products.map((product)=>product.cloneNode(true));
                container.replaceChildren(...products);
            });
        };
        this.defaultCardsLimit = $86cd3420253cdced$var$RecentlyViewed.defaultLimit;
        this.defaultCardImgRatio = "portrait";
        this.defaultCardAlignment = "left";
        this.containerAttribute = "[recently-viewed-container]";
        this.localStorageSelector = $86cd3420253cdced$var$RecentlyViewed.localStorageSelector;
        this.cardTemplateSelector = "product-card-template";
        this.cardLimit = +this.dataset.cardLimit ?? this.defaultCardsLimit;
        this.cardImgRatio = this.dataset.imgRatio ?? this.defaultCardImgRatio;
        this.cardAlignment = this.dataset.cardAlignment ?? this.defaultCardAlignment;
        this.cardSelector = "product-card";
        this.cardAlignmentClass = `product-card--${this.cardAlignment}-alignment`;
        this.cardInnerSelector = "[data-product-card-inner]";
        this.shapeClass = `shape--${this.cardImgRatio}`;
        this.products = [];
        this.containers = this.querySelectorAll(this.containerAttribute);
    }
    async connectedCallback() {
        await this.fetchItems();
        if (this.products.length > 0) {
            this.setItems();
            this.setVisible(true);
        }
    }
    setVisible(isVisible) {
        this.classList.toggle("hidden", !isVisible);
    }
    createNodeByString(productString) {
        const node = new DOMParser().parseFromString(productString, "text/html").querySelector(`.${this.cardTemplateSelector}`);
        node?.querySelector(this.cardSelector)?.classList.add(this.cardAlignmentClass);
        node?.querySelector(this.cardInnerSelector)?.classList.add(this.shapeClass);
        return node;
    }
    static updateProductsInLocalStorage(handle) {
        if (!handle) return;
        const currentSavedProducts = JSON.parse(localStorage.getItem(this.localStorageSelector)) ?? [];
        const isExist = currentSavedProducts?.find((item)=>item === handle);
        const newProducts = isExist ? currentSavedProducts : [
            handle,
            ...currentSavedProducts
        ].slice(0, this.defaultLimit);
        localStorage.setItem(this.localStorageSelector, JSON.stringify(newProducts));
    }
}
var $86cd3420253cdced$export$2e2bcd8739ae039 = $86cd3420253cdced$var$RecentlyViewed;



const { Shopify: $3cd23536a2e700ff$var$Shopify } = window;
class $3cd23536a2e700ff$var$QuickViewComponent extends (0, $a31366d6d865bd48$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleContentScroll = ()=>{
            const isScrolled = this.content ? this.content.scrollTop > 0 : false;
            this.toggleAttribute("header-shadow-visible", isScrolled);
        };
        this.openAndRenderProductByUrl = (url)=>{
            if (this.cache[url]) this.cache[url].then((html)=>{
                if (this.isRenderedOnPage) this.isRenderedOnPage.replaceChildren();
                if (this.isOpen) this.hide().then(()=>{
                    this.setProductFromHTML(html);
                    super.open();
                });
                else {
                    this.setProductFromHTML(html);
                    super.open();
                }
                $3cd23536a2e700ff$var$Shopify?.PaymentButton?.init();
            });
        };
        this.cache = {};
    }
    requestProductFromUrl(url, id) {
        if (!this.cache[url]) {
            this.isRenderedOnPage = document.querySelector(`.shopify-section [data-quick-view-product-id="${id}"]`);
            if (this.isRenderedOnPage && this.isRenderedOnPage.dataset.quickViewProductUrl === url) this.cache[url] = (0, $6de5ff37caa957d8$export$1391212d75b2ee65)(0).then(()=>this.isRenderedOnPage);
            else this.cache[url] = fetch(url).then((response)=>response.text()).then((responseText)=>(0, $aa19cdf2f552e6e0$export$8a49393be2d55148)(responseText));
        }
    }
    open() {
    //
    }
    setProductFromHTML(html) {
        if (this.dataset.targetId) {
            const target = html.getElementById(this.dataset.targetId);
            if (target) {
                (0, $86cd3420253cdced$export$2e2bcd8739ae039).updateProductsInLocalStorage(target.dataset.productHandle);
                const targetClass = target.getAttribute("class") || "";
                const clonedTarget = target.cloneNode(true);
                this.element.setAttribute("class", targetClass);
                this.element.replaceChildren(...clonedTarget.childNodes);
                this.content = this.element.querySelector("[data-quick-view-content]");
                if (this.content) this.content.addEventListener("scroll", this.handleContentScroll);
            }
        }
    }
    resetProduct() {
        if (this.content) {
            this.content.removeEventListener("scroll", this.handleContentScroll);
            if (this.isRenderedOnPage) {
                const clonedContent = this.content.cloneNode(true);
                this.isRenderedOnPage.replaceChildren(...clonedContent.childNodes);
            }
            this.content = null;
        }
        this.element.replaceChildren();
    }
}
var $3cd23536a2e700ff$export$2e2bcd8739ae039 = $3cd23536a2e700ff$var$QuickViewComponent;


function $ac3e16be11e130a5$var$_extends() {
    $ac3e16be11e130a5$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ac3e16be11e130a5$var$_extends.apply(this, arguments);
}
var $ac3e16be11e130a5$var$DECAY = 0.996;
/**
 * movement projection based on velocity
 * @param velocityPxMs
 * @param decay
 */ var $ac3e16be11e130a5$export$b74061472fe7c07 = function projection(velocityPxMs, decay) {
    if (decay === void 0) decay = $ac3e16be11e130a5$var$DECAY;
    return velocityPxMs * decay / (1 - decay);
};
function $ac3e16be11e130a5$export$891a5c5c55cf41aa(array) {
    return array[array.length - 1];
}
function $ac3e16be11e130a5$export$cc6710ee5f037d57(numbers) {
    return numbers.reduce(function(a, b) {
        return a + b;
    }) / numbers.length;
}
var $ac3e16be11e130a5$export$7d15b64cf5a3a4c4 = function clamp(value, min, max) {
    return Math.min(Math.max(min, value), max);
};
function $ac3e16be11e130a5$export$75064e1c6824e15c(v1, v2) {
    if (v1.length !== v2.length) throw new Error("vectors must be same length");
    return v1.map(function(val, i) {
        return val + v2[i];
    });
}
function $ac3e16be11e130a5$export$bb8a7d60274b5fc6(numbers) {
    return Math.max.apply(Math, numbers.map(Math.abs));
} // eslint-disable-next-line @typescript-eslint/ban-types
function $ac3e16be11e130a5$export$7e32b29e1cb162e1(o) {
    Object.freeze(o);
    Object.values(o).forEach(function(value) {
        if (value !== null && typeof value === "object" && !Object.isFrozen(value)) $ac3e16be11e130a5$export$7e32b29e1cb162e1(value);
    });
    return o;
}
function $ac3e16be11e130a5$var$EventBus() {
    var listeners = {};
    function on(type, listener) {
        listeners[type] = (listeners[type] || []).concat(listener);
        return function() {
            return off(type, listener);
        };
    }
    function off(type, listener) {
        listeners[type] = (listeners[type] || []).filter(function(l) {
            return l !== listener;
        });
    }
    function dispatch(type, data) {
        if (!(type in listeners)) return;
        listeners[type].forEach(function(l) {
            return l(data);
        });
    }
    return $ac3e16be11e130a5$export$7e32b29e1cb162e1({
        on: on,
        off: off,
        dispatch: dispatch
    });
}
function $ac3e16be11e130a5$var$WheelTargetObserver(eventListener) {
    var targets = []; // add event listener to target element
    var observe = function observe(target) {
        target.addEventListener("wheel", eventListener, {
            passive: false
        });
        targets.push(target);
        return function() {
            return unobserve(target);
        };
    }; /// remove event listener from target element
    var unobserve = function unobserve(target) {
        target.removeEventListener("wheel", eventListener);
        targets = targets.filter(function(t) {
            return t !== target;
        });
    }; // stops watching all of its target elements for visibility changes.
    var disconnect = function disconnect() {
        targets.forEach(unobserve);
    };
    return $ac3e16be11e130a5$export$7e32b29e1cb162e1({
        observe: observe,
        unobserve: unobserve,
        disconnect: disconnect
    });
}
var $ac3e16be11e130a5$var$LINE_HEIGHT = 18;
var $ac3e16be11e130a5$var$PAGE_HEIGHT = typeof window !== "undefined" && window.innerHeight || 800;
var $ac3e16be11e130a5$var$DELTA_MODE_UNIT = [
    1,
    $ac3e16be11e130a5$var$LINE_HEIGHT,
    $ac3e16be11e130a5$var$PAGE_HEIGHT
];
function $ac3e16be11e130a5$var$normalizeWheel(e) {
    var deltaX = e.deltaX * $ac3e16be11e130a5$var$DELTA_MODE_UNIT[e.deltaMode];
    var deltaY = e.deltaY * $ac3e16be11e130a5$var$DELTA_MODE_UNIT[e.deltaMode];
    var deltaZ = (e.deltaZ || 0) * $ac3e16be11e130a5$var$DELTA_MODE_UNIT[e.deltaMode];
    return {
        timeStamp: e.timeStamp,
        axisDelta: [
            deltaX,
            deltaY,
            deltaZ
        ]
    };
}
var $ac3e16be11e130a5$var$reverseAll = [
    -1,
    -1,
    -1
];
function $ac3e16be11e130a5$var$reverseAxisDeltaSign(wheel, reverseSign) {
    if (!reverseSign) return wheel;
    var multipliers = reverseSign === true ? $ac3e16be11e130a5$var$reverseAll : reverseSign.map(function(shouldReverse) {
        return shouldReverse ? -1 : 1;
    });
    return $ac3e16be11e130a5$var$_extends({}, wheel, {
        axisDelta: wheel.axisDelta.map(function(delta, i) {
            return delta * multipliers[i];
        })
    });
}
var $ac3e16be11e130a5$var$DELTA_MAX_ABS = 700;
var $ac3e16be11e130a5$var$clampAxisDelta = function clampAxisDelta(wheel) {
    return $ac3e16be11e130a5$var$_extends({}, wheel, {
        axisDelta: wheel.axisDelta.map(function(delta) {
            return $ac3e16be11e130a5$export$7d15b64cf5a3a4c4(delta, -$ac3e16be11e130a5$var$DELTA_MAX_ABS, $ac3e16be11e130a5$var$DELTA_MAX_ABS);
        })
    });
};
var $ac3e16be11e130a5$var$__DEV__ = false;
var $ac3e16be11e130a5$var$ACC_FACTOR_MIN = 0.6;
var $ac3e16be11e130a5$var$ACC_FACTOR_MAX = 0.96;
var $ac3e16be11e130a5$var$WHEELEVENTS_TO_MERGE = 2;
var $ac3e16be11e130a5$var$WHEELEVENTS_TO_ANALAZE = 5;
var $ac3e16be11e130a5$export$3208dd15ca232a1a = /*#__PURE__*/ $ac3e16be11e130a5$export$7e32b29e1cb162e1({
    preventWheelAction: true,
    reverseSign: [
        true,
        true,
        false
    ]
});
var $ac3e16be11e130a5$var$WILL_END_TIMEOUT_DEFAULT = 400;
function $ac3e16be11e130a5$var$createWheelGesturesState() {
    return {
        isStarted: false,
        isStartPublished: false,
        isMomentum: false,
        startTime: 0,
        lastAbsDelta: Infinity,
        axisMovement: [
            0,
            0,
            0
        ],
        axisVelocity: [
            0,
            0,
            0
        ],
        accelerationFactors: [],
        scrollPoints: [],
        scrollPointsToMerge: [],
        willEndTimeout: $ac3e16be11e130a5$var$WILL_END_TIMEOUT_DEFAULT
    };
}
function $ac3e16be11e130a5$export$fd0a73f04f41aa21(optionsParam) {
    if (optionsParam === void 0) optionsParam = {};
    var _EventBus = $ac3e16be11e130a5$var$EventBus(), on = _EventBus.on, off = _EventBus.off, dispatch = _EventBus.dispatch;
    var config = $ac3e16be11e130a5$export$3208dd15ca232a1a;
    var state = $ac3e16be11e130a5$var$createWheelGesturesState();
    var currentEvent;
    var negativeZeroFingerUpSpecialEvent = false;
    var prevWheelEventState;
    var feedWheel = function feedWheel(wheelEvents) {
        if (Array.isArray(wheelEvents)) wheelEvents.forEach(function(wheelEvent) {
            return processWheelEventData(wheelEvent);
        });
        else processWheelEventData(wheelEvents);
    };
    var updateOptions = function updateOptions(newOptions) {
        if (newOptions === void 0) newOptions = {};
        if (Object.values(newOptions).some(function(option) {
            return option === undefined || option === null;
        })) {
            $ac3e16be11e130a5$var$__DEV__ && console.error("updateOptions ignored! undefined & null options not allowed");
            return config;
        }
        return config = $ac3e16be11e130a5$export$7e32b29e1cb162e1($ac3e16be11e130a5$var$_extends({}, $ac3e16be11e130a5$export$3208dd15ca232a1a, config, newOptions));
    };
    var publishWheel = function publishWheel(additionalData) {
        var wheelEventState = $ac3e16be11e130a5$var$_extends({
            event: currentEvent,
            isStart: false,
            isEnding: false,
            isMomentumCancel: false,
            isMomentum: state.isMomentum,
            axisDelta: [
                0,
                0,
                0
            ],
            axisVelocity: state.axisVelocity,
            axisMovement: state.axisMovement,
            get axisMovementProjection () {
                return $ac3e16be11e130a5$export$75064e1c6824e15c(wheelEventState.axisMovement, wheelEventState.axisVelocity.map(function(velocity) {
                    return $ac3e16be11e130a5$export$b74061472fe7c07(velocity);
                }));
            }
        }, additionalData);
        dispatch("wheel", $ac3e16be11e130a5$var$_extends({}, wheelEventState, {
            previous: prevWheelEventState
        })); // keep reference without previous, otherwise we would create a long chain
        prevWheelEventState = wheelEventState;
    }; // should prevent when there is mainly movement on the desired axis
    var shouldPreventDefault = function shouldPreventDefault(deltaMaxAbs, axisDelta) {
        var _config = config, preventWheelAction = _config.preventWheelAction;
        var deltaX = axisDelta[0], deltaY = axisDelta[1], deltaZ = axisDelta[2];
        if (typeof preventWheelAction === "boolean") return preventWheelAction;
        switch(preventWheelAction){
            case "x":
                return Math.abs(deltaX) >= deltaMaxAbs;
            case "y":
                return Math.abs(deltaY) >= deltaMaxAbs;
            case "z":
                return Math.abs(deltaZ) >= deltaMaxAbs;
            default:
                $ac3e16be11e130a5$var$__DEV__ && console.warn("unsupported preventWheelAction value: " + preventWheelAction, "warn");
                return false;
        }
    };
    var processWheelEventData = function processWheelEventData(wheelEvent) {
        var _clampAxisDelta = $ac3e16be11e130a5$var$clampAxisDelta($ac3e16be11e130a5$var$reverseAxisDeltaSign($ac3e16be11e130a5$var$normalizeWheel(wheelEvent), config.reverseSign)), axisDelta = _clampAxisDelta.axisDelta, timeStamp = _clampAxisDelta.timeStamp;
        var deltaMaxAbs = $ac3e16be11e130a5$export$bb8a7d60274b5fc6(axisDelta);
        if (wheelEvent.preventDefault && shouldPreventDefault(deltaMaxAbs, axisDelta)) wheelEvent.preventDefault();
        if (!state.isStarted) start();
        else if (state.isMomentum && deltaMaxAbs > Math.max(2, state.lastAbsDelta * 2)) {
            end(true);
            start();
        } // special finger up event on windows + blink
        if (deltaMaxAbs === 0 && Object.is && Object.is(wheelEvent.deltaX, -0)) {
            negativeZeroFingerUpSpecialEvent = true; // return -> zero delta event should not influence velocity
            return;
        }
        currentEvent = wheelEvent;
        state.axisMovement = $ac3e16be11e130a5$export$75064e1c6824e15c(state.axisMovement, axisDelta);
        state.lastAbsDelta = deltaMaxAbs;
        state.scrollPointsToMerge.push({
            axisDelta: axisDelta,
            timeStamp: timeStamp
        });
        mergeScrollPointsCalcVelocity(); // only wheel event (move) and not start/end get the delta values
        publishWheel({
            axisDelta: axisDelta,
            isStart: !state.isStartPublished
        }); // state.isMomentum ? MOMENTUM_WHEEL : WHEEL, { axisDelta })
        // publish start after velocity etc. have been updated
        state.isStartPublished = true; // calc debounced end function, to recognize end of wheel event stream
        willEnd();
    };
    var mergeScrollPointsCalcVelocity = function mergeScrollPointsCalcVelocity() {
        if (state.scrollPointsToMerge.length === $ac3e16be11e130a5$var$WHEELEVENTS_TO_MERGE) {
            state.scrollPoints.unshift({
                axisDeltaSum: state.scrollPointsToMerge.map(function(b) {
                    return b.axisDelta;
                }).reduce($ac3e16be11e130a5$export$75064e1c6824e15c),
                timeStamp: $ac3e16be11e130a5$export$cc6710ee5f037d57(state.scrollPointsToMerge.map(function(b) {
                    return b.timeStamp;
                }))
            }); // only update velocity after a merged scrollpoint was generated
            updateVelocity(); // reset toMerge array
            state.scrollPointsToMerge.length = 0; // after calculation of velocity only keep the most recent merged scrollPoint
            state.scrollPoints.length = 1;
            if (!state.isMomentum) detectMomentum();
        } else if (!state.isStartPublished) updateStartVelocity();
    };
    var updateStartVelocity = function updateStartVelocity() {
        state.axisVelocity = $ac3e16be11e130a5$export$891a5c5c55cf41aa(state.scrollPointsToMerge).axisDelta.map(function(d) {
            return d / state.willEndTimeout;
        });
    };
    var updateVelocity = function updateVelocity() {
        // need to have two recent points to calc velocity
        var _state$scrollPoints = state.scrollPoints, latestScrollPoint = _state$scrollPoints[0], prevScrollPoint = _state$scrollPoints[1];
        if (!prevScrollPoint || !latestScrollPoint) return;
         // time delta
        var deltaTime = latestScrollPoint.timeStamp - prevScrollPoint.timeStamp;
        if (deltaTime <= 0) {
            $ac3e16be11e130a5$var$__DEV__ && console.warn("invalid deltaTime");
            return;
        } // calc the velocity per axes
        var velocity = latestScrollPoint.axisDeltaSum.map(function(d) {
            return d / deltaTime;
        }); // calc the acceleration factor per axis
        var accelerationFactor = velocity.map(function(v, i) {
            return v / (state.axisVelocity[i] || 1);
        });
        state.axisVelocity = velocity;
        state.accelerationFactors.push(accelerationFactor);
        updateWillEndTimeout(deltaTime);
    };
    var updateWillEndTimeout = function updateWillEndTimeout(deltaTime) {
        // use current time between events rounded up and increased by a bit as timeout
        var newTimeout = Math.ceil(deltaTime / 10) * 12; // double the timeout, when momentum was not detected yet
        if (!state.isMomentum) newTimeout = Math.max(100, newTimeout * 2);
        state.willEndTimeout = Math.min(1000, Math.round(newTimeout));
    };
    var accelerationFactorInMomentumRange = function accelerationFactorInMomentumRange(accFactor) {
        // when main axis is the the other one and there is no movement/change on the current one
        if (accFactor === 0) return true;
        return accFactor <= $ac3e16be11e130a5$var$ACC_FACTOR_MAX && accFactor >= $ac3e16be11e130a5$var$ACC_FACTOR_MIN;
    };
    var detectMomentum = function detectMomentum() {
        if (state.accelerationFactors.length >= $ac3e16be11e130a5$var$WHEELEVENTS_TO_ANALAZE) {
            if (negativeZeroFingerUpSpecialEvent) {
                negativeZeroFingerUpSpecialEvent = false;
                if ($ac3e16be11e130a5$export$bb8a7d60274b5fc6(state.axisVelocity) >= 0.2) {
                    recognizedMomentum();
                    return;
                }
            }
            var recentAccelerationFactors = state.accelerationFactors.slice($ac3e16be11e130a5$var$WHEELEVENTS_TO_ANALAZE * -1); // check recent acceleration / deceleration factors
            // all recent need to match, if any did not match
            var detectedMomentum = recentAccelerationFactors.every(function(accFac) {
                // when both axis decelerate exactly in the same rate it is very likely caused by momentum
                var sameAccFac = !!accFac.reduce(function(f1, f2) {
                    return f1 && f1 < 1 && f1 === f2 ? 1 : 0;
                }); // check if acceleration factor is within momentum range
                var bothAreInRangeOrZero = accFac.filter(accelerationFactorInMomentumRange).length === accFac.length; // one the requirements must be fulfilled
                return sameAccFac || bothAreInRangeOrZero;
            });
            if (detectedMomentum) recognizedMomentum();
             // only keep the most recent events
            state.accelerationFactors = recentAccelerationFactors;
        }
    };
    var recognizedMomentum = function recognizedMomentum() {
        state.isMomentum = true;
    };
    var start = function start() {
        state = $ac3e16be11e130a5$var$createWheelGesturesState();
        state.isStarted = true;
        state.startTime = Date.now();
        prevWheelEventState = undefined;
        negativeZeroFingerUpSpecialEvent = false;
    };
    var willEnd = function() {
        var willEndId;
        return function() {
            clearTimeout(willEndId);
            willEndId = setTimeout(end, state.willEndTimeout);
        };
    }();
    var end = function end(isMomentumCancel) {
        if (isMomentumCancel === void 0) isMomentumCancel = false;
        if (!state.isStarted) return;
        if (state.isMomentum && isMomentumCancel) publishWheel({
            isEnding: true,
            isMomentumCancel: true
        });
        else publishWheel({
            isEnding: true
        });
        state.isMomentum = false;
        state.isStarted = false;
    };
    var _WheelTargetObserver = $ac3e16be11e130a5$var$WheelTargetObserver(feedWheel), observe = _WheelTargetObserver.observe, unobserve = _WheelTargetObserver.unobserve, disconnect = _WheelTargetObserver.disconnect;
    updateOptions(optionsParam);
    return $ac3e16be11e130a5$export$7e32b29e1cb162e1({
        on: on,
        off: off,
        observe: observe,
        unobserve: unobserve,
        disconnect: disconnect,
        feedWheel: feedWheel,
        updateOptions: updateOptions
    });
}
var $ac3e16be11e130a5$export$2e2bcd8739ae039 = $ac3e16be11e130a5$export$fd0a73f04f41aa21;


var $72cc5d09e7e9c7ab$var$defaultOptions = {
    active: true,
    breakpoints: {},
    wheelDraggingClass: "is-wheel-dragging",
    forceWheelAxis: undefined,
    target: undefined
};
$72cc5d09e7e9c7ab$export$1c3f64aa406d3265.globalOptions = undefined;
var $72cc5d09e7e9c7ab$var$__DEV__ = false;
function $72cc5d09e7e9c7ab$export$1c3f64aa406d3265(userOptions) {
    if (userOptions === void 0) userOptions = {};
    var options;
    var cleanup = function cleanup() {};
    function init(embla, optionsHandler) {
        var _options$target, _options$forceWheelAx;
        var mergeOptions = optionsHandler.mergeOptions, optionsAtMedia = optionsHandler.optionsAtMedia;
        var optionsBase = mergeOptions($72cc5d09e7e9c7ab$var$defaultOptions, $72cc5d09e7e9c7ab$export$1c3f64aa406d3265.globalOptions);
        var allOptions = mergeOptions(optionsBase, userOptions);
        options = optionsAtMedia(allOptions);
        var engine = embla.internalEngine();
        var targetNode = (_options$target = options.target) != null ? _options$target : embla.containerNode().parentNode;
        var wheelAxis = (_options$forceWheelAx = options.forceWheelAxis) != null ? _options$forceWheelAx : engine.options.axis;
        var wheelGestures = (0, $ac3e16be11e130a5$export$2e2bcd8739ae039)({
            preventWheelAction: wheelAxis,
            reverseSign: [
                true,
                true,
                false
            ]
        });
        var unobserveTargetNode = wheelGestures.observe(targetNode);
        var offWheel = wheelGestures.on("wheel", handleWheel);
        var isStarted = false;
        var startEvent;
        function wheelGestureStarted(state) {
            try {
                startEvent = new MouseEvent("mousedown", state.event);
                dispatchEvent(startEvent);
            } catch (e) {
                // Legacy Browsers like IE 10 & 11 will throw when attempting to create the Event
                if ($72cc5d09e7e9c7ab$var$__DEV__) console.warn("Legacy browser requires events-polyfill (https://github.com/xiel/embla-carousel-wheel-gestures#legacy-browsers)");
                return cleanup();
            }
            isStarted = true;
            addNativeMouseEventListeners();
            if (options.wheelDraggingClass) targetNode.classList.add(options.wheelDraggingClass);
        }
        function wheelGestureEnded(state) {
            isStarted = false;
            dispatchEvent(createRelativeMouseEvent("mouseup", state));
            removeNativeMouseEventListeners();
            if (options.wheelDraggingClass) targetNode.classList.remove(options.wheelDraggingClass);
        }
        function addNativeMouseEventListeners() {
            document.documentElement.addEventListener("mousemove", preventNativeMouseHandler, true);
            document.documentElement.addEventListener("mouseup", preventNativeMouseHandler, true);
            document.documentElement.addEventListener("mousedown", preventNativeMouseHandler, true);
        }
        function removeNativeMouseEventListeners() {
            document.documentElement.removeEventListener("mousemove", preventNativeMouseHandler, true);
            document.documentElement.removeEventListener("mouseup", preventNativeMouseHandler, true);
            document.documentElement.removeEventListener("mousedown", preventNativeMouseHandler, true);
        }
        function preventNativeMouseHandler(e) {
            if (isStarted && e.isTrusted) e.stopImmediatePropagation();
        }
        function createRelativeMouseEvent(type, state) {
            var moveX, moveY;
            if (wheelAxis === engine.options.axis) {
                var _state$axisMovement = state.axisMovement;
                moveX = _state$axisMovement[0];
                moveY = _state$axisMovement[1];
            } else {
                var _state$axisMovement2 = state.axisMovement;
                moveY = _state$axisMovement2[0];
                moveX = _state$axisMovement2[1];
            }
            return new MouseEvent(type, {
                clientX: startEvent.clientX + moveX,
                clientY: startEvent.clientY + moveY,
                screenX: startEvent.screenX + moveX,
                screenY: startEvent.screenY + moveY,
                movementX: moveX,
                movementY: moveY,
                button: 0,
                bubbles: true,
                cancelable: true,
                composed: true
            });
        }
        function dispatchEvent(event) {
            embla.containerNode().dispatchEvent(event);
        }
        function handleWheel(state) {
            var _state$axisDelta = state.axisDelta, deltaX = _state$axisDelta[0], deltaY = _state$axisDelta[1];
            var primaryAxisDelta = wheelAxis === "x" ? deltaX : deltaY;
            var crossAxisDelta = wheelAxis === "x" ? deltaY : deltaX;
            var isRelease = state.isMomentum && state.previous && !state.previous.isMomentum;
            var isEndingOrRelease = state.isEnding && !state.isMomentum || isRelease;
            var primaryAxisDeltaIsDominant = Math.abs(primaryAxisDelta) > Math.abs(crossAxisDelta);
            if (primaryAxisDeltaIsDominant && !isStarted && !state.isMomentum) wheelGestureStarted(state);
            if (!isStarted) return;
            if (isEndingOrRelease) wheelGestureEnded(state);
            else dispatchEvent(createRelativeMouseEvent("mousemove", state));
        }
        cleanup = function cleanup() {
            unobserveTargetNode();
            offWheel();
            removeNativeMouseEventListeners();
        };
    }
    var self = {
        name: "wheelGestures",
        options: userOptions,
        init: init,
        destroy: function destroy() {
            return cleanup();
        }
    };
    return self;
}



function $b2c6a347bb6bb2cc$var$isNumber(subject) {
    return typeof subject === "number";
}
function $b2c6a347bb6bb2cc$var$isString(subject) {
    return typeof subject === "string";
}
function $b2c6a347bb6bb2cc$var$isBoolean(subject) {
    return typeof subject === "boolean";
}
function $b2c6a347bb6bb2cc$var$isObject(subject) {
    return Object.prototype.toString.call(subject) === "[object Object]";
}
function $b2c6a347bb6bb2cc$var$mathAbs(n) {
    return Math.abs(n);
}
function $b2c6a347bb6bb2cc$var$mathSign(n) {
    return Math.sign(n);
}
function $b2c6a347bb6bb2cc$var$deltaAbs(valueB, valueA) {
    return $b2c6a347bb6bb2cc$var$mathAbs(valueB - valueA);
}
function $b2c6a347bb6bb2cc$var$factorAbs(valueB, valueA) {
    if (valueB === 0 || valueA === 0) return 0;
    if ($b2c6a347bb6bb2cc$var$mathAbs(valueB) <= $b2c6a347bb6bb2cc$var$mathAbs(valueA)) return 0;
    const diff = $b2c6a347bb6bb2cc$var$deltaAbs($b2c6a347bb6bb2cc$var$mathAbs(valueB), $b2c6a347bb6bb2cc$var$mathAbs(valueA));
    return $b2c6a347bb6bb2cc$var$mathAbs(diff / valueB);
}
function $b2c6a347bb6bb2cc$var$arrayKeys(array) {
    return $b2c6a347bb6bb2cc$var$objectKeys(array).map(Number);
}
function $b2c6a347bb6bb2cc$var$arrayLast(array) {
    return array[$b2c6a347bb6bb2cc$var$arrayLastIndex(array)];
}
function $b2c6a347bb6bb2cc$var$arrayLastIndex(array) {
    return Math.max(0, array.length - 1);
}
function $b2c6a347bb6bb2cc$var$arrayFromNumber(n, startAt = 0) {
    return Array.from(Array(n), (_, i)=>startAt + i);
}
function $b2c6a347bb6bb2cc$var$objectKeys(object) {
    return Object.keys(object);
}
function $b2c6a347bb6bb2cc$var$objectsMergeDeep(objectA, objectB) {
    return [
        objectA,
        objectB
    ].reduce((mergedObjects, currentObject)=>{
        $b2c6a347bb6bb2cc$var$objectKeys(currentObject).forEach((key)=>{
            const valueA = mergedObjects[key];
            const valueB = currentObject[key];
            const areObjects = $b2c6a347bb6bb2cc$var$isObject(valueA) && $b2c6a347bb6bb2cc$var$isObject(valueB);
            mergedObjects[key] = areObjects ? $b2c6a347bb6bb2cc$var$objectsMergeDeep(valueA, valueB) : valueB;
        });
        return mergedObjects;
    }, {});
}
function $b2c6a347bb6bb2cc$var$isMouseEvent(evt, ownerWindow) {
    return typeof ownerWindow.MouseEvent !== "undefined" && evt instanceof ownerWindow.MouseEvent;
}
function $b2c6a347bb6bb2cc$var$Alignment(align, viewSize) {
    const predefined = {
        start: start,
        center: center,
        end: end
    };
    function start() {
        return 0;
    }
    function center(n) {
        return end(n) / 2;
    }
    function end(n) {
        return viewSize - n;
    }
    function percent() {
        return viewSize * Number(align);
    }
    function measure(n) {
        if ($b2c6a347bb6bb2cc$var$isNumber(align)) return percent();
        return predefined[align](n);
    }
    const self = {
        measure: measure
    };
    return self;
}
function $b2c6a347bb6bb2cc$var$Axis(axis, direction) {
    const scroll = axis === "y" ? "y" : "x";
    const cross = axis === "y" ? "x" : "y";
    const startEdge = getStartEdge();
    const endEdge = getEndEdge();
    function measureSize(rect) {
        const { width: width, height: height } = rect;
        return scroll === "x" ? width : height;
    }
    function getStartEdge() {
        if (scroll === "y") return "top";
        return direction === "rtl" ? "right" : "left";
    }
    function getEndEdge() {
        if (scroll === "y") return "bottom";
        return direction === "rtl" ? "left" : "right";
    }
    const self = {
        scroll: scroll,
        cross: cross,
        startEdge: startEdge,
        endEdge: endEdge,
        measureSize: measureSize
    };
    return self;
}
function $b2c6a347bb6bb2cc$var$Limit(min, max) {
    const length = $b2c6a347bb6bb2cc$var$mathAbs(min - max);
    function reachedMin(n) {
        return n < min;
    }
    function reachedMax(n) {
        return n > max;
    }
    function reachedAny(n) {
        return reachedMin(n) || reachedMax(n);
    }
    function constrain(n) {
        if (!reachedAny(n)) return n;
        return reachedMin(n) ? min : max;
    }
    function removeOffset(n) {
        if (!length) return n;
        return n - length * Math.ceil((n - max) / length);
    }
    const self = {
        length: length,
        max: max,
        min: min,
        constrain: constrain,
        reachedAny: reachedAny,
        reachedMax: reachedMax,
        reachedMin: reachedMin,
        removeOffset: removeOffset
    };
    return self;
}
function $b2c6a347bb6bb2cc$var$Counter(max, start, loop) {
    const { constrain: constrain } = $b2c6a347bb6bb2cc$var$Limit(0, max);
    const loopEnd = max + 1;
    let counter = withinLimit(start);
    function withinLimit(n) {
        return !loop ? constrain(n) : $b2c6a347bb6bb2cc$var$mathAbs((loopEnd + n) % loopEnd);
    }
    function get() {
        return counter;
    }
    function set(n) {
        counter = withinLimit(n);
        return self;
    }
    function add(n) {
        return clone().set(get() + n);
    }
    function clone() {
        return $b2c6a347bb6bb2cc$var$Counter(max, get(), loop);
    }
    const self = {
        get: get,
        set: set,
        add: add,
        clone: clone
    };
    return self;
}
function $b2c6a347bb6bb2cc$var$Direction(direction) {
    const sign = direction === "rtl" ? -1 : 1;
    function apply(n) {
        return n * sign;
    }
    const self = {
        apply: apply
    };
    return self;
}
function $b2c6a347bb6bb2cc$var$EventStore() {
    let listeners = [];
    function add(node, type, handler, options = {
        passive: true
    }) {
        let removeListener;
        if ("addEventListener" in node) {
            node.addEventListener(type, handler, options);
            removeListener = ()=>node.removeEventListener(type, handler, options);
        } else {
            const legacyMediaQueryList = node;
            legacyMediaQueryList.addListener(handler);
            removeListener = ()=>legacyMediaQueryList.removeListener(handler);
        }
        listeners.push(removeListener);
        return self;
    }
    function clear() {
        listeners = listeners.filter((remove)=>remove());
    }
    const self = {
        add: add,
        clear: clear
    };
    return self;
}
function $b2c6a347bb6bb2cc$var$DragHandler(axis, direction, rootNode, ownerDocument, ownerWindow, target, dragTracker, location, animation, scrollTo, scrollBody, scrollTarget, index, eventHandler, percentOfView, dragFree, dragThreshold, skipSnaps, baseFriction, watchDrag) {
    const { cross: crossAxis } = axis;
    const focusNodes = [
        "INPUT",
        "SELECT",
        "TEXTAREA"
    ];
    const nonPassiveEvent = {
        passive: false
    };
    const initEvents = $b2c6a347bb6bb2cc$var$EventStore();
    const dragEvents = $b2c6a347bb6bb2cc$var$EventStore();
    const goToNextThreshold = $b2c6a347bb6bb2cc$var$Limit(50, 225).constrain(percentOfView.measure(20));
    const snapForceBoost = {
        mouse: 300,
        touch: 400
    };
    const freeForceBoost = {
        mouse: 500,
        touch: 600
    };
    const baseSpeed = dragFree ? 43 : 25;
    let isMoving = false;
    let startScroll = 0;
    let startCross = 0;
    let pointerIsDown = false;
    let preventScroll = false;
    let preventClick = false;
    let isMouse = false;
    function init(emblaApi) {
        if (!watchDrag) return;
        function downIfAllowed(evt) {
            if ($b2c6a347bb6bb2cc$var$isBoolean(watchDrag) || watchDrag(emblaApi, evt)) down(evt);
        }
        const node = rootNode;
        initEvents.add(node, "dragstart", (evt)=>evt.preventDefault(), nonPassiveEvent).add(node, "touchmove", ()=>undefined, nonPassiveEvent).add(node, "touchend", ()=>undefined).add(node, "touchstart", downIfAllowed).add(node, "mousedown", downIfAllowed).add(node, "touchcancel", up).add(node, "contextmenu", up).add(node, "click", click, true);
    }
    function destroy() {
        initEvents.clear();
        dragEvents.clear();
    }
    function addDragEvents() {
        const node = isMouse ? ownerDocument : rootNode;
        dragEvents.add(node, "touchmove", move, nonPassiveEvent).add(node, "touchend", up).add(node, "mousemove", move, nonPassiveEvent).add(node, "mouseup", up);
    }
    function isFocusNode(node) {
        const nodeName = node.nodeName || "";
        return focusNodes.includes(nodeName);
    }
    function forceBoost() {
        const boost = dragFree ? freeForceBoost : snapForceBoost;
        const type = isMouse ? "mouse" : "touch";
        return boost[type];
    }
    function allowedForce(force, targetChanged) {
        const next = index.add($b2c6a347bb6bb2cc$var$mathSign(force) * -1);
        const baseForce = scrollTarget.byDistance(force, !dragFree).distance;
        if (dragFree || $b2c6a347bb6bb2cc$var$mathAbs(force) < goToNextThreshold) return baseForce;
        if (skipSnaps && targetChanged) return baseForce * 0.5;
        return scrollTarget.byIndex(next.get(), 0).distance;
    }
    function down(evt) {
        const isMouseEvt = $b2c6a347bb6bb2cc$var$isMouseEvent(evt, ownerWindow);
        isMouse = isMouseEvt;
        if (isMouseEvt && evt.button !== 0) return;
        if (isFocusNode(evt.target)) return;
        preventClick = dragFree && isMouseEvt && !evt.buttons && isMoving;
        isMoving = $b2c6a347bb6bb2cc$var$deltaAbs(target.get(), location.get()) >= 2;
        pointerIsDown = true;
        dragTracker.pointerDown(evt);
        scrollBody.useFriction(0).useDuration(0);
        target.set(location);
        addDragEvents();
        startScroll = dragTracker.readPoint(evt);
        startCross = dragTracker.readPoint(evt, crossAxis);
        eventHandler.emit("pointerDown");
    }
    function move(evt) {
        const lastScroll = dragTracker.readPoint(evt);
        const lastCross = dragTracker.readPoint(evt, crossAxis);
        const diffScroll = $b2c6a347bb6bb2cc$var$deltaAbs(lastScroll, startScroll);
        const diffCross = $b2c6a347bb6bb2cc$var$deltaAbs(lastCross, startCross);
        if (!preventScroll && !isMouse) {
            if (!evt.cancelable) return up(evt);
            preventScroll = diffScroll > diffCross;
            if (!preventScroll) return up(evt);
        }
        const diff = dragTracker.pointerMove(evt);
        if (diffScroll > dragThreshold) preventClick = true;
        scrollBody.useFriction(0.3).useDuration(1);
        animation.start();
        target.add(direction.apply(diff));
        evt.preventDefault();
    }
    function up(evt) {
        const currentLocation = scrollTarget.byDistance(0, false);
        const targetChanged = currentLocation.index !== index.get();
        const rawForce = dragTracker.pointerUp(evt) * forceBoost();
        const force = allowedForce(direction.apply(rawForce), targetChanged);
        const forceFactor = $b2c6a347bb6bb2cc$var$factorAbs(rawForce, force);
        const speed = baseSpeed - 10 * forceFactor;
        const friction = baseFriction + forceFactor / 50;
        preventScroll = false;
        pointerIsDown = false;
        dragEvents.clear();
        scrollBody.useDuration(speed).useFriction(friction);
        scrollTo.distance(force, !dragFree);
        isMouse = false;
        eventHandler.emit("pointerUp");
    }
    function click(evt) {
        if (preventClick) {
            evt.stopPropagation();
            evt.preventDefault();
        }
    }
    function pointerDown() {
        return pointerIsDown;
    }
    const self = {
        init: init,
        pointerDown: pointerDown,
        destroy: destroy
    };
    return self;
}
function $b2c6a347bb6bb2cc$var$DragTracker(axis, ownerWindow) {
    const logInterval = 170;
    let startEvent;
    let lastEvent;
    function readTime(evt) {
        return evt.timeStamp;
    }
    function readPoint(evt, evtAxis) {
        const property = evtAxis || axis.scroll;
        const coord = `client${property === "x" ? "X" : "Y"}`;
        return ($b2c6a347bb6bb2cc$var$isMouseEvent(evt, ownerWindow) ? evt : evt.touches[0])[coord];
    }
    function pointerDown(evt) {
        startEvent = evt;
        lastEvent = evt;
        return readPoint(evt);
    }
    function pointerMove(evt) {
        const diff = readPoint(evt) - readPoint(lastEvent);
        const expired = readTime(evt) - readTime(startEvent) > logInterval;
        lastEvent = evt;
        if (expired) startEvent = evt;
        return diff;
    }
    function pointerUp(evt) {
        if (!startEvent || !lastEvent) return 0;
        const diffDrag = readPoint(lastEvent) - readPoint(startEvent);
        const diffTime = readTime(evt) - readTime(startEvent);
        const expired = readTime(evt) - readTime(lastEvent) > logInterval;
        const force = diffDrag / diffTime;
        const isFlick = diffTime && !expired && $b2c6a347bb6bb2cc$var$mathAbs(force) > 0.1;
        return isFlick ? force : 0;
    }
    const self = {
        pointerDown: pointerDown,
        pointerMove: pointerMove,
        pointerUp: pointerUp,
        readPoint: readPoint
    };
    return self;
}
function $b2c6a347bb6bb2cc$var$PercentOfView(viewSize) {
    function measure(n) {
        return viewSize * (n / 100);
    }
    const self = {
        measure: measure
    };
    return self;
}
function $b2c6a347bb6bb2cc$var$ResizeHandler(container, eventHandler, ownerWindow, slides, axis, watchResize) {
    let resizeObserver;
    let containerSize;
    let slideSizes = [];
    let destroyed = false;
    function readSize(node) {
        return axis.measureSize(node.getBoundingClientRect());
    }
    function init(emblaApi) {
        if (!watchResize) return;
        containerSize = readSize(container);
        slideSizes = slides.map(readSize);
        function defaultCallback(entries) {
            for (const entry of entries){
                const isContainer = entry.target === container;
                const slideIndex = slides.indexOf(entry.target);
                const lastSize = isContainer ? containerSize : slideSizes[slideIndex];
                const newSize = readSize(isContainer ? container : slides[slideIndex]);
                const diffSize = $b2c6a347bb6bb2cc$var$mathAbs(newSize - lastSize);
                if (diffSize >= 0.2) {
                    ownerWindow.requestAnimationFrame(()=>{
                        emblaApi.reInit();
                        eventHandler.emit("resize");
                    });
                    break;
                }
            }
        }
        resizeObserver = new ResizeObserver((entries)=>{
            if (destroyed) return;
            if ($b2c6a347bb6bb2cc$var$isBoolean(watchResize) || watchResize(emblaApi, entries)) defaultCallback(entries);
        });
        const observeNodes = [
            container
        ].concat(slides);
        observeNodes.forEach((node)=>resizeObserver.observe(node));
    }
    function destroy() {
        if (resizeObserver) resizeObserver.disconnect();
        destroyed = true;
    }
    const self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $b2c6a347bb6bb2cc$var$ScrollBody(location, target, baseDuration, baseFriction) {
    let hasSettled = true;
    let bodyVelocity = 0;
    let scrollDirection = 0;
    let scrollDuration = baseDuration;
    let scrollFriction = baseFriction;
    let rawLocation = location.get();
    let rawLocationPrevious = 0;
    function seek() {
        const diff = target.get() - location.get();
        const isInstant = !scrollDuration;
        let directionDiff = 0;
        if (isInstant) {
            bodyVelocity = 0;
            location.set(target);
            directionDiff = diff;
        } else {
            bodyVelocity += diff / scrollDuration;
            bodyVelocity *= scrollFriction;
            rawLocation += bodyVelocity;
            location.add(bodyVelocity);
            directionDiff = rawLocation - rawLocationPrevious;
        }
        scrollDirection = $b2c6a347bb6bb2cc$var$mathSign(directionDiff);
        rawLocationPrevious = rawLocation;
        hasSettled = $b2c6a347bb6bb2cc$var$mathAbs(diff) < 0.001;
        return self;
    }
    function settled() {
        return hasSettled;
    }
    function duration() {
        return scrollDuration;
    }
    function direction() {
        return scrollDirection;
    }
    function velocity() {
        return bodyVelocity;
    }
    function useBaseDuration() {
        return useDuration(baseDuration);
    }
    function useBaseFriction() {
        return useFriction(baseFriction);
    }
    function useDuration(n) {
        scrollDuration = n;
        return self;
    }
    function useFriction(n) {
        scrollFriction = n;
        return self;
    }
    const self = {
        direction: direction,
        duration: duration,
        velocity: velocity,
        seek: seek,
        settled: settled,
        useBaseFriction: useBaseFriction,
        useBaseDuration: useBaseDuration,
        useFriction: useFriction,
        useDuration: useDuration
    };
    return self;
}
function $b2c6a347bb6bb2cc$var$ScrollBounds(limit, location, target, scrollBody, percentOfView) {
    const pullBackThreshold = percentOfView.measure(10);
    const edgeOffsetTolerance = percentOfView.measure(50);
    const frictionLimit = $b2c6a347bb6bb2cc$var$Limit(0.1, 0.99);
    let disabled = false;
    function shouldConstrain() {
        if (disabled) return false;
        if (!limit.reachedAny(target.get())) return false;
        if (!limit.reachedAny(location.get())) return false;
        return true;
    }
    function constrain(pointerDown) {
        if (!shouldConstrain()) return;
        const edge = limit.reachedMin(location.get()) ? "min" : "max";
        const diffToEdge = $b2c6a347bb6bb2cc$var$mathAbs(limit[edge] - location.get());
        const diffToTarget = target.get() - location.get();
        const friction = frictionLimit.constrain(diffToEdge / edgeOffsetTolerance);
        target.subtract(diffToTarget * friction);
        if (!pointerDown && $b2c6a347bb6bb2cc$var$mathAbs(diffToTarget) < pullBackThreshold) {
            target.set(limit.constrain(target.get()));
            scrollBody.useDuration(25).useBaseFriction();
        }
    }
    function toggleActive(active) {
        disabled = !active;
    }
    const self = {
        constrain: constrain,
        toggleActive: toggleActive
    };
    return self;
}
function $b2c6a347bb6bb2cc$var$ScrollContain(viewSize, contentSize, snapsAligned, containScroll) {
    const scrollBounds = $b2c6a347bb6bb2cc$var$Limit(-contentSize + viewSize, 0);
    const snapsBounded = measureBounded();
    const scrollContainLimit = findScrollContainLimit();
    const snapsContained = measureContained();
    function findScrollContainLimit() {
        const startSnap = snapsBounded[0];
        const endSnap = $b2c6a347bb6bb2cc$var$arrayLast(snapsBounded);
        const min = snapsBounded.lastIndexOf(startSnap);
        const max = snapsBounded.indexOf(endSnap) + 1;
        return $b2c6a347bb6bb2cc$var$Limit(min, max);
    }
    function measureBounded() {
        return snapsAligned.map(scrollBounds.constrain).map((scrollBound)=>parseFloat(scrollBound.toFixed(3)));
    }
    function measureContained() {
        if (contentSize <= viewSize) return [
            scrollBounds.max
        ];
        if (containScroll === "keepSnaps") return snapsBounded;
        const { min: min, max: max } = scrollContainLimit;
        return snapsBounded.slice(min, max);
    }
    const self = {
        snapsContained: snapsContained,
        scrollContainLimit: scrollContainLimit
    };
    return self;
}
function $b2c6a347bb6bb2cc$var$ScrollLimit(contentSize, scrollSnaps, loop) {
    const max = scrollSnaps[0];
    const min = loop ? max - contentSize : $b2c6a347bb6bb2cc$var$arrayLast(scrollSnaps);
    const limit = $b2c6a347bb6bb2cc$var$Limit(min, max);
    const self = {
        limit: limit
    };
    return self;
}
function $b2c6a347bb6bb2cc$var$ScrollLooper(contentSize, limit, offsetLocation, vectors) {
    const jointSafety = 0.1;
    const min = limit.min + jointSafety;
    const max = limit.max + jointSafety;
    const { reachedMin: reachedMin, reachedMax: reachedMax } = $b2c6a347bb6bb2cc$var$Limit(min, max);
    function shouldLoop(direction) {
        if (direction === 1) return reachedMax(offsetLocation.get());
        if (direction === -1) return reachedMin(offsetLocation.get());
        return false;
    }
    function loop(direction) {
        if (!shouldLoop(direction)) return;
        const loopDistance = contentSize * (direction * -1);
        vectors.forEach((v)=>v.add(loopDistance));
    }
    const self = {
        loop: loop
    };
    return self;
}
function $b2c6a347bb6bb2cc$var$ScrollProgress(limit) {
    const { max: max, length: length } = limit;
    function get(n) {
        const currentLocation = n - max;
        return length ? currentLocation / -length : 0;
    }
    const self = {
        get: get
    };
    return self;
}
function $b2c6a347bb6bb2cc$var$ScrollSnaps(axis, alignment, containerRect, slideRects, slidesToScroll) {
    const { startEdge: startEdge, endEdge: endEdge } = axis;
    const { groupSlides: groupSlides } = slidesToScroll;
    const alignments = measureSizes().map(alignment.measure);
    const snaps = measureUnaligned();
    const snapsAligned = measureAligned();
    function measureSizes() {
        return groupSlides(slideRects).map((rects)=>$b2c6a347bb6bb2cc$var$arrayLast(rects)[endEdge] - rects[0][startEdge]).map($b2c6a347bb6bb2cc$var$mathAbs);
    }
    function measureUnaligned() {
        return slideRects.map((rect)=>containerRect[startEdge] - rect[startEdge]).map((snap)=>-$b2c6a347bb6bb2cc$var$mathAbs(snap));
    }
    function measureAligned() {
        return groupSlides(snaps).map((g)=>g[0]).map((snap, index)=>snap + alignments[index]);
    }
    const self = {
        snaps: snaps,
        snapsAligned: snapsAligned
    };
    return self;
}
function $b2c6a347bb6bb2cc$var$SlideRegistry(viewSize, contentSize, containSnaps, scrollContainLimit, slidesToScroll, slideIndexes) {
    const { groupSlides: groupSlides } = slidesToScroll;
    const { min: min, max: max } = scrollContainLimit;
    const slideRegistry = createSlideRegistry();
    function createSlideRegistry() {
        const groupedSlideIndexes = groupSlides(slideIndexes);
        if (!containSnaps || contentSize <= viewSize) return groupedSlideIndexes;
        return groupedSlideIndexes.slice(min, max).map((group, index, groups)=>{
            const indexIsFirst = !index;
            const indexIsLast = !indexIsFirst && index === $b2c6a347bb6bb2cc$var$arrayLastIndex(groups);
            if (indexIsFirst) {
                const range = $b2c6a347bb6bb2cc$var$arrayLast(groups[0]) + 1;
                return $b2c6a347bb6bb2cc$var$arrayFromNumber(range);
            }
            if (indexIsLast) {
                const range = $b2c6a347bb6bb2cc$var$arrayLastIndex(slideIndexes) - $b2c6a347bb6bb2cc$var$arrayLast(groups)[0] + 1;
                return $b2c6a347bb6bb2cc$var$arrayFromNumber(range, $b2c6a347bb6bb2cc$var$arrayLast(groups)[0]);
            }
            return group;
        });
    }
    const self = {
        slideRegistry: slideRegistry
    };
    return self;
}
function $b2c6a347bb6bb2cc$var$ScrollTarget(loop, scrollSnaps, contentSize, limit, targetVector) {
    const { reachedAny: reachedAny, removeOffset: removeOffset, constrain: constrain } = limit;
    function minDistance(distances) {
        return distances.concat().sort((a, b)=>$b2c6a347bb6bb2cc$var$mathAbs(a) - $b2c6a347bb6bb2cc$var$mathAbs(b))[0];
    }
    function findTargetSnap(target) {
        const distance = loop ? removeOffset(target) : constrain(target);
        const ascDiffsToSnaps = scrollSnaps.map((scrollSnap)=>scrollSnap - distance).map((diffToSnap)=>shortcut(diffToSnap, 0)).map((diff, i)=>({
                diff: diff,
                index: i
            })).sort((d1, d2)=>$b2c6a347bb6bb2cc$var$mathAbs(d1.diff) - $b2c6a347bb6bb2cc$var$mathAbs(d2.diff));
        const { index: index } = ascDiffsToSnaps[0];
        return {
            index: index,
            distance: distance
        };
    }
    function shortcut(target, direction) {
        const targets = [
            target,
            target + contentSize,
            target - contentSize
        ];
        if (!loop) return targets[0];
        if (!direction) return minDistance(targets);
        const matchingTargets = targets.filter((t)=>$b2c6a347bb6bb2cc$var$mathSign(t) === direction);
        if (matchingTargets.length) return minDistance(matchingTargets);
        return $b2c6a347bb6bb2cc$var$arrayLast(targets) - contentSize;
    }
    function byIndex(index, direction) {
        const diffToSnap = scrollSnaps[index] - targetVector.get();
        const distance = shortcut(diffToSnap, direction);
        return {
            index: index,
            distance: distance
        };
    }
    function byDistance(distance, snap) {
        const target = targetVector.get() + distance;
        const { index: index, distance: targetSnapDistance } = findTargetSnap(target);
        const reachedBound = !loop && reachedAny(target);
        if (!snap || reachedBound) return {
            index: index,
            distance: distance
        };
        const diffToSnap = scrollSnaps[index] - targetSnapDistance;
        const snapDistance = distance + shortcut(diffToSnap, 0);
        return {
            index: index,
            distance: snapDistance
        };
    }
    const self = {
        byDistance: byDistance,
        byIndex: byIndex,
        shortcut: shortcut
    };
    return self;
}
function $b2c6a347bb6bb2cc$var$ScrollTo(animation, indexCurrent, indexPrevious, scrollTarget, scrollBody, targetVector, eventHandler) {
    function scrollTo(target) {
        const distanceDiff = target.distance;
        const indexDiff = target.index !== indexCurrent.get();
        targetVector.add(distanceDiff);
        if (distanceDiff) {
            if (scrollBody.duration()) animation.start();
            else {
                animation.update();
                animation.render(1);
                animation.update();
            }
        }
        if (indexDiff) {
            indexPrevious.set(indexCurrent.get());
            indexCurrent.set(target.index);
            eventHandler.emit("select");
        }
    }
    function distance(n, snap) {
        const target = scrollTarget.byDistance(n, snap);
        scrollTo(target);
    }
    function index(n, direction) {
        const targetIndex = indexCurrent.clone().set(n);
        const target = scrollTarget.byIndex(targetIndex.get(), direction);
        scrollTo(target);
    }
    const self = {
        distance: distance,
        index: index
    };
    return self;
}
function $b2c6a347bb6bb2cc$var$SlideFocus(root, slides, slideRegistry, scrollTo, scrollBody, eventStore) {
    let lastTabPressTime = 0;
    function init() {
        eventStore.add(document, "keydown", registerTabPress, false);
        slides.forEach(addSlideFocusEvent);
    }
    function registerTabPress(event) {
        if (event.code === "Tab") lastTabPressTime = new Date().getTime();
    }
    function addSlideFocusEvent(slide) {
        const focus = ()=>{
            const nowTime = new Date().getTime();
            const diffTime = nowTime - lastTabPressTime;
            if (diffTime > 10) return;
            root.scrollLeft = 0;
            const index = slides.indexOf(slide);
            const group = slideRegistry.findIndex((group)=>group.includes(index));
            if (!$b2c6a347bb6bb2cc$var$isNumber(group)) return;
            scrollBody.useDuration(0);
            scrollTo.index(group, 0);
        };
        eventStore.add(slide, "focus", focus, {
            passive: true,
            capture: true
        });
    }
    const self = {
        init: init
    };
    return self;
}
function $b2c6a347bb6bb2cc$var$Vector1D(initialValue) {
    let value = initialValue;
    function get() {
        return value;
    }
    function set(n) {
        value = normalizeInput(n);
    }
    function add(n) {
        value += normalizeInput(n);
    }
    function subtract(n) {
        value -= normalizeInput(n);
    }
    function normalizeInput(n) {
        return $b2c6a347bb6bb2cc$var$isNumber(n) ? n : n.get();
    }
    const self = {
        get: get,
        set: set,
        add: add,
        subtract: subtract
    };
    return self;
}
function $b2c6a347bb6bb2cc$var$Translate(axis, direction, container) {
    const translate = axis.scroll === "x" ? x : y;
    const containerStyle = container.style;
    let disabled = false;
    function x(n) {
        return `translate3d(${n}px,0px,0px)`;
    }
    function y(n) {
        return `translate3d(0px,${n}px,0px)`;
    }
    function to(target) {
        if (disabled) return;
        containerStyle.transform = translate(direction.apply(target));
    }
    function toggleActive(active) {
        disabled = !active;
    }
    function clear() {
        if (disabled) return;
        containerStyle.transform = "";
        if (!container.getAttribute("style")) container.removeAttribute("style");
    }
    const self = {
        clear: clear,
        to: to,
        toggleActive: toggleActive
    };
    return self;
}
function $b2c6a347bb6bb2cc$var$SlideLooper(axis, direction, viewSize, contentSize, slideSizes, slideSizesWithGaps, snaps, scrollSnaps, offsetLocation, slides) {
    const roundingSafety = 0.5;
    const ascItems = $b2c6a347bb6bb2cc$var$arrayKeys(slideSizesWithGaps);
    const descItems = $b2c6a347bb6bb2cc$var$arrayKeys(slideSizesWithGaps).reverse();
    const loopPoints = startPoints().concat(endPoints());
    function removeSlideSizes(indexes, from) {
        return indexes.reduce((a, i)=>{
            return a - slideSizesWithGaps[i];
        }, from);
    }
    function slidesInGap(indexes, gap) {
        return indexes.reduce((a, i)=>{
            const remainingGap = removeSlideSizes(a, gap);
            return remainingGap > 0 ? a.concat([
                i
            ]) : a;
        }, []);
    }
    function findSlideBounds(offset) {
        return snaps.map((snap, index)=>({
                start: snap - slideSizes[index] + roundingSafety + offset,
                end: snap + viewSize - roundingSafety + offset
            }));
    }
    function findLoopPoints(indexes, offset, isEndEdge) {
        const slideBounds = findSlideBounds(offset);
        return indexes.map((index)=>{
            const initial = isEndEdge ? 0 : -contentSize;
            const altered = isEndEdge ? contentSize : 0;
            const boundEdge = isEndEdge ? "end" : "start";
            const loopPoint = slideBounds[index][boundEdge];
            return {
                index: index,
                slideLocation: $b2c6a347bb6bb2cc$var$Vector1D(-1),
                translate: $b2c6a347bb6bb2cc$var$Translate(axis, direction, slides[index]),
                target: ()=>offsetLocation.get() > loopPoint ? initial : altered
            };
        });
    }
    function startPoints() {
        const gap = scrollSnaps[0] - 1;
        const indexes = slidesInGap(descItems, gap);
        return findLoopPoints(indexes, contentSize, false);
    }
    function endPoints() {
        const gap = viewSize - scrollSnaps[0] - 1;
        const indexes = slidesInGap(ascItems, gap);
        return findLoopPoints(indexes, -contentSize, true);
    }
    function canLoop() {
        return loopPoints.every(({ index: index })=>{
            const otherIndexes = ascItems.filter((i)=>i !== index);
            return removeSlideSizes(otherIndexes, viewSize) <= 0.1;
        });
    }
    function loop() {
        loopPoints.forEach((loopPoint)=>{
            const { target: target, translate: translate, slideLocation: slideLocation } = loopPoint;
            const shiftLocation = target();
            if (shiftLocation === slideLocation.get()) return;
            translate.to(shiftLocation);
            slideLocation.set(shiftLocation);
        });
    }
    function clear() {
        loopPoints.forEach((loopPoint)=>loopPoint.translate.clear());
    }
    const self = {
        canLoop: canLoop,
        clear: clear,
        loop: loop,
        loopPoints: loopPoints
    };
    return self;
}
function $b2c6a347bb6bb2cc$var$SlidesHandler(container, eventHandler, watchSlides) {
    let mutationObserver;
    let destroyed = false;
    function init(emblaApi) {
        if (!watchSlides) return;
        function defaultCallback(mutations) {
            for (const mutation of mutations)if (mutation.type === "childList") {
                emblaApi.reInit();
                eventHandler.emit("slidesChanged");
                break;
            }
        }
        mutationObserver = new MutationObserver((mutations)=>{
            if (destroyed) return;
            if ($b2c6a347bb6bb2cc$var$isBoolean(watchSlides) || watchSlides(emblaApi, mutations)) defaultCallback(mutations);
        });
        mutationObserver.observe(container, {
            childList: true
        });
    }
    function destroy() {
        if (mutationObserver) mutationObserver.disconnect();
        destroyed = true;
    }
    const self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $b2c6a347bb6bb2cc$var$SlidesInView(container, slides, eventHandler, threshold) {
    const intersectionEntryMap = {};
    let inViewCache = null;
    let notInViewCache = null;
    let intersectionObserver;
    let destroyed = false;
    function init() {
        intersectionObserver = new IntersectionObserver((entries)=>{
            if (destroyed) return;
            entries.forEach((entry)=>{
                const index = slides.indexOf(entry.target);
                intersectionEntryMap[index] = entry;
            });
            inViewCache = null;
            notInViewCache = null;
            eventHandler.emit("slidesInView");
        }, {
            root: container.parentElement,
            threshold: threshold
        });
        slides.forEach((slide)=>intersectionObserver.observe(slide));
    }
    function destroy() {
        if (intersectionObserver) intersectionObserver.disconnect();
        destroyed = true;
    }
    function createInViewList(inView) {
        return $b2c6a347bb6bb2cc$var$objectKeys(intersectionEntryMap).reduce((list, slideIndex)=>{
            const index = parseInt(slideIndex);
            const { isIntersecting: isIntersecting } = intersectionEntryMap[index];
            const inViewMatch = inView && isIntersecting;
            const notInViewMatch = !inView && !isIntersecting;
            if (inViewMatch || notInViewMatch) list.push(index);
            return list;
        }, []);
    }
    function get(inView = true) {
        if (inView && inViewCache) return inViewCache;
        if (!inView && notInViewCache) return notInViewCache;
        const slideIndexes = createInViewList(inView);
        if (inView) inViewCache = slideIndexes;
        if (!inView) notInViewCache = slideIndexes;
        return slideIndexes;
    }
    const self = {
        init: init,
        destroy: destroy,
        get: get
    };
    return self;
}
function $b2c6a347bb6bb2cc$var$SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap, ownerWindow) {
    const { measureSize: measureSize, startEdge: startEdge, endEdge: endEdge } = axis;
    const withEdgeGap = slideRects[0] && readEdgeGap;
    const startGap = measureStartGap();
    const endGap = measureEndGap();
    const slideSizes = slideRects.map(measureSize);
    const slideSizesWithGaps = measureWithGaps();
    function measureStartGap() {
        if (!withEdgeGap) return 0;
        const slideRect = slideRects[0];
        return $b2c6a347bb6bb2cc$var$mathAbs(containerRect[startEdge] - slideRect[startEdge]);
    }
    function measureEndGap() {
        if (!withEdgeGap) return 0;
        const style = ownerWindow.getComputedStyle($b2c6a347bb6bb2cc$var$arrayLast(slides));
        return parseFloat(style.getPropertyValue(`margin-${endEdge}`));
    }
    function measureWithGaps() {
        return slideRects.map((rect, index, rects)=>{
            const isFirst = !index;
            const isLast = index === $b2c6a347bb6bb2cc$var$arrayLastIndex(rects);
            if (isFirst) return slideSizes[index] + startGap;
            if (isLast) return slideSizes[index] + endGap;
            return rects[index + 1][startEdge] - rect[startEdge];
        }).map($b2c6a347bb6bb2cc$var$mathAbs);
    }
    const self = {
        slideSizes: slideSizes,
        slideSizesWithGaps: slideSizesWithGaps,
        startGap: startGap,
        endGap: endGap
    };
    return self;
}
function $b2c6a347bb6bb2cc$var$SlidesToScroll(axis, direction, viewSize, slidesToScroll, loop, containerRect, slideRects, startGap, endGap) {
    const { startEdge: startEdge, endEdge: endEdge } = axis;
    const groupByNumber = $b2c6a347bb6bb2cc$var$isNumber(slidesToScroll);
    function byNumber(array, groupSize) {
        return $b2c6a347bb6bb2cc$var$arrayKeys(array).filter((i)=>i % groupSize === 0).map((i)=>array.slice(i, i + groupSize));
    }
    function bySize(array) {
        if (!array.length) return [];
        return $b2c6a347bb6bb2cc$var$arrayKeys(array).reduce((groups, rectB)=>{
            const rectA = $b2c6a347bb6bb2cc$var$arrayLast(groups) || 0;
            const isFirst = rectA === 0;
            const isLast = rectB === $b2c6a347bb6bb2cc$var$arrayLastIndex(array);
            const edgeA = containerRect[startEdge] - slideRects[rectA][startEdge];
            const edgeB = containerRect[startEdge] - slideRects[rectB][endEdge];
            const gapA = !loop && isFirst ? direction.apply(startGap) : 0;
            const gapB = !loop && isLast ? direction.apply(endGap) : 0;
            const chunkSize = $b2c6a347bb6bb2cc$var$mathAbs(edgeB - gapB - (edgeA + gapA));
            if (chunkSize > viewSize) groups.push(rectB);
            if (isLast) groups.push(array.length);
            return groups;
        }, []).map((currentSize, index, groups)=>{
            const previousSize = Math.max(groups[index - 1] || 0);
            return array.slice(previousSize, currentSize);
        });
    }
    function groupSlides(array) {
        return groupByNumber ? byNumber(array, slidesToScroll) : bySize(array);
    }
    const self = {
        groupSlides: groupSlides
    };
    return self;
}
function $b2c6a347bb6bb2cc$var$Engine(root, container, slides, ownerDocument, ownerWindow, options, eventHandler, animations) {
    // Options
    const { align: align, axis: scrollAxis, direction: contentDirection, startIndex: startIndex, loop: loop, duration: duration, dragFree: dragFree, dragThreshold: dragThreshold, inViewThreshold: inViewThreshold, slidesToScroll: groupSlides, skipSnaps: skipSnaps, containScroll: containScroll, watchResize: watchResize, watchSlides: watchSlides, watchDrag: watchDrag } = options;
    // Measurements
    const containerRect = container.getBoundingClientRect();
    const slideRects = slides.map((slide)=>slide.getBoundingClientRect());
    const direction = $b2c6a347bb6bb2cc$var$Direction(contentDirection);
    const axis = $b2c6a347bb6bb2cc$var$Axis(scrollAxis, contentDirection);
    const viewSize = axis.measureSize(containerRect);
    const percentOfView = $b2c6a347bb6bb2cc$var$PercentOfView(viewSize);
    const alignment = $b2c6a347bb6bb2cc$var$Alignment(align, viewSize);
    const containSnaps = !loop && !!containScroll;
    const readEdgeGap = loop || !!containScroll;
    const { slideSizes: slideSizes, slideSizesWithGaps: slideSizesWithGaps, startGap: startGap, endGap: endGap } = $b2c6a347bb6bb2cc$var$SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap, ownerWindow);
    const slidesToScroll = $b2c6a347bb6bb2cc$var$SlidesToScroll(axis, direction, viewSize, groupSlides, loop, containerRect, slideRects, startGap, endGap);
    const { snaps: snaps, snapsAligned: snapsAligned } = $b2c6a347bb6bb2cc$var$ScrollSnaps(axis, alignment, containerRect, slideRects, slidesToScroll);
    const contentSize = -$b2c6a347bb6bb2cc$var$arrayLast(snaps) + $b2c6a347bb6bb2cc$var$arrayLast(slideSizesWithGaps);
    const { snapsContained: snapsContained, scrollContainLimit: scrollContainLimit } = $b2c6a347bb6bb2cc$var$ScrollContain(viewSize, contentSize, snapsAligned, containScroll);
    const scrollSnaps = containSnaps ? snapsContained : snapsAligned;
    const { limit: limit } = $b2c6a347bb6bb2cc$var$ScrollLimit(contentSize, scrollSnaps, loop);
    // Indexes
    const index = $b2c6a347bb6bb2cc$var$Counter($b2c6a347bb6bb2cc$var$arrayLastIndex(scrollSnaps), startIndex, loop);
    const indexPrevious = index.clone();
    const slideIndexes = $b2c6a347bb6bb2cc$var$arrayKeys(slides);
    // Animation
    const update = ({ dragHandler: dragHandler, scrollBody: scrollBody, scrollBounds: scrollBounds, eventHandler: eventHandler, animation: animation, options: { loop: loop } })=>{
        const pointerDown = dragHandler.pointerDown();
        if (!loop) scrollBounds.constrain(pointerDown);
        const hasSettled = scrollBody.seek().settled();
        if (hasSettled && !pointerDown) {
            animation.stop();
            eventHandler.emit("settle");
        }
        if (!hasSettled) eventHandler.emit("scroll");
    };
    const render = ({ scrollBody: scrollBody, translate: translate, location: location, offsetLocation: offsetLocation, scrollLooper: scrollLooper, slideLooper: slideLooper, options: { loop: loop } }, lagOffset)=>{
        const velocity = scrollBody.velocity();
        offsetLocation.set(location.get() - velocity + velocity * lagOffset);
        if (loop) {
            scrollLooper.loop(scrollBody.direction());
            slideLooper.loop();
        }
        translate.to(offsetLocation.get());
    };
    const animation = {
        start: ()=>animations.start(engine),
        stop: ()=>animations.stop(engine),
        update: ()=>update(engine),
        render: (lagOffset)=>render(engine, lagOffset)
    };
    // Shared
    const friction = 0.68;
    const startLocation = scrollSnaps[index.get()];
    const location = $b2c6a347bb6bb2cc$var$Vector1D(startLocation);
    const offsetLocation = $b2c6a347bb6bb2cc$var$Vector1D(startLocation);
    const target = $b2c6a347bb6bb2cc$var$Vector1D(startLocation);
    const scrollBody = $b2c6a347bb6bb2cc$var$ScrollBody(location, target, duration, friction);
    const scrollTarget = $b2c6a347bb6bb2cc$var$ScrollTarget(loop, scrollSnaps, contentSize, limit, target);
    const scrollTo = $b2c6a347bb6bb2cc$var$ScrollTo(animation, index, indexPrevious, scrollTarget, scrollBody, target, eventHandler);
    const scrollProgress = $b2c6a347bb6bb2cc$var$ScrollProgress(limit);
    const eventStore = $b2c6a347bb6bb2cc$var$EventStore();
    const slidesInView = $b2c6a347bb6bb2cc$var$SlidesInView(container, slides, eventHandler, inViewThreshold);
    const { slideRegistry: slideRegistry } = $b2c6a347bb6bb2cc$var$SlideRegistry(viewSize, contentSize, containSnaps, scrollContainLimit, slidesToScroll, slideIndexes);
    const slideFocus = $b2c6a347bb6bb2cc$var$SlideFocus(root, slides, slideRegistry, scrollTo, scrollBody, eventStore);
    // Engine
    const engine = {
        ownerDocument: ownerDocument,
        ownerWindow: ownerWindow,
        eventHandler: eventHandler,
        containerRect: containerRect,
        slideRects: slideRects,
        animation: animation,
        axis: axis,
        direction: direction,
        dragHandler: $b2c6a347bb6bb2cc$var$DragHandler(axis, direction, root, ownerDocument, ownerWindow, target, $b2c6a347bb6bb2cc$var$DragTracker(axis, ownerWindow), location, animation, scrollTo, scrollBody, scrollTarget, index, eventHandler, percentOfView, dragFree, dragThreshold, skipSnaps, friction, watchDrag),
        eventStore: eventStore,
        percentOfView: percentOfView,
        index: index,
        indexPrevious: indexPrevious,
        limit: limit,
        location: location,
        offsetLocation: offsetLocation,
        options: options,
        resizeHandler: $b2c6a347bb6bb2cc$var$ResizeHandler(container, eventHandler, ownerWindow, slides, axis, watchResize),
        scrollBody: scrollBody,
        scrollBounds: $b2c6a347bb6bb2cc$var$ScrollBounds(limit, location, target, scrollBody, percentOfView),
        scrollLooper: $b2c6a347bb6bb2cc$var$ScrollLooper(contentSize, limit, offsetLocation, [
            location,
            offsetLocation,
            target
        ]),
        scrollProgress: scrollProgress,
        scrollSnapList: scrollSnaps.map(scrollProgress.get),
        scrollSnaps: scrollSnaps,
        scrollTarget: scrollTarget,
        scrollTo: scrollTo,
        slideLooper: $b2c6a347bb6bb2cc$var$SlideLooper(axis, direction, viewSize, contentSize, slideSizes, slideSizesWithGaps, snaps, scrollSnaps, offsetLocation, slides),
        slideFocus: slideFocus,
        slidesHandler: $b2c6a347bb6bb2cc$var$SlidesHandler(container, eventHandler, watchSlides),
        slidesInView: slidesInView,
        slideIndexes: slideIndexes,
        slideRegistry: slideRegistry,
        slidesToScroll: slidesToScroll,
        target: target,
        translate: $b2c6a347bb6bb2cc$var$Translate(axis, direction, container)
    };
    return engine;
}
function $b2c6a347bb6bb2cc$var$Animations(ownerWindow) {
    const timeStep = 1000 / 60;
    let engines = [];
    let lastTimeStamp = null;
    let lag = 0;
    let animationFrame = 0;
    function animate(timeStamp) {
        if (!lastTimeStamp) lastTimeStamp = timeStamp;
        const elapsed = timeStamp - lastTimeStamp;
        lastTimeStamp = timeStamp;
        lag += elapsed;
        while(lag >= timeStep){
            engines.forEach(({ animation: animation })=>animation.update());
            lag -= timeStep;
        }
        const lagOffset = $b2c6a347bb6bb2cc$var$mathAbs(lag / timeStep);
        engines.forEach(({ animation: animation })=>animation.render(lagOffset));
        if (animationFrame) ownerWindow.requestAnimationFrame(animate);
    }
    function start(engine) {
        if (!engines.includes(engine)) engines.push(engine);
        if (animationFrame) return;
        animationFrame = ownerWindow.requestAnimationFrame(animate);
    }
    function stop(engine) {
        engines = engines.filter((e)=>e !== engine);
        if (engines.length) return;
        ownerWindow.cancelAnimationFrame(animationFrame);
        lastTimeStamp = null;
        lag = 0;
        animationFrame = 0;
    }
    function reset() {
        lastTimeStamp = null;
        lag = 0;
    }
    const self = {
        start: start,
        stop: stop,
        reset: reset,
        window: ownerWindow
    };
    return self;
}
function $b2c6a347bb6bb2cc$var$EventHandler() {
    const listeners = {};
    let api;
    function init(emblaApi) {
        api = emblaApi;
    }
    function getListeners(evt) {
        return listeners[evt] || [];
    }
    function emit(evt) {
        getListeners(evt).forEach((e)=>e(api, evt));
        return self;
    }
    function on(evt, cb) {
        listeners[evt] = getListeners(evt).concat([
            cb
        ]);
        return self;
    }
    function off(evt, cb) {
        listeners[evt] = getListeners(evt).filter((e)=>e !== cb);
        return self;
    }
    const self = {
        init: init,
        emit: emit,
        off: off,
        on: on
    };
    return self;
}
const $b2c6a347bb6bb2cc$var$defaultOptions = {
    align: "center",
    axis: "x",
    container: null,
    slides: null,
    containScroll: "trimSnaps",
    direction: "ltr",
    slidesToScroll: 1,
    inViewThreshold: 0,
    breakpoints: {},
    dragFree: false,
    dragThreshold: 10,
    loop: false,
    skipSnaps: false,
    duration: 25,
    startIndex: 0,
    active: true,
    watchDrag: true,
    watchResize: true,
    watchSlides: true
};
function $b2c6a347bb6bb2cc$var$OptionsHandler(ownerWindow) {
    function mergeOptions(optionsA, optionsB) {
        return $b2c6a347bb6bb2cc$var$objectsMergeDeep(optionsA, optionsB || {});
    }
    function optionsAtMedia(options) {
        const optionsAtMedia = options.breakpoints || {};
        const matchedMediaOptions = $b2c6a347bb6bb2cc$var$objectKeys(optionsAtMedia).filter((media)=>ownerWindow.matchMedia(media).matches).map((media)=>optionsAtMedia[media]).reduce((a, mediaOption)=>mergeOptions(a, mediaOption), {});
        return mergeOptions(options, matchedMediaOptions);
    }
    function optionsMediaQueries(optionsList) {
        return optionsList.map((options)=>$b2c6a347bb6bb2cc$var$objectKeys(options.breakpoints || {})).reduce((acc, mediaQueries)=>acc.concat(mediaQueries), []).map(ownerWindow.matchMedia);
    }
    const self = {
        mergeOptions: mergeOptions,
        optionsAtMedia: optionsAtMedia,
        optionsMediaQueries: optionsMediaQueries
    };
    return self;
}
function $b2c6a347bb6bb2cc$var$PluginsHandler(optionsHandler) {
    let activePlugins = [];
    function init(emblaApi, plugins) {
        activePlugins = plugins.filter(({ options: options })=>optionsHandler.optionsAtMedia(options).active !== false);
        activePlugins.forEach((plugin)=>plugin.init(emblaApi, optionsHandler));
        return plugins.reduce((map, plugin)=>Object.assign(map, {
                [plugin.name]: plugin
            }), {});
    }
    function destroy() {
        activePlugins = activePlugins.filter((plugin)=>plugin.destroy());
    }
    const self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $b2c6a347bb6bb2cc$export$2e2bcd8739ae039(root, userOptions, userPlugins) {
    const ownerDocument = root.ownerDocument;
    const ownerWindow = ownerDocument.defaultView;
    const optionsHandler = $b2c6a347bb6bb2cc$var$OptionsHandler(ownerWindow);
    const pluginsHandler = $b2c6a347bb6bb2cc$var$PluginsHandler(optionsHandler);
    const mediaHandlers = $b2c6a347bb6bb2cc$var$EventStore();
    const documentVisibleHandler = $b2c6a347bb6bb2cc$var$EventStore();
    const eventHandler = $b2c6a347bb6bb2cc$var$EventHandler();
    const { animationRealms: animationRealms } = $b2c6a347bb6bb2cc$export$2e2bcd8739ae039;
    const { mergeOptions: mergeOptions, optionsAtMedia: optionsAtMedia, optionsMediaQueries: optionsMediaQueries } = optionsHandler;
    const { on: on, off: off, emit: emit } = eventHandler;
    const reInit = reActivate;
    let destroyed = false;
    let engine;
    let optionsBase = mergeOptions($b2c6a347bb6bb2cc$var$defaultOptions, $b2c6a347bb6bb2cc$export$2e2bcd8739ae039.globalOptions);
    let options = mergeOptions(optionsBase);
    let pluginList = [];
    let pluginApis;
    let container;
    let slides;
    function storeElements() {
        const { container: userContainer, slides: userSlides } = options;
        const customContainer = $b2c6a347bb6bb2cc$var$isString(userContainer) ? root.querySelector(userContainer) : userContainer;
        container = customContainer || root.children[0];
        const customSlides = $b2c6a347bb6bb2cc$var$isString(userSlides) ? container.querySelectorAll(userSlides) : userSlides;
        slides = [].slice.call(customSlides || container.children);
    }
    function createEngine(options, animations) {
        const engine = $b2c6a347bb6bb2cc$var$Engine(root, container, slides, ownerDocument, ownerWindow, options, eventHandler, animations);
        if (options.loop && !engine.slideLooper.canLoop()) {
            const optionsWithoutLoop = Object.assign({}, options, {
                loop: false
            });
            return createEngine(optionsWithoutLoop, animations);
        }
        return engine;
    }
    function activate(withOptions, withPlugins) {
        if (destroyed) return;
        const animationRealm = animationRealms.find((a)=>a.window === ownerWindow);
        const animations = animationRealm || $b2c6a347bb6bb2cc$var$Animations(ownerWindow);
        if (!animationRealm) animationRealms.push(animations);
        optionsBase = mergeOptions(optionsBase, withOptions);
        options = optionsAtMedia(optionsBase);
        pluginList = withPlugins || pluginList;
        storeElements();
        engine = createEngine(options, animations);
        optionsMediaQueries([
            optionsBase,
            ...pluginList.map(({ options: options })=>options)
        ]).forEach((query)=>mediaHandlers.add(query, "change", reActivate));
        if (!options.active) return;
        engine.translate.to(engine.location.get());
        engine.slidesInView.init();
        engine.slideFocus.init();
        engine.eventHandler.init(self);
        engine.resizeHandler.init(self);
        engine.slidesHandler.init(self);
        documentVisibleHandler.add(ownerDocument, "visibilitychange", ()=>{
            if (ownerDocument.hidden) animations.reset();
        });
        if (engine.options.loop) engine.slideLooper.loop();
        if (container.offsetParent && slides.length) engine.dragHandler.init(self);
        pluginApis = pluginsHandler.init(self, pluginList);
    }
    function reActivate(withOptions, withPlugins) {
        const startIndex = selectedScrollSnap();
        deActivate();
        activate(mergeOptions({
            startIndex: startIndex
        }, withOptions), withPlugins);
        eventHandler.emit("reInit");
    }
    function deActivate() {
        engine.dragHandler.destroy();
        engine.animation.stop();
        engine.eventStore.clear();
        engine.translate.clear();
        engine.slideLooper.clear();
        engine.resizeHandler.destroy();
        engine.slidesHandler.destroy();
        pluginsHandler.destroy();
        mediaHandlers.clear();
        documentVisibleHandler.clear();
    }
    function destroy() {
        if (destroyed) return;
        destroyed = true;
        mediaHandlers.clear();
        deActivate();
        eventHandler.emit("destroy");
    }
    function scrollTo(index, jump, direction) {
        if (!options.active || destroyed) return;
        engine.scrollBody.useBaseFriction().useDuration(jump ? 0 : options.duration);
        engine.scrollTo.index(index, direction || 0);
    }
    function scrollNext(jump) {
        const next = engine.index.add(1).get();
        scrollTo(next, jump === true, -1);
    }
    function scrollPrev(jump) {
        const prev = engine.index.add(-1).get();
        scrollTo(prev, jump === true, 1);
    }
    function canScrollNext() {
        const next = engine.index.add(1).get();
        return next !== selectedScrollSnap();
    }
    function canScrollPrev() {
        const prev = engine.index.add(-1).get();
        return prev !== selectedScrollSnap();
    }
    function scrollSnapList() {
        return engine.scrollSnapList;
    }
    function scrollProgress() {
        return engine.scrollProgress.get(engine.location.get());
    }
    function selectedScrollSnap() {
        return engine.index.get();
    }
    function previousScrollSnap() {
        return engine.indexPrevious.get();
    }
    function slidesInView() {
        return engine.slidesInView.get();
    }
    function slidesNotInView() {
        return engine.slidesInView.get(false);
    }
    function plugins() {
        return pluginApis;
    }
    function internalEngine() {
        return engine;
    }
    function rootNode() {
        return root;
    }
    function containerNode() {
        return container;
    }
    function slideNodes() {
        return slides;
    }
    const self = {
        canScrollNext: canScrollNext,
        canScrollPrev: canScrollPrev,
        containerNode: containerNode,
        internalEngine: internalEngine,
        destroy: destroy,
        off: off,
        on: on,
        emit: emit,
        plugins: plugins,
        previousScrollSnap: previousScrollSnap,
        reInit: reInit,
        rootNode: rootNode,
        scrollNext: scrollNext,
        scrollPrev: scrollPrev,
        scrollProgress: scrollProgress,
        scrollSnapList: scrollSnapList,
        scrollTo: scrollTo,
        selectedScrollSnap: selectedScrollSnap,
        slideNodes: slideNodes,
        slidesInView: slidesInView,
        slidesNotInView: slidesNotInView
    };
    activate(userOptions, userPlugins);
    setTimeout(()=>eventHandler.emit("init"), 0);
    return self;
}
$b2c6a347bb6bb2cc$export$2e2bcd8739ae039.animationRealms = [];
$b2c6a347bb6bb2cc$export$2e2bcd8739ae039.globalOptions = undefined;


const $94796692209c620f$var$defaultOptions = {
    active: true,
    breakpoints: {},
    snapped: "is-snapped",
    inView: "is-in-view",
    draggable: "is-draggable",
    dragging: "is-dragging"
};
function $94796692209c620f$var$removeClass(node, className) {
    if (!node || !className) return;
    const { classList: classList } = node;
    if (classList.contains(className)) classList.remove(className);
}
function $94796692209c620f$var$addClass(node, className) {
    if (!node || !className) return;
    const { classList: classList } = node;
    if (!classList.contains(className)) classList.add(className);
}
function $94796692209c620f$var$nodeListToArray(nodeList) {
    return Array.from(nodeList);
}
function $94796692209c620f$export$2e2bcd8739ae039(userOptions = {}) {
    let options;
    let emblaApi;
    let root;
    let slides;
    const selectedEvents = [
        "select"
    ];
    const draggingEvents = [
        "pointerDown",
        "pointerUp"
    ];
    const inViewEvents = [
        "slidesInView"
    ];
    function init(emblaApiInstance, optionsHandler) {
        emblaApi = emblaApiInstance;
        const { mergeOptions: mergeOptions, optionsAtMedia: optionsAtMedia } = optionsHandler;
        const optionsBase = mergeOptions($94796692209c620f$var$defaultOptions, $94796692209c620f$export$2e2bcd8739ae039.globalOptions);
        const allOptions = mergeOptions(optionsBase, userOptions);
        options = optionsAtMedia(allOptions);
        root = emblaApi.rootNode();
        slides = emblaApi.slideNodes();
        const isDraggable = !!emblaApi.internalEngine().options.watchDrag;
        if (isDraggable) $94796692209c620f$var$addClass(root, options.draggable);
        if (options.dragging) draggingEvents.forEach((evt)=>emblaApi.on(evt, toggleDraggingClass));
        if (options.snapped) {
            selectedEvents.forEach((evt)=>emblaApi.on(evt, toggleSnappedClasses));
            toggleSnappedClasses();
        }
        if (options.inView) {
            inViewEvents.forEach((evt)=>emblaApi.on(evt, toggleInViewClasses));
            toggleInViewClasses();
        }
    }
    function destroy() {
        $94796692209c620f$var$removeClass(root, options.draggable);
        draggingEvents.forEach((evt)=>emblaApi.off(evt, toggleDraggingClass));
        selectedEvents.forEach((evt)=>emblaApi.off(evt, toggleSnappedClasses));
        inViewEvents.forEach((evt)=>emblaApi.off(evt, toggleInViewClasses));
        slides.forEach((slide)=>$94796692209c620f$var$removeClass(slide, options.snapped));
    }
    function toggleDraggingClass(_, evt) {
        if (evt === "pointerDown") $94796692209c620f$var$addClass(root, options.dragging);
        else $94796692209c620f$var$removeClass(root, options.dragging);
    }
    function toggleSlideClasses(slideIndexes, className) {
        const container = emblaApi.containerNode();
        const slideNodeList = container.querySelectorAll(`.${className}`);
        const removeClassSlides = $94796692209c620f$var$nodeListToArray(slideNodeList);
        removeClassSlides.forEach((slide)=>$94796692209c620f$var$removeClass(slide, className));
        slideIndexes.forEach((index)=>$94796692209c620f$var$addClass(slides[index], className));
    }
    function toggleSnappedClasses() {
        const { slideRegistry: slideRegistry } = emblaApi.internalEngine();
        const slideIndexes = slideRegistry[emblaApi.selectedScrollSnap()];
        toggleSlideClasses(slideIndexes, options.snapped);
    }
    function toggleInViewClasses() {
        const slideIndexes = emblaApi.slidesInView();
        toggleSlideClasses(slideIndexes, options.inView);
    }
    const self = {
        name: "classNames",
        options: userOptions,
        init: init,
        destroy: destroy
    };
    return self;
}
$94796692209c620f$export$2e2bcd8739ae039.globalOptions = undefined;



const $a8ab321a15f5f581$var$STATE = {
    idle: "idle",
    running: "running",
    paused: "paused",
    resumed: "resumed"
};
class $a8ab321a15f5f581$var$IntervalTimer {
    constructor(callback, interval){
        this.interval = interval;
        this.callback = callback;
        this.state = $a8ab321a15f5f581$var$STATE.idle;
        this.pausedTime = 0;
        this.remainingTime = 0;
    }
    proxyCallback() {
        this.lastFireTime = new Date();
        this.callback();
    }
    start() {
        this.timerId = setInterval(()=>this.proxyCallback(), this.interval);
        this.lastFireTime = new Date();
        this.state = $a8ab321a15f5f581$var$STATE.running;
    }
    pause() {
        if (this.state !== $a8ab321a15f5f581$var$STATE.running && this.state !== $a8ab321a15f5f581$var$STATE.resumed) return;
        this.remainingTime = this.interval - (new Date() - this.lastFireTime) + this.pausedTime;
        this.lastPauseTime = new Date();
        clearInterval(this.timerId);
        clearTimeout(this.resumeId);
        this.state = $a8ab321a15f5f581$var$STATE.paused;
    }
    resume() {
        if (this.state !== $a8ab321a15f5f581$var$STATE.paused) return;
        this.pausedTime += new Date() - this.lastPauseTime;
        this.state = $a8ab321a15f5f581$var$STATE.resumed;
        this.resumeId = setTimeout(()=>this.timeoutCallback(), this.remainingTime);
    }
    timeoutCallback() {
        if (this.state !== $a8ab321a15f5f581$var$STATE.resumed) return;
        this.pausedTime = 0;
        this.proxyCallback();
        this.start();
    }
    stop() {
        if (this.state === $a8ab321a15f5f581$var$STATE.idle) return;
        clearInterval(this.timerId);
        clearTimeout(this.resumeId);
        this.state = $a8ab321a15f5f581$var$STATE.idle;
    }
    setInterval(newInterval) {
        if (this.state === $a8ab321a15f5f581$var$STATE.running) {
            this.pause();
            this.interval = newInterval;
            this.resume();
        } else this.interval = newInterval;
    }
}
var $a8ab321a15f5f581$export$2e2bcd8739ae039 = $a8ab321a15f5f581$var$IntervalTimer;


const $d3853ff46148cdb3$export$7f5c76c795c3dd96 = (embla, interval)=>{
    const next = ()=>{
        const lastSlideIndex = embla.scrollSnapList().length - 1;
        const isLastSlide = embla.selectedScrollSnap() === lastSlideIndex;
        if (isLastSlide) embla.scrollTo(0);
        else embla.scrollNext();
    };
    const intervalTimer = new (0, $a8ab321a15f5f581$export$2e2bcd8739ae039)(next, interval);
    const play = ()=>{
        intervalTimer.resume();
    };
    const stop = ()=>{
        intervalTimer.stop();
    };
    const pause = ()=>{
        intervalTimer.pause();
    };
    const start = ()=>{
        intervalTimer.start();
    };
    return {
        play: play,
        stop: stop,
        start: start,
        pause: pause
    };
};
const $d3853ff46148cdb3$export$2c703acc48b258d4 = (embla, interval)=>{
    let tick = 0;
    const engine = embla.internalEngine();
    const distance = interval / -5;
    const animate = ()=>{
        engine.scrollTo.distance(distance);
        tick = requestAnimationFrame(animate);
    };
    const play = ()=>{
        tick = requestAnimationFrame(animate);
    };
    const pause = ()=>{
        tick = cancelAnimationFrame(tick) || 0;
    };
    const stop = ()=>{
        cancelAnimationFrame(tick);
    };
    return {
        play: play,
        pause: pause,
        stop: stop
    };
};



class $5553604b15244d84$var$Carousel extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleCarouselTargetKeyDown = (event)=>{
            event.preventDefault();
            const targetIndex = this.focusableTargets.findIndex((target)=>target === event.target);
            const currentFocusTarget = this.focusableTargets[targetIndex];
            const nextFocusTarget = this.focusableTargets[targetIndex + 1];
            const prevFocusTarget = this.focusableTargets[targetIndex - 1];
            if (event.keyCode === 9) {
                event.preventDefault();
                if (document.activeElement === currentFocusTarget) this.focusScroll(currentFocusTarget);
                if (!event.shiftKey) {
                    if (nextFocusTarget) this.focusScroll(nextFocusTarget);
                    else document.activeElement.blur();
                }
                if (event.shiftKey) {
                    if (prevFocusTarget) this.focusScroll(prevFocusTarget);
                    else document.activeElement.blur();
                }
            }
        };
        this.handleCarouselResize = ()=>{
            if (this.isEditorMode) {
                const currentViewMode = (0, $336348f90f7c8f21$export$e7a5aad9bb00dd62)() ? "mobile" : "desktop";
                const isAnotherViewMode = this.lastViewModeIsMobile !== currentViewMode;
                if (isAnotherViewMode && this.isForceStopped) {
                    this.forcePlay();
                    this.changePlayState(true);
                }
                this.lastViewModeIsMobile = currentViewMode;
            }
        };
        this.focusScroll = (targetElement)=>{
            const slides = [
                ...this.embla.slideNodes()
            ];
            const slideIndex = slides.findIndex((slide)=>slide.contains(targetElement));
            if (slideIndex !== -1) {
                this.embla.scrollTo(slideIndex, true);
                this.forceStop();
            }
            targetElement.focus();
        };
        this.handleCarouselEnter = ()=>{
            const isMobile = (0, $336348f90f7c8f21$export$e7a5aad9bb00dd62)();
            if (isMobile) return;
            this.changePlayState(false);
        };
        this.handleCarouselSelect = ()=>{
            if (this.isTouchOnCarousel) this.forceStop();
        };
        this.handleCarouselPointerUp = ()=>{
            this.isTouchOnCarousel = false;
        };
        this.handleCarouselPointerDown = ()=>{
            this.isTouchOnCarousel = true;
        };
        this.handleCarouselLeave = ()=>{
            const isMobile = (0, $336348f90f7c8f21$export$e7a5aad9bb00dd62)();
            if (isMobile) return;
            this.changePlayState(true);
        };
        this.handleKeydown = (event)=>{
            const key = event.key || event.keyCode;
            const isLeftArrow = (0, $6de5ff37caa957d8$export$703c582f38858004)(key);
            const isRightArrow = (0, $6de5ff37caa957d8$export$e2fe3643cb517b19)(key);
            if (isLeftArrow) this.embla.scrollPrev();
            if (isRightArrow) this.embla.scrollNext();
        };
        this.handleBlockSelect = ({ detail: { sectionId: sectionId, blockId: blockId, load: load } })=>{
            if (this.dataset.sectionId === sectionId) {
                const slides = this.embla.slideNodes();
                const targetIndex = slides.findIndex(({ attributes: attributes })=>attributes["block-id"]?.value === blockId);
                if (targetIndex !== -1) {
                    this.embla.scrollTo(targetIndex, load);
                    this.forceStop();
                }
            }
        };
        this.handleSectionLoad = ({ detail: { sectionId: sectionId } })=>{
            if (this.dataset.sectionId === sectionId) this.reInit();
        };
        this.getOptions = ()=>({
                loop: this.hasAttribute("data-loop"),
                dragFree: this.hasAttribute("data-drag-free"),
                watchDrag: this.hasAttribute("data-draggable"),
                skipSnaps: this.hasAttribute("data-skip-snaps"),
                align: this.getAttribute("data-align"),
                containScroll: this.getAttribute("data-contain-scroll"),
                inViewThreshold: +(this.dataset.inViewThreshhold || 0) || 0.75,
                axis: this.getAttribute("data-axis"),
                speed: 50,
                breakpoints: this.hasAttribute("data-breakpoints") ? JSON.parse(this.dataset.breakpoints) : undefined
            });
        this.getPlugins = ()=>{
            const plugins = [];
            const classNamesPlugin = (0, $94796692209c620f$export$2e2bcd8739ae039)();
            plugins.push(classNamesPlugin);
            if (this.hasAttribute("data-with-wheel-gestures")) {
                const wheelGesturesPlugin = (0, $72cc5d09e7e9c7ab$export$1c3f64aa406d3265)({
                    forceWheelAxis: this.getAttribute("data-axis")
                });
                plugins.push(wheelGesturesPlugin);
            }
            return plugins;
        };
        this.changePlayState = (isPlay)=>{
            if (!this.withOneAtTimeAutoplay && !this.withSeamlessAutoplay) return;
            if (this.isForceStopped) return;
            this.isPlay = isPlay;
            if (isPlay) this.autoplay.play();
            else this.autoplay.pause();
        };
        this.reInit = (options = {})=>{
            const preparedOptions = {
                ...this.getOptions(),
                ...options
            };
            const preparedPlugins = this.getPlugins();
            this.embla.reInit(preparedOptions, preparedPlugins);
        };
        this.scrollNext = ()=>{
            this.embla.scrollNext();
        };
        this.scrollPrev = ()=>{
            this.embla.scrollPrev();
        };
        this.canScrollNext = ()=>{
            return this.embla.canScrollNext();
        };
        this.canScrollPrev = ()=>{
            return this.embla.canScrollPrev();
        };
        this.scrollToIndex = (index)=>{
            this.embla.scrollTo(index);
        };
        const autoplayInterval = +(this.dataset.autoplayInterval || 0);
        this.withOneAtTimeAutoplay = this.dataset.animationType === "one_at_time";
        this.withSeamlessAutoplay = this.dataset.animationType === "seamless";
        this.isPlay = autoplayInterval > 0;
        this.isForceStopped = false;
        this.resizeObserver = new ResizeObserver(this.handleCarouselResize);
        this.resizeObserver.observe(this);
        this.focusableTargets = [
            ...this.querySelectorAll((0, $6de5ff37caa957d8$export$f2d94ec8507fd10b)())
        ];
    }
    connectedCallback() {
        if (this.clientWidth === 0) return;
        this.setCarousel();
        this.focusableTargets.forEach((target)=>{
            target.addEventListener("keydown", this.handleCarouselTargetKeyDown);
        });
        if (this.withStopOnHover) {
            this.addEventListener("mouseenter", this.handleCarouselEnter);
            this.addEventListener("mouseleave", this.handleCarouselLeave);
        }
        this.addEventListener("keydown", this.handleKeydown);
        this.embla.on("select", this.handleCarouselSelect);
        this.embla.on("pointerUp", this.handleCarouselPointerUp);
        this.embla.on("pointerDown", this.handleCarouselPointerDown);
        if (this.isEditorMode) {
            this.editor.subscribe("BLOCK_SELECT", this.handleBlockSelect);
            this.editor.subscribe("SECTION_LOAD", this.handleSectionLoad);
        }
    }
    disconnectedCallback() {
        if (this.clientWidth === 0) return;
        this.focusableTargets.forEach((target)=>{
            target.removeEventListener("keydown", this.handleCarouselTargetKeyDown);
        });
        this.resizeObserver.disconnect();
        if (this.withStopOnHover) {
            this.removeEventListener("mouseenter", this.handleCarouselEnter);
            this.removeEventListener("mouseleave", this.handleCarouselLeave);
        }
        this.removeEventListener("keydown", this.handleKeydown);
        this.embla.off("select", this.handleCarouselSelect);
        this.embla.off("pointerUp", this.handleCarouselPointerUp);
        this.embla.off("pointerDown", this.handleCarouselPointerDown);
        if (this.isEditorMode) this.editor.destroy();
        this.embla.destroy();
    }
    setCarousel() {
        const viewport = this.querySelector("[data-carousel-viewport]");
        if (!viewport) return;
        this.embla = (0, $b2c6a347bb6bb2cc$export$2e2bcd8739ae039)(viewport, this.getOptions(), this.getPlugins());
        if (this.withOneAtTimeAutoplay) {
            this.autoplay = (0, $d3853ff46148cdb3$export$7f5c76c795c3dd96)(this.embla, this.autoplayInterval * 1000);
            this.autoplay.start();
        }
        if (this.withSeamlessAutoplay) {
            this.autoplay = (0, $d3853ff46148cdb3$export$2c703acc48b258d4)(this.embla, this.autoplayInterval);
            this.autoplay.play();
        }
    }
    getClassNamesPlugin() {
        return (0, $94796692209c620f$export$2e2bcd8739ae039)();
    }
    forceStop() {
        if (!this.withOneAtTimeAutoplay && !this.withSeamlessAutoplay) return;
        this.autoplay.stop();
        this.isPlay = false;
        this.isForceStopped = true;
        this.emit("forceChangePlayState", {});
    }
    forcePlay() {
        if (!this.withOneAtTimeAutoplay && !this.withSeamlessAutoplay) return;
        this.isForceStopped = false;
        this.isPlay = true;
        this.autoplay.start();
        this.changePlayState(true);
        this.emit("forceChangePlayState", {});
    }
    get withStopOnHover() {
        return this.hasAttribute("with-stop-on-hover");
    }
    get autoplayInterval() {
        return +(this.dataset.autoplayInterval || 0);
    }
}
var $5553604b15244d84$export$2e2bcd8739ae039 = $5553604b15244d84$var$Carousel;



class $0e9fbda6d500f52a$var$CarouselPlayButton extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleCarouselChangePlayState = ()=>{
            this.updatePlayState();
        };
        this.handleButtonClick = (event)=>{
            event.stopPropagation();
            if (!this.carousel) return;
            const isForceStopped = this.carousel.isForceStopped;
            if (isForceStopped) this.carousel.forcePlay();
            else this.carousel.forceStop();
        };
        this.button = this.querySelector("[data-carousel-play-button]");
    }
    connectedCallback() {
        this.updatePlayState();
        if (this.button) this.button.addEventListener("click", this.handleButtonClick);
        if (this.carousel) {
            customElements.upgrade(this.carousel) // https://developer.mozilla.org/en-US/docs/Web/API/CustomElementRegistry/upgrade
            ;
            customElements.whenDefined("carousel-component").then(()=>{
                this.carousel.subscribe("forceChangePlayState", this.handleCarouselChangePlayState);
            });
        }
    }
    disconnectedCallback() {
        if (this.button) this.button.removeEventListener("click", this.handleButtonClick);
        if (this.carousel) customElements.whenDefined("carousel-component").then(()=>{
            this.carousel.unsubscribe("forceChangePlayState", this.handleCarouselChangePlayState);
        });
    }
    updatePlayState() {
        if (!this.carousel || !this.button) return;
        const isForceStopped = this.carousel.isForceStopped;
        this.button.setAttribute("data-autoplay-stopped", isForceStopped ? "true" : "false");
    }
    get carousel() {
        return this.closest("carousel-component");
    }
}
var $0e9fbda6d500f52a$export$2e2bcd8739ae039 = $0e9fbda6d500f52a$var$CarouselPlayButton;






var $adb0a393977b573d$exports = {};

$parcel$export($adb0a393977b573d$exports, "debounce", function () { return $adb0a393977b573d$export$61fc7d43ac8f84b0; });
const $adb0a393977b573d$export$61fc7d43ac8f84b0 = (fn, wait)=>{
    let t;
    return (...args)=>{
        clearTimeout(t);
        t = setTimeout(()=>fn.apply(undefined, args), wait);
    };
};


class $28307c828f23ed7f$var$CarouselDots extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleSettle = ()=>{
            this.update();
        };
        this.handleCarouselReInit = ()=>{
            this.embla.reInit(this.getOptions(), this.getPlugins());
        };
        this.handleResize = (0, $adb0a393977b573d$exports.debounce)(()=>{
            this.embla.reInit(this.getOptions(), this.getPlugins());
            this.update();
        }, 100);
        this.handleCarouselSelect = ()=>{
            if (!this.carousel) return;
            const dots = [
                ...this.embla.slideNodes()
            ];
            const selectedDotIndex = this.carousel.embla.selectedScrollSnap();
            dots.forEach((dot)=>{
                const isSelectedDot = +dot.dataset.dotIndex === selectedDotIndex;
                dot.classList.toggle("is-primary", isSelectedDot);
            });
            this.embla.scrollTo(selectedDotIndex);
        };
        this.getOptions = ()=>({
                inViewThreshold: +(this.dataset.inViewThreshhold || 0) || 0.5,
                containScroll: this.getAttribute("data-contain-scroll"),
                align: this.getAttribute("data-align"),
                speed: 80,
                skipSnaps: this.hasAttribute("data-skip-snaps"),
                draggable: this.hasAttribute("is-draggable"),
                axis: this.getAttribute("data-axis")
            });
        this.getPlugins = ()=>{
            const plugins = [];
            const classNamesPlugin = (0, $94796692209c620f$export$2e2bcd8739ae039)();
            plugins.push(classNamesPlugin);
            if (this.hasAttribute("data-with-wheel-gestures")) {
                const wheelGesturesPlugin = (0, $72cc5d09e7e9c7ab$export$1c3f64aa406d3265)({
                    forceWheelAxis: this.getAttribute("data-axis")
                });
                plugins.push(wheelGesturesPlugin);
            }
            return plugins;
        };
        this.scrollNext = ()=>{
            if (!this.carousel) return;
            this.carousel.embla.scrollNext();
        };
        this.scrollPrev = ()=>{
            if (!this.carousel) return;
            this.carousel.embla.scrollPrev();
        };
        this.canScrollNext = ()=>{
            if (!this.carousel) return false;
            return this.carousel.canScrollNext();
        };
        this.canScrollPrev = ()=>{
            if (!this.carousel) return false;
            return this.carousel.canScrollPrev();
        };
    }
    connectedCallback() {
        if (this.clientWidth === 0) return;
        this.setCarousel();
        this.update();
        if (this.carousel) {
            this.carousel.embla.on("reInit", this.handleCarouselReInit);
            this.carousel.embla.on("select", this.handleCarouselSelect);
        }
        this.embla.on("resize", this.handleResize);
        this.embla.on("settle", this.handleSettle);
    }
    disconnectedCallback() {
        if (this.clientWidth === 0) return;
        if (this.carousel) {
            this.carousel.embla.off("reInit", this.handleCarouselReInit);
            this.carousel.embla.off("select", this.handleCarouselSelect);
        }
        this.embla.off("settle", this.handleSettle);
        this.embla.off("resize", this.handleResize);
        this.embla.destroy();
    }
    reInit() {
        this.embla.reInit(this.getOptions(), this.getPlugins());
    }
    setCarousel() {
        const viewport = this.querySelector("[data-carousel-viewport]");
        if (!viewport) return;
        this.embla = (0, $b2c6a347bb6bb2cc$export$2e2bcd8739ae039)(viewport, this.getOptions(), this.getPlugins());
    }
    update() {
        const dots = [
            ...this.embla.slideNodes()
        ];
        const dotsIndexList = dots.map((_, index)=>index);
        const visibleDotIndexList = this.embla.slidesInView();
        dots.forEach((dot, index)=>{
            dot.classList.remove("is-prev-prev");
            const firstVisibleDotIndex = visibleDotIndexList[0];
            const lastVisibleDotIndex = visibleDotIndexList[visibleDotIndexList.length - 1];
            const firstDotIndex = dotsIndexList[0];
            const lastDotIndex = dotsIndexList[dotsIndexList.length - 1];
            const isLastDot = index === lastDotIndex;
            const isLastVisibleDot = index === lastVisibleDotIndex;
            const isFirstDot = index === firstDotIndex;
            const isFirstVisibleDot = index === firstVisibleDotIndex;
            if ((isFirstVisibleDot || isLastVisibleDot) && !isLastDot && !isFirstDot) dot.classList.add("is-prev-prev");
        });
    }
    get carousel() {
        return this.closest("carousel-component");
    }
}
var $28307c828f23ed7f$export$2e2bcd8739ae039 = $28307c828f23ed7f$var$CarouselDots;




class $d3cd6a32dd3f9b39$var$CarouselDot extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleCarouselForceChangePlayState = ()=>{
            if (!this.autoplayLoader || !this.carousel) return;
            const isForceStopped = this.carousel.isForceStopped;
            this.autoplayLoader.setAttribute("data-autoplay-stopped", isForceStopped ? "true" : "false");
        };
        this.handleCarouselChangePlayState = ()=>{
            this.updateAutoplayIndicator();
        };
        this.handleDotClick = ()=>{
            this.scroll();
        };
        this.handleKeyDown = (event)=>{
            const isEnterKey = (0, $6de5ff37caa957d8$export$793b145c7f680179)(event.key || event.keyCode);
            if (isEnterKey) {
                event.preventDefault();
                this.scroll();
            }
        };
        this.autoplayLoader = this.querySelector("[data-autoplay-indicator]");
    }
    connectedCallback() {
        this.updateAutoplayIndicator();
        if (this.carousel) {
            customElements.upgrade(this.carousel) // https://developer.mozilla.org/en-US/docs/Web/API/CustomElementRegistry/upgrade
            ;
            customElements.whenDefined("carousel-component").then(()=>{
                this.carousel.subscribe("changePlayState", this.handleCarouselChangePlayState);
                this.carousel.subscribe("forceChangePlayState", this.handleCarouselForceChangePlayState);
            });
        }
        this.addEventListener("keydown", this.handleKeyDown);
        this.addEventListener("click", this.handleDotClick);
    }
    disconnectedCallback() {
        if (this.carousel) customElements.whenDefined("carousel-component").then(()=>{
            this.carousel.unsubscribe("changePlayState", this.handleCarouselChangePlayState);
            this.carousel.unsubscribe("forceChangePlayState", this.handleCarouselForceChangePlayState);
        });
        this.removeEventListener("keydown", this.handleKeyDown);
        this.removeEventListener("click", this.handleDotClick);
    }
    updateAutoplayIndicator() {
        if (!this.carousel) return;
        const isPlay = this.carousel.isPlay;
        if (this.autoplayLoader) this.autoplayLoader.setAttribute("data-play-state", isPlay ? "true" : "false");
    }
    scroll() {
        if (!this.carousel) return;
        const index = +this.dataset.dotIndex;
        this.carousel.embla.scrollTo(index);
        this.carousel.forceStop();
    }
    get carousel() {
        return this.closest("carousel-component");
    }
    get dotsCarousel() {
        return this.closest("carousel-dots");
    }
}
var $d3cd6a32dd3f9b39$export$2e2bcd8739ae039 = $d3cd6a32dd3f9b39$var$CarouselDot;





class $86ad8436c7a8eff7$var$CarouselBtn extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleButtonClick = ()=>{
            this.trigger();
        };
        this.handleCarouselReInit = ()=>{
            this.update();
        };
        this.handleCarouselSelect = ()=>{
            this.update();
        };
        this.handleCarouselScroll = (0, $adb0a393977b573d$exports.debounce)(()=>{
            this.update();
        }, 100);
        this.handleKeyDown = (event)=>{
            const isEnterKey = (0, $6de5ff37caa957d8$export$793b145c7f680179)(event.key || event.keyCode);
            if (isEnterKey) {
                event.preventDefault();
                this.trigger();
            }
        };
        this.updateDisabled = ()=>{
            this.toggleAttribute("disabled", !this.canScroll());
        };
    }
    connectedCallback() {
        if (this.clientWidth === 0) return;
        this.update();
        if (this.carousel) {
            this.carousel.embla.on("reInit", this.handleCarouselReInit);
            this.carousel.embla.on("select", this.handleCarouselSelect);
            this.carousel.embla.on("scroll", this.handleCarouselScroll);
        }
        this.addEventListener("keydown", this.handleKeyDown);
        this.addEventListener("click", this.handleButtonClick);
    }
    disconnectedCallback() {
        if (this.clientWidth === 0) return;
        if (this.carousel) {
            this.carousel.embla.off("reInit", this.handleCarouselReInit);
            this.carousel.embla.off("select", this.handleCarouselSelect);
            this.carousel.embla.off("scroll", this.handleCarouselScroll);
        }
        this.removeEventListener("keydown", this.handleKeyDown);
        this.removeEventListener("click", this.handleButtonClick);
    }
    update() {
        this.updateDisabled();
        this.updateVisible();
    }
    updateVisible() {
        if (!this.carousel) return;
        const snapList = [
            ...Array(this.carousel.embla.slideNodes().length).keys()
        ];
        const firstSnap = 0;
        const lastSnap = snapList.length - 1;
        const slidesInView = this.carousel.embla.slidesInView();
        const isNextButton = this.dataset.scrollDirection === "next";
        const isVisible = isNextButton ? slidesInView.includes(lastSnap) : slidesInView.includes(firstSnap);
        this.toggleAttribute("has-not-slides-not-in-view", isVisible);
    }
    canScroll() {
        if (!this.carousel) return false;
        const isScrollNext = this.dataset.scrollDirection === "next";
        const canScroll = isScrollNext ? this.carousel.canScrollNext() : this.carousel.canScrollPrev();
        return canScroll;
    }
    trigger() {
        if (!this.carousel) return;
        const { scrollNext: scrollNext, scrollPrev: scrollPrev } = this.carousel;
        const isScrollNext = this.dataset.scrollDirection === "next";
        if (isScrollNext) scrollNext();
        else scrollPrev();
    }
    get carousel() {
        const carouselDots = this.closest("carousel-dots");
        const carousel = this.closest("carousel-component");
        return carouselDots || carousel;
    }
}
var $86ad8436c7a8eff7$export$2e2bcd8739ae039 = $86ad8436c7a8eff7$var$CarouselBtn;



class $d07817196a087230$var$CarouselProgress extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleProgress = ()=>{
            this.updateProgressBar();
        };
        this.handleCarouselReInit = ()=>{
            this.updateProgressBar();
        };
        this.eventSetProgress = this.dataset.target === "scroll" ? "scroll" : "settle";
    }
    connectedCallback() {
        this.updateProgressBar();
        if (this.carousel) {
            this.carousel.embla.on(this.eventSetProgress, this.handleProgress);
            this.carousel.embla.on("reInit", this.handleCarouselReInit);
        }
    }
    disconnectedCallback() {
        if (this.carousel) {
            this.carousel.embla.off(this.eventSetProgress, this.handleProgress);
            this.carousel.embla.off("reInit", this.handleCarouselReInit);
        }
    }
    updateProgressBar() {
        const progressBarIndicator = this.querySelector("[data-carousel-progress-indicator]");
        if (!progressBarIndicator) return;
        const progress = this.getProgress();
        const isVerticalBar = this.dataset.axis === "vertical";
        progressBarIndicator.style.transform = isVerticalBar ? `translate3d(0, ${progress}%, 0)` : `translate3d(${progress}%, 0, 0)`;
    }
    getProgress() {
        const isTargetScroll = this.dataset.target === "scroll";
        return isTargetScroll ? this.getProgressByScroll() : this.getProgressBySlideInView();
    }
    getProgressBySlideInView() {
        if (!this.carousel) return 0;
        const slideCount = this.carousel.embla.slideNodes().length;
        const visibleSlides = this.carousel.embla.slidesInView();
        const lastVisibleSlide = visibleSlides[visibleSlides.length - 1] + 1;
        const progressPerSlide = 100 / slideCount;
        const progress = Math.ceil(progressPerSlide * lastVisibleSlide);
        return progress;
    }
    getProgressByScroll() {
        if (!this.carousel) return 0;
        const scrollProgress = this.carousel.embla.scrollProgress();
        const progress = Math.max(0, Math.min(1, scrollProgress)) * 100;
        return progress;
    }
    get carousel() {
        return this.closest("carousel-component");
    }
}
var $d07817196a087230$export$2e2bcd8739ae039 = $d07817196a087230$var$CarouselProgress;







class $02b57f4d670da284$var$HeaderComponent extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleResize = (0, $adb0a393977b573d$exports.debounce)(()=>{
            this.setHidden(false);
            this.updatePosition();
            const headerSectionRect = this.sectionElement.getBoundingClientRect();
            this.headerSectionBottom = headerSectionRect.bottom;
        }, 100);
        this.handleScroll = (0, $adb0a393977b573d$exports.debounce)(()=>{
            const isMobile = (0, $336348f90f7c8f21$export$e7a5aad9bb00dd62)();
            if (isMobile) this.updateVisibleAfterScroll();
            this.setScrollStatus();
        }, 100);
        this.handleDrodpownHide = ()=>{
            this.classList.remove("header--light-bordered");
        };
        this.handleDropdownShow = ()=>{
            this.classList.add("header--light-bordered");
        };
        this.lastScrollPosition = 0;
        this.dropdowns = [
            ...this.querySelectorAll("[data-header-dropdown]")
        ];
        this.resizeObserver = new ResizeObserver(this.handleResize);
        this.resizeObserver.observe(this);
    }
    connectedCallback() {
        this.setSticky();
        this.updatePosition();
        window.addEventListener("scroll", this.handleScroll);
        this.dropdowns.forEach((dropdown)=>{
            customElements.upgrade(dropdown) // https://developer.mozilla.org/en-US/docs/Web/API/CustomElementRegistry/upgrade
            ;
            customElements.whenDefined("float-element").then(()=>{
                dropdown.subscribe("show", this.handleDropdownShow);
                dropdown.subscribe("hide", this.handleDrodpownHide);
            });
        });
    }
    disconnectedCallback() {
        window.removeEventListener("scroll", this.handleScroll);
        this.dropdowns.forEach((dropdown)=>{
            customElements.upgrade(dropdown) // https://developer.mozilla.org/en-US/docs/Web/API/CustomElementRegistry/upgrade
            ;
            customElements.whenDefined("float-element").then(()=>{
                dropdown.unsubscribe("show", this.handleDropdownShow);
                dropdown.unsubscribe("hide", this.handleDrodpownHide);
            });
        });
        this.resizeObserver.disconnect();
    }
    setScrollStatus() {
        if (!this.sectionElement) return;
        const savedScrollPosition = Math.abs(parseInt(document.body.style.top || "0"));
        const scrollPosition = window.scrollY || savedScrollPosition;
        const isUnderHeader = scrollPosition > this.headerSectionBottom;
        this.sectionElement.toggleAttribute("scrolled", isUnderHeader);
    }
    updateVisibleAfterScroll() {
        if (!this.sectionElement) return;
        if ((0, $339187790c656b4d$export$e1122b4c4bd5b838).isFixed) return;
        const scrollPosition = window.scrollY;
        const threshold = 48;
        const scrollDistance = scrollPosition - this.lastScrollPosition;
        const isScrollUp = scrollDistance < 0;
        const isScrollDown = scrollDistance > 0;
        const isUnderHeader = scrollPosition > this.headerSectionBottom;
        if (isScrollUp) {
            const showOnScrollUp = scrollDistance + threshold > 0;
            this.setHidden(this.isHidden && showOnScrollUp && isUnderHeader);
        } else if (isScrollDown) {
            const hideOnScrollDown = scrollDistance > threshold;
            this.setHidden(hideOnScrollDown && isUnderHeader);
        }
        this.lastScrollPosition = scrollPosition;
    }
    setHidden(isHidden) {
        if (!this.sectionElement) return;
        this.isHidden = isHidden;
        this.sectionElement.setAttribute("aria-hidden", isHidden ? "true" : "false");
    }
    setSticky() {
        if (!this.sectionElement) return;
        this.sectionElement.setAttribute("mobile-sticky", "");
        this.sectionElement.toggleAttribute("desktop-sticky", this.isSticky);
        document.body.toggleAttribute("header-desktop-sticky", this.isSticky);
    }
    updatePosition() {
        if (!this.sectionElement) return;
        const headerRect = this.getBoundingClientRect();
        (0, $aa19cdf2f552e6e0$export$f99c757f0e3e3773)("header-height", `${headerRect.height}px`);
        (0, $aa19cdf2f552e6e0$export$f99c757f0e3e3773)("header-bottom-side", `${headerRect.bottom}px`);
    }
    get isSticky() {
        return this.hasAttribute("is-sticky");
    }
    get sectionElement() {
        return document.querySelector(".shopify-section-header");
    }
}
var $02b57f4d670da284$export$2e2bcd8739ae039 = $02b57f4d670da284$var$HeaderComponent;




class $bedbe0d090f2b54b$var$DrawerMenu extends (0, $a31366d6d865bd48$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleSectionLoad = ()=>{
        //
        };
        this.handleSectionSelect = ({ detail: { sectionId: sectionId } })=>{
            if (this.isVisible && this.dataset.sectionId === sectionId) {
                this.mount();
                this.reset();
            }
        };
        this.handleSectionDeselect = ({ detail: { sectionId: sectionId } })=>{
            if (this.isVisible && this.dataset.sectionId === sectionId) {
                this.reset();
                this.hide(true);
            }
        };
        this.handleBlockSelect = ({ detail: { blockId: blockId, sectionId: sectionId } })=>{
            if (this.dataset.sectionId === sectionId) {
                const target = this.pages.find((page)=>{
                    return page.getAttribute("block-id") === blockId;
                });
                if (!target) return;
                this.open();
                this.setPage(target);
            }
        };
        this.handleBlockDeselect = ({ detail: { blockId: blockId, sectionId: sectionId } })=>{
            if (this.dataset.sectionId === sectionId) {
                const target = this.pages.find((page)=>{
                    return page.getAttribute("block-id") === blockId;
                });
                if (!target) return;
                this.hide(true);
            }
        };
        this.handlePageKeydown = (event)=>{
            const target = event.target;
            const page = target.closest("drawer-menu-page");
            if (!page) return;
            const targets = page.querySelectorAll((0, $6de5ff37caa957d8$export$f2d94ec8507fd10b)());
            const isLastTarget = target === targets[targets.length - 1];
            const isFirstTarget = target === targets[0];
            const isShift = event.shiftKey;
            if (event.keyCode !== 9) return;
            if (isShift && isFirstTarget || !isShift && isLastTarget) {
                event.preventDefault();
                this.focusOnToggler();
            }
        };
        this.header = document.querySelector("header-component");
        this.pages = [
            ...this.element.querySelectorAll("drawer-menu-page")
        ];
        this.pageMap = this.generatePageMap();
        this.homePage = this.pageMap["Menu"];
        this.toggler = document.getElementById("DrawerMenuToggler");
    }
    connectedCallback() {
        super.connectedCallback();
        this.addEventListener("keydown", this.handlePageKeydown);
        if (this.isEditorMode) {
            this.editor.subscribe("BLOCK_SELECT", this.handleBlockSelect);
            this.editor.subscribe("BLOCK_DESELECT", this.handleBlockDeselect);
            this.editor.subscribe("SECTION_SELECT", this.handleSectionSelect);
            this.editor.subscribe("SECTION_DESELECT", this.handleSectionDeselect);
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener("keydown", this.handlePageKeydown);
        if (this.isEditorMode) this.editor.destroy();
    }
    focusOnToggler() {
        if (!this.toggler) return;
        this.toggler.focus();
        this.hide();
    }
    generatePageMap() {
        const pageMap = this.pages.reduce((map, page)=>{
            const pageId = page.dataset.pageId;
            return pageId ? {
                ...map,
                [pageId]: page
            } : map;
        }, {});
        return pageMap;
    }
    setPage(page) {
        const pageId = page.dataset.pageId;
        const prevOpenedPageId = this.openedPage?.dataset.prevPageId;
        const isReturn = pageId === prevOpenedPageId;
        const isNextPageEmpty = page.hasAttribute("data-empty-menu");
        if (this.openedPage) {
            if (isReturn || isNextPageEmpty) this.setPageVisible(this.openedPage, false);
        }
        const firstFocusTarget = page.querySelector((0, $6de5ff37caa957d8$export$f2d94ec8507fd10b)());
        if (firstFocusTarget) firstFocusTarget.focus();
        this.setPageVisible(page, true);
        this.openedPage = page;
    }
    reset() {
        this.pages.forEach((page)=>{
            this.setPageVisible(page, false);
        });
        this.setPageVisible(this.homePage, true);
        this.openedPage = this.homePage;
    }
    setPageVisible(page, isVisible) {
        page.setAttribute("aria-hidden", isVisible ? "false" : "true");
    }
    open() {
        if (this.header) this.header.updatePosition();
        return super.open();
    }
    hide(isInstant) {
        this.reset();
        return super.hide(isInstant);
    }
    getPage(pageId) {
        return this.pageMap[pageId];
    }
    get isVisible() {
        const isLowResolution = matchMedia("(max-width: 1016px)").matches;
        const isSection = this.hasAttribute("data-drawer-menu-is-section");
        return isSection || isLowResolution;
    }
}
var $bedbe0d090f2b54b$export$2e2bcd8739ae039 = $bedbe0d090f2b54b$var$DrawerMenu;



class $ff43ca58ad1a35b0$var$DrawerHeaderPage extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleBlockScroll = ()=>{
            if (!this.block) return;
            const isScrolled = this.block.scrollTop > 0;
            this.toggleAttribute("header-shadow-visible", isScrolled);
        };
        this.block = this.querySelector("[data-drawer-menu-content]");
    }
    connectedCallback() {
        if (this.block) this.block.addEventListener("scroll", this.handleBlockScroll);
    }
    disconnectedCallback() {
        if (this.block) this.block.removeEventListener("scroll", this.handleBlockScroll);
    }
}
var $ff43ca58ad1a35b0$export$2e2bcd8739ae039 = $ff43ca58ad1a35b0$var$DrawerHeaderPage;




class $46bdfac96ac457a6$var$DrawerHeaderPageLink extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    connectedCallback() {
        this.addEventListener("click", this.handlePageLinkClick);
        this.addEventListener("keyup", this.handleKeyDown);
    }
    disconnectedCallback() {
        this.removeEventListener("click", this.handlePageLinkClick);
        this.removeEventListener("keyup", this.handleKeyDown);
    }
    setPage() {
        const drawerHeader = this.closest("drawer-menu");
        const pageId = this.dataset.pageId;
        if (!pageId || !drawerHeader) return;
        const page = drawerHeader.getPage(pageId);
        if (!page) return;
        drawerHeader.setPage(page);
    }
    constructor(...args){
        super(...args);
        this.handlePageLinkClick = (event)=>{
            event.preventDefault();
            this.setPage();
        };
        this.handleKeyDown = (event)=>{
            event.preventDefault();
            const key = event.key || event.keyCode;
            const isEnterKey = (0, $6de5ff37caa957d8$export$793b145c7f680179)(key);
            if (isEnterKey) this.setPage();
        };
    }
}
var $46bdfac96ac457a6$export$2e2bcd8739ae039 = $46bdfac96ac457a6$var$DrawerHeaderPageLink;



class $a8fce1fcc675f0a8$var$Preloader {
    constructor(element){
        this.element = element;
    }
    show() {
        this.element.classList.remove("hidden");
    }
    hide() {
        this.element.classList.add("hidden");
    }
}
var $a8fce1fcc675f0a8$export$2e2bcd8739ae039 = $a8fce1fcc675f0a8$var$Preloader;


class $d452cbb331ba5fd0$var$Pagination extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.cache = {};
    }
    updateTargetsFromHTML(html) {
        if (!this.dataset.containerId) return;
        const newResults = html.getElementById(this.dataset.containerId);
        const results = document.getElementById(this.dataset.containerId);
        if (newResults && results) {
            const targets = newResults.querySelectorAll(`.${this.dataset.target}`);
            const fragment = document.createDocumentFragment();
            targets.forEach((target)=>{
                fragment.appendChild(target);
            });
            results.appendChild(fragment);
        }
    }
    updateResultsFromHTML(html) {
        if (!this.dataset.containerId) return;
        const newResults = html.getElementById(this.dataset.containerId);
        const results = document.getElementById(this.dataset.containerId);
        if (newResults && results) {
            const resultsParentNode = results.parentNode;
            resultsParentNode.replaceChild(newResults, results);
            newResults.scrollIntoView({
                behavior: "smooth"
            });
        }
    }
    updateFromHTML(html) {
        const newPagination = html.querySelector("pagination-component");
        if (newPagination) {
            const clonedNewPagination = newPagination.cloneNode(true);
            this.replaceChildren(...clonedNewPagination.childNodes);
        }
    }
    get loadingOverlay() {
        const prealoader = document.getElementById(this.dataset.overlayId || "");
        return new (0, $a8fce1fcc675f0a8$export$2e2bcd8739ae039)(prealoader);
    }
}
var $d452cbb331ba5fd0$export$2e2bcd8739ae039 = $d452cbb331ba5fd0$var$Pagination;






class $793284be4b91206d$var$PaginationLoadButton extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    connectedCallback() {
        this.addEventListener("keydown", this.handleKeyDown);
        this.addEventListener("click", this.handleButtonClick);
    }
    disconnectedCallback() {
        this.removeEventListener("keydown", this.handleKeyDown);
        this.removeEventListener("click", this.handleButtonClick);
    }
    fetchResults() {
        const url = this.dataset.url;
        if (url) {
            this.setLoadingStatus(true);
            fetch(url).then((response)=>response.text()).then((responseText)=>{
                const html = (0, $aa19cdf2f552e6e0$export$8a49393be2d55148)(responseText);
                this.setLoadingStatus(false);
                this.updateFromHTML(html);
                this.updatePaginationFromHTML(html);
            }).catch(()=>{
                if (!(0, $339187790c656b4d$export$e1122b4c4bd5b838).notification) return;
                (0, $339187790c656b4d$export$e1122b4c4bd5b838).notification.show("Error in pagination load button component", "warning");
            });
        }
    }
    updatePaginationFromHTML(html) {
        const pagination = this.closest("pagination-component");
        if (pagination) {
            pagination.updateTargetsFromHTML(html);
            pagination.updateFromHTML(html);
        }
    }
    setPaginationUrl(newBtn) {
        this.dataset.url = newBtn.dataset.url;
    }
    removePagination() {
        const pagination = this.closest("pagination-component");
        if (pagination) pagination.remove();
    }
    updateFromHTML(html) {
        const newBtn = html.querySelector("pagination-load-button");
        if (newBtn) this.setPaginationUrl(newBtn);
        else this.removePagination();
    }
    setLoadingStatus(isLoading) {
        this.toggleAttribute("disabled", isLoading);
        this.classList.toggle("loading", isLoading);
    }
    constructor(...args){
        super(...args);
        this.handleButtonClick = ()=>{
            this.fetchResults();
        };
        this.handleKeyDown = (event)=>{
            const isEnterKey = (0, $6de5ff37caa957d8$export$793b145c7f680179)(event.key || event.keyCode);
            if (isEnterKey) {
                event.preventDefault();
                this.fetchResults();
            }
        };
    }
}
var $793284be4b91206d$export$2e2bcd8739ae039 = $793284be4b91206d$var$PaginationLoadButton;






class $136d61ced317755a$var$PaginationLink extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    connectedCallback() {
        this.addEventListener("keydown", this.handleKeyDown);
        this.addEventListener("click", this.handleLinkClick);
    }
    disconnectedCallback() {
        this.removeEventListener("keydown", this.handleKeyDown);
        this.removeEventListener("click", this.handleLinkClick);
    }
    fetchResults() {
        const pagination = this.closest("pagination-component");
        const url = this.dataset.url;
        if (pagination && url) {
            if (pagination.cache[url]) this.updatePaginationFromHTML(pagination.cache[url]);
            else this.getFromUrl(url);
        }
    }
    getFromUrl(url) {
        const pagination = this.closest("pagination-component");
        if (pagination) {
            pagination.loadingOverlay.show();
            fetch(url).then((response)=>response.text()).then((responseText)=>{
                const html = (0, $aa19cdf2f552e6e0$export$8a49393be2d55148)(responseText);
                pagination.loadingOverlay.hide();
                pagination.cache[url] = html;
                this.updatePaginationFromHTML(html);
            }).catch(()=>{
                if (!(0, $339187790c656b4d$export$e1122b4c4bd5b838).notification) return;
                (0, $339187790c656b4d$export$e1122b4c4bd5b838).notification.show("Error in pagination link component", "warning");
            });
        }
    }
    updatePaginationFromHTML(html) {
        const pagination = this.closest("pagination-component");
        if (pagination) {
            pagination.updateResultsFromHTML(html);
            pagination.updateFromHTML(html);
        }
    }
    constructor(...args){
        super(...args);
        this.handleLinkClick = ()=>{
            this.fetchResults();
        };
        this.handleKeyDown = (event)=>{
            const isEnterKey = (0, $6de5ff37caa957d8$export$793b145c7f680179)(event.key || event.keyCode);
            if (isEnterKey) {
                event.preventDefault();
                this.fetchResults();
            }
        };
    }
}
var $136d61ced317755a$export$2e2bcd8739ae039 = $136d61ced317755a$var$PaginationLink;






class $3a486be31b563d39$var$PaginationInfiniteScroll extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleIntersectionObserve = (entries)=>{
            const url = this.dataset.url;
            if (url) {
                if (!entries[0].isIntersecting) return;
                this.intersectionObserver.unobserve(this);
                this.preloaderComponent.show();
                fetch(url).then((response)=>response.text()).then((responseText)=>{
                    const html = (0, $aa19cdf2f552e6e0$export$8a49393be2d55148)(responseText);
                    const pagination = this.closest("pagination-component");
                    this.preloaderComponent.hide();
                    this.updateFromHTML(html);
                    if (pagination) pagination.updateTargetsFromHTML(html);
                }).catch(()=>{
                    if (!(0, $339187790c656b4d$export$e1122b4c4bd5b838).notification) return;
                    (0, $339187790c656b4d$export$e1122b4c4bd5b838).notification.show("Error in infinite scroll component", "warning");
                });
            }
        };
        this.observerOptions = {
            root: null,
            rootMargin: "0px 0px 200px 0px"
        };
        this.preloaderSelector = ".loading-spinner";
        this.preloader = this.querySelector(this.preloaderSelector);
        this.preloaderComponent = new (0, $a8fce1fcc675f0a8$export$2e2bcd8739ae039)(this.preloader);
        this.intersectionObserver = new IntersectionObserver(this.handleIntersectionObserve, this.observerOptions);
        this.intersectionObserver.observe(this);
    }
    disconnectedCallback() {
        this.intersectionObserver.disconnect();
    }
    updateFromHTML(html) {
        const newPagination = html.querySelector("pagination-infinite-scroll");
        const url = newPagination?.dataset.url;
        if (newPagination && url) {
            this.setPaginationUrl(url);
            this.intersectionObserver.observe(this);
        } else this.removeAttribute("data-url");
    }
    setPaginationUrl(url) {
        this.dataset.url = url;
    }
}
var $3a486be31b563d39$export$2e2bcd8739ae039 = $3a486be31b563d39$var$PaginationInfiniteScroll;



class $f6cd4dce23a584d0$var$DeferredMedia extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleCarouselSelect = ()=>{
            this.removeVideo();
        };
        this.handlePosterClick = ()=>{
            this.loadContent();
        };
        this.poster = this.querySelector('[id^="Deferred-Poster-"]');
    }
    connectedCallback() {
        if (this.hasAttribute("data-autoplay")) this.loadContent();
        this.poster.addEventListener("click", this.handlePosterClick);
        if (this.carousel) this.carousel.embla.on("select", this.handleCarouselSelect);
    }
    disconnectedCallback() {
        this.poster.removeEventListener("click", this.handlePosterClick);
        if (this.carousel) this.carousel.embla.off("select", this.handleCarouselSelect);
    }
    loadContent() {
        if (!this.getAttribute("loaded")) {
            this.addVideo();
            this.setAttribute("loaded", "true");
        }
    }
    removeVideo() {
        const video = this.querySelector("video,  iframe");
        if (video) {
            video.remove();
            this.removeAttribute("loaded");
        }
    }
    addVideo() {
        const content = document.createElement("div");
        const template = this.querySelector("template");
        const templateContent = template?.content;
        if (!templateContent || !templateContent.firstElementChild) return;
        const firstChild = templateContent.firstElementChild.cloneNode(true);
        content.appendChild(firstChild);
        const video = content.querySelector("video, model-viewer, iframe");
        if (!video) return;
        this.appendChild(video);
        if (video.tagName === "VIDEO") video.play();
    }
    get carousel() {
        return this.closest("carousel-component");
    }
}
var $f6cd4dce23a584d0$export$2e2bcd8739ae039 = $f6cd4dce23a584d0$var$DeferredMedia;





class $107617871cb58ad4$var$PickupAvailability extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    connectedCallback() {
        this.fetchAvailability();
    }
    fetchAvailability() {
        const variantSectionUrl = `${this.dataset.baseUrl}variants/${this.dataset.variantId}/?section_id=pickup-availability`;
        fetch(variantSectionUrl).then((response)=>response.text()).then((text)=>{
            const html = (0, $aa19cdf2f552e6e0$export$8a49393be2d55148)(text).querySelector(".shopify-section");
            this.updateSidebarFromHTML(html);
            this.updateContentFromHTML(html);
        }).catch(()=>{
            if (!(0, $339187790c656b4d$export$e1122b4c4bd5b838).notification) return;
            (0, $339187790c656b4d$export$e1122b4c4bd5b838).notification.show("Error in pickup availability component", "warning");
        });
    }
    updateVariantId(newVariantId) {
        this.dataset.variantId = newVariantId;
    }
    updateContentFromHTML(html) {
        const content = this.querySelector("pickup-availability-content");
        const newContent = html.querySelector("pickup-availability-content");
        if (content && newContent) {
            const clonedNewContent = newContent.cloneNode(true);
            content.replaceChildren(...clonedNewContent.childNodes);
        }
    }
    updateSidebarFromHTML(html) {
        const drawer = document.getElementById("pickup-availability-sidebar");
        if (!drawer) return;
        const newTemplate = html.querySelector(`[data-sidebar-template="${drawer.id}"]`);
        if (newTemplate) drawer.updateTemplate(newTemplate);
    }
}
var $107617871cb58ad4$export$2e2bcd8739ae039 = $107617871cb58ad4$var$PickupAvailability;


class $decbcfa9753297a1$var$Button {
    constructor(element){
        this.element = element;
        this.text = this.element.querySelector("[data-button-text]");
    }
    setDisable(isDisabled) {
        this.element.toggleAttribute("disabled", isDisabled);
    }
    setLoading(isLoading) {
        this.element.classList.toggle("loading", isLoading);
    }
    setText(text) {
        if (!this.text) return;
        this.text.textContent = text;
    }
}
var $decbcfa9753297a1$export$2e2bcd8739ae039 = $decbcfa9753297a1$var$Button;




const { routes: $1b010c1f8f906b69$var$routes } = window;
class $1b010c1f8f906b69$var$CartAPI {
    change(config) {
        return fetch($1b010c1f8f906b69$var$routes.cart_change_url, config).then((response)=>response.text());
    }
    add(config) {
        return fetch($1b010c1f8f906b69$var$routes.cart_add_url, config).then((response)=>response.text());
    }
    update(config) {
        return fetch($1b010c1f8f906b69$var$routes.cart_update_url, config);
    }
    get() {
        return fetch($1b010c1f8f906b69$var$routes.cart_url).then((response)=>response.text());
    }
}
var $1b010c1f8f906b69$export$2e2bcd8739ae039 = $1b010c1f8f906b69$var$CartAPI;


const $63e707e627e3e55d$export$1811237fdf5ac5d = (type = "json")=>{
    return {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: `application/${type}`
        }
    };
};


const $f024daef53a1187c$export$2bccf78e246a5305 = (form)=>{
    const obj = {};
    const formData = new FormData(form);
    for (const key of formData.keys()){
        const regex = /(?:^(properties\[))(.*?)(?:\]$)/;
        if (regex.test(key)) {
            obj.properties = obj.properties || {};
            obj.properties[regex.exec(key)[2]] = formData.get(key);
        } else obj[key] = formData.get(key);
    }
    return JSON.stringify(obj);
};



class $1f317d8f16a4f7fb$var$ProductForm extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleFormSubmit = (event)=>{
            event.preventDefault();
            const config = this.getQueryConfig();
            this.setDisable(true);
            this.setLoading(true);
            this.cartApi.add(config).then((state)=>{
                const parsedState = JSON.parse(state);
                this.setDisable(false);
                this.setLoading(false);
                if (parsedState.description) {
                    if (!(0, $339187790c656b4d$export$e1122b4c4bd5b838).notification) return;
                    const errorMessage = typeof parsedState.description === "object" ? this.getErrorMessageFromObject(parsedState.description) : parsedState.description;
                    (0, $339187790c656b4d$export$e1122b4c4bd5b838).notification.show(errorMessage, "warning");
                    return;
                }
                if (this.cart) this.updateCart(parsedState);
                else if (this.cartDrawer) this.updateCartDrawerByParsedState(parsedState);
                else this.updatePopupByParsedState(parsedState);
            }).catch(()=>{
                if (!(0, $339187790c656b4d$export$e1122b4c4bd5b838).notification) return;
                (0, $339187790c656b4d$export$e1122b4c4bd5b838).notification.show("Error in product form component", "warning");
            });
        };
        this.cartDrawer = document.querySelector(`#CartDrawer`);
        this.cart = document.querySelector("cart-page");
        this.cartNotificationPopup = document.querySelector("#CartNotificationPopup");
        this.formSelector = "form";
        this.variantInputSelector = `[data-product-form-variant]`;
        this.form = this.querySelector(this.formSelector);
        this.quickView = document.getElementById("Quick-view");
        if (this.form) this.variantInput = this.form.querySelector(this.variantInputSelector);
        this.cartApi = new (0, $1b010c1f8f906b69$export$2e2bcd8739ae039)();
    }
    connectedCallback() {
        this.form.addEventListener("submit", this.handleFormSubmit);
    }
    disconnectedCallback() {
        this.form.removeEventListener("submit", this.handleFormSubmit);
    }
    getErrorMessageFromObject(errorObject) {
        return Object.keys(errorObject).map((key)=>{
            return `${key}: ${errorObject[key]}`;
        }).join(" , ");
    }
    updateCart(parsedState) {
        if (!this.cart) return;
        this.cart.updateEmptyStatus(false);
        this.showCallbackAfterCloseDialogWindow(()=>{
            this.cart.purchaseHandler(parsedState);
        });
    }
    updateCartDrawerByParsedState(parsedState) {
        if (!this.cartDrawer) return;
        this.cartDrawer.updateEmptyStatus();
        const openCartDrawerCallback = ()=>{
            if (!this.cartDrawer) return;
            this.cartDrawer.purchaseHandler(parsedState);
        };
        this.showCallbackAfterCloseDialogWindow(openCartDrawerCallback);
    }
    updatePopupByParsedState(parsedState) {
        const openPopupCallback = ()=>{
            if (!this.cartNotificationPopup) return;
            this.cartNotificationPopup.showProductFromParsedState(parsedState, parsedState.id);
        };
        this.showCallbackAfterCloseDialogWindow(openPopupCallback);
    }
    showCallbackAfterCloseDialogWindow(callback) {
        return (0, $6de5ff37caa957d8$export$1391212d75b2ee65)(0).then(()=>{
            if (this.quickView.isOpen) this.quickView.hide().then(callback);
            else callback();
        });
    }
    getFormData() {
        return JSON.parse((0, $f024daef53a1187c$export$2bccf78e246a5305)(this.form));
    }
    getQueryConfig() {
        const config = (0, $63e707e627e3e55d$export$1811237fdf5ac5d)("javascript");
        const cartDrawerSectionId = this.cartDrawer?.dataset.sectionId || "cart-drawer";
        const cartSectionId = this.cart?.dataset.sectionId || "cart";
        const sections = [
            cartDrawerSectionId,
            cartSectionId,
            "cart-notification-popup-content"
        ];
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        config.body = JSON.stringify({
            ...this.getFormData(),
            sections: sections,
            sections_url: window.location.pathname
        });
        return config;
    }
    setLoading(isLoading) {
        const submitButtons = this.querySelectorAll('button[type="submit"]');
        submitButtons.forEach((submitButton)=>{
            const submitButtonComponent = new (0, $decbcfa9753297a1$export$2e2bcd8739ae039)(submitButton);
            submitButtonComponent.setLoading(isLoading);
        });
    }
    setDisable(isDisable) {
        const submitButtons = this.querySelectorAll('button[type="submit"]');
        submitButtons.forEach((submitButton)=>{
            const submitButtonComponent = new (0, $decbcfa9753297a1$export$2e2bcd8739ae039)(submitButton);
            submitButtonComponent.setDisable(isDisable);
        });
    }
    setButtonText(text) {
        const submitButtons = this.querySelectorAll('button[type="submit"]');
        submitButtons.forEach((submitButton)=>{
            const submitButtonComponent = new (0, $decbcfa9753297a1$export$2e2bcd8739ae039)(submitButton);
            submitButtonComponent.setText(text);
        });
    }
}
var $1f317d8f16a4f7fb$export$2e2bcd8739ae039 = $1f317d8f16a4f7fb$var$ProductForm;



class $aed5447d179a13f9$var$ProductFormButton extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleWindowScroll = ()=>{
            if (!this.button || !this.form) return;
            const scrollPosition = window.scrollY;
            const criticalPoint = this.form.offsetTop + this.form.offsetHeight;
            const footerOffsetTop = this.footer ? this.footer.offsetTop : 0;
            const isOverFooter = window.innerHeight + scrollPosition < footerOffsetTop;
            const isVisible = isOverFooter && scrollPosition > criticalPoint;
            this.toggleAttribute("visible", isVisible);
            document.body.toggleAttribute("is-product-form-button-fixed", isVisible);
        };
        this.button = this.querySelector("[data-product-form-button]");
        this.footer = document.querySelector(".shopify-section.shopify-section-footer");
        this.form = this.closest("product-form");
    }
    connectedCallback() {
        window.addEventListener("scroll", this.handleWindowScroll);
    }
    disconnectedCallback() {
        window.removeEventListener("scroll", this.handleWindowScroll);
    }
}
var $aed5447d179a13f9$export$2e2bcd8739ae039 = $aed5447d179a13f9$var$ProductFormButton;




class $10a1c0df1ee7ad84$var$ProductBlock extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.blockSelector = `[data-product-block-item]`;
        this.containerSelector = `[data-product-block-container]`;
        this.activeTemplate = this.querySelector(this.blockSelector);
        this.activeTemplateContainer = this.querySelector(this.containerSelector);
    }
    updateByVariantId(variantId) {
        const selectedTemplate = this.querySelector(`[data-product-block-template="${variantId}"]`);
        if (this.activeTemplate && this.activeTemplateContainer) {
            const newTemplate = (0, $aa19cdf2f552e6e0$export$8ea4fc17cec6f158)(selectedTemplate);
            if (newTemplate) {
                this.activeTemplate.remove();
                this.activeTemplate = newTemplate;
                this.activeTemplateContainer.appendChild(newTemplate);
            }
        }
    }
}
var $10a1c0df1ee7ad84$export$2e2bcd8739ae039 = $10a1c0df1ee7ad84$var$ProductBlock;



const { Shopify: $910c02f4e66f28fc$var$Shopify } = window;
class $910c02f4e66f28fc$var$ProductModel extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.poster = this.querySelector('[id^="Deferred-Poster-"]');
    }
    connectedCallback() {
        this.poster.addEventListener("click", this.handlePosterClick);
        if (this.carousel) this.carousel.embla.on("select", this.handleCarouselSelect);
    }
    disconnectedCallback() {
        this.poster.removeEventListener("click", this.handlePosterClick);
        if (this.carousel) this.carousel.embla.off("select", this.handleCarouselSelect);
    }
    handlePosterClick = ()=>{
        this.loadContent();
    };
    handleCarouselSelect = ()=>{
        if (this.carousel) this.setCarouselDraggable(true);
    };
    loadContent() {
        if (!this.getAttribute("loaded")) {
            this.addModel();
            this.setAttribute("loaded", true);
            if (this.carousel) this.setCarouselDraggable(false);
        }
        $910c02f4e66f28fc$var$Shopify.loadFeatures([
            {
                name: "model-viewer-ui",
                version: "1.0",
                onLoad: this.setupModelViewerUI.bind(this)
            }
        ]);
    }
    addModel() {
        const template = this.querySelector("template");
        if (!template || !template.content) return;
        const templateContent = template.content;
        const content = document.createElement("div");
        content.appendChild(templateContent.firstElementChild.cloneNode(true));
        const modelViewer = content.querySelector("model-viewer");
        this.appendChild(modelViewer);
    }
    setupModelViewerUI(errors) {
        if (errors) return;
        this.modelViewerUI = new $910c02f4e66f28fc$var$Shopify.ModelViewerUI(this.querySelector("model-viewer"));
    }
    setCarouselDraggable(isDraggable) {
        const modelViewer = this.querySelector(".shopify-model-viewer-ui");
        this.carousel.dataset.draggable = isDraggable ? "true" : "false";
        this.carousel.reInit();
        if (isDraggable && modelViewer) {
            modelViewer.remove();
            this.removeAttribute("loaded");
        }
    }
    get carousel() {
        return this.closest("carousel-component");
    }
}
var $910c02f4e66f28fc$export$2e2bcd8739ae039 = $910c02f4e66f28fc$var$ProductModel;
window.ProductModel = {
    loadShopifyXR () {
        $910c02f4e66f28fc$var$Shopify.loadFeatures([
            {
                name: "shopify-xr",
                version: "1.0",
                onLoad: this.setupShopifyXR.bind(this)
            }
        ]);
    },
    setupShopifyXR (errors) {
        if (errors) return;
        if (!window.ShopifyXR) {
            document.addEventListener("shopify_xr_initialized", ()=>this.setupShopifyXR());
            return;
        }
        document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON)=>{
            window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
            modelJSON.remove();
        });
        window.ShopifyXR.setupXRElements();
    }
};
window.addEventListener("DOMContentLoaded", ()=>{
    if ($910c02f4e66f28fc$var$Shopify.designMode) document.querySelectorAll("[data-shopify-xr-hidden]").forEach((element)=>element.classList.add("hidden"));
    if (window.ProductModel) window.ProductModel.loadShopifyXR();
});




class $6a7882e68e66864e$var$CartItem extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleResize = ()=>{
            this.setMaxHeight(this.scrollHeight);
        };
        this.removeItem = ()=>{
            this.collapse().then(()=>{
                this.remove();
            });
        };
        this.expand = ()=>{
            this.setMaxHeight(this.scrollHeight);
            return (0, $6de5ff37caa957d8$export$1391212d75b2ee65)((0, $6de5ff37caa957d8$export$5faba83c1624a4ba)(this.styles));
        };
        this.collapse = ()=>{
            this.setMaxHeight(0);
            return (0, $6de5ff37caa957d8$export$1391212d75b2ee65)((0, $6de5ff37caa957d8$export$5faba83c1624a4ba)(this.styles));
        };
        this.showCheckmark = ()=>{
            const checkmark = this.querySelector(this.checkmarkSelector);
            if (!checkmark) return;
            checkmark.classList.remove("hidden");
            (0, $6de5ff37caa957d8$export$1391212d75b2ee65)(2500).then(()=>{
                checkmark.classList.add("hidden");
            });
        };
        this.setLoading = (isLoading)=>{
            const totals = this.querySelector(this.totalsSelector);
            if (!totals) return;
            totals.toggleAttribute("is-loading", isLoading);
        };
        this.checkmarkSelector = `[data-cart-item-checkmark]`;
        this.totalsSelector = `[data-cart-item-totals]`;
        this.quantitySelector = `[data-cart-item-quantity]`;
        this.styles = getComputedStyle(this);
        this.resizeObserver = new ResizeObserver(this.handleResize);
        this.resizeObserver.observe(this);
    }
    connectedCallback() {
        this.setMaxHeight(this.scrollHeight);
    }
    disconnectedCallback() {
        this.resizeObserver.disconnect();
    }
    setMaxHeight(maxHeight) {
        this.style.maxHeight = `${maxHeight}px`;
    }
    setDisabled(isDisable) {
        const quantity = this.querySelector(this.quantitySelector);
        if (!quantity) return;
        quantity.setDisable(isDisable);
    }
}
var $6a7882e68e66864e$export$2e2bcd8739ae039 = $6a7882e68e66864e$var$CartItem;








class $9cd57d8ee4ebf51c$var$Cart extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleCartItemChange = (event)=>{
            const itemIndex = +event.target.dataset.index;
            const cartItem = this.querySelector(`#CartItem-${itemIndex}`);
            if (!cartItem) return;
            cartItem.setLoading(true);
        };
        this.handleCartChange = (0, $adb0a393977b573d$exports.debounce)((event)=>{
            const itemIndex = +event.target.dataset.index;
            const value = event.target.value;
            this.updateItem(itemIndex, value);
        }, 500);
        this.cartAPI = new (0, $1b010c1f8f906b69$export$2e2bcd8739ae039)();
    }
    connectedCallback() {
        this.addEventListener("change", this.handleCartChange);
        this.addEventListener("change", this.handleCartItemChange);
    }
    disconnectedCallback() {
        this.removeEventListener("change", this.handleCartChange);
        this.removeEventListener("change", this.handleCartItemChange);
    }
    createQueryConfig(itemIndex, quantity) {
        const config = {
            ...(0, $63e707e627e3e55d$export$1811237fdf5ac5d)(),
            body: JSON.stringify({
                line: itemIndex + 1,
                quantity: quantity,
                sections: this.dataset.sectionId,
                sections_url: window.location.pathname
            })
        };
        return config;
    }
    updateItem(itemIndex, quantity) {
        const cartItem = this.querySelector(`#CartItem-${itemIndex}`);
        if (!cartItem) return;
        const config = this.createQueryConfig(itemIndex, quantity);
        const newQuantity = +quantity;
        const currentQuantity = +(cartItem.dataset.quantity || 0);
        const hasDifferenceQuantity = currentQuantity === newQuantity;
        const isZeroQuantity = newQuantity === 0;
        if (hasDifferenceQuantity) {
            cartItem.setLoading(false);
            return;
        }
        if (isZeroQuantity) {
            const cartItems = this.querySelectorAll("cart-item");
            const cartCount = cartItems.length;
            this.updateEmptyStatus(cartCount === 1);
            cartItem.removeItem();
        }
        this.emit("start-update", {});
        cartItem.setDisabled(true);
        this.cartAPI.change(config).then((state)=>{
            const parsedState = JSON.parse(state);
            cartItem.setDisabled(false);
            cartItem.setLoading(false);
            const node = (0, $aa19cdf2f552e6e0$export$8a49393be2d55148)(parsedState.sections[this.dataset.sectionId]);
            this.emit("update-nodes", {
                node: node
            });
        }).catch(()=>{
            this.showError();
        });
    }
    purchaseHandler(parsedState) {
        const node = (0, $aa19cdf2f552e6e0$export$8a49393be2d55148)(parsedState.sections[this.dataset.sectionId]);
        this.emit("update-nodes", {
            node: node
        });
        const cartItem = this.querySelector(`cart-item[data-variant-id="${parsedState.id}"]`);
        if (!cartItem) return;
        if (parsedState.quantity === 1) cartItem.collapse().then(()=>cartItem.expand()).then(()=>cartItem.showCheckmark());
        else cartItem.showCheckmark();
    }
    showError() {
        if (!(0, $339187790c656b4d$export$e1122b4c4bd5b838).notification) return;
        const { cartStrings: cartStrings } = window.auroraThemeLocales;
        (0, $339187790c656b4d$export$e1122b4c4bd5b838).notification.show(cartStrings.error, "warning");
    }
    updateEmptyStatus(isEmpty) {
        this.toggleAttribute("is-empty", isEmpty);
        if (isEmpty) this.emit("cartIsEmpty", {});
    }
}
var $9cd57d8ee4ebf51c$export$2e2bcd8739ae039 = $9cd57d8ee4ebf51c$var$Cart;









class $287a1f0af5f6b4fe$var$CartDrawer extends (0, $a31366d6d865bd48$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleCartItemChange = (event)=>{
            const itemIndex = +event.target.dataset.index;
            const cartItem = this.querySelector(`#CartItem-${itemIndex}`);
            if (!cartItem) return;
            cartItem.setLoading(true);
        };
        this.handleCartChange = (0, $adb0a393977b573d$exports.debounce)((event)=>{
            const itemIndex = +event.target.dataset.index;
            const value = +event.target.value;
            this.updateItem(itemIndex, value);
        }, 500);
        this.handleViewportScroll = ()=>{
            this.updateViewport();
        };
        this.handleResultsResize = ()=>{
            this.updateViewport();
        };
        this.viewport = this.element.querySelector("[data-cart-drawer-viewport]");
        this.results = this.element.querySelector("[data-cart-drawer-results]");
        this.header = this.element.querySelector("[data-cart-drawer-header]");
        this.footer = this.element.querySelector("[data-cart-drawer-footer]");
        this.cartAPI = new (0, $1b010c1f8f906b69$export$2e2bcd8739ae039)();
        if (this.results) {
            this.resizeObserver = new ResizeObserver(this.handleResultsResize);
            this.resizeObserver.observe(this.results);
        }
    }
    connectedCallback() {
        super.connectedCallback();
        this.addEventListener("change", this.handleCartChange);
        this.addEventListener("change", this.handleCartItemChange);
        if (this.viewport) this.viewport.addEventListener("scroll", this.handleViewportScroll);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener("change", this.handleCartChange);
        this.removeEventListener("change", this.handleCartItemChange);
        if (this.viewport) this.viewport.removeEventListener("scroll", this.handleViewportScroll);
        this.resizeObserver.disconnect();
    }
    updateViewport() {
        if (!this.results || !this.viewport) return;
        const isOverflow = this.results.offsetHeight > this.viewport.offsetHeight;
        const isScrolled = this.viewport.scrollTop > 0;
        this.classList.toggle("header-shadow-visible", isOverflow && isScrolled);
        this.classList.toggle("footer-shadow-visible", isOverflow);
    }
    updateItem(itemIndex, quantity) {
        const config = this.createConfig(itemIndex, quantity);
        const cartItem = this.querySelector(`#CartItem-${itemIndex}`);
        if (!cartItem) return;
        const currentQuantity = +(cartItem.dataset.quantity || 0);
        if (currentQuantity === quantity) {
            cartItem.setLoading(false);
            return;
        }
        cartItem.setDisabled(true);
        if (quantity === 0) cartItem.removeItem();
        this.emit("start-update", {});
        this.cartAPI.change(config).then((state)=>{
            const parsedState = JSON.parse(state);
            cartItem.setLoading(false);
            cartItem.setDisabled(false);
            const node = this.getTemplateContent(parsedState);
            this.mount();
            this.emit("update-nodes", {
                node: node
            });
            this.updateEmptyStatus();
        }).catch(()=>{
            this.showError();
        });
    }
    showError() {
        const notificationElement = this.querySelector("#CartDrawerNotification");
        if (notificationElement) {
            const notification = new (0, $2baf4cc1d12f378d$export$2e2bcd8739ae039)(notificationElement);
            notification.show(window.auroraThemeLocales.cartStrings.error, "warning");
        }
    }
    purchaseHandler(parsedState) {
        const node = this.getTemplateContent(parsedState);
        const customElementContainer = (0, $6de5ff37caa957d8$export$402b71a6ab88771a)(node);
        this.mount();
        this.emit("update-nodes", {
            node: node
        });
        this.updateEmptyStatus();
        (0, $6de5ff37caa957d8$export$6b8b061b59c6fc66)(customElementContainer);
        const cartItem = this.element.querySelector(`cart-item[data-variant-id="${parsedState.id}"]`);
        if (!cartItem) return;
        if (parsedState.quantity === 1) cartItem.collapse().then(()=>this.open()).then(()=>cartItem.expand()).then(()=>cartItem.showCheckmark());
        else this.open().then(()=>cartItem.showCheckmark());
    }
    getTemplateContent(parsedState) {
        const html = (0, $aa19cdf2f552e6e0$export$8a49393be2d55148)(parsedState.sections[this.dataset.sectionId]);
        const newTemplate = html.querySelector(`[data-sidebar-template="${this.id}"]`);
        const node = (0, $aa19cdf2f552e6e0$export$8ea4fc17cec6f158)(newTemplate);
        return node;
    }
    updateEmptyStatus() {
        const cartItems = this.element.querySelectorAll("cart-item");
        const hasWarningPlaceholder = this.hasAttribute("data-has-warning-placeholder");
        const isEmpty = cartItems.length === 0;
        if (hasWarningPlaceholder) this.toggleAttribute("is-empty", isEmpty);
        if (isEmpty) this.emit("cartIsEmpty", {});
    }
    createConfig(itemIndex, quantity) {
        return {
            ...(0, $63e707e627e3e55d$export$1811237fdf5ac5d)(),
            body: JSON.stringify({
                line: itemIndex + 1,
                quantity: quantity,
                sections: this.dataset.sectionId,
                sections_url: window.location.pathname
            })
        };
    }
}
var $287a1f0af5f6b4fe$export$2e2bcd8739ae039 = $287a1f0af5f6b4fe$var$CartDrawer;



const { Shopify: $afe431fb3d0d9679$var$Shopify } = window;
class $afe431fb3d0d9679$var$FreeShippingBar extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.setProgress = (value)=>{
            this.style.setProperty(`--gsc-free-shipping-progress`, `${value}%`);
        };
        this.setMessage = (message)=>{
            const messageNode = this.querySelector(this.messageNodeSelector);
            if (messageNode) messageNode.replaceChildren(message);
        };
        this.messageNodeSelector = "[data-free-shipping-bar-message]";
    }
    connectedCallback() {
        const cartTotal = this.dataset.cartTotal || 0;
        this.updateProgressByCartTotal(+cartTotal);
    }
    updateProgressByCartTotal(cartTotal) {
        const currencyFormat = this.dataset.currencyFormat || "";
        const threshold = +(this.dataset.threshold || 0);
        const currencyRate = +$afe431fb3d0d9679$var$Shopify.currency.rate;
        const progressMessage = this.dataset.progressMessage || "";
        const achievedMessage = this.dataset.achievedMessage || "";
        const thresholdInStoreCurrency = threshold * currencyRate;
        const valueLeft = +(thresholdInStoreCurrency - cartTotal).toFixed(2);
        const moneyPerPercent = thresholdInStoreCurrency / 100;
        if (valueLeft > 0) {
            const preparedValueLeft = currencyFormat.replace(/{{.+?}}/g, `${valueLeft}`);
            this.setMessage(progressMessage.replace("[value]", preparedValueLeft));
            this.setProgress(cartTotal / moneyPerPercent);
        } else {
            this.setMessage(achievedMessage);
            this.setProgress(100);
        }
    }
}
var $afe431fb3d0d9679$export$2e2bcd8739ae039 = $afe431fb3d0d9679$var$FreeShippingBar;



class $cd220d380db8039c$var$ProductMedia extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    connectedCallback() {
        this.setReady();
    }
    updateFirstMediaByVariant(variant, isForceAnimation = false) {
        if (variant && variant.featured_media) {
            const media = this.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
            const elementToScroll = media ?? this;
            elementToScroll.scrollIntoView({
                behavior: isForceAnimation ? "auto" : "smooth"
            });
        }
    }
    setReady() {
        this.setAttribute("ready", "");
    }
}
var $cd220d380db8039c$export$2e2bcd8739ae039 = $cd220d380db8039c$var$ProductMedia;



class $2a3f92ba81d32d00$var$ProductMediaCarousel extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.carouselSelector = `[data-product-media-carousel-component]`;
    }
    connectedCallback() {
        this.setReady();
    }
    updateFirstMediaByVariant(variant, isForceAnimation = false) {
        const carousel = this.querySelector(this.carouselSelector);
        if (variant && variant.featured_media && carousel) {
            const slides = carousel.embla.slideNodes();
            const targetIndex = slides.findIndex((slide)=>{
                if (!slide.dataset.mediaId) return false;
                return +slide.dataset.mediaId === +variant.featured_media.id;
            });
            carousel.embla.scrollTo(targetIndex, isForceAnimation);
        }
    }
    setReady() {
        this.setAttribute("ready", "");
    }
}
var $2a3f92ba81d32d00$export$2e2bcd8739ae039 = $2a3f92ba81d32d00$var$ProductMediaCarousel;





class $772275475650e7af$var$VariantPicker extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.pickupAvailability = document.getElementById(`product-pickup-availability-${this.dataset.productId}-${this.dataset.section}`);
        this.elements = [
            "sticky-product-buy-btn",
            "product-buy-btn",
            "product-quantity"
        ];
        this.productMediaFilteringOption = this.dataset.productMediaFilteringOption;
    }
    connectedCallback() {
        this.updateVariant();
        setTimeout(()=>{
            this.updateOptionsAvailable();
            this.setFocusListeners();
        }, 100);
        if (this.dataset.selectedVariantId) this.updateFirstMediaByVariant(this.variant, true);
        this.addEventListener("change", this.handleVariantChange);
    }
    disconnectedCallback() {
        this.removeEventListener("change", this.handleVariantChange);
    }
    handleVariantChange = (event)=>{
        this.updateForm();
        this.setInventoryStatusAvailable(this.variant);
        if (!this.variant) {
            this.setButtonsUnavailable();
            return;
        }
        this.form.setDisable(true);
        this.form.setLoading(true);
        if (this.pickupAvailability) this.updatePickupAvailability();
        this.updateURL();
        this.updateVariantInput();
        this.updateProduct();
        if (this.productMediaFilteringOption !== event.target.name) this.updateFirstMediaByVariant(this.variant, false);
        this.emit("variantChange", {
            variant: this.variant,
            optionChanged: event.target.name
        });
    };
    updateLabels() {
        const inputContainers = this.querySelectorAll("[data-variant-picker-option-inputs]");
        const labelContainers = this.querySelectorAll("[data-variant-picker-option-labels]");
        inputContainers.forEach((inputContainer, idx)=>{
            const labels = [
                ...labelContainers[idx].querySelectorAll("label")
            ];
            const inputs = [
                ...inputContainer.querySelectorAll("input")
            ];
            const checkedInput = this.getCheckedInput(inputs);
            const dropdownLabel = labelContainers[idx].querySelector("[data-dropdown-variant-picker-label]");
            if (dropdownLabel) dropdownLabel.toggleAttribute("no-available", !this.variant?.available);
            labels.forEach((label)=>{
                const isMatched = label.getAttribute("for") === checkedInput.id;
                if (dropdownLabel && isMatched) {
                    const dropdown = dropdownLabel.closest("dropdown-opener");
                    const clonedLabel = label.cloneNode(true);
                    dropdownLabel.replaceChildren(...clonedLabel.childNodes);
                    dropdown.trigger();
                }
                label.classList.toggle("selected", isMatched);
            });
        });
    }
    updateURL() {
        if (!this.variant || this.dataset.updateUrl === "false") return;
        window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.variant.id}`);
    }
    setInventoryStatusAvailable(isAvailable) {
        const productStockInner = document.getElementById(`product-stock-inner-${this.dataset.productId}-${this.dataset.section}`);
        if (productStockInner) productStockInner.classList.toggle("hidden", !isAvailable);
    }
    setButtonsUnavailable() {
        this.form.setDisable(true);
        this.form.setButtonText(window.auroraThemeLocales.variantStrings.unavailable);
    }
    updateVariant() {
        const options = this.querySelectorAll("[data-variant-picker-option-inputs]");
        const variants = this.getVariants();
        const selectedOptions = [
            ...options
        ].map((option)=>{
            const inputs = [
                ...option.querySelectorAll("input")
            ];
            const found = this.getCheckedInput(inputs);
            return found.value;
        });
        this.variant = variants.find(({ options: options })=>{
            return !options.map((option, index)=>selectedOptions[index] === option).includes(false);
        });
    }
    setFocusListeners() {
        if (this.dataset.type === "dropdown") {
            const labels = [
                ...this.querySelectorAll("float-element")
            ].map((dropdown)=>{
                return [
                    ...dropdown.element.querySelectorAll("label")
                ];
            }).reduce((acc, labels)=>[
                    ...acc,
                    ...labels
                ], []);
            this.setListenersForLabels(labels);
        } else {
            const labels = [
                ...this.querySelectorAll("label")
            ];
            this.setListenersForLabels(labels);
        }
    }
    handleLabelFocus = (event)=>{
        const inputId = event.target.getAttribute("for");
        const input = this.querySelector(`input[id="${inputId}"]`);
        input.dispatchEvent(new MouseEvent("click", {
            button: 0,
            which: 1
        }));
        document.addEventListener("keydown", this.handleLabelKeydown);
    };
    setListenersForLabels(labels) {
        labels.forEach((label)=>{
            label.addEventListener("focus", this.handleLabelFocus);
        });
    }
    removeListenersForLabels(labels) {
        labels.forEach((label)=>{
            label.addEventListener("focus", this.handleLabelFocus);
        });
    }
    handleLabelKeydown = (event)=>{
        const labelContainer = event.target.closest("[data-variant-picker-option-labels]");
        const isArrowKey = event.key === "ArrowLeft" || event.key === "ArrowRight" || event.key === "ArrowUp" || event.key === "ArrowDown";
        if (!isArrowKey) return;
        if (!labelContainer) {
            document.removeEventListener("keydown", this.handleLabelKeydown);
            return;
        }
        const labels = [
            ...labelContainer.querySelectorAll("label")
        ];
        const index = labels.findIndex((label)=>label === e.target);
        const currentLabel = labels[index];
        const firstLabel = labels[0];
        const lastLabel = labels[labels.length - 1];
        const nextLabel = labels[index + 1];
        const prevLabel = labels[index - 1];
        if (labels.length !== 1) e.preventDefault();
        const setActiveLabel = (newLabel)=>{
            currentLabel.removeAttribute("tabindex");
            newLabel.setAttribute("tabindex", 0);
            newLabel.focus();
        };
        const changeActiveLabelOnNext = ()=>{
            const label = nextLabel || firstLabel;
            setActiveLabel(label);
        };
        const changeActiveLabelOnPrev = ()=>{
            const label = prevLabel || lastLabel;
            setActiveLabel(label);
        };
        const callback = {
            ArrowLeft: changeActiveLabelOnPrev,
            ArrowRight: changeActiveLabelOnNext,
            ArrowUp: changeActiveLabelOnPrev,
            ArrowDown: changeActiveLabelOnNext
        }[e.key];
        callback();
    };
    updateOptionsAvailable() {
        const options = this.querySelectorAll("[data-variant-picker-option-inputs]");
        const getOptionsByIndex = (index)=>{
            return options[index] ? [
                ...options[index].querySelectorAll("input")
            ] : null;
        };
        const firstOptions = getOptionsByIndex(0);
        const secondOptions = getOptionsByIndex(1);
        const thirdOptions = getOptionsByIndex(2);
        const variants = this.getVariants();
        const getVariantsByOption = (...prevOptions)=>{
            return variants.reduce((result, variant)=>{
                const isIncludePrevOptions = prevOptions ? prevOptions.every((prevOption)=>variant.options.includes(prevOption.value)) : true;
                return variant.available && isIncludePrevOptions ? [
                    ...result,
                    variant.options
                ] : result;
            }, []);
        };
        const getDropdownElementBySelector = (selector)=>{
            return [
                ...this.querySelectorAll("float-element")
            ].find((dropdown)=>{
                return dropdown.element.querySelector(selector);
            }).element.querySelector(selector);
        };
        const setOptions = (options, possibleVariants)=>{
            for (const option of options){
                const value = option.value;
                let available = false;
                possibleVariants.forEach((possibleVariant)=>{
                    if (possibleVariant.includes(value)) available = true;
                });
                const labelSelector = `label[for="${option.id}"]`;
                const hasLabel = this.querySelector(labelSelector);
                const label = hasLabel ? this.querySelector(labelSelector) : getDropdownElementBySelector(labelSelector);
                label.toggleAttribute("no-available", !available);
            }
        };
        setOptions(firstOptions, getVariantsByOption());
        if (secondOptions) {
            const firstSelectedOption = this.getCheckedInput(firstOptions);
            setOptions(secondOptions, getVariantsByOption(firstSelectedOption));
        }
        if (thirdOptions) {
            const firstSelectedOption = this.getCheckedInput(firstOptions);
            const secondSelectedOption = this.getCheckedInput(secondOptions);
            setOptions(thirdOptions, getVariantsByOption(firstSelectedOption, secondSelectedOption));
        }
    }
    getVariants() {
        const variantsJSON = this.querySelector("[data-variant-picker-variants]");
        const variants = JSON.parse(variantsJSON.textContent);
        return variants;
    }
    updateFirstMediaByVariant(variant, isForceAnimation) {
        if (!this.clientWidth) return;
        const mediaList = [
            ...document.querySelectorAll(`#product-media-${this.dataset.productId}-${this.dataset.section}`)
        ].filter((el)=>el.clientWidth !== 0);
        mediaList.forEach((media)=>media.updateFirstMediaByVariant(variant, isForceAnimation));
    }
    updateForm() {
        this.updateVariant();
        this.updateLabels();
        this.updateOptionsAvailable();
    }
    updateVariantInput() {
        const input = this.form.variantInput;
        input.value = this.variant.id;
        input.dispatchEvent(new Event("change", {
            bubbles: true
        }));
    }
    updatePickupAvailability() {
        this.pickupAvailability.updateVariantId(this.variant.id);
        this.pickupAvailability.fetchAvailability();
    }
    updateProduct() {
        const queryUrl = `${this.dataset.url}?variant=${this.variant.id}&section_id=${this.dataset.sectionIdWithoutPrefix}`;
        this.updateBlocksByVariantId(this.variant.id);
        fetch(queryUrl).then((response)=>response.text()).then((responseText)=>{
            if (!this.form) return;
            const html = (0, $aa19cdf2f552e6e0$export$8a49393be2d55148)(responseText);
            const isAvailable = this.variant.available;
            this.form.setDisable(!isAvailable);
            this.form.setLoading(false);
            this.updateElements(html);
        }).catch(()=>{
            if (!(0, $339187790c656b4d$export$e1122b4c4bd5b838).notification) return;
            (0, $339187790c656b4d$export$e1122b4c4bd5b838).notification.show("Error in variant picker component", "warning");
        });
    }
    updateElements(html) {
        this.elements.forEach((block)=>{
            const id = `${block}-${this.dataset.productId}-${this.dataset.section}`;
            const target = document.getElementById(id);
            if (target) {
                const newTarget = html.getElementById(id);
                const clonedNewTarget = newTarget.cloneNode(true);
                target.replaceChildren(...clonedNewTarget.childNodes);
            }
        });
    }
    updateBlocksByVariantId(variantId) {
        const blocks = [
            "product-price",
            "product-sku",
            "product-stock"
        ];
        blocks.forEach((block)=>{
            const target = document.getElementById(`${block}-${this.dataset.productId}-${this.dataset.section}`);
            if (target) target.updateByVariantId(variantId);
        });
    }
    getCheckedInput(inputs) {
        return inputs.find(({ checked: checked })=>checked);
    }
    get form() {
        return document.getElementById(`product-form-component-${this.dataset.productId}-${this.dataset.section}`);
    }
}
var $772275475650e7af$export$2e2bcd8739ae039 = $772275475650e7af$var$VariantPicker;



class $8779fa52f03f70cd$var$ColorSwatchesPicker extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleFormChange = ()=>{
            this.updateSelected();
        };
        this.handleMouseEnter = (event)=>{
            this.updateActiveValue(event.target.dataset.value);
        };
        this.handleMouseLeave = ()=>{
            this.updateSelected();
        };
        this.activeValueSelector = "[data-color-swatches-picker-active-value]";
        this.activeValue = this.querySelector(this.activeValueSelector);
        this.labelSelector = "[data-color-swatches-picker-label]";
        this.labels = [
            ...this.querySelectorAll(this.labelSelector)
        ];
        this.form = this.closest("variant-picker").form;
    }
    connectedCallback() {
        this.form.addEventListener("change", this.handleFormChange);
        this.labels.forEach((label)=>{
            label.addEventListener("mouseenter", this.handleMouseEnter);
            label.addEventListener("mouseleave", this.handleMouseLeave);
        });
    }
    disconnectedCallback() {
        this.form.removeEventListener("change", this.handleFormChange);
        this.labels.forEach((label)=>{
            label.removeEventListener("mouseenter", this.handleMouseEnter);
            label.removeEventListener("mouseleave", this.handleMouseLeave);
        });
    }
    updateSelected() {
        const selectedLabel = this.querySelector(`${this.labelSelector}.selected`);
        if (selectedLabel) {
            const value = selectedLabel.getAttribute("data-value") || "";
            this.updateActiveValue(value);
        }
    }
    updateActiveValue(value) {
        if (this.activeValue) this.activeValue.textContent = value;
    }
}
var $8779fa52f03f70cd$export$2e2bcd8739ae039 = $8779fa52f03f70cd$var$ColorSwatchesPicker;





class $416dc6426d2e3160$var$ProductModal extends (0, $1eaff675051c24fc$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleKeydown = (event)=>{
            const key = event.key || event.keyCode;
            const isEscape = (0, $6de5ff37caa957d8$export$39246f7a93d1f0fc)(key);
            if (isEscape) this.isZoomed ? this.zoomedImage.reset() : this.hide();
        };
        this.handleCarouselInit = ()=>{
            this.updateCarouselDraggableState();
        };
        this.handleCarouselSelect = ()=>{
            this.updateSelectedSlideNumber();
        };
        this.selectors = {
            carousel: `[data-product-modal-carousel]`,
            carouselButtons: `[data-product-modal-carousel-button]`,
            carouselSlide: `[data-product-modal-slide]`,
            carouselSelectedSlideNumber: `[data-product-modal-selected-slide-number]`,
            carouselSlideNumber: `[data-product-modal-slide-number]`,
            zoomCursor: `zoom-cursor`
        };
        if (this.element) {
            this.carousel = this.element.querySelector(this.selectors.carousel);
            this.carouselButtons = this.carousel.querySelectorAll(this.selectors.carouselButtons);
            this.slides = [
                ...this.element.querySelectorAll(this.selectors.carouselSlide)
            ];
            this.selectedSlideNumber = this.element.querySelector(this.selectors.carouselSelectedSlideNumber);
            this.slideNumber = this.element.querySelector(this.selectors.carouselSlideNumber);
        }
        this.zoomCursor = document.querySelector(this.selectors.zoomCursor);
        this.mediaIndexMap = this.createMediaIndexMap();
        this.isZoomed = false;
    }
    openAndShowMediaById(mediaId) {
        this.show();
        if (!this.carousel) return;
        const mediaIndex = this.mediaIndexMap[mediaId];
        this.carousel.embla.scrollTo(mediaIndex, true);
        if (this.carouselButtons[0]) this.carouselButtons[0].focus();
        this.updateSelectedSlideNumber();
    }
    initCarousel() {
        if (!this.carousel) return;
        this.carousel.embla.on("select", this.handleCarouselSelect);
        this.carousel.embla.on("init", this.handleCarouselInit);
    }
    resetCarousel() {
        if (!this.carousel) return;
        this.carousel.embla.off("select", this.handleCarouselSelect);
        this.carousel.embla.off("init", this.handleCarouselInit);
    }
    hide() {
        this.resetCarousel();
        super.hide();
        this.isZoomed = false;
        this.updateModal();
        this.emit("hide", {});
    }
    show() {
        super.show();
        this.initCarousel();
    }
    updateSelectedSlideNumber() {
        if (!this.selectedSlideNumber || !this.carousel) return;
        const selectedIndex = this.carousel.embla.selectedScrollSnap();
        const newSlideNumber = selectedIndex + 1;
        this.selectedSlideNumber.textContent = newSlideNumber;
    }
    updateModal() {
        this.updateCarouselDraggableState();
        this.updateZoomCursorState();
        this.updateZoomState();
    }
    createMediaIndexMap() {
        return this.slides.reduce((acc, slide, index)=>{
            if (!slide.dataset.mediaId) return acc;
            return {
                ...acc,
                [slide.dataset.mediaId]: index
            };
        }, {});
    }
    updateCarouselDraggableState() {
        if (!this.carousel) return;
        const isMobile = (0, $336348f90f7c8f21$export$e7a5aad9bb00dd62)();
        if (!isMobile) {
            this.carousel.reInit({
                watchDrag: false
            });
            return;
        }
        this.carousel.reInit({
            watchDrag: !this.isZoomed
        });
    }
    updateZoomCursorState() {
        if (!this.zoomCursor) return;
        this.zoomCursor.updateState(this.isZoomed);
    }
    updateZoomState() {
        this.toggleAttribute("zoom-enabled", this.isZoomed);
    }
}
var $416dc6426d2e3160$export$2e2bcd8739ae039 = $416dc6426d2e3160$var$ProductModal;




class $83ddc8473eeccce4$var$ProductModalImageWrap extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.image = this.querySelector("img");
        this.modal = this.closest("product-modal");
        this.carousel = this.modal.carousel;
        this.preloader = this.querySelector("[data-product-modal-image-preloader]");
        this.currentSettedScale = 1;
        this.isDragging = false;
        this.offsetX = 0;
        this.offsetY = 0;
        this.startDragPoint = {
            x: 0,
            y: 0
        };
        this.maxScale = 3;
        this.minScale = 1;
        this.isTapped = false;
        this.tapTimeout = 300;
        this.lastGesture = null;
        this.setZoomCursorVisible(true);
    }
    connectedCallback() {
        (0, $6de5ff37caa957d8$export$b9291b92670abfe3).observe(this.preloader);
        this.image.addEventListener("mousedown", this.handleMouseDown);
        this.image.addEventListener("mouseup", this.handleMouseUp);
        this.image.addEventListener("mousemove", this.handleMouseMove);
        this.image.addEventListener("touchstart", this.handleTouchStart);
        this.image.addEventListener("touchend", this.handleTouchEnd);
        this.image.addEventListener("touchmove", this.handleTouchMove);
        this.image.addEventListener("load", this.handleImageLoad);
        customElements.upgrade(this.modal) // https://developer.mozilla.org/en-US/docs/Web/API/CustomElementRegistry/upgrade
        ;
        this.modal.subscribe("hide", this.handleModalHide);
        this.carousel.embla.on("select", this.handleCarouselSelect);
    }
    disconnectedCallback() {
        (0, $6de5ff37caa957d8$export$b9291b92670abfe3).unobserve(this.preloader);
        this.image.removeEventListener("mousedown", this.handleMouseDown);
        this.image.removeEventListener("mouseup", this.handleMouseUp);
        this.image.removeEventListener("mousemove", this.handleMouseMove);
        this.image.removeEventListener("touchstart", this.handleTouchStart);
        this.image.removeEventListener("touchend", this.handleTouchEnd);
        this.image.removeEventListener("touchmove", this.handleTouchMove);
        this.image.removeEventListener("load", this.handleImageLoad);
        this.modal.unsubscribe("hide", this.handleModalHide);
        this.carousel.embla.off("select", this.handleCarouselSelect);
    }
    handleImageLoad = ()=>{
        this.setPreloaderVisible(false);
    };
    handleModalHide = ()=>{
        this.reset();
    };
    handleCarouselSelect = ()=>{
        this.reset();
    };
    handleTouchStart = (event)=>{
        event.preventDefault();
        this.fingers = event.touches.length;
        this.firstMove = true;
        this.detectDoubleTap(event);
    };
    handleTouchMove = (event)=>{
        event.preventDefault();
        if (!this.isDoubleTapped) {
            if (this.firstMove) {
                this.updateGesture(event);
                this.startMoveTouches = event.touches.length;
            } else if (this.lastGesture) switch(this.lastGesture){
                case "zoom":
                    if (this.startMoveTouches === 2 && event.touches.length === 2) this.pinch(event);
                    break;
                case "drag":
                    if (this.startMoveTouches === 1 && event.touches.length === 1) {
                        const { clientX: clientX, clientY: clientY } = event.targetTouches[0];
                        this.drag(clientX, clientY);
                    }
                    break;
            }
            else this.setGesture("none", event);
            this.firstMove = false;
        }
    };
    handleTouchEnd = (event)=>{
        event.preventDefault();
        this.fingers = event.touches.length;
        this.updateGesture(event);
    };
    handleMouseDown = (event)=>{
        event.preventDefault();
        this.startDrag(event.clientX, event.clientY);
        this.setDragging(true);
    };
    handleMouseUp = (event)=>{
        this.setDragging(false);
        const time = this.modal.isZoomed ? 75 : 0;
        this.zoomTimeoutId = setTimeout(()=>{
            this.touchZoom(event.clientX, event.clientY);
        }, time);
    };
    handleMouseMove = (event)=>{
        event.preventDefault();
        clearTimeout(this.zoomTimeoutId);
        if (this.isDragging && this.modal.isZoomed) {
            const { clientX: clientX, clientY: clientY } = event;
            this.drag(clientX, clientY);
        }
    };
    detectDoubleTap(event) {
        if (this.isTappedTimeout && this.fingers === 1) {
            clearTimeout(this.isTappedTimeout);
            this.isTappedTimeout = null;
            this.isDoubleTapped = true;
            this.touchZoom(event.changedTouches[0].clientX, event.changedTouches[0].clientY);
            switch(this.lastGesture){
                case "zoom":
                    this.setPinchScaling(false);
                    break;
                case "drag":
                    this.setDragging(false);
                    break;
            }
        } else this.isTappedTimeout = setTimeout(()=>{
            this.isTappedTimeout = null;
            this.isDoubleTapped = false;
        }, this.tapTimeout);
    }
    updateGesture(event) {
        if (this.fingers === 2) this.setGesture("zoom");
        else if (this.fingers === 1) this.setGesture("drag", event);
        else this.setGesture("none", event);
    }
    setGesture(newGesture, event) {
        if (this.lastGesture !== newGesture) {
            if (this.lastGesture && !newGesture) switch(this.lastGesture){
                case "zoom":
                    this.setPinchScaling(false);
                    break;
                case "drag":
                    this.setDragging(false);
                    break;
            }
            switch(newGesture){
                case "zoom":
                    this.setPinchScaling(true);
                    break;
                case "drag":
                    this.startDrag(event.changedTouches[0].clientX, event.changedTouches[0].clientY);
                    this.setDragging(true);
                    break;
                case "none":
                    this.setDragging(false);
                    this.setPinchScaling(false);
                    break;
            }
        }
        this.lastGesture = newGesture;
    }
    pinch(event) {
        const distanceBetweenTouches = this.getDistanceBetweenTouches(event);
        const isZoomIn = distanceBetweenTouches > this.lastDistanceBetweenTouches;
        const factor = isZoomIn ? 0.125 : -0.125;
        const newScale = this.getNewScale(this.currentScale + factor);
        const midPoint = this.getTouchCenter(event);
        const xs = (midPoint.x - this.offsetX) / this.currentScale;
        const ys = (midPoint.y - this.offsetY) / this.currentScale;
        this.lastDistanceBetweenTouches = distanceBetweenTouches;
        if (!isZoomIn && newScale === 1) {
            this.reset();
            return;
        }
        this.setTransform({
            scale: newScale,
            offsetX: midPoint.x - xs * newScale,
            offsetY: midPoint.y - ys * newScale
        });
    }
    getDistanceBetweenTouches(event) {
        return Math.hypot(event.touches[0].pageX - event.touches[1].pageX, event.touches[0].pageY - event.touches[1].pageY);
    }
    startDrag(clientX, clientY) {
        this.startDragPoint = {
            x: clientX - this.offsetX,
            y: clientY - this.offsetY
        };
        this.dragStartPointX = clientX;
        this.dragStartPointY = clientY;
    }
    drag(clientX, clientY) {
        const isRightDrag = this.dragStartPointX > clientX;
        const isBottomDrag = this.dragStartPointY > clientY;
        const newScale = this.getNewScale(this.currentScale);
        let newOffsetX = clientX - this.startDragPoint.x;
        let newOffsetY = clientY - this.startDragPoint.y;
        const isIntersectBounds = this.getIntersectBounds({
            isRightDrag: isRightDrag,
            isBottomDrag: isBottomDrag
        });
        if (isIntersectBounds.right || isIntersectBounds.left) newOffsetX = this.offsetX;
        if (isIntersectBounds.bottom || isIntersectBounds.top) newOffsetY = this.offsetY;
        this.setTransform({
            scale: newScale,
            offsetX: newOffsetX,
            offsetY: newOffsetY
        });
    }
    getIntersectBounds({ isRightDrag: isRightDrag, isBottomDrag: isBottomDrag }) {
        const imageRect = this.image.getBoundingClientRect();
        const delta = 8;
        const deltaX = isRightDrag ? -1 * delta : delta;
        const deltaY = isBottomDrag ? -1 * delta : delta;
        const right = isRightDrag && imageRect.right + deltaX < window.innerWidth;
        const left = !isRightDrag && imageRect.left + deltaX > 0;
        const bottom = isBottomDrag && imageRect.bottom + deltaY < window.innerHeight;
        const top = !isBottomDrag && imageRect.top + deltaY > 0;
        return {
            right: right,
            left: left,
            bottom: bottom,
            top: top
        };
    }
    getTouchCenter(event) {
        const sum = (a, b)=>a + b;
        const touches = [
            ...event.touches
        ];
        const touchCount = touches.length;
        return {
            x: touches.map((touch)=>touch.pageX).reduce(sum) / touchCount,
            y: touches.map((touch)=>touch.pageY).reduce(sum) / touchCount
        };
    }
    setTransform({ offsetX: offsetX, offsetY: offsetY, scale: scale }) {
        this.style.transform = `translate3d(${offsetX}px, ${offsetY}px, 0) scale3d(${scale}, ${scale}, 1)`;
        this.offsetX = offsetX;
        this.offsetY = offsetY;
        this.currentScale = scale;
    }
    touchZoom(clientX, clientY) {
        const xs = (clientX - this.offsetX) / this.currentScale;
        const ys = (clientY - this.offsetY) / this.currentScale;
        let newScale;
        let newOffsetX;
        let newOffsetY;
        if (this.modal.isZoomed) {
            newScale = this.getNewScale(1);
            newOffsetX = 0;
            newOffsetY = 0;
        } else {
            newScale = this.getNewScale(3);
            newOffsetX = clientX - xs * newScale;
            newOffsetY = clientY - ys * newScale;
        }
        this.style.cursor = this.modal.isZoomed ? "" : "grab";
        this.setZoomCursorVisible(this.modal.isZoomed);
        this.setTransform({
            scale: newScale,
            offsetX: newOffsetX,
            offsetY: newOffsetY
        });
    }
    reset() {
        this.setTransform({
            scale: 1,
            offsetX: 0,
            offsetY: 0
        });
    }
    getNewScale(newScale) {
        return Math.max(this.minScale, Math.min(this.maxScale, newScale));
    }
    setPinchScaling(isPinchScaling) {
        this.toggleAttribute("is-pinch-scaling", isPinchScaling);
        this.isPinchScaling = isPinchScaling;
    }
    setDragging(isDragging) {
        this.toggleAttribute("is-dragging", isDragging);
        this.isDragging = isDragging;
    }
    setZoomCursorVisible(isVisible) {
        this.image.toggleAttribute("data-zoom-cursor-target", isVisible);
    }
    setModalZoom(isZoomed) {
        this.modal.isZoomed = isZoomed;
        if (this.modal.isZoomed) this.modal.zoomedImage = this;
        this.modal.updateModal();
    }
    setPreloaderVisible(isVisible) {
        this.preloader.classList.toggle("hidden", !isVisible);
        this.image.toggleAttribute("is-loaded", !isVisible);
    }
    set currentScale(value) {
        if (this.currentSettedScale !== value) {
            this.setModalZoom(value > 1);
            this.currentSettedScale = value;
        }
    }
    get currentScale() {
        return this.currentSettedScale;
    }
}
var $83ddc8473eeccce4$export$2e2bcd8739ae039 = $83ddc8473eeccce4$var$ProductModalImageWrap;



class $5c029bc4f95f822b$var$ProductModalOpener extends (0, $90627309f9e09618$export$2e2bcd8739ae039) {
    showModal() {
        if (!this.dataset.modal) return;
        const modal = document.querySelector(this.dataset.modal);
        if (!modal) return;
        modal.openAndShowMediaById(this.dataset.mediaId);
    }
}
var $5c029bc4f95f822b$export$2e2bcd8739ae039 = $5c029bc4f95f822b$var$ProductModalOpener;





class $345f814d0df47536$var$ProductRecommendations extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleIntersectionObserve = (entries, observer)=>{
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);
            const url = this.dataset.url;
            if (!url) return;
            fetch(url).then((response)=>response.text()).then((text)=>{
                const html = (0, $aa19cdf2f552e6e0$export$8a49393be2d55148)(text);
                this.updateByHTML(html);
            }).catch(()=>{
                if (!(0, $339187790c656b4d$export$e1122b4c4bd5b838).notification) return;
                (0, $339187790c656b4d$export$e1122b4c4bd5b838).notification.show("Error in product recommendations component", "warning");
            });
        };
        this.intersectionObserver = new IntersectionObserver(this.handleIntersectionObserve, {
            rootMargin: "0px 0px 200px 0px"
        });
        this.intersectionObserver.observe(this);
    }
    disconnectedCallback() {
        this.intersectionObserver.disconnect();
    }
    updateByHTML(html) {
        const recommendations = html.querySelector("product-recommendations");
        if (recommendations) {
            const clonedRecommendations = recommendations.cloneNode(true);
            this.replaceChildren(...clonedRecommendations.childNodes);
        }
    }
}
var $345f814d0df47536$export$2e2bcd8739ae039 = $345f814d0df47536$var$ProductRecommendations;




const { routes: $0f82be44d69265a2$var$routes } = window;
class $0f82be44d69265a2$var$PredictiveSearchAPI {
    get(params) {
        const query = this.prepareQuery(params);
        return fetch(query).then((response)=>response.text());
    }
    prepareQuery(params) {
        const { searchQuery: searchQuery, sectionParam: sectionParam, limitParam: limitParam, fieldsParam: fieldsParam } = params;
        const baseUrl = $0f82be44d69265a2$var$routes.predictive_search_url;
        return `${baseUrl}?q=${searchQuery}&${limitParam}&${sectionParam}&${fieldsParam}`;
    }
}
var $0f82be44d69265a2$export$2e2bcd8739ae039 = $0f82be44d69265a2$var$PredictiveSearchAPI;




class $ed7630b6475693b2$var$SearchSidebarFormWrapper extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleInputChange = (0, $adb0a393977b573d$exports.debounce)(()=>{
            if (this.searchQuery) this.renderResults();
            else this.resetResults();
        }, 500);
        this.cache = {};
        this.sidebar = this.closest("#SearchSidebar");
        this.inputComponentSelector = `[data-sidebar-search-input-component]`;
        this.contentResults = `[data-sidebar-search-content-results]`;
        this.footerSelector = `[data-sidebar-search-footer]`;
        this.itemSelector = `[data-sidebar-search-item]`;
        if (this.sidebar) this.results = this.sidebar.element.querySelector(this.contentResults);
        this.predictiveSearchAPI = new (0, $0f82be44d69265a2$export$2e2bcd8739ae039)();
    }
    connectedCallback() {
        this.addEventListener("input", this.handleInputChange);
    }
    disconnectedCallback() {
        this.removeEventListener("input", this.handleInputChange);
    }
    renderResults() {
        this.cache[this.searchQuery] ? this.renderFromCache(this.searchQuery) : this.renderFromUrl(this.searchQuery);
    }
    resetResults() {
        if (!this.sidebar) return;
        this.updateResultsFromHTML(this.sidebar.defaultStateElement);
    }
    renderFromCache(queryKey) {
        try {
            this.updateResultsFromHTML(this.cache[queryKey]);
        } catch (error) {
            if (!(0, $339187790c656b4d$export$e1122b4c4bd5b838).notification) return;
            (0, $339187790c656b4d$export$e1122b4c4bd5b838).notification.show("Error in search component when try update from cache", "warning");
        }
    }
    renderFromUrl(queryKey) {
        const sectionId = this.sidebar?.dataset.sectionId || "search-sidebar";
        const limitParam = "resources[limit]=999";
        const sectionParam = `section_id=${sectionId}` || "";
        const fieldsParam = this.sidebar?.hasAttribute("enable-extended-search") ? "resources[options][fields]=author,body,product_type,tag,title,variants.barcode,variants.sku,variants.title,vendor" : "resources[options][fields]=title,product_type,variants.title,vendor";
        this.predictiveSearchAPI.get({
            searchQuery: this.searchQuery,
            limitParam: limitParam,
            sectionParam: sectionParam,
            fieldsParam: fieldsParam
        }).then((text)=>{
            const html = (0, $aa19cdf2f552e6e0$export$8a49393be2d55148)(text);
            this.cache[queryKey] = html;
            this.updateResultsFromHTML(html);
        }).catch(()=>{
            if (!(0, $339187790c656b4d$export$e1122b4c4bd5b838).notification) return;
            (0, $339187790c656b4d$export$e1122b4c4bd5b838).notification.show("Error in search component", "warning");
        });
    }
    updateResultsFromHTML(html) {
        const newModal = html.getElementById("SearchSidebar");
        if (newModal) {
            const template = newModal.querySelector('[data-sidebar-template="SearchSidebar"]');
            const element = (0, $aa19cdf2f552e6e0$export$8ea4fc17cec6f158)(template);
            const newResults = element.querySelector(this.contentResults);
            this.updateResultsHTML(newResults);
            this.updateFooterVisible();
        }
    }
    updateResultsHTML(newResults) {
        if (!this.results) return;
        const clonedNewResults = newResults.cloneNode(true);
        this.results.replaceChildren(...clonedNewResults.childNodes);
    }
    updateFooterVisible() {
        if (this.sidebar) {
            const footer = this.sidebar.element.querySelector(this.footerSelector);
            const renderedItems = this.sidebar.element.querySelectorAll(this.itemSelector);
            if (footer) footer.classList.toggle("hidden", renderedItems.length === 0);
        }
    }
    get searchQuery() {
        if (!this.inputComponent) return "";
        return this.inputComponent.value.trim();
    }
    get inputComponent() {
        if (!this.sidebar) return null;
        return this.sidebar.querySelector(this.inputComponentSelector);
    }
}
var $ed7630b6475693b2$export$2e2bcd8739ae039 = $ed7630b6475693b2$var$SearchSidebarFormWrapper;




class $7e9166cddce9e186$var$CartRemoveButton extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    connectedCallback() {
        this.addEventListener("keydown", this.handleKeyDown);
        this.addEventListener("click", this.handleButtonClick);
    }
    disconnectedCallback() {
        this.removeEventListener("keydown", this.handleKeyDown);
        this.removeEventListener("click", this.handleButtonClick);
    }
    update() {
        const cart = this.closest("cart-page, cart-drawer");
        const cartItemIndex = this.dataset.index;
        if (cart && cartItemIndex) cart.updateItem(+cartItemIndex, 0);
    }
    constructor(...args){
        super(...args);
        this.handleButtonClick = ()=>{
            this.update();
        };
        this.handleKeyDown = (event)=>{
            const isEnterKey = (0, $6de5ff37caa957d8$export$793b145c7f680179)(event.key || event.keyCode);
            if (isEnterKey) {
                event.preventDefault();
                this.update();
            }
        };
    }
}
var $7e9166cddce9e186$export$2e2bcd8739ae039 = $7e9166cddce9e186$var$CartRemoveButton;




class $c1a5360a95e3ad18$var$ClipboardButton extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    connectedCallback() {
        this.addEventListener("click", this.handleButtonClick);
    }
    disconnectedCallback() {
        this.removeEventListener("click", this.handleButtonClick);
    }
    showTooltip() {
        const tooltipId = this.dataset.tooltipId;
        if (!tooltipId) return;
        const tooltip = document.getElementById(tooltipId);
        if (tooltip) {
            tooltip.show();
            (0, $6de5ff37caa957d8$export$1391212d75b2ee65)(1000).then(()=>{
                tooltip.hide();
            });
        }
    }
    constructor(...args){
        super(...args);
        this.handleButtonClick = ()=>{
            this.copy();
        };
        this.copy = ()=>{
            const value = this.dataset.value;
            if (value && navigator.clipboard) navigator.clipboard.writeText(value).then(()=>{
                this.showTooltip();
            }).catch((e)=>{
                if (window.Shopify.designMode) // The Clipboard API blocked in Shopify editor
                this.showTooltip();
                throw e;
            });
        };
    }
}
var $c1a5360a95e3ad18$export$2e2bcd8739ae039 = $c1a5360a95e3ad18$var$ClipboardButton;





class $454301f39b303a98$var$ClipboardButtonTooltip extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.init = ()=>{
            if (!this.target) return;
            (0, $d9c5c13022e8d55b$export$deee3a793edee05f)(this.target, this, ()=>{
                (0, $d9c5c13022e8d55b$export$48a53dcb22e581d0)(this.target, this, this.getOptions()).then((data)=>{
                    this.updatePosition(data);
                    this.updateArrow(data);
                });
            });
        };
        this.show = ()=>{
            this.mount();
            this.setVisible(true);
            this.emit("show", {});
        };
        this.hide = ()=>{
            this.setVisible(false);
            this.unmount();
            this.emit("hide", {});
        };
        const template = this.querySelector(`[data-clipboard-button-tooltip-template="${this.id}"]`);
        this.element = (0, $aa19cdf2f552e6e0$export$8ea4fc17cec6f158)(template);
        this.arrow = this.element.querySelector("[data-float-element-arrow]");
    }
    connectedCallback() {
        this.init();
    }
    updatePosition({ x: x, y: y }) {
        Object.assign(this.style, {
            left: `${x}px`,
            top: `${y}px`
        });
    }
    getOptions() {
        return {
            placement: this.placement,
            middleware: this.getMiddleware(),
            strategy: "absolute"
        };
    }
    getMiddleware() {
        const alignmentAxisOffset = this.dataset.alignmentAxisOffset || 0;
        const mainAxisOffset = this.dataset.mainAxisOffset || 0;
        const middleware = [
            (0, $91121656e03b27e0$export$cc800923e997bb8)({
                alignmentAxis: +alignmentAxisOffset,
                mainAxis: +mainAxisOffset
            }),
            (0, $91121656e03b27e0$export$8a83211c878a3f1f)(),
            (0, $91121656e03b27e0$export$fba63a578e423eb)()
        ];
        if (this.arrow) middleware.push((0, $91121656e03b27e0$export$f2120bbfa5450bd2)({
            element: this.arrow
        }));
        return middleware;
    }
    updateArrow({ placement: placement, middlewareData: middlewareData }) {
        if (!this.arrow) return;
        const { x: arrowX, y: arrowY } = middlewareData.arrow;
        const staticSide = {
            top: "bottom",
            right: "left",
            bottom: "top",
            left: "right"
        }[placement.split("-")[0]];
        Object.assign(this.arrow.style, {
            left: arrowX != null ? `${arrowX}px` : "",
            top: arrowY != null ? `${arrowY}px` : "",
            right: "",
            bottom: "",
            [staticSide]: "-5px"
        });
    }
    mount() {
        if (!this.contains(this.element)) this.appendChild(this.element);
    }
    unmount() {
        if (this.element) this.element.remove();
    }
    setVisible(isVisible) {
        this.setAttribute("aria-hidden", isVisible ? "false" : "true");
    }
    get target() {
        return document.querySelector(`[data-clipboard-button-tooltip-target-id="${this.id}"]`);
    }
    get placement() {
        return this.dataset.placement || "bottom-end";
    }
}
var $454301f39b303a98$export$2e2bcd8739ae039 = $454301f39b303a98$var$ClipboardButtonTooltip;




class $40c8fbe341f607ee$var$Card extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
}
var $40c8fbe341f607ee$export$2e2bcd8739ae039 = $40c8fbe341f607ee$var$Card;




class $9ad483dc02354acb$var$ProductCard extends (0, $40c8fbe341f607ee$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleMouseEnter = ()=>{
            const url = this.dataset.url;
            const id = this.dataset.id;
            if (!this.quickView) return;
            if (url && id) this.quickView.requestProductFromUrl(url, id);
        };
        this.handleQuickViewTriggerClick = ()=>{
            const url = this.dataset.url;
            if (!this.quickView) return;
            if (url) this.quickView.openAndRenderProductByUrl(url);
        };
        this.handleResize = (0, $adb0a393977b573d$exports.debounce)(()=>{
            if (this.buttons) this.setButtonsOverflow();
            if (this.swatches) this.swatches.update();
        }, 100);
        this.handleImageLoad = ()=>{
            this.loadedImageCount += 1;
            if (this.loadedImageCount === this.featuredImages?.length) {
                this.removeLoader();
                this.featuredImages.forEach((image)=>{
                    image.removeEventListener("load", this.handleImageLoad);
                });
            }
        };
        this.lastButtonsWidth = 0;
        this.loadedImageCount = 0;
        this.quickViewTrigger = this.querySelector("[data-product-card-quick-view-button]");
        this.loader = this.querySelector("[data-product-card-preloader]");
        this.buttons = this.querySelector("[data-product-card-buttons]");
        this.featuredImages = [
            ...this.querySelectorAll("[data-product-card-featured-image]")
        ];
        this.swatches = this.querySelector("[data-product-card-color-swatches]");
        this.quickView = document.getElementById("Quick-view");
        this.resizeObserver = new ResizeObserver(this.handleResize);
        this.resizeObserver.observe(this);
        (0, $6de5ff37caa957d8$export$b9291b92670abfe3).observe(this);
    }
    connectedCallback() {
        this.featuredImages.forEach((image)=>{
            image.addEventListener("load", this.handleImageLoad);
        });
        if (this.quickViewTrigger) {
            this.quickViewTrigger.addEventListener("mouseenter", this.handleMouseEnter);
            this.quickViewTrigger.addEventListener("click", this.handleQuickViewTriggerClick);
        }
    }
    disconnectedCallback() {
        this.featuredImages.forEach((image)=>{
            image.removeEventListener("load", this.handleImageLoad);
        });
        this.resizeObserver.disconnect();
        (0, $6de5ff37caa957d8$export$b9291b92670abfe3).unobserve(this);
        if (this.quickViewTrigger) {
            this.quickViewTrigger.removeEventListener("mouseenter", this.handleMouseEnter);
            this.quickViewTrigger.removeEventListener("click", this.handleQuickViewTriggerClick);
        }
    }
    setButtonsOverflow() {
        if (!this.buttons) return;
        if (this.offsetWidth < this.lastButtonsWidth) return;
        const isOverflowed = this.buttons.offsetWidth > this.offsetWidth;
        if (isOverflowed && this.buttons.offsetWidth > this.lastButtonsWidth) this.lastButtonsWidth = this.buttons.offsetWidth;
        this.buttons.classList.toggle("product-card__btns--overflowed", isOverflowed);
    }
    removeLoader() {
        if (!this.loader) return;
        (0, $6de5ff37caa957d8$export$b9291b92670abfe3).unobserve(this);
        (0, $aa19cdf2f552e6e0$export$7669482c90f5c50f)(this.loader);
    }
}
var $9ad483dc02354acb$export$2e2bcd8739ae039 = $9ad483dc02354acb$var$ProductCard;




class $ee33f956d661ebdb$var$MaxLinesComponent extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleResize = (0, $adb0a393977b573d$exports.debounce)(()=>{
            this.update();
        }, 100);
        this.resizeObserver = new ResizeObserver(this.handleResize);
        this.resizeObserver.observe(this);
        this.lineClamp = this.querySelector("[data-quote-line-clamp]");
        this.target = this.querySelector("[data-quote-line-clamp-target]");
        this.styles = getComputedStyle(this.target);
    }
    disconnectedCallback() {
        this.resizeObserver.disconnect();
    }
    update() {
        const maxLines = this.getMaxLines();
        if (maxLines) this.setMaxLines(maxLines);
    }
    setMaxLines(maxLines) {
        if (!this.target) return;
        this.target.style.setProperty("--gsc-max-lines", `${maxLines}`);
        this.setAttribute("data-line-clamp-setter-is-ready", "");
    }
    getMaxLines() {
        if (!this.lineClamp || !this.target) return 0;
        const lineHeight = this.styles["lineHeight"];
        const height = this.lineClamp.offsetHeight;
        const maxLines = Math.floor(height / parseFloat(lineHeight));
        return maxLines;
    }
}
var $ee33f956d661ebdb$export$2e2bcd8739ae039 = $ee33f956d661ebdb$var$MaxLinesComponent;



class $ed74028c1311c05e$var$CountrySelector extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleItemClick = (event)=>{
            if (!this.input || !this.dropdownBtnLabel || !this.dropdown) return;
            this.input.setAttribute("value", event.target.dataset.value);
            this.setActiveItem(event.target.dataset.value);
            this.dropdownBtnLabel.innerHTML = event.target.dataset.value;
            this.dropdown.hide();
        };
        this.input = this.querySelector("input");
        this.dropdown = this.querySelector("float-element");
        this.dropdownBtnLabel = this.querySelector(".dropdown__toggle-label");
        this.createItems();
        this.items = [
            ...this.querySelectorAll(".dropdown__item")
        ];
    }
    connectedCallback() {
        this.items.forEach((item)=>{
            item.addEventListener("click", this.handleItemClick);
        });
    }
    disconnectedCallback() {
        this.items.forEach((item)=>{
            item.removeEventListener("click", this.handleItemClick);
        });
    }
    setActiveItem(activeCountryValue) {
        this.items.forEach((item)=>{
            item.classList.toggle("active", item.dataset.value === activeCountryValue);
        });
    }
    createItems() {
        const options = this.querySelectorAll("option");
        const fragment = document.createDocumentFragment();
        if (!this.dropdown) return;
        options.forEach((option)=>{
            const item = document.createElement("div");
            const clonedOption = option.cloneNode(true);
            item.classList.add("dropdown__item");
            item.dataset.value = option.value;
            item.dataset.provinces = option.dataset.provinces;
            item.replaceChildren(...clonedOption.childNodes);
            fragment.appendChild(item);
        });
        this.dropdown.replaceChildren(...fragment.childNodes);
    }
}
var $ed74028c1311c05e$export$2e2bcd8739ae039 = $ed74028c1311c05e$var$CountrySelector;



class $4c99f7b6b20d5804$var$SearchField extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleWindowClick = (event)=>{
            const target = event.target;
            const isInputChild = target.closest("search-input");
            const isInput = this.input === target;
            const isOutsideClick = !isInput && !isInputChild;
            if (isOutsideClick) this.updateResetButtonVisible();
        };
        this.handleInputChange = ()=>{
            this.updateResetButtonVisible();
        };
        this.handleResetBtnClick = (event)=>{
            event.preventDefault();
            this.reset();
        };
        this.inputSelector = `[data-search-field-input]`;
        this.resetBtnSelector = `[data-search-field-reset-button]`;
        this.input = this.querySelector(this.inputSelector);
        this.resetBtn = this.querySelector(this.resetBtnSelector);
    }
    connectedCallback() {
        this.input.addEventListener("input", this.handleInputChange);
        window.addEventListener("click", this.handleWindowClick);
        this.resetBtn.addEventListener("click", this.handleResetBtnClick);
    }
    disconnectedCallback() {
        this.input.removeEventListener("input", this.handleInputChange);
        window.removeEventListener("click", this.handleWindowClick);
        this.resetBtn.removeEventListener("click", this.handleResetBtnClick);
    }
    reset() {
        if (this.input) {
            const event = new Event("input", {
                bubbles: true
            });
            this.input.value = "";
            this.input.dispatchEvent(event);
            this.input.focus();
        }
    }
    updateResetButtonVisible() {
        if (this.resetBtn) {
            const hasValue = this.hasInputValue();
            this.resetBtn.classList.toggle("hidden", !hasValue);
        }
    }
    hasInputValue() {
        if (!this.input) return false;
        return this.input.value.trim().length > 0;
    }
    get value() {
        if (!this.input) return "";
        return this.input.value;
    }
}
var $4c99f7b6b20d5804$export$2e2bcd8739ae039 = $4c99f7b6b20d5804$var$SearchField;



class $c9dfc4882548cf20$var$PasswordField extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleButtonClick = ()=>{
            this.togglePasswordVisible();
        };
        this.inputSelector = `[data-password-field-input]`;
        this.buttonSelector = `[data-password-field-button]`;
        this.input = this.querySelector(this.inputSelector);
        this.button = this.querySelector(this.buttonSelector);
    }
    connectedCallback() {
        this.button.addEventListener("click", this.handleButtonClick);
    }
    disconnectedCallback() {
        this.button.removeEventListener("click", this.handleButtonClick);
    }
    togglePasswordVisible() {
        if (this.input) {
            const isPasswordHidden = this.input.getAttribute("type") === "password";
            const type = isPasswordHidden ? "text" : "password";
            this.input.setAttribute("type", type);
            this.setButton(isPasswordHidden);
        }
    }
    setButton(isPasswordHidden) {
        if (this.button) this.button.toggleAttribute("password-visible", isPasswordHidden);
    }
}
var $c9dfc4882548cf20$export$2e2bcd8739ae039 = $c9dfc4882548cf20$var$PasswordField;




class $82a6b2eb57d7ff00$var$ZoomCursor extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleMutations = (mutations)=>{
            mutations.forEach((mutation)=>{
                if (mutation.type === "attributes") {
                    const isZoomTarget = mutation.target.matches(this.zoomTargetSelector);
                    this.setVisible(isZoomTarget);
                }
            });
        };
        this.handleMouseMove = (event)=>{
            const target = event.target;
            const isZoomTarget = !!target.closest(this.zoomTargetSelector);
            const isMobile = (0, $336348f90f7c8f21$export$e7a5aad9bb00dd62)();
            if (this.isVisible) {
                this.style.top = `${event.clientY}px`;
                this.style.left = `${event.clientX}px`;
            }
            if (!isMobile) {
                this.setVisible(isZoomTarget);
                if (isZoomTarget) this.mutationObserver.observe(target, {
                    attributes: true
                });
            }
        };
        this.zoomTargetSelector = `[data-zoom-cursor-target]`;
        this.mutationObserver = new MutationObserver(this.handleMutations);
    }
    connectedCallback() {
        this.autoCheckTargets();
    }
    disconnectedCallback() {
        window.removeEventListener("mousemove", this.handleMouseMove);
        this.mutationObserver.disconnect();
        clearInterval(this.checkTargetsIntervalID);
    }
    setVisible(isVisible) {
        this.toggleAttribute("visible", isVisible);
        document.body.style.cursor = isVisible ? "none" : "";
    }
    updateState(isZoomed) {
        this.toggleAttribute("zoomed", isZoomed);
    }
    autoCheckTargets() {
        this.checkTargetsIntervalID = setInterval(()=>{
            const targets = document.querySelectorAll(this.zoomTargetSelector);
            if (targets.length && !this.isHandlerSetted) {
                window.addEventListener("mousemove", this.handleMouseMove);
                this.isHandlerSetted = true;
            }
        }, 5000);
    }
    get isVisible() {
        return this.hasAttribute("visible");
    }
}
var $82a6b2eb57d7ff00$export$2e2bcd8739ae039 = $82a6b2eb57d7ff00$var$ZoomCursor;






class $f86b6c4dd05ec780$var$Shop extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleHistoryChange = ({ state: { searchParams: searchParams } })=>{
            const newSearchParams = searchParams || this.searchParamsInitial;
            if (newSearchParams !== this.searchParamsPrev) this.updateBySearchParams(newSearchParams);
        };
        this.cache = {};
        this.searchParamsInitial = window.location.search.slice(1);
        this.searchParamsPrev = window.location.search.slice(1);
        this.sortQuery = "";
        this.filterQuery = "";
    }
    connectedCallback() {
        window.addEventListener("popstate", this.handleHistoryChange);
    }
    disconnectedCallback() {
        window.removeEventListener("popstate", this.handleHistoryChange);
    }
    formatParams(searchParams) {
        this.searchParamsPrev = searchParams;
        const baseParams = this.dataset.baseParams || "";
        return `${baseParams}${searchParams}`;
    }
    updateBySearchParams(searchParams) {
        this.updateShopBySearchParams(searchParams);
        this.updateFiltersBySearchParams(searchParams);
    }
    updateShopBySearchParams(searchParams) {
        const url = this.createUrl(searchParams);
        this.cache[url] ? this.updateElements(this.cache[url]) : this.getFromUrl(url).then((html)=>this.updateElements(html));
        this.updateURL(searchParams, url);
    }
    updateFiltersBySearchParams(searchParams) {
        const url = this.createUrl(searchParams);
        const mobileFilter = document.querySelector("#SidebarFiltersMobile");
        const desktopFilter = document.querySelector("#SidebarFiltersDesktop");
        if (mobileFilter && desktopFilter) {
            const filters = [
                mobileFilter,
                desktopFilter
            ];
            filters.forEach((filter)=>{
                filter.loadingOverlay.show();
            });
            const updateFilters = (html)=>{
                filters.forEach((filter)=>{
                    filter.updateHTML(html);
                    filter.loadingOverlay.hide();
                });
            };
            this.cache[url] ? updateFilters(this.cache[url]) : this.getFromUrl(url).then((html)=>updateFilters(html));
        }
    }
    getFromUrl(url) {
        const loadingOverlayElement = this.querySelector("#ShopProductsOverlay");
        const loadingOverlay = loadingOverlayElement ? new (0, $a8fce1fcc675f0a8$export$2e2bcd8739ae039)(loadingOverlayElement) : null;
        if (loadingOverlay) loadingOverlay.show();
        const preparedUrl = `${url}&section_id=${this.dataset.sectionId}`;
        return fetch(preparedUrl).then((response)=>response.text()).then((responseText)=>{
            const html = (0, $aa19cdf2f552e6e0$export$8a49393be2d55148)(responseText);
            this.cache[url] = html;
            if (loadingOverlay) loadingOverlay.hide();
            return html;
        }).catch(()=>{
            if (!(0, $339187790c656b4d$export$e1122b4c4bd5b838).notification) return;
            (0, $339187790c656b4d$export$e1122b4c4bd5b838).notification.show("Error in shop component", "warning");
        });
    }
    updateURL(searchParams, url) {
        history.pushState({
            searchParams: searchParams
        }, "", url);
    }
    createUrl(searchParams) {
        const params = this.formatParams(searchParams) || "";
        const url = `${window.location.pathname}?${params}`;
        return url;
    }
    updateElements(html) {
        const elements = [
            "ShopProducts",
            "ShopProductCount",
            "ShopSortList",
            "ShopActiveFilters"
        ];
        elements.forEach((elementId)=>{
            const element = document.getElementById(elementId);
            const newElement = html.getElementById(elementId);
            if (element && newElement) {
                const clonedNewElement = newElement.cloneNode(true);
                element.replaceChildren(...clonedNewElement.childNodes);
            }
        });
    }
    resetQueries() {
        this.sortQuery = "";
        this.filterQuery = "";
    }
}
var $f86b6c4dd05ec780$export$2e2bcd8739ae039 = $f86b6c4dd05ec780$var$Shop;



class $c96c6a8307311b94$var$ShopActiveFilters extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.optionsSelector = `[data-shop-active-filters-options]`;
        this.removeBtnSelector = `[data-shop-active-filters-remove-btn]`;
    }
    reset() {
        this.replaceChildren();
    }
    setDisable() {
        if (this.options) this.options.setAttribute("disabled", "");
    }
    get options() {
        return this.querySelector(this.optionsSelector);
    }
    get buttons() {
        return [
            ...this.querySelectorAll(this.removeBtnSelector)
        ];
    }
}
var $c96c6a8307311b94$export$2e2bcd8739ae039 = $c96c6a8307311b94$var$ShopActiveFilters;





class $75068168d17c5105$var$SidebarFilters extends (0, $a31366d6d865bd48$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleFormScroll = ()=>{
            if (this.form) {
                const isScrolled = this.form.scrollTop > 0;
                this.toggleAttribute("header-shadow-visible", isScrolled);
            }
        };
        this.handleClick = (event)=>{
            const target = event.target;
            const label = target.closest("[data-filters-checkbox]");
            if (label) label.setAttribute("selected", "");
        };
        this.handleInputChange = (event)=>{
            const target = event.target;
            if (target.tagName === "INPUT") this.change();
        };
        this.form = this.element.querySelector("[data-filters-form]");
    }
    connectedCallback() {
        super.connectedCallback();
        this.form.addEventListener("scroll", this.handleFormScroll);
        this.addEventListener("change", this.handleInputChange);
        this.addEventListener("click", this.handleClick);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.form.removeEventListener("scroll", this.handleFormScroll);
        this.removeEventListener("change", this.handleInputChange);
        this.removeEventListener("click", this.handleClick);
    }
    change() {
    // re-define in children
    }
    createFilterQuery() {
        if (this.form && this.shop) {
            const formData = new FormData(this.form);
            const filterQuery = new URLSearchParams(formData).toString();
            this.shop.filterQuery = filterQuery;
        }
    }
    updateHTML(html) {
        if (this.isOpenOnInit) {
            const filterId = this.getAttribute("id");
            const newFilter = filterId ? html.getElementById(filterId) : null;
            const newElement = newFilter ? newFilter.querySelector("[data-sidebar-body]") : null;
            if (newElement) {
                this.updateFormFromElement(newElement);
                this.updateHeaderFromElement(newElement);
            }
        } else {
            const filterId = this.getAttribute("id");
            const newFilter = filterId ? html.getElementById(filterId) : null;
            const newTemplate = newFilter ? newFilter.querySelector(`[data-sidebar-template="${this.id}"]`) : null;
            if (newTemplate) {
                const newElement = (0, $aa19cdf2f552e6e0$export$8ea4fc17cec6f158)(newTemplate);
                this.updateFormFromElement(newElement);
                this.updateHeaderFromElement(newElement);
            }
        }
    }
    updateHeaderFromElement(newElement) {
        const header = this.element.querySelector("[data-filters-header]");
        const newHeader = newElement.querySelector("[data-filters-header]");
        if (header && newHeader) {
            const clonedNewHeader = newHeader.cloneNode(true);
            header.replaceChildren(...clonedNewHeader.childNodes);
        }
    }
    updateFormFromElement(newElement) {
        const form = this.element.querySelector("[data-filters-form]");
        const newForm = newElement.querySelector("[data-filters-form]");
        if (form && newForm) {
            const clonedNewForm = newForm.cloneNode(true);
            form.replaceChildren(...clonedNewForm.childNodes);
        }
    }
    get shop() {
        return this.element.closest("shop-component");
    }
    get searchParams() {
        if (!this.shop) return "";
        return [
            this.shop.filterQuery,
            this.shop.sortQuery
        ].join("&");
    }
    get loadingOverlay() {
        const preloader = this.element.querySelector("[data-filters-loading-overlay]");
        if (!preloader) return null;
        return new (0, $a8fce1fcc675f0a8$export$2e2bcd8739ae039)(preloader);
    }
}
var $75068168d17c5105$export$2e2bcd8739ae039 = $75068168d17c5105$var$SidebarFilters;


class $3bd3d3cd1c8b6535$var$SidebarFiltersDesktop extends (0, $75068168d17c5105$export$2e2bcd8739ae039) {
    change() {
        if (this.shop) {
            this.createFilterQuery();
            this.shop.updateBySearchParams(this.searchParams);
        }
    }
    constructor(...args){
        super(...args);
        this.handleSectionLoad = ()=>{};
    }
}
var $3bd3d3cd1c8b6535$export$2e2bcd8739ae039 = $3bd3d3cd1c8b6535$var$SidebarFiltersDesktop;




class $d0dbb720f185ae36$var$SidebarFiltersMobile extends (0, $75068168d17c5105$export$2e2bcd8739ae039) {
    change() {
        if (this.shop) {
            this.createFilterQuery();
            this.shop.updateFiltersBySearchParams(this.searchParams);
            this.setButtonForReset();
        }
    }
    setButtonForReset() {
        const button = this.element.querySelector("filter-remove-btn");
        if (button) {
            const isHidden = button.classList.contains("hidden");
            if (isHidden) (0, $aa19cdf2f552e6e0$export$998191bfdf710c72)(button);
        }
    }
}
var $d0dbb720f185ae36$export$2e2bcd8739ae039 = $d0dbb720f185ae36$var$SidebarFiltersMobile;




class $f111209aa1d37420$var$FilterRemoveBtn extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    connectedCallback() {
        this.addEventListener("keydown", this.handleKeyDown);
        this.addEventListener("click", this.handleButtonClick);
    }
    disconnectedCallback() {
        this.removeEventListener("keydown", this.handleKeyDown);
        this.removeEventListener("click", this.handleButtonClick);
    }
    update() {
        const shopActiveFilters = this.closest("shop-active-filters");
        const shop = this.closest("shop-component");
        const url = this.dataset.url;
        if (shopActiveFilters) {
            const isRemoveButton = this.hasAttribute("data-shop-active-filters-remove-btn");
            const isResetButton = this.hasAttribute("data-shop-active-filters-reset");
            if (isResetButton) shopActiveFilters.reset();
            if (isRemoveButton) {
                const withSingleActiveFilter = shopActiveFilters.buttons.length === 1;
                if (withSingleActiveFilter) shopActiveFilters.reset();
                else {
                    shopActiveFilters.setDisable();
                    this.remove();
                }
            }
        }
        if (url && shop) {
            const searchParams = url.indexOf("?") === -1 ? "" : url.slice(url.indexOf("?") + 1);
            shop.resetQueries();
            shop.updateBySearchParams(searchParams);
        }
    }
    constructor(...args){
        super(...args);
        this.handleButtonClick = ()=>{
            this.update();
        };
        this.handleKeyDown = (event)=>{
            const isEnterKey = (0, $6de5ff37caa957d8$export$793b145c7f680179)(event.key || event.keyCode);
            if (isEnterKey) {
                event.preventDefault();
                this.update();
            }
        };
    }
}
var $f111209aa1d37420$export$2e2bcd8739ae039 = $f111209aa1d37420$var$FilterRemoveBtn;





class $f09e1e1cab3acf53$var$SortList extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleFormInput = (0, $adb0a393977b573d$exports.debounce)((event)=>{
            event.preventDefault();
            const shop = this.closest("shop-component");
            const sidebarParent = this.closest("sidebar-component");
            const input = event.target;
            if (sidebarParent) sidebarParent.hide();
            if (shop && input) {
                const sortQuery = this.getSortQuery(input);
                const searchParams = [
                    shop.filterQuery,
                    sortQuery
                ].join("&");
                shop.sortQuery = sortQuery;
                shop.updateBySearchParams(searchParams);
            }
        }, 250);
        this.handleLabelKeyDown = (event)=>{
            const isEnterKey = (0, $6de5ff37caa957d8$export$793b145c7f680179)(event.key || event.keyCode);
            if (isEnterKey) {
                event.preventDefault();
                const target = event.target;
                const input = target.querySelector(`input`);
                if (input) {
                    const inputEvent = new MouseEvent("click", {
                        button: 0,
                        which: 1
                    });
                    input.dispatchEvent(inputEvent);
                }
            }
        };
        this.labels = [
            ...this.querySelectorAll("[data-sort-list-label]")
        ];
    }
    connectedCallback() {
        this.labels.forEach((label)=>{
            label.addEventListener("keydown", this.handleLabelKeyDown);
        });
        this.addEventListener("input", this.handleFormInput);
    }
    disconnectedCallback() {
        this.labels.forEach((label)=>{
            label.removeEventListener("keydown", this.handleLabelKeyDown);
        });
        this.removeEventListener("input", this.handleFormInput);
    }
    getSortQuery(input) {
        const form = input.closest("form");
        let sortQuery = "";
        if (form) {
            const formData = new FormData(form);
            sortQuery = new URLSearchParams(formData).toString();
        }
        return sortQuery;
    }
}
var $f09e1e1cab3acf53$export$2e2bcd8739ae039 = $f09e1e1cab3acf53$var$SortList;



class $085c732c29c95db8$var$PriceRange extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleRangeInput = (event)=>{
            const maxInput = this.querySelector(`[data-price-range-max-input]`);
            const minInput = this.querySelector(`[data-price-range-min-input]`);
            if (this.progress && minInput && maxInput) {
                const middleOfProgress = this.progress.offsetLeft + this.progress.offsetWidth / 2;
                const isMinInputClosest = event.offsetX < middleOfProgress;
                minInput.toggleAttribute("targeted", isMinInputClosest);
                maxInput.toggleAttribute("targeted", !isMinInputClosest);
            }
        };
        this.handleNumberChange = ()=>{
            if (this.minNumberInput && this.maxNumberInput) {
                const minPrice = parseFloat(this.minNumberInput.value);
                const maxPrice = parseFloat(this.maxNumberInput.value);
                this.updateMinRangeInput(minPrice);
                this.updateMaxRangeInput(maxPrice);
            }
        };
        this.handleRangeChange = ()=>{
            if (this.minRangeInput && this.maxRangeInput) {
                const minVal = parseFloat(this.minRangeInput.value);
                const maxVal = parseFloat(this.maxRangeInput.value);
                this.updateMaxPriceInput(maxVal);
                this.updateMaxRangeInput(maxVal);
                this.updateMinPriceInput(minVal);
                this.updateMinRangeInput(minVal);
            }
        };
        this.minNumberInput = this.querySelector(`[data-price-min-range-number]`);
        this.maxNumberInput = this.querySelector(`[data-price-max-range-number]`);
        this.rangeWrapper = this.querySelector(`[data-price-range-inputs-wrapper]`);
        this.minRangeInput = this.querySelector(`[data-price-min-range-input]`);
        this.maxRangeInput = this.querySelector(`[data-price-max-range-input]`);
        this.progress = this.querySelector(`[data-price-range-progress]`);
    }
    connectedCallback() {
        if (this.minRangeInput) this.updateMinRangeInput(+this.minRangeInput.value);
        if (this.maxRangeInput) this.updateMaxRangeInput(+this.maxRangeInput.value);
        this.minNumberInput.addEventListener("input", this.handleNumberChange);
        this.maxNumberInput.addEventListener("input", this.handleNumberChange);
        this.minRangeInput.addEventListener("input", this.handleRangeChange);
        this.maxRangeInput.addEventListener("input", this.handleRangeChange);
        this.rangeWrapper.addEventListener("mouseenter", this.handleRangeInput);
        this.rangeWrapper.addEventListener("mousemove", this.handleRangeInput);
    }
    disconnectedCallback() {
        this.minNumberInput.removeEventListener("input", this.handleNumberChange);
        this.maxNumberInput.removeEventListener("input", this.handleNumberChange);
        this.minRangeInput.removeEventListener("input", this.handleRangeChange);
        this.maxRangeInput.removeEventListener("input", this.handleRangeChange);
        this.rangeWrapper.removeEventListener("mouseenter", this.handleRangeInput);
        this.rangeWrapper.removeEventListener("mousemove", this.handleRangeInput);
    }
    updateMaxRangeInput(value) {
        if (this.maxRangeInput && this.progress) {
            const rightPosition = 100 - value / +this.maxRangeInput.max * 100;
            this.maxRangeInput.value = `${value}`;
            this.progress.style.right = `${rightPosition}%`;
        }
    }
    updateMinRangeInput(value) {
        if (this.minRangeInput && this.progress) {
            const leftPosition = value / +this.minRangeInput.max * 100;
            this.minRangeInput.value = `${value}`;
            this.progress.style.left = `${leftPosition}%`;
        }
    }
    updateMaxPriceInput(value) {
        if (this.maxNumberInput) this.maxNumberInput.value = value.toFixed(2);
    }
    updateMinPriceInput(value) {
        if (this.minNumberInput) this.minNumberInput.value = value.toFixed(2);
    }
}
var $085c732c29c95db8$export$2e2bcd8739ae039 = $085c732c29c95db8$var$PriceRange;




class $c7792eb8ec3a4fe1$var$ColumnSwitcher extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleWindowLoad = ()=>{
            if (!this.isEditorMode) this.init();
        };
        this.handleSectionLoad = (event)=>{
            if (this.dataset.sectionId === event.detail.sectionId) this.reset();
        };
        this.handleItemClick = (event)=>{
            const eventTarget = event.target;
            const target = eventTarget.closest(this.itemSelector);
            if (target) {
                const columnCount = +(target.dataset.value || 1);
                this.switch(columnCount);
            }
        };
        this.handleKeyDown = (event)=>{
            const isEnterKey = (0, $6de5ff37caa957d8$export$793b145c7f680179)(event.key || event.keyCode);
            if (isEnterKey) {
                event.preventDefault();
                const eventTarget = event.target;
                const target = eventTarget.closest(this.itemSelector);
                if (target) {
                    const columnCount = +(target.dataset.value || 1);
                    this.switch(columnCount);
                }
            }
        };
        this.itemSelector = `[data-column-switcher-item]`;
        this.targetSelector = `[data-column-switcher-target]`;
        this.items = [
            ...this.querySelectorAll(this.itemSelector)
        ];
        this.cssVariable = this.dataset.columnSwitcherCssVariable || "";
    }
    connectedCallback() {
        window.addEventListener("load", this.handleWindowLoad);
        this.items.forEach((item)=>{
            item.addEventListener("keydown", this.handleKeyDown);
            item.addEventListener("click", this.handleItemClick);
        });
        if (this.isEditorMode) this.editor.subscribe("SECTION_LOAD", this.handleSectionLoad);
    }
    disconnectedCallback() {
        window.removeEventListener("load", this.handleWindowLoad);
        this.items.forEach((item)=>{
            item.removeEventListener("keydown", this.handleKeyDown);
            item.removeEventListener("click", this.handleItemClick);
        });
        if (this.isEditorMode) this.editor.destroy();
    }
    updateByColumnCount(columnCount) {
        this.selectSwitch(columnCount);
        this.updateColumnCount(columnCount);
    }
    selectSwitch(columnCount) {
        this.items.forEach((item)=>{
            const value = +(item.getAttribute("data-value") || 1);
            item.classList.toggle("selected", value === columnCount);
        });
    }
    updateColumnCount(value) {
        const target = this.closest(this.targetSelector);
        if (target) {
            target.style.setProperty(`--gsc-${this.cssVariable}`, value.toString());
            localStorage.setItem(`products-${this.cssVariable}`, value.toString());
        }
    }
    init() {
        const value = localStorage.getItem(`products-${this.cssVariable}`);
        if (!value || value === "null") return;
        const preparedValue = Number(value);
        if (preparedValue > 0) this.updateByColumnCount(preparedValue);
    }
    switch(columnCount) {
        this.updateByColumnCount(columnCount);
    }
    reset() {
        if (!this.dataset.default) return;
        this.switch(Number(this.dataset.default));
    }
}
var $c7792eb8ec3a4fe1$export$2e2bcd8739ae039 = $c7792eb8ec3a4fe1$var$ColumnSwitcher;



class $1c203727e41c1ba2$var$FiltersSubmitBtn extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    connectedCallback() {
        this.addEventListener("click", this.handleButtonClick);
    }
    disconnectedCallback() {
        this.removeEventListener("click", this.handleButtonClick);
    }
    constructor(...args){
        super(...args);
        this.handleButtonClick = ()=>{
            const shop = this.closest("shop-component");
            const sidebar = this.closest("#SidebarFiltersMobile");
            if (shop) {
                const searchParams = [
                    shop.filterQuery,
                    shop.sortQuery
                ].join("&");
                shop.updateShopBySearchParams(searchParams);
            }
            if (sidebar) sidebar.hide();
        };
    }
}
var $1c203727e41c1ba2$export$2e2bcd8739ae039 = $1c203727e41c1ba2$var$FiltersSubmitBtn;




class $fd0203a38c9fb9e2$var$BeforeAfterImages extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleButtonMouseDown = (event)=>{
            event.preventDefault();
            this.startMove();
        };
        this.handleButtonMouseUp = ()=>{
            this.endMove();
        };
        this.handleMouseMove = (event)=>{
            if (!this.isMoving) return;
            this.moveSeparator(event.pageX);
        };
        this.handleButtonKeyUp = (event)=>{
            if (!this.button) return;
            const currentKey = event.key || event.keyCode;
            const isLeftKey = (0, $6de5ff37caa957d8$export$703c582f38858004)(currentKey);
            const isRightKey = (0, $6de5ff37caa957d8$export$e2fe3643cb517b19)(currentKey);
            if (!isLeftKey && !isRightKey) return;
            const btnRect = this.button.getBoundingClientRect();
            const btnCenterPoint = btnRect.right - btnRect.width / 2;
            const newPosition = isLeftKey ? btnCenterPoint - this.step : btnCenterPoint + this.step;
            this.moveSeparator(newPosition);
        };
        this.handleTouchStart = ()=>{
            this.startMove();
        };
        this.handleTouchEnd = ()=>{
            this.endMove();
        };
        this.handleTouchMove = (event)=>{
            if (!this.isMoving) return;
            event.preventDefault();
            this.moveSeparator(event.targetTouches[0].clientX);
        };
        this.button = this.querySelector("[data-before-after-images-button]");
        this.isMoving = false;
        this.step = 20;
    }
    connectedCallback() {
        this.setSeparatorPosition(Number(this.dataset.initialDragPosition));
        this.button.addEventListener("keyup", this.handleButtonKeyUp);
        this.button.addEventListener("mousedown", this.handleButtonMouseDown);
        document.addEventListener("mouseup", this.handleButtonMouseUp);
        document.addEventListener("mousemove", this.handleMouseMove);
        this.button.addEventListener("touchstart", this.handleTouchStart);
        this.addEventListener("touchmove", this.handleTouchMove);
        document.addEventListener("touchend", this.handleTouchEnd);
    }
    disconnectedCallback() {
        this.button.removeEventListener("keyup", this.handleButtonKeyUp);
        this.button.removeEventListener("mousedown", this.handleButtonMouseDown);
        document.removeEventListener("mouseup", this.handleButtonMouseUp);
        document.removeEventListener("mousemove", this.handleMouseMove);
        this.button.removeEventListener("touchstart", this.handleTouchStart);
        this.removeEventListener("touchmove", this.handleTouchMove);
        document.removeEventListener("touchend", this.handleTouchEnd);
    }
    startMove() {
        this.isMoving = true;
    }
    endMove() {
        this.isMoving = false;
    }
    setSeparatorPosition(position) {
        this.style.setProperty("--gsc-drag-position", `${position}%`);
    }
    moveSeparator(newPosition) {
        const rect = this.getBoundingClientRect();
        if (newPosition <= rect.left) this.setSeparatorPosition(0);
        else if (newPosition >= rect.right) this.setSeparatorPosition(100);
        else {
            const positionPercent = Math.floor((newPosition - rect.left) / this.offsetWidth * 1000) / 10;
            this.setSeparatorPosition(positionPercent);
        }
    }
}
var $fd0203a38c9fb9e2$export$2e2bcd8739ae039 = $fd0203a38c9fb9e2$var$BeforeAfterImages;



class $94131d7037328e3c$var$Hotspots extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handlePinBtnClick = (event)=>{
            this.setAttribute("animation-state", "pause");
        };
        this.handlePinBtnEnter = (event)=>{
            this.setAttribute("animation-state", "pause");
        };
        this.handlePinBtnLeave = (event)=>{
            if (this.hasOpenFloatElement) return;
            this.removeAttribute("animation-state");
        };
        this.handleFloatElementShow = ()=>{
            this.hasOpenFloatElement = true;
        };
        this.handleFloatElementHide = ()=>{
            this.hasOpenFloatElement = false;
            this.removeAttribute("animation-state");
        };
        this.handleModalOpen = ()=>{
            this.setAttribute("animation-state", "pause");
            if (this.header) this.header.setHidden(true);
        };
        this.handleModalHide = ()=>{
            this.removeAttribute("animation-state");
            if (this.header) this.header.setHidden(false);
        };
        this.handleEditorClick = (event)=>{
            const isTriggerBtn = event.target?.closest("float-element-btn");
            const isFloatElement = event.target?.closest("hotspots-float-element");
            if (isTriggerBtn || isFloatElement) return;
            this.floatElements.forEach((floatElement)=>{
                floatElement.hide();
            });
        };
        this.modals = [
            ...this.querySelectorAll("modal-component")
        ];
        this.floatElements = [
            ...this.querySelectorAll("hotspots-float-element")
        ];
        this.floatElementsBtns = [
            ...this.querySelectorAll("float-element-btn")
        ];
        this.header = document.querySelector("header-component");
    }
    connectedCallback() {
        this.modals.forEach((modal)=>{
            customElements.whenDefined("modal-component").then(()=>{
                modal.subscribe("show", this.handleModalOpen);
                modal.subscribe("hide", this.handleModalHide);
            });
        });
        this.floatElements.forEach((floatElement)=>{
            customElements.whenDefined("hotspots-float-element").then(()=>{
                floatElement.subscribe("hide", this.handleFloatElementHide);
                floatElement.subscribe("show", this.handleFloatElementShow);
            });
        });
        this.floatElementsBtns.forEach((btn)=>{
            btn?.addEventListener("mouseenter", this.handlePinBtnEnter);
            btn?.addEventListener("mouseleave", this.handlePinBtnLeave);
            btn?.addEventListener("click", this.handlePinBtnClick);
        });
        if (this.isEditorMode) window.addEventListener("click", this.handleEditorClick);
    }
    disconnectedCallback() {
        this.modals.forEach((modal)=>{
            customElements.whenDefined("modal-component").then(()=>{
                modal.unsubscribe("show", this.handleModalOpen);
                modal.unsubscribe("hide", this.handleModalHide);
            });
        });
        this.floatElements.forEach((floatElement)=>{
            customElements.whenDefined("hotspots-float-element").then(()=>{
                floatElement.unsubscribe("hide", this.handleFloatElementHide);
                floatElement.unsubscribe("show", this.handleFloatElementShow);
            });
        });
        this.floatElementsBtns.forEach((btn)=>{
            btn?.removeEventListener("mouseenter", this.handlePinBtnEnter);
            btn?.removeEventListener("mouseleave", this.handlePinBtnLeave);
            btn?.removeEventListener("click", this.handlePinBtnClick);
        });
        if (this.isEditorMode) window.removeEventListener("click", this.handleEditorClick);
    }
}
var $94131d7037328e3c$export$2e2bcd8739ae039 = $94131d7037328e3c$var$Hotspots;




const $9c9a0c1dc0918389$var$STORAGE_KEY = "AuroraTheme-Timer";
class $9c9a0c1dc0918389$export$2abf39e5d318a92d {
    constructor(blockId){
        this._blockId = blockId;
    }
    parseData(data) {
        try {
            const obj = JSON.parse(data ?? "{}");
            if ("endDate" in obj && "hash" in obj) return {
                endDate: new Date(+obj.endDate),
                hash: obj.hash
            };
            return null;
        } catch (error) {
            return null;
        }
    }
    saveData(data) {
        try {
            localStorage.setItem(`${$9c9a0c1dc0918389$var$STORAGE_KEY}-${this._blockId}`, JSON.stringify({
                endDate: data.endDate.getTime(),
                hash: data.hash
            }));
        } catch (e) {}
    }
    loadData() {
        try {
            return this.parseData(localStorage.getItem(`${$9c9a0c1dc0918389$var$STORAGE_KEY}-${this._blockId}`));
        } catch (e) {
            return null;
        }
    }
}


var $2e85bca88b136791$export$68ce355ceaf0e5a8;
(function(TimerMode) {
    TimerMode["Fixed"] = "fixed";
    TimerMode["Evergreen"] = "evergreen";
})($2e85bca88b136791$export$68ce355ceaf0e5a8 || ($2e85bca88b136791$export$68ce355ceaf0e5a8 = {}));
var $2e85bca88b136791$export$e4942a299e715e9a;
(function(TimerFinishStrategy) {
    TimerFinishStrategy["None"] = "none";
    TimerFinishStrategy["Hide"] = "hide";
    TimerFinishStrategy["Restart"] = "restart";
    TimerFinishStrategy["WaitOneDay"] = "wait_one_day";
})($2e85bca88b136791$export$e4942a299e715e9a || ($2e85bca88b136791$export$e4942a299e715e9a = {}));


const $2e33d2093da83dd1$var$ONE_DAY_MS = 86400000;
const $2e33d2093da83dd1$var$MONTHS = {
    january: 0,
    february: 1,
    march: 2,
    april: 3,
    may: 4,
    june: 5,
    july: 6,
    august: 7,
    september: 8,
    october: 9,
    november: 10,
    december: 11
};
const $2e33d2093da83dd1$var$getEvergreenEndDate = (unit, value)=>{
    const date = new Date();
    switch(unit){
        case "day":
            date.setDate(date.getDate() + value);
            break;
        case "hour":
            date.setHours(date.getHours() + value);
            break;
        case "minute":
            date.setMinutes(date.getMinutes() + value);
            break;
        case "second":
            date.setSeconds(date.getSeconds() + value);
            break;
    }
    return date;
};
class $2e33d2093da83dd1$var$CountdownTimer extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.mode = (0, $2e85bca88b136791$export$68ce355ceaf0e5a8).Fixed;
        this.endDate = new Date();
        this.finishStrategy = (0, $2e85bca88b136791$export$e4942a299e715e9a).None;
        this.daysUnit = this.querySelector("[data-timer-days]");
        this.hoursUnit = this.querySelector("[data-timer-hours]");
        this.minutesUnit = this.querySelector("[data-timer-minutes]");
        this.secondsUnit = this.querySelector("[data-timer-seconds]");
        this.daysUnitLabel = this.querySelector("[data-timer-days-label]");
        this.hoursUnitLabel = this.querySelector("[data-timer-hours-label]");
        this.minutesUnitLabel = this.querySelector("[data-timer-minutes-label]");
        this.secondsUnitLabel = this.querySelector("[data-timer-seconds-label]");
        this.evergreenUnit = this.dataset.evergreenUnit || "minute";
        this.evergreenValue = parseInt(this.dataset.evergreenValue || "0");
        this.mode = this.dataset.mode;
        if (this.mode === (0, $2e85bca88b136791$export$68ce355ceaf0e5a8).Fixed) this.finishStrategy = this.dataset.hideOnComplete === "true" ? (0, $2e85bca88b136791$export$e4942a299e715e9a).Hide : (0, $2e85bca88b136791$export$e4942a299e715e9a).None;
        if (this.mode === (0, $2e85bca88b136791$export$68ce355ceaf0e5a8).Evergreen) {
            this.finishStrategy = this.dataset.evergreenOnComplete || (0, $2e85bca88b136791$export$e4942a299e715e9a).Restart;
            this.timerStorage = new (0, $9c9a0c1dc0918389$export$2abf39e5d318a92d)(this.dataset.blockId || this.id);
        }
    }
    connectedCallback() {
        this.start();
    }
    disconnectedCallback() {
        clearInterval(this.timerRef);
    }
    getHash() {
        return `${this.finishStrategy}-${this.evergreenUnit}-${this.evergreenValue}`;
    }
    start() {
        if (this.mode === (0, $2e85bca88b136791$export$68ce355ceaf0e5a8).Fixed) {
            const year = Number(this.dataset.year);
            const month = $2e33d2093da83dd1$var$MONTHS[this.dataset.month ?? "january"];
            const day = Number(this.dataset.day);
            const hour = Number(this.dataset.hour);
            const minute = Number(this.dataset.minute);
            this.endDate = new Date(year, month, day, hour, minute);
        }
        if (this.mode === (0, $2e85bca88b136791$export$68ce355ceaf0e5a8).Evergreen) {
            const timerData = this.timerStorage.loadData();
            if (!timerData || timerData.hash !== this.getHash()) this.updateEvergreenData();
            else this.endDate = timerData.endDate;
        }
        this.timerRef = window.setInterval(this.tick.bind(this), 1000);
        this.tick();
    }
    updateEvergreenData() {
        const endDate = $2e33d2093da83dd1$var$getEvergreenEndDate(this.evergreenUnit, this.evergreenValue);
        this.timerStorage.saveData({
            endDate: endDate,
            hash: this.getHash()
        });
        this.endDate = endDate;
    }
    finish() {
        clearInterval(this.timerRef);
        switch(this.finishStrategy){
            case (0, $2e85bca88b136791$export$e4942a299e715e9a).Restart:
                this.timerStorage.saveData({
                    endDate: $2e33d2093da83dd1$var$getEvergreenEndDate(this.evergreenUnit, this.evergreenValue),
                    hash: this.getHash()
                });
                this.start();
                break;
            case (0, $2e85bca88b136791$export$e4942a299e715e9a).WaitOneDay:
                if (new Date().getTime() - this.endDate.getTime() > $2e33d2093da83dd1$var$ONE_DAY_MS) {
                    const endDate = $2e33d2093da83dd1$var$getEvergreenEndDate(this.evergreenUnit, this.evergreenValue);
                    this.timerStorage.saveData({
                        endDate: endDate,
                        hash: this.getHash()
                    });
                    this.start();
                } else this.hide();
                break;
            case (0, $2e85bca88b136791$export$e4942a299e715e9a).None:
                this.show() // show zero-values if time is over
                ;
                break;
            default:
                this.hide();
        }
    }
    renderTime(days, hours, minutes, seconds) {
        if (!this.daysUnit || !this.hoursUnit || !this.minutesUnit || !this.secondsUnit) return;
        this.daysUnit.innerText = days.toString();
        this.hoursUnit.innerText = hours.toString();
        this.minutesUnit.innerText = minutes.toString();
        this.secondsUnit.innerText = seconds.toString();
        this.renderLabels(days, hours, minutes, seconds);
    }
    renderLabels(days, hours, minutes, seconds) {
        if (!this.daysUnitLabel || !this.hoursUnitLabel || !this.minutesUnitLabel || !this.secondsUnitLabel) return;
        this.daysUnitLabel.innerText = days === 1 ? window.auroraThemeLocales.countdownTimerString.day : window.auroraThemeLocales.countdownTimerString.days;
        this.hoursUnitLabel.innerText = hours === 1 ? window.auroraThemeLocales.countdownTimerString.hour : window.auroraThemeLocales.countdownTimerString.hours;
        this.minutesUnitLabel.innerText = minutes === 1 ? window.auroraThemeLocales.countdownTimerString.minute : window.auroraThemeLocales.countdownTimerString.minutes;
        this.secondsUnitLabel.innerText = seconds === 1 ? window.auroraThemeLocales.countdownTimerString.second : window.auroraThemeLocales.countdownTimerString.seconds;
    }
    tick() {
        const diff = this.endDate.getTime() - new Date().getTime();
        if (diff > 0) {
            this.show();
            this.renderTime(Math.floor(diff / 86400000), Math.floor(diff % 86400000 / 3600000), Math.floor(diff % 3600000 / 60000), Math.floor(diff % 60000 / 1000));
            return;
        }
        this.renderTime(0, 0, 0, 0);
        this.finish();
        if (window.Shopify.designMode) this.show();
    }
    show() {
        (0, $aa19cdf2f552e6e0$export$998191bfdf710c72)(this);
        if (this.dataset.blockId) (0, $aa19cdf2f552e6e0$export$998191bfdf710c72)(document.querySelector(`.block-${this.dataset.blockId}`));
    }
    hide() {
        if (window.Shopify.designMode) return;
        if (this.dataset.sectionId) (0, $aa19cdf2f552e6e0$export$7669482c90f5c50f)(document.querySelector(`.section-${this.dataset.sectionId}`));
        if (this.dataset.blockId) (0, $aa19cdf2f552e6e0$export$7669482c90f5c50f)(document.querySelector(`.block-${this.dataset.blockId}`));
        (0, $aa19cdf2f552e6e0$export$7669482c90f5c50f)(this);
    }
}
var $2e33d2093da83dd1$export$2e2bcd8739ae039 = $2e33d2093da83dd1$var$CountdownTimer;



class $377bad8f45fc260d$var$ProductInformationDrawer extends (0, $a31366d6d865bd48$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleFormScroll = ()=>{
            if (!this.viewport) return;
            const isScrolled = this.viewport.scrollTop > 0;
            this.toggleAttribute("header-shadow-visible", isScrolled);
        };
        this.viewport = this.element.querySelector("[data-product-information-drawer-viewport]");
    }
    connectedCallback() {
        super.connectedCallback();
        this.viewport.addEventListener("scroll", this.handleFormScroll);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.viewport.removeEventListener("scroll", this.handleFormScroll);
    }
}
var $377bad8f45fc260d$export$2e2bcd8739ae039 = $377bad8f45fc260d$var$ProductInformationDrawer;




class $1f039782252bfa34$var$Tab extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.styles = getComputedStyle(this);
    }
    show() {
        this.setVisible(true);
        return (0, $6de5ff37caa957d8$export$1391212d75b2ee65)((0, $6de5ff37caa957d8$export$5faba83c1624a4ba)(this.styles));
    }
    hide() {
        this.setVisible(false);
        return (0, $6de5ff37caa957d8$export$1391212d75b2ee65)((0, $6de5ff37caa957d8$export$5faba83c1624a4ba)(this.styles));
    }
    setVisible(isVisible) {
        this.setAttribute("aria-hidden", isVisible ? "false" : "true");
    }
    get isVisible() {
        return this.getAttribute("aria-hidden") === "false";
    }
}
var $1f039782252bfa34$export$2e2bcd8739ae039 = $1f039782252bfa34$var$Tab;




class $e26046236c7b85ae$var$MobileFiltersStickyButton extends (0, $acdb0ba51c71b753$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleWindowScroll = ()=>{
            if (!this.lastScrollPosition) this.lastScrollPosition = window.scrollY;
            this.updateVisibleStatus();
            this.updateExtendStatus();
        };
        this.updateExtendStatus = (0, $adb0a393977b573d$exports.debounce)(()=>{
            const threshold = 24;
            const distance = Math.abs(window.scrollY - this.lastScrollPosition);
            if (distance > threshold) {
                const isExtended = this.lastScrollPosition > window.scrollY;
                this.toggleAttribute("is-extended", isExtended);
            }
            this.lastScrollPosition = 0;
        }, 50);
        this.products = document.getElementById("ShopProducts");
        this.footer = document.querySelector(".shopify-section-footer");
    }
    connectedCallback() {
        super.connectedCallback();
        window.addEventListener("scroll", this.handleWindowScroll);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        window.removeEventListener("scroll", this.handleWindowScroll);
    }
    updateVisibleStatus() {
        const footerOffsetTop = this.footer ? this.footer.offsetTop : 0;
        const productsRect = this.products.getBoundingClientRect();
        const isUnderFooter = window.innerHeight + window.scrollY < footerOffsetTop;
        const isUnderProductTopSide = productsRect.top < 0;
        const isVisible = isUnderFooter && isUnderProductTopSide;
        this.toggleAttribute("is-visible", isVisible);
        document.body.toggleAttribute("is-filters-button-fixed", isVisible);
    }
}
var $e26046236c7b85ae$export$2e2bcd8739ae039 = $e26046236c7b85ae$var$MobileFiltersStickyButton;




class $9f019d2059cd198c$var$RecipientForm extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.checkbox = this.querySelector(`[data-recipient-form-checkbox]`);
        this.timezoneInput = this.querySelector(`[data-recipient-form-timezone-input]`);
        this.inputs = this.querySelectorAll("[data-recipient-form-input], [data-recipient-form-timezone-input]");
        this.fields = this.querySelector("[data-recipient-form-fields]");
        this.timezoneInput.value = new Date().getTimezoneOffset();
    }
    connectedCallback() {
        this.addEventListener("change", this.handleChange);
    }
    disconnectedCallback() {
        this.removeEventListener("change", this.handleChange);
    }
    handleChange() {
        const isChecked = this.checkbox.checked;
        this.updateMaxHeight(isChecked);
        this.updateInputDisable(!isChecked);
        if (!isChecked) this.clearInputs();
    }
    clearInputs() {
        this.inputs.forEach((input)=>{
            input.value = "";
        });
    }
    updateInputDisable(isDisabled) {
        this.inputs.forEach((field)=>{
            field.disabled = isDisabled;
        });
    }
    reset() {
        this.checkbox.checked = false;
        this.clearInputs();
    }
    updateMaxHeight(isChecked) {
        if (!this.fields) return;
        const height = isChecked ? this.fields.scrollHeight : 0;
        this.fields.style.maxHeight = `${height}px`;
    }
}
var $9f019d2059cd198c$export$2e2bcd8739ae039 = $9f019d2059cd198c$var$RecipientForm;



class $9bfba46bfd4ec803$var$CollectionCard extends (0, $40c8fbe341f607ee$export$2e2bcd8739ae039) {
    connectedCallback() {}
}
var $9bfba46bfd4ec803$export$2e2bcd8739ae039 = $9bfba46bfd4ec803$var$CollectionCard;



class $f0997b6c3261fdfe$var$ArticleCard extends (0, $40c8fbe341f607ee$export$2e2bcd8739ae039) {
}
var $f0997b6c3261fdfe$export$2e2bcd8739ae039 = $f0997b6c3261fdfe$var$ArticleCard;


const $dad80f0e437da50c$var$colorNames = {
    aliceblue: "#f0f8ff",
    antiquewhite: "#faebd7",
    aqua: "#00ffff",
    aquamarine: "#7fffd4",
    azure: "#f0ffff",
    beige: "#f5f5dc",
    bisque: "#ffe4c4",
    black: "#000000",
    blanchedalmond: "#ffebcd",
    blue: "#0000ff",
    blueviolet: "#8a2be2",
    brown: "#a52a2a",
    burlywood: "#deb887",
    cadetblue: "#5f9ea0",
    chartreuse: "#7fff00",
    chocolate: "#d2691e",
    coral: "#ff7f50",
    cornflowerblue: "#6495ed",
    cornsilk: "#fff8dc",
    crimson: "#dc143c",
    cyan: "#00ffff",
    darkblue: "#00008b",
    darkcyan: "#008b8b",
    darkgoldenrod: "#b8860b",
    darkgray: "#a9a9a9",
    darkgreen: "#006400",
    darkkhaki: "#bdb76b",
    darkmagenta: "#8b008b",
    darkolivegreen: "#556b2f",
    darkorange: "#ff8c00",
    darkorchid: "#9932cc",
    darkred: "#8b0000",
    darksalmon: "#e9967a",
    darkseagreen: "#8fbc8f",
    darkslateblue: "#483d8b",
    darkslategray: "#2f4f4f",
    darkturquoise: "#00ced1",
    darkviolet: "#9400d3",
    deeppink: "#ff1493",
    deepskyblue: "#00bfff",
    dimgray: "#696969",
    dodgerblue: "#1e90ff",
    firebrick: "#b22222",
    floralwhite: "#fffaf0",
    forestgreen: "#228b22",
    fuchsia: "#ff00ff",
    gainsboro: "#dcdcdc",
    ghostwhite: "#f8f8ff",
    gold: "#ffd700",
    goldenrod: "#daa520",
    gray: "#808080",
    green: "#008000",
    greenyellow: "#adff2f",
    honeydew: "#f0fff0",
    hotpink: "#ff69b4",
    indianred: "#cd5c5c",
    indigo: "#4b0082",
    ivory: "#fffff0",
    khaki: "#f0e68c",
    lavender: "#e6e6fa",
    lavenderblush: "#fff0f5",
    lawngreen: "#7cfc00",
    lemonchiffon: "#fffacd",
    lightblue: "#add8e6",
    lightcoral: "#f08080",
    lightcyan: "#e0ffff",
    lightgoldenrodyellow: "#fafad2",
    lightgrey: "#d3d3d3",
    lightgreen: "#90ee90",
    lightpink: "#ffb6c1",
    lightsalmon: "#ffa07a",
    lightseagreen: "#20b2aa",
    lightskyblue: "#87cefa",
    lightslategray: "#778899",
    lightsteelblue: "#b0c4de",
    lightyellow: "#ffffe0",
    lime: "#00ff00",
    limegreen: "#32cd32",
    linen: "#faf0e6",
    magenta: "#ff00ff",
    maroon: "#800000",
    mediumaquamarine: "#66cdaa",
    mediumblue: "#0000cd",
    mediumorchid: "#ba55d3",
    mediumpurple: "#9370d8",
    mediumseagreen: "#3cb371",
    mediumslateblue: "#7b68ee",
    mediumspringgreen: "#00fa9a",
    mediumturquoise: "#48d1cc",
    mediumvioletred: "#c71585",
    midnightblue: "#191970",
    mintcream: "#f5fffa",
    mistyrose: "#ffe4e1",
    moccasin: "#ffe4b5",
    navajowhite: "#ffdead",
    navy: "#000080",
    oldlace: "#fdf5e6",
    olive: "#808000",
    olivedrab: "#6b8e23",
    orange: "#ffa500",
    orangered: "#ff4500",
    orchid: "#da70d6",
    palegoldenrod: "#eee8aa",
    palegreen: "#98fb98",
    paleturquoise: "#afeeee",
    palevioletred: "#d87093",
    papayawhip: "#ffefd5",
    peachpuff: "#ffdab9",
    peru: "#cd853f",
    pink: "#ffc0cb",
    plum: "#dda0dd",
    powderblue: "#b0e0e6",
    purple: "#800080",
    rebeccapurple: "#663399",
    red: "#ff0000",
    rosybrown: "#bc8f8f",
    royalblue: "#4169e1",
    saddlebrown: "#8b4513",
    salmon: "#fa8072",
    sandybrown: "#f4a460",
    seagreen: "#2e8b57",
    seashell: "#fff5ee",
    sienna: "#a0522d",
    silver: "#c0c0c0",
    skyblue: "#87ceeb",
    slateblue: "#6a5acd",
    slategray: "#708090",
    snow: "#fffafa",
    springgreen: "#00ff7f",
    steelblue: "#4682b4",
    tan: "#d2b48c",
    teal: "#008080",
    thistle: "#d8bfd8",
    tomato: "#ff6347",
    turquoise: "#40e0d0",
    violet: "#ee82ee",
    wheat: "#f5deb3",
    white: "#ffffff",
    whitesmoke: "#f5f5f5",
    yellow: "#ffff00",
    yellowgreen: "#9acd32"
};
const $dad80f0e437da50c$var$colorHexs = Object.keys($dad80f0e437da50c$var$colorNames).reduce((acc, key)=>{
    return {
        ...acc,
        [$dad80f0e437da50c$var$colorNames[key]]: key
    };
}, {});
const $dad80f0e437da50c$export$71af4efcc3018b59 = (color)=>{
    return $dad80f0e437da50c$var$colorNames[color.toLowerCase()];
};
const $dad80f0e437da50c$export$2886ca5ebdd9139c = (hex)=>{
    return $dad80f0e437da50c$var$colorHexs[hex];
};



class $888e7b8fcdc7f3c5$var$ShapeSwatch extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.element = this.querySelector(".color-swatch") || this;
        this.setValue();
    }
    setValue() {
        if (this.hasAttribute("is-image")) return;
        const selectedValue = this.dataset.color.toLowerCase().trim();
        const patterns = this.dataset.colorsPatterns.split("\n");
        const isValidColor = this.isColor(selectedValue);
        if (!isValidColor) this.element.setAttribute("not-valid", "");
        this.setPropertyValue(selectedValue);
        patterns.forEach((pattern)=>{
            const config = pattern.split("::");
            const patternLabel = config[0];
            const patternValue = config[1];
            const patternLabelDowncase = patternLabel.toLowerCase().trim();
            if (patternLabelDowncase === selectedValue) {
                this.setPropertyValue(patternValue);
                return;
            }
        });
    }
    getGradientValue(colors) {
        let gradientValue = "90deg, ";
        let notValidColor = 0;
        const patterns = this.dataset.colorsPatterns.split("\n");
        const preparedPatterns = patterns.reduce((acc, pattern)=>{
            const config = pattern.split("::");
            const patternLabel = config[0];
            const patternValue = config[1];
            const patternLabelDowncase = patternLabel.toLowerCase().trim();
            return {
                ...acc,
                [patternLabelDowncase]: patternValue
            };
        }, {});
        colors.forEach((gradientColor, index)=>{
            const percent = 100.0 / colors.length;
            let color = gradientColor.toLowerCase();
            if (preparedPatterns[color]) color = preparedPatterns[color];
            else if (!this.isColor(color)) {
                color = "white";
                notValidColor += 1;
            }
            const startPoint = `${percent * index}%`;
            const endPoint = `${percent * (index + 1)}%`;
            const pointValue = `${color} ${startPoint}, ${color} ${endPoint}`;
            gradientValue = `${gradientValue} ${pointValue}`;
            if (index !== colors.length - 1) gradientValue = `${gradientValue}, `;
        });
        return notValidColor === colors.length ? null : `linear-gradient(${gradientValue})`;
    }
    setPropertyValue(value) {
        const isImage = this.isImage(value);
        const isUrl = this.isUrl(value);
        const isGradient = this.isGradient(value);
        const isValidColor = this.isColor(value);
        const bgColorHex = this.dataset.sectionBackground;
        const bgColorName = (0, $dad80f0e437da50c$export$2886ca5ebdd9139c)(bgColorHex);
        if (isUrl) {
            this.element.removeAttribute("not-valid");
            this.element.style.setProperty("--gsc-color-swatch-value", `url(${value})`);
            this.setSimilarlyBgColorStatus(false);
        } else if (isImage) // this.element.style.setProperty('--gsc-color-swatch-value', ``)
        this.setSimilarlyBgColorStatus(false);
        else if (isGradient) {
            const gradientColors = value.split("/");
            const gradientValue = this.getGradientValue(gradientColors);
            const isSimilarlyBgColor = value.includes(bgColorHex) || value.includes(bgColorName);
            if (gradientValue) {
                this.element.removeAttribute("not-valid");
                this.element.style.setProperty("--gsc-color-swatch-value", gradientValue);
            }
            this.setSimilarlyBgColorStatus(isSimilarlyBgColor);
        } else {
            const isSimilarlyBgColor = value === bgColorHex || value === bgColorName;
            if (isValidColor) this.element.removeAttribute("not-valid");
            this.setSimilarlyBgColorStatus(isSimilarlyBgColor);
            this.element.style.setProperty("--gsc-color-swatch-value", value);
        }
    }
    setSimilarlyBgColorStatus(isSimilarlyBgColor) {
        this.element.toggleAttribute("section-background-color-equally", isSimilarlyBgColor);
    }
    isColor(color) {
        const style = new Option().style;
        style.color = color;
        return style.color !== "";
    }
    isImage(value) {
        return value.includes(".png") || value.includes(".jp");
    }
    isUrl(value) {
        try {
            new URL(value);
            return true;
        } catch (err) {
            return false;
        }
    }
    isGradient(value) {
        return value.includes("/");
    }
}
var $888e7b8fcdc7f3c5$export$2e2bcd8739ae039 = $888e7b8fcdc7f3c5$var$ShapeSwatch;



class $a56acb4f3ca968ab$var$HorizontalProductCard extends (0, $40c8fbe341f607ee$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleMouseEnter = ()=>{
            const url = this.dataset.url;
            const id = this.dataset.id;
            if (!this.quickView) return;
            if (url && id) this.quickView.requestProductFromUrl(url, id);
        };
        this.handleQuickViewTriggerClick = ()=>{
            const url = this.dataset.url;
            if (!this.quickView) return;
            if (url) this.quickView.openAndRenderProductByUrl(url);
        };
        this.quickViewTrigger = this.querySelector("[data-product-card-quick-view-button]");
        this.quickView = document.getElementById("Quick-view");
    }
    connectedCallback() {
        this.addEventListener("mouseenter", this.handleMouseEnter);
        if (this.quickViewTrigger) this.quickViewTrigger.addEventListener("click", this.handleQuickViewTriggerClick);
    }
    disconnectedCallback() {
        this.removeEventListener("mouseenter", this.handleMouseEnter);
        if (this.quickViewTrigger) this.quickViewTrigger.removeEventListener("click", this.handleQuickViewTriggerClick);
    }
}
var $a56acb4f3ca968ab$export$2e2bcd8739ae039 = $a56acb4f3ca968ab$var$HorizontalProductCard;



class $e628b66f290b10fb$var$VerticalProductCard extends (0, $40c8fbe341f607ee$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleMouseEnter = ()=>{
            const url = this.dataset.url;
            const id = this.dataset.id;
            if (!this.quickView) return;
            if (url && id) this.quickView.requestProductFromUrl(url, id);
        };
        this.handleQuickViewTriggerClick = ()=>{
            const url = this.dataset.url;
            if (!this.quickView) return;
            if (url) this.quickView.openAndRenderProductByUrl(url);
        };
        this.quickViewTrigger = this.querySelector("[data-product-card-quick-view-button]");
        this.quickView = document.getElementById("Quick-view");
    }
    connectedCallback() {
        this.addEventListener("mouseenter", this.handleMouseEnter);
        if (this.quickViewTrigger) this.quickViewTrigger.addEventListener("click", this.handleQuickViewTriggerClick);
    }
    disconnectedCallback() {
        this.removeEventListener("mouseenter", this.handleMouseEnter);
        if (this.quickViewTrigger) this.quickViewTrigger.removeEventListener("click", this.handleQuickViewTriggerClick);
    }
}
var $e628b66f290b10fb$export$2e2bcd8739ae039 = $e628b66f290b10fb$var$VerticalProductCard;





class $cc81f5a00925e941$var$ProductRelatedBlock extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    connectedCallback() {
        this.loadProducts();
    }
    loadProducts() {
        this.setAttribute("is-loading", "");
        return fetch(this.dataset.url).then((response)=>response.text()).then((text)=>{
            const html = (0, $aa19cdf2f552e6e0$export$8a49393be2d55148)(text);
            this.updateByHTML(html);
            this.removeAttribute("is-loading");
        }).catch(()=>{
            if (!(0, $339187790c656b4d$export$e1122b4c4bd5b838).notification) return;
            (0, $339187790c656b4d$export$e1122b4c4bd5b838).notification.show("Error in product recommendations component", "warning");
        });
    }
    updateByHTML(html) {
        const recommendations = html.getElementById(this.id);
        if (recommendations) {
            const clonedRecommendations = recommendations.cloneNode(true);
            this.replaceChildren(...clonedRecommendations.childNodes);
            this.toggleAttribute("is-ready", this.hasChildNodes());
        }
    }
}
var $cc81f5a00925e941$export$2e2bcd8739ae039 = $cc81f5a00925e941$var$ProductRelatedBlock;



const $43d7dd945c60db1a$var$postLink = function(path, options) {
    options = options || {};
    const method = options["method"] || "post";
    const params = options["parameters"] || {};
    const form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);
    for(let key in params){
        let hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};
class $43d7dd945c60db1a$var$CustomerAddresses extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleDeleteButtonClick = ({ currentTarget: currentTarget })=>{
            const confirmMessage = currentTarget.getAttribute("data-confirm-message");
            const isConfirm = confirm(confirmMessage);
            if (isConfirm) $43d7dd945c60db1a$var$postLink(currentTarget.dataset.target, {
                parameters: {
                    _method: "delete"
                }
            });
        };
        this.deleteButtons = [
            ...this.querySelectorAll("[data-addresses-delete-button]")
        ];
    }
    connectedCallback() {
        this.deleteButtons.forEach((element)=>{
            element.addEventListener("click", this.handleDeleteButtonClick);
        });
    }
    disconnectedCallback() {
        this.deleteButtons.forEach((element)=>{
            element.removeEventListener("click", this.handleDeleteButtonClick);
        });
    }
}
var $43d7dd945c60db1a$export$2e2bcd8739ae039 = $43d7dd945c60db1a$var$CustomerAddresses;




class $c38fa6c1258ee087$var$TabWithDynamicHeight extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleContentResize = ()=>{
            this.updateMaxHeight(this.isVisible);
        };
        this.content = this.querySelector("[data-tabs-element-content]");
        this.resizeObserver = new ResizeObserver(this.handleContentResize);
        if (this.content) this.resizeObserver.observe(this.content);
    }
    connectedCallback() {
        this.updateMaxHeight(this.isVisible);
    }
    disconnectedCallback() {
        this.resizeObserver.disconnect();
    }
    attributeChangedCallback(name, oldValue, newValue) {
        this.updateMaxHeight(this.isVisible);
    }
    show() {
        this.setVisible(true);
        return (0, $6de5ff37caa957d8$export$1391212d75b2ee65)(0);
    }
    hide() {
        this.setVisible(false);
        return (0, $6de5ff37caa957d8$export$1391212d75b2ee65)(0);
    }
    setVisible(isVisible) {
        this.setAttribute("aria-hidden", isVisible ? "false" : "true");
    }
    updateMaxHeight(isVisible) {
        if (!this.content) return;
        const height = isVisible ? this.content.offsetHeight : 0;
        this.style.maxHeight = `${height}px`;
    }
    get isVisible() {
        return this.getAttribute("aria-hidden") === "false";
    }
    static get observedAttributes() {
        return [
            "aria-hidden"
        ];
    }
}
var $c38fa6c1258ee087$export$2e2bcd8739ae039 = $c38fa6c1258ee087$var$TabWithDynamicHeight;



class $54c3517ce53a9699$var$VideoBanner extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleClick = (event)=>{
            if (event.target.tagName === "VIDEO") {
                const video = event.target;
                if (!this.options.isControlsEnabled) this.videoToggle(video);
            }
        };
        this.handlePosterClick = ()=>{
            this.loadContent();
        };
        this.poster = this.querySelector("[data-video-banner-poster]");
        this.options = {
            isAutoplayEnabled: this.hasAttribute("data-enable-autoplay"),
            isControlsEnabled: this.hasAttribute("data-enable-controls")
        };
    }
    connectedCallback() {
        if (this.options.isAutoplayEnabled) this.loadContent();
        if (this.poster) this.poster.addEventListener("click", this.handlePosterClick);
        this.addEventListener("click", this.handleClick);
    }
    disconnectedCallback() {
        if (this.poster) this.poster.removeEventListener("click", this.handlePosterClick);
        this.removeEventListener("click", this.handleClick);
    }
    videoToggle(video) {
        const isPaused = video.paused;
        if (isPaused) video.play();
        else video.pause();
    }
    loadContent() {
        if (!this.getAttribute("loaded")) {
            this.addVideo();
            this.setAttribute("loaded", "true");
        }
    }
    removeVideo() {
        const video = this.querySelector("video,  iframe");
        if (video) {
            video.remove();
            this.removeAttribute("loaded");
        }
    }
    addVideo() {
        const content = document.createElement("div");
        const template = this.querySelector("[data-video-banner-media-template]");
        const templateContent = template?.content;
        const container = this.querySelector("[data-video-banner-container]");
        if (!templateContent || !templateContent.firstElementChild) return;
        const firstChild = templateContent.firstElementChild.cloneNode(true);
        content.appendChild(firstChild);
        const video = content.querySelector("video, iframe");
        if (!video) return;
        if (this.poster) this.poster.remove();
        container.appendChild(video);
        if (video.tagName === "VIDEO") video.play();
    }
}
var $54c3517ce53a9699$export$2e2bcd8739ae039 = $54c3517ce53a9699$var$VideoBanner;





class $1297e6521f2e1bff$var$CartDrawerRelatedProducts extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    connectedCallback() {
        this.loadProducts();
    }
    erase() {
        this.replaceChildren();
        this.setReady(false);
    }
    loadProducts() {
        if (this.lastRequestedUrl === this.dataset.url) return;
        this.lastRequestedUrl = this.dataset.url;
        if (!this.dataset.url) return;
        this.showPreloader();
        return fetch(this.dataset.url).then((response)=>response.text()).then((text)=>{
            this.hidePreloader();
            const html = (0, $aa19cdf2f552e6e0$export$8a49393be2d55148)(text);
            const template = html.querySelector('[data-sidebar-template="CartDrawer"]');
            const node = (0, $aa19cdf2f552e6e0$export$8ea4fc17cec6f158)(template);
            this.updateByHTML(node);
        }).catch(()=>{
            if (!(0, $339187790c656b4d$export$e1122b4c4bd5b838).notification) return;
            (0, $339187790c656b4d$export$e1122b4c4bd5b838).notification.show("Error in cart drawer related products", "warning");
        });
    }
    setReady(isReady) {
        this.toggleAttribute("is-ready", isReady);
    }
    showPreloader() {
        const loadingOverlay = this.querySelector(".loading-overlay");
        (0, $aa19cdf2f552e6e0$export$998191bfdf710c72)(loadingOverlay);
    }
    hidePreloader() {
        const loadingOverlay = this.querySelector(".loading-overlay");
        (0, $aa19cdf2f552e6e0$export$7669482c90f5c50f)(loadingOverlay);
    }
    constructor(...args){
        super(...args);
        this.updateByHTML = (node)=>{
            const recommendations = node.querySelector(`#${this.id}`);
            if (!recommendations) return;
            const clonedRecommendations = recommendations?.cloneNode(true);
            this.replaceChildren(...clonedRecommendations?.childNodes);
            const relatedProductsBlock = this.closest("cart-drawer-related-products-block");
            // const products = this.querySelectorAll('vertical-product-card')
            const products = this.querySelectorAll("[in-cart-related-product]");
            this.setReady(products.length > 0);
            relatedProductsBlock.checkHasAsideProducts();
        };
    }
}
var $1297e6521f2e1bff$export$2e2bcd8739ae039 = $1297e6521f2e1bff$var$CartDrawerRelatedProducts;



class $ff4cdf815295c02e$var$CartDrawerItemsBlock extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleCartDrawerFinishUpdate = ({ node: node })=>{
            this.updateByNode(node);
        };
        this.cartDrawer = this.closest("cart-drawer");
    }
    connectedCallback() {
        if (this.cartDrawer) this.cartDrawer.subscribe("update-nodes", this.handleCartDrawerFinishUpdate);
    }
    disconnectedCallback() {
        if (this.cartDrawer) this.cartDrawer.unsubscribe("update-nodes", this.handleCartDrawerFinishUpdate);
    }
    updateByNode(node) {
        const blockId = this.getAttribute("block-id");
        const newItems = node.querySelector(`cart-drawer-items-block[block-id="${blockId}"]`);
        if (!newItems) return;
        const clonedNewItems = newItems.cloneNode(true);
        this.replaceChildren(...clonedNewItems.childNodes);
    }
}
var $ff4cdf815295c02e$export$2e2bcd8739ae039 = $ff4cdf815295c02e$var$CartDrawerItemsBlock;



class $cd2aa49f18bbc679$var$CartDrawerInCartBannerBlock extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleCartDrawerFinishUpdate = ({ node: node })=>{
            this.updateByNode(node);
        };
        this.cartDrawer = this.closest("cart-drawer");
    }
    connectedCallback() {
        if (this.cartDrawer) this.cartDrawer.subscribe("update-nodes", this.handleCartDrawerFinishUpdate);
    }
    disconnectedCallback() {
        if (this.cartDrawer) this.cartDrawer.unsubscribe("update-nodes", this.handleCartDrawerFinishUpdate);
    }
    updateByNode(node) {
        const blockId = this.getAttribute("block-id");
        const newCartBanner = node.querySelector(`cart-drawer-in-cart-banner-block[block-id="${blockId}"]`);
        if (!newCartBanner) return;
        const clonedNewCartBanner = newCartBanner.cloneNode(true);
        this.replaceChildren(...clonedNewCartBanner.childNodes);
    }
}
var $cd2aa49f18bbc679$export$2e2bcd8739ae039 = $cd2aa49f18bbc679$var$CartDrawerInCartBannerBlock;




class $03b515c4ee477a83$var$CartDrawerRelatedProductsBlock extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleCartDrawerFinishUpdate = ({ node: node })=>{
            this.updateByNode(node);
        };
        this.relatedProducts = this.querySelector("[data-cart-drawer-related-products]");
        this.cartDrawer = this.closest("cart-drawer");
        this.isAutoRecommendations = this.hasAttribute("is-auto-recommendations");
    }
    connectedCallback() {
        this.checkHasAsideProducts();
        if (this.cartDrawer) this.cartDrawer.subscribe("update-nodes", this.handleCartDrawerFinishUpdate);
    }
    disconnectedCallback() {
        if (this.cartDrawer) this.cartDrawer.unsubscribe("update-nodes", this.handleCartDrawerFinishUpdate);
    }
    checkHasAsideProducts() {
        const isAsideProducts = this.hasAttribute("is-aside-related-products");
        if (isAsideProducts) {
            const products = document.querySelectorAll("[is-aside-related-products] vertical-product-card");
            const hasAsideProducts = products?.length > 0;
            const cartDrawer = document.querySelector("cart-drawer");
            if (cartDrawer) cartDrawer.toggleAttribute("has-aside-products", hasAsideProducts);
        }
    }
    updateByNode(node) {
        if (!this.relatedProducts) return;
        const blockId = this.getAttribute("block-id");
        const newRelatedProducts = node.querySelector(`cart-drawer-related-products-block[block-id="${blockId}"] [data-cart-drawer-related-products]`);
        if (!newRelatedProducts) return;
        if (this.isAutoRecommendations) {
            const newUrl = newRelatedProducts.getAttribute("data-url");
            this.relatedProducts.setAttribute("data-url", newUrl);
            if (newUrl) {
                this.relatedProducts.loadProducts();
                (0, $aa19cdf2f552e6e0$export$998191bfdf710c72)(this);
            } else {
                this.relatedProducts.erase();
                (0, $aa19cdf2f552e6e0$export$7669482c90f5c50f)(this);
                this.checkHasAsideProducts();
            }
        } else {
            const clonedNewRelatedProducts = newRelatedProducts.cloneNode(true);
            this.relatedProducts.replaceChildren(...clonedNewRelatedProducts.childNodes);
            this.checkHasAsideProducts();
        }
    }
}
var $03b515c4ee477a83$export$2e2bcd8739ae039 = $03b515c4ee477a83$var$CartDrawerRelatedProductsBlock;



class $79942e84011d359f$var$CartDrawerTimerBlock extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleCartDrawerFinishUpdate = ({ node: node })=>{
            this.updateByNode(node);
        };
        this.cartDrawer = this.closest("cart-drawer");
    }
    connectedCallback() {
        if (this.cartDrawer) this.cartDrawer.subscribe("update-nodes", this.handleCartDrawerFinishUpdate);
    }
    disconnectedCallback() {
        if (this.cartDrawer) this.cartDrawer.unsubscribe("update-nodes", this.handleCartDrawerFinishUpdate);
    }
    updateByNode(node) {
        const blockId = this.getAttribute("block-id");
        const newTimerBlock = node.querySelector(`cart-drawer-timer-block[block-id="${blockId}"]`);
        if (!newTimerBlock) return;
        const clonedNewTimerBlock = newTimerBlock.cloneNode(true);
        this.replaceChildren(...clonedNewTimerBlock.childNodes);
    }
}
var $79942e84011d359f$export$2e2bcd8739ae039 = $79942e84011d359f$var$CartDrawerTimerBlock;



class $abef8efddcc95b0a$var$CartDrawerHeader extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleCartDrawerFinishUpdate = ({ node: node })=>{
            this.updateByNode(node);
        };
        this.cartDrawer = this.closest("cart-drawer");
    }
    connectedCallback() {
        if (this.cartDrawer) this.cartDrawer.subscribe("update-nodes", this.handleCartDrawerFinishUpdate);
    }
    disconnectedCallback() {
        if (this.cartDrawer) this.cartDrawer.unsubscribe("update-nodes", this.handleCartDrawerFinishUpdate);
    }
    updateByNode(node) {
        const newItems = node.querySelector("cart-drawer-header");
        if (!newItems) return;
        const clonedNewItems = newItems.cloneNode(true);
        this.replaceChildren(...clonedNewItems.childNodes);
    }
}
var $abef8efddcc95b0a$export$2e2bcd8739ae039 = $abef8efddcc95b0a$var$CartDrawerHeader;



class $30815dc769e7bb58$var$CartDrawerFooter extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleCartDrawerFinishUpdate = ({ node: node })=>{
            this.updateByNode(node);
        };
        // this.swipeAreaSelector = 'data-swipe-area'
        // this.swipeBarSelector = 'data-swipe-area-bar'
        // this.expandableElementSelector = 'data-cart-drawer-expandable-element'
        this.cartDrawer = this.closest("cart-drawer");
    // this.swipeArea = this.querySelector(`[${this.swipeAreaSelector}]`)
    // this.swipeAreaBar = this.querySelector(`[${this.swipeBarSelector}]`)
    // this.isExpanded = true
    // this.expandableElements = [
    //   ...this.querySelectorAll(`[${this.expandableElementSelector}]`),
    // ] as HTMLElement[]
    // this.isMobile = checkMobileVersion()
    // this.resizeObserver = new ResizeObserver(this.handleResize)
    }
    connectedCallback() {
        if (this.cartDrawer) this.cartDrawer.subscribe("update-nodes", this.handleCartDrawerFinishUpdate);
    // this.init()
    // this.swipeArea.addEventListener('touchstart', this.handleTouchStart)
    // this.swipeArea.addEventListener('touchend', this.handleTouchEnd)
    // this.swipeAreaBar.addEventListener('click', this.handleBarClick)
    // this.resizeObserver.observe(this.cartDrawer)
    }
    disconnectedCallback() {
        if (this.cartDrawer) this.cartDrawer.unsubscribe("update-nodes", this.handleCartDrawerFinishUpdate);
    // this.swipeArea.removeEventListener('touchstart', this.handleTouchStart)
    // this.swipeArea.removeEventListener('touchend', this.handleTouchEnd)
    // this.swipeAreaBar.removeEventListener('click', this.handleBarClick)
    }
    updateByNode(node) {
        const newItems = node.querySelector("cart-drawer-footer");
        if (!newItems) return;
        const clonedNewItems = newItems.cloneNode(true);
        this.replaceChildren(...clonedNewItems.childNodes);
    }
}
var $30815dc769e7bb58$export$2e2bcd8739ae039 = $30815dc769e7bb58$var$CartDrawerFooter;



class $835cc83ad3e6e844$var$CartItemsBlock extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleFinishCartUpdate = ({ node: node })=>{
            this.updateByNode(node);
        };
        this.cart = this.closest("cart-page");
    }
    connectedCallback() {
        if (this.cart) this.cart.subscribe("update-nodes", this.handleFinishCartUpdate);
    }
    disconnectedCallback() {
        if (this.cart) this.cart.unsubscribe("update-nodes", this.handleFinishCartUpdate);
    }
    updateByNode(node) {
        const blockId = this.getAttribute("block-id");
        const newItems = node.querySelector(`cart-items-block[block-id="${blockId}"]`);
        if (!newItems) return;
        const clonedNewItems = newItems.cloneNode(true);
        this.replaceChildren(...clonedNewItems.childNodes);
        this.scrollIntoView({
            behavior: "smooth"
        });
    }
}
var $835cc83ad3e6e844$export$2e2bcd8739ae039 = $835cc83ad3e6e844$var$CartItemsBlock;



class $d1d79df3e61148ca$var$CartButtonsBlock extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleStartCartUpdate = ()=>{
            this.setLoading(true);
        };
        this.handleFinishCartUpdate = ({ node: node })=>{
            this.updateByNode(node);
            this.setLoading(false);
        };
        this.cart = this.closest("cart-page");
    }
    connectedCallback() {
        if (this.cart) {
            this.cart.subscribe("start-update", this.handleStartCartUpdate);
            this.cart.subscribe("update-nodes", this.handleFinishCartUpdate);
        }
    }
    disconnectedCallback() {
        if (this.cart) {
            this.cart.unsubscribe("start-update", this.handleStartCartUpdate);
            this.cart.unsubscribe("update-nodes", this.handleFinishCartUpdate);
        }
    }
    updateByNode(node) {
        const blockId = this.getAttribute("block-id");
        const newButtonsBlock = node.querySelector(`cart-buttons-block[block-id="${blockId}"]`);
        if (!newButtonsBlock) return;
        const clonedNewButtonsBlock = newButtonsBlock.cloneNode(true);
        this.replaceChildren(...clonedNewButtonsBlock.childNodes);
    }
    setLoading(isLoading) {
        const button = this.querySelector("[data-cart-page-checkout-button]");
        if (!button) return;
        button.toggleAttribute("disabled", isLoading);
        button.classList.toggle("loading", isLoading);
    }
}
var $d1d79df3e61148ca$export$2e2bcd8739ae039 = $d1d79df3e61148ca$var$CartButtonsBlock;



class $d5135c49284e3adc$var$CartCountdownBlock extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleFinishCartUpdate = ({ node: node })=>{
            this.updateByNode(node);
        };
        this.cart = this.closest("cart-page");
    }
    connectedCallback() {
        if (this.cart) this.cart.subscribe("update-nodes", this.handleFinishCartUpdate);
    }
    disconnectedCallback() {
        if (this.cart) this.cart.unsubscribe("update-nodes", this.handleFinishCartUpdate);
    }
    updateByNode(node) {
        const blockId = this.getAttribute("block-id");
        const newCountdownBlock = node.querySelector(`cart-countdown-block[block-id="${blockId}"]`);
        if (!newCountdownBlock) return;
        const clonedNewCountdownBlock = newCountdownBlock.cloneNode(true);
        this.replaceChildren(...clonedNewCountdownBlock.childNodes);
    }
}
var $d5135c49284e3adc$export$2e2bcd8739ae039 = $d5135c49284e3adc$var$CartCountdownBlock;




class $a34378d0e5ffadd9$var$CartRelatedProductsBlock extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleCartFinishUpdate = ({ node: node })=>{
            this.updateByNode(node);
        };
        this.relatedProducts = this.querySelector("[data-cart-related-products]");
        this.cart = this.closest("cart-page");
        this.isAutoRecommendations = this.hasAttribute("is-auto-recommendations");
    }
    connectedCallback() {
        if (this.cart) this.cart.subscribe("update-nodes", this.handleCartFinishUpdate);
    }
    disconnectedCallback() {
        if (this.cart) this.cart.unsubscribe("update-nodes", this.handleCartFinishUpdate);
    }
    updateByNode(node) {
        if (!this.relatedProducts) return;
        const blockId = this.getAttribute("block-id");
        const newRelatedProducts = node.querySelector(`cart-related-products-block[block-id="${blockId}"] [data-cart-related-products]`);
        if (!newRelatedProducts) return;
        if (this.isAutoRecommendations) {
            const newUrl = newRelatedProducts.getAttribute("data-url");
            this.relatedProducts.setAttribute("data-url", newUrl);
            if (newUrl) {
                this.relatedProducts.loadProducts();
                (0, $aa19cdf2f552e6e0$export$998191bfdf710c72)(this);
            } else {
                this.relatedProducts.erase();
                (0, $aa19cdf2f552e6e0$export$7669482c90f5c50f)(this);
            }
        } else {
            const clonedNewRelatedProducts = newRelatedProducts.cloneNode(true);
            this.relatedProducts.replaceChildren(...clonedNewRelatedProducts.childNodes);
        }
    }
}
var $a34378d0e5ffadd9$export$2e2bcd8739ae039 = $a34378d0e5ffadd9$var$CartRelatedProductsBlock;



class $cd78aa261dafac9f$var$CartOrderNotesBlock extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleFinishCartUpdate = ({ node: node })=>{
            this.updateByNode(node);
        };
        this.cart = this.closest("cart-page");
    }
    connectedCallback() {
        if (this.cart) this.cart.subscribe("update-nodes", this.handleFinishCartUpdate);
    }
    disconnectedCallback() {
        if (this.cart) this.cart.unsubscribe("update-nodes", this.handleFinishCartUpdate);
    }
    updateByNode(node) {
        const blockId = this.getAttribute("block-id");
        const newOrderNotesBlock = node.querySelector(`cart-order-notes-block[block-id="${blockId}"]`);
        if (!newOrderNotesBlock) return;
        const clonedNewOrderNotesBlock = newOrderNotesBlock.cloneNode(true);
        this.replaceChildren(...clonedNewOrderNotesBlock.childNodes);
    }
}
var $cd78aa261dafac9f$export$2e2bcd8739ae039 = $cd78aa261dafac9f$var$CartOrderNotesBlock;



class $24cc6098f6bcd310$var$CartNote extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleTextareaBlur = (e)=>{
            const { value: value } = e.target;
            if (!value) return;
            localStorage.setItem(this.localStorageSelector, value);
            this.currentValue = value;
        };
        this.setValueFromLS = ()=>{
            this.valueFromLS = localStorage.getItem(this.localStorageSelector);
            if (this.valueFromLS !== this.currentValue) {
                this.textarea.value = this.valueFromLS;
                this.currentValue = this.valueFromLS;
            }
        };
        this.handleBetweenTabsUpdate = (e)=>{
            if (e.key === this.localStorageSelector) this.setValueFromLS();
        };
        this.handleCartStatusUpdate = ()=>{
            this.clearValueFromLS();
        };
        this.clearValueFromLS = ()=>{
            localStorage.removeItem(this.localStorageSelector);
            this.currentValue = undefined;
        };
        this.textareaAttribute = "data-cart-note-textarea";
        this.localStorageSelector = "cartNote";
        this.cartSelector = "cart-page";
        this.cartDrawerSelector = "cart-drawer";
        this.cart = this.closest(this.cartSelector);
        this.cartDrawer = this.closest(this.cartDrawerSelector);
        this.textarea = this.querySelector(`[${this.textareaAttribute}]`);
        this.currentValue = this.textarea?.value;
    }
    connectedCallback() {
        this.setValueFromLS();
        this.textarea?.addEventListener("blur", this.handleTextareaBlur);
        window.addEventListener("storage", this.handleBetweenTabsUpdate);
        customElements.whenDefined(this.cartSelector).then(()=>this.cart?.subscribe("cartIsEmpty", this.handleCartStatusUpdate)).catch((err)=>{
            console.log(err);
        });
        customElements.whenDefined(this.cartDrawerSelector).then(()=>this.cartDrawer?.subscribe("cartIsEmpty", this.handleCartStatusUpdate)).catch((err)=>{
            console.log(err);
        });
    }
    disconnectedCallback() {
        this.textarea?.removeEventListener("blur", this.handleTextareaBlur);
        window.removeEventListener("storage", this.handleBetweenTabsUpdate);
        this.cart?.unsubscribe("cartIsEmpty", this.handleCartStatusUpdate);
        this.cartDrawer?.unsubscribe("cartIsEmpty", this.handleCartStatusUpdate);
    }
}
var $24cc6098f6bcd310$export$2e2bcd8739ae039 = $24cc6098f6bcd310$var$CartNote;



class $84abd37f87689b92$var$CartAppBlock extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleFinishCartUpdate = ({ node: node })=>{
            this.updateByNode(node);
        };
        this.cart = this.closest("cart-page");
    }
    connectedCallback() {
        if (this.cart) this.cart.subscribe("update-nodes", this.handleFinishCartUpdate);
    }
    disconnectedCallback() {
        if (this.cart) this.cart.unsubscribe("update-nodes", this.handleFinishCartUpdate);
    }
    updateByNode(node) {
        const blockId = this.getAttribute("block-id");
        const newAppBlock = node.querySelector(`cart-app-block[block-id="${blockId}"]`);
        if (!newAppBlock) return;
        const clonedNewAppBlock = newAppBlock.cloneNode(true);
        this.replaceChildren(...clonedNewAppBlock.childNodes);
    }
}
var $84abd37f87689b92$export$2e2bcd8739ae039 = $84abd37f87689b92$var$CartAppBlock;



class $de10742ef32b76c2$var$CartInCartBannerBlock extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleFinishCartUpdate = ({ node: node })=>{
            this.updateByNode(node);
        };
        this.cart = this.closest("cart-page");
    }
    connectedCallback() {
        if (this.cart) this.cart.subscribe("update-nodes", this.handleFinishCartUpdate);
    }
    disconnectedCallback() {
        if (this.cart) this.cart.unsubscribe("update-nodes", this.handleFinishCartUpdate);
    }
    updateByNode(node) {
        const blockId = this.getAttribute("block-id");
        const newBanner = node.querySelector(`cart-in-cart-banner-block[block-id="${blockId}"]`);
        if (!newBanner) return;
        const clonedNewBanner = newBanner.cloneNode(true);
        this.replaceChildren(...clonedNewBanner.childNodes);
    }
}
var $de10742ef32b76c2$export$2e2bcd8739ae039 = $de10742ef32b76c2$var$CartInCartBannerBlock;



class $1f825532668d5d2d$var$CartSubtotalBlock extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleFinishCartUpdate = ({ node: node })=>{
            this.updateByNode(node);
        };
        this.cart = this.closest("cart-page");
    }
    connectedCallback() {
        if (this.cart) this.cart.subscribe("update-nodes", this.handleFinishCartUpdate);
    }
    disconnectedCallback() {
        if (this.cart) this.cart.unsubscribe("update-nodes", this.handleFinishCartUpdate);
    }
    updateByNode(node) {
        const blockId = this.getAttribute("block-id");
        const newSubtotal = node.querySelector(`cart-subtotal-block[block-id="${blockId}"]`);
        if (!newSubtotal) return;
        const clonedNewSubtotal = newSubtotal.cloneNode(true);
        this.replaceChildren(...clonedNewSubtotal.childNodes);
    }
}
var $1f825532668d5d2d$export$2e2bcd8739ae039 = $1f825532668d5d2d$var$CartSubtotalBlock;



class $1a9e13162d1f3522$var$CartFreeShippingBarBlock extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleFinishCartUpdate = ({ node: node })=>{
            this.updateByNode(node);
        };
        this.cart = this.closest("cart-page");
    }
    connectedCallback() {
        if (this.cart) this.cart.subscribe("update-nodes", this.handleFinishCartUpdate);
    }
    disconnectedCallback() {
        if (this.cart) this.cart.unsubscribe("update-nodes", this.handleFinishCartUpdate);
    }
    updateByNode(node) {
        const bar = this.querySelector("free-shipping-bar");
        const newBar = node.querySelector("free-shipping-bar");
        if (!bar || !newBar) return;
        const cartTotal = newBar.dataset.cartTotal || 0;
        bar.updateProgressByCartTotal(+cartTotal);
    }
}
var $1a9e13162d1f3522$export$2e2bcd8739ae039 = $1a9e13162d1f3522$var$CartFreeShippingBarBlock;



class $f975bfd7b0d53173$var$CartCount extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleFinishCartUpdate = ({ node: node })=>{
            this.updateByNode(node);
        };
        this.cart = document.querySelector("cart-page");
        this.cartDrawer = document.querySelector("cart-drawer");
    }
    connectedCallback() {
        if (this.cart) this.cart.subscribe("update-nodes", this.handleFinishCartUpdate);
        if (this.cartDrawer) this.cartDrawer.subscribe("update-nodes", this.handleFinishCartUpdate);
    }
    disconnectedCallback() {
        if (this.cart) this.cart.unsubscribe("update-nodes", this.handleFinishCartUpdate);
        if (this.cartDrawer) this.cartDrawer.unsubscribe("update-nodes", this.handleFinishCartUpdate);
    }
    updateByNode(node) {
        const newCount = node.querySelector(`#NewCartCount`);
        if (!newCount) return;
        const clonedNewCount = newCount.cloneNode(true);
        this.replaceChildren(...clonedNewCount.childNodes);
    }
}
var $f975bfd7b0d53173$export$2e2bcd8739ae039 = $f975bfd7b0d53173$var$CartCount;



class $4588122c4bdbd54f$var$CartDrawerFreeShippingBarBlock extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleCartUpdate = ({ node: node })=>{
            this.updateByNode(node);
        };
        this.cartDrawer = this.closest("cart-drawer");
    }
    connectedCallback() {
        if (this.cartDrawer) this.cartDrawer.subscribe("update-nodes", this.handleCartUpdate);
    }
    disconnectedCallback() {
        if (this.cartDrawer) this.cartDrawer.unsubscribe("update-nodes", this.handleCartUpdate);
    }
    updateByNode(node) {
        const bar = this.querySelector("free-shipping-bar");
        const newBar = node.querySelector("free-shipping-bar");
        if (!bar || !newBar) return;
        const cartTotal = newBar.dataset.cartTotal || 0;
        bar.updateProgressByCartTotal(+cartTotal);
    }
}
var $4588122c4bdbd54f$export$2e2bcd8739ae039 = $4588122c4bdbd54f$var$CartDrawerFreeShippingBarBlock;



class $239dc695a17fb6b4$var$CartDrawerButtonsBlock extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleStartCartUpdate = ()=>{
            this.setLoading(true);
        };
        this.handleFinishCartUpdate = ()=>{
            this.setLoading(false);
        };
        this.cartDrawer = this.closest("cart-drawer");
    }
    connectedCallback() {
        if (this.cartDrawer) {
            this.cartDrawer.subscribe("start-update", this.handleStartCartUpdate);
            this.cartDrawer.subscribe("update-nodes", this.handleFinishCartUpdate);
        }
    }
    disconnectedCallback() {
        if (this.cartDrawer) {
            this.cartDrawer.unsubscribe("start-update", this.handleStartCartUpdate);
            this.cartDrawer.unsubscribe("update-nodes", this.handleFinishCartUpdate);
        }
    }
    setLoading(isLoading) {
        const button = this.querySelector("[data-cart-checkout-button]");
        if (!button) return;
        button.toggleAttribute("disabled", isLoading);
        button.classList.toggle("loading", isLoading);
    }
}
var $239dc695a17fb6b4$export$2e2bcd8739ae039 = $239dc695a17fb6b4$var$CartDrawerButtonsBlock;





class $808a521a7221a6b5$var$CartRelatedProducts extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    connectedCallback() {
        this.loadProducts();
    }
    erase() {
        this.replaceChildren();
        this.setReady(false);
    }
    loadProducts() {
        if (this.lastRequestedUrl === this.dataset.url) return;
        this.lastRequestedUrl = this.dataset.url;
        if (!this.dataset.url) return;
        this.showPreloader();
        return fetch(this.dataset.url).then((response)=>response.text()).then((text)=>{
            this.hidePreloader();
            const html = (0, $aa19cdf2f552e6e0$export$8a49393be2d55148)(text);
            this.updateByHTML(html);
        }).catch(()=>{
            if (!(0, $339187790c656b4d$export$e1122b4c4bd5b838).notification) return;
            (0, $339187790c656b4d$export$e1122b4c4bd5b838).notification.show("Error in cart related products", "warning");
        });
    }
    setReady(isReady) {
        this.toggleAttribute("is-ready", isReady);
    }
    showPreloader() {
        const loadingOverlay = this.querySelector(".loading-overlay");
        (0, $aa19cdf2f552e6e0$export$998191bfdf710c72)(loadingOverlay);
    }
    hidePreloader() {
        const loadingOverlay = this.querySelector(".loading-overlay");
        (0, $aa19cdf2f552e6e0$export$7669482c90f5c50f)(loadingOverlay);
    }
    constructor(...args){
        super(...args);
        this.updateByHTML = (node)=>{
            const recommendations = node.querySelector(`#${this.id}`);
            if (recommendations) {
                const clonedRecommendations = recommendations.cloneNode(true);
                this.replaceChildren(...clonedRecommendations.childNodes);
            }
            const products = this.querySelectorAll("vertical-product-card");
            this.setReady(products.length > 0);
        };
    }
}
var $808a521a7221a6b5$export$2e2bcd8739ae039 = $808a521a7221a6b5$var$CartRelatedProducts;




class $4cb96661e6799c90$var$ShareWrapper extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.customTemplate = this.querySelector("[data-share-custom-template]");
        this.systemDefaultTemplate = this.querySelector("[data-share-system-default-template]");
    }
    connectedCallback() {
        this.init();
    }
    init() {
        const template = navigator.share ? this.systemDefaultTemplate : this.customTemplate;
        const node = (0, $aa19cdf2f552e6e0$export$d4e734980dda982f)(template);
        this.appendChild(node);
    }
}
var $4cb96661e6799c90$export$2e2bcd8739ae039 = $4cb96661e6799c90$var$ShareWrapper;



class $64c5fbccb7ea5232$var$ShareComponent extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleButtonClick = (event)=>{
            event.preventDefault();
            if (navigator.share) navigator.share({
                text: this.dataset.valueToCopy
            });
        };
        this.button = this.querySelector("[data-share-button]");
    }
    connectedCallback() {
        if (this.button) this.button.addEventListener("click", this.handleButtonClick);
    }
    disconnectedCallback() {
        if (this.button) this.button.removeEventListener("click", this.handleButtonClick);
    }
}
var $64c5fbccb7ea5232$export$2e2bcd8739ae039 = $64c5fbccb7ea5232$var$ShareComponent;



class $f2cf88e0e56b20c4$var$AccordeonContainer extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleTabToggle = ({ blockId: blockId })=>{
            this.tabs.forEach((tab)=>{
                if (tab.dataset.blockId !== blockId && tab.isExpanded) tab.hide();
            });
        };
        this.tabs = [
            ...this.querySelectorAll("accordeon-component")
        ];
    }
    connectedCallback() {
        this.tabs.forEach((tab)=>{
            customElements.whenDefined("accordeon-component").then(()=>{
                tab.subscribe("toggle", this.handleTabToggle);
            });
        });
    }
    disconnectedCallback() {
        this.tabs.forEach((tab)=>{
            customElements.whenDefined("accordeon-component").then(()=>{
                tab.unsubscribe("toggle", this.handleTabToggle);
            });
        });
    }
}
var $f2cf88e0e56b20c4$export$2e2bcd8739ae039 = $f2cf88e0e56b20c4$var$AccordeonContainer;




class $dfa45174aa0ae021$var$ScrollingText extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.calcHeight = ()=>{
            this.paddings = parseInt(this.styles.paddingTop) + parseInt(this.styles.paddingBottom);
            const lines = this.querySelectorAll(this.lineSelector);
            let heightToSet;
            const firstLineRect = lines[0].getBoundingClientRect();
            if (lines.length > 1) {
                const coordsTop = [];
                const coordsBottom = [];
                const lastLineRect = lines[lines.length - 1].getBoundingClientRect();
                coordsTop.push(firstLineRect.top);
                coordsTop.push(lastLineRect.top);
                coordsBottom.push(firstLineRect.bottom);
                coordsBottom.push(lastLineRect.bottom);
                heightToSet = coordsBottom.sort((a, b)=>b - a)[0] - coordsTop.sort((a, b)=>a - b)[0];
            } else heightToSet = firstLineRect.height;
            return heightToSet;
        };
        this.setHeight = ()=>{
            const height = this.calcHeight();
            this.style.setProperty("--gsc-section-height", `${height}px`);
        };
        this.handleResize = (0, $adb0a393977b573d$exports.debounce)(()=>{
            this.setHeight();
        }, 100);
        this.containerSelector = "[data-scrolling-text-container]";
        this.lineSelector = "scrolling-text-line";
        this.container = this.querySelector(this.containerSelector);
        this.resizeObserver = new ResizeObserver(this.handleResize);
        this.resizeObserver.observe(this.container);
        this.styles = getComputedStyle(this.container);
    }
    disconnectedCallback() {
        this.resizeObserver.disconnect();
    }
}
var $dfa45174aa0ae021$export$2e2bcd8739ae039 = $dfa45174aa0ae021$var$ScrollingText;




class $c114d569c007c240$var$ScrollingTextLine extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.getDimentions = ()=>{
            const announcement = this.querySelector(this.announcementSelector);
            if (!announcement) return;
            const screenWidth = document.body.clientWidth;
            const announcementWidth = announcement.clientWidth;
            this.initialScreenWidth = screenWidth;
            return {
                screenWidth: screenWidth,
                announcementWidth: announcementWidth
            };
        };
        this.calcQuantityToRender = (screenWidth, announcementWidth)=>{
            const blocksNumberToRender = Math.round(screenWidth * this.screenSizeMultiply / announcementWidth);
            return blocksNumberToRender % 2 === 0 ? blocksNumberToRender : blocksNumberToRender + 1;
        };
        this.renderNodes = (blocksNumberToRender)=>{
            const announcement = this.querySelector(this.announcementSelector);
            if (!announcement) return;
            const nodes = this.isWithFontMixed ? this.getFragmentWithMixedFont(blocksNumberToRender, announcement) : this.getFragment(blocksNumberToRender, announcement);
            announcement.classList.add(this.animationClass);
            this.replaceChildren(nodes);
        };
        this.getFragment = (blocksNumberToRender, announcement)=>{
            const fragment = document.createDocumentFragment();
            for(let i = 0; i < blocksNumberToRender; i++){
                const clonedAnnouncement = announcement.cloneNode(true);
                clonedAnnouncement.classList.add(this.animationClass);
                if (this.isWithFontMixed && i % 2 === 0) clonedAnnouncement.classList.add(this.fontOutlineClass);
                fragment.appendChild(clonedAnnouncement);
            }
            return fragment;
        };
        this.getFragmentWithMixedFont = (blocksNumberToRender, announcement)=>{
            const fragment = document.createDocumentFragment();
            for(let i = 0; i < blocksNumberToRender - 1; i++){
                const clonedAnnouncement1 = announcement.cloneNode(true);
                const clonedAnnouncement2 = announcement.cloneNode(true);
                const div = document.createElement("div");
                clonedAnnouncement1.classList.add(this.fontOutlineClass);
                div.appendChild(clonedAnnouncement1);
                div.appendChild(clonedAnnouncement2);
                div.classList.add(this.animationClass);
                fragment.appendChild(div);
            }
            return fragment;
        };
        this.handleResize = (0, $adb0a393977b573d$exports.debounce)(()=>{
            const screenWidth = document.body.clientWidth;
            if (screenWidth > this.initialScreenWidth) this.render();
            this.setAttribute("data-is-rendered", "true");
        }, 100);
        this.render = ()=>{
            const { screenWidth: screenWidth, announcementWidth: announcementWidth } = this.getDimentions();
            const blocksNumberToRender = this.calcQuantityToRender(screenWidth, announcementWidth);
            this.renderNodes(blocksNumberToRender);
        };
        this.initialScreenWidth = 0;
        this.screenSizeMultiply = 2;
        this.announcementSelector = "[data-scrolling-text-line]";
        this.animationClass = "scrolling-text--animated";
        this.fontMixedAttribute = "with-font-mixed";
        this.fontOutlineClass = "scrolling-text__text--font-outline";
        this.isWithFontMixed = this.hasAttribute(this.fontMixedAttribute);
        this.resizeObserver = new ResizeObserver(this.handleResize);
        this.resizeObserver.observe(document.body);
    }
    disconnectedCallback() {
        this.resizeObserver.disconnect();
    }
}
var $c114d569c007c240$export$2e2bcd8739ae039 = $c114d569c007c240$var$ScrollingTextLine;



class $aa487af407119233$var$CollapsedTags extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleContentResize = ()=>{
            this.update();
        };
        this.visibleTags = this.querySelector("[data-visible-tags]");
        this.hiddenTags = this.querySelector("[data-collapsed-tags]");
        this.tags = [
            ...this.querySelectorAll("[data-tag]")
        ];
        this.extendButton = this.querySelector("[data-extend-button]");
        this.resizeObserver = new ResizeObserver(this.handleContentResize);
        this.resizeObserver.observe(this);
    }
    connectedCallback() {
        this.initOffsets();
        this.update();
    }
    disconnectedCallback() {
        this.resizeObserver.disconnect();
    }
    updateButtonVisible() {
        if (!this.extendButton) return;
        const hiddenTags = this.querySelectorAll("[tag-hidden]");
        const hasHiddenTags = hiddenTags.length > 0;
        this.extendButton.classList.toggle("hidden", !hasHiddenTags);
        this.toggleAttribute("data-is-collapsed", !hasHiddenTags);
    }
    initOffsets() {
        this.tags.forEach((tag)=>{
            tag.style.left = `${tag.offsetLeft}px`;
            tag.style.top = `${tag.offsetTop}px`;
        });
    }
    updateTagsVisible() {
        const collapsedTagsFragment = document.createDocumentFragment();
        const extendButtonWidth = this.extendButton?.offsetWidth || 0;
        const visibleTags = this.tags.filter((tag)=>!tag.hasAttribute("tag-hidden"));
        const lastVisibleTag = visibleTags[visibleTags.length - 1];
        this.tags.forEach((tag)=>{
            const tagRightPosition = tag.offsetLeft + tag.offsetWidth;
            const maxWidth = this.offsetWidth - extendButtonWidth - lastVisibleTag.offsetWidth;
            const isOverflowed = tagRightPosition > maxWidth;
            if (isOverflowed) {
                const clone = tag.cloneNode(true);
                this.setTagVisible(clone, true);
                collapsedTagsFragment.appendChild(clone);
            }
            this.setTagVisible(tag, !isOverflowed);
        });
        this.hiddenTags?.element.replaceChildren(collapsedTagsFragment);
    }
    setTagVisible(tag, isVisible) {
        tag.toggleAttribute("tag-hidden", !isVisible);
    }
    update() {
        this.updateTagsVisible();
        this.updateButtonVisible();
    }
}
var $aa487af407119233$export$2e2bcd8739ae039 = $aa487af407119233$var$CollapsedTags;



class $d78102815606377f$var$ArticleTags extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleContentResize = ()=>{
            this.update();
        };
        this.visibleTags = this.querySelector("[data-visible-tags]");
        this.hiddenTags = this.querySelector("[data-collapsed-tags]");
        this.tags = [
            ...this.querySelectorAll("[data-tag]")
        ];
        this.extendButton = this.querySelector(`[data-extend-button]`);
        this.resizeObserver = new ResizeObserver(this.handleContentResize);
        this.resizeObserver.observe(this);
    }
    connectedCallback() {
        document.fonts.ready.then(()=>{
            this.update();
        });
    }
    disconnectedCallback() {
        this.resizeObserver.disconnect();
    }
    updateTagsOffsets() {
        this.tags.forEach((tag)=>{
            tag.style.left = `${tag.offsetLeft}px`;
            tag.style.top = `${tag.offsetTop}px`;
        });
    }
    updateExtendButton() {
        if (!this.extendButton) return;
        const hiddenTags = this.querySelectorAll("[tag-hidden]");
        const hasHiddenTags = hiddenTags.length > 0;
        this.extendButton.classList.toggle("hidden", !hasHiddenTags);
    }
    updateCollapsedTags() {
        const collapsedTagsFragment = document.createDocumentFragment();
        this.tags.forEach((tag, index)=>{
            const nextTab = this.tags[index + 1];
            if (!nextTab) return;
            const nextTabBottomSide = nextTab.offsetTop + nextTab.offsetWidth;
            const maxHeight = this.offsetHeight - tag.offsetHeight;
            const isHidden = nextTabBottomSide > maxHeight;
            if (isHidden) {
                const clone = tag.cloneNode(true);
                this.setTagVisible(clone, true);
                collapsedTagsFragment.appendChild(clone);
            }
            this.setTagVisible(tag, !isHidden);
        });
        this.hiddenTags?.element.replaceChildren(collapsedTagsFragment);
    }
    setTagVisible(tag, isVisible) {
        tag.toggleAttribute("tag-hidden", !isVisible);
    }
    update() {
        this.updateTagsOffsets();
        this.updateCollapsedTags();
        this.updateExtendButton();
    }
}
var $d78102815606377f$export$2e2bcd8739ae039 = $d78102815606377f$var$ArticleTags;




const $e6c2f4a84ed4ff08$export$3ef052ec262b821 = "AuroraTheme-Popup";
const $e6c2f4a84ed4ff08$export$a1f9d7c8b7a8d094 = {
    active: "popup--active",
    closing: "popup--closing",
    success: "popup--success"
};


class $fd81f36af47c5c32$export$b0ae89502bf0ca38 {
    constructor(blockId){
        this._blockId = blockId;
    }
    parseData(data) {
        if (!data) return null;
        try {
            const obj = JSON.parse(data ?? "{}");
            return obj;
        } catch (error) {
            return null;
        }
    }
    saveData(data) {
        try {
            localStorage.setItem(`${(0, $e6c2f4a84ed4ff08$export$3ef052ec262b821)}-${this._blockId}`, JSON.stringify(data));
        } catch (e) {}
    }
    loadData() {
        try {
            return this.parseData(localStorage.getItem(`${(0, $e6c2f4a84ed4ff08$export$3ef052ec262b821)}-${this._blockId}`));
        } catch (e) {
            return null;
        }
    }
}


var $98b47ffe6bc86618$export$9656cfe2bd6e411f;
(function(PopupType) {
    PopupType["AgeVerifier"] = "age";
    PopupType["Promo"] = "promo";
    PopupType["Signup"] = "signup";
})($98b47ffe6bc86618$export$9656cfe2bd6e411f || ($98b47ffe6bc86618$export$9656cfe2bd6e411f = {}));



const $267cced8c2e3b2eb$export$990cad246af8d401 = (wildcardPattern, flags)=>{
    const regexMatch = /^\/(.+)\/([im]+)?$/.exec(wildcardPattern);
    if (regexMatch) return new RegExp(regexMatch[1], regexMatch[2] || flags);
    const pattern = wildcardPattern.replace(/[\-\[\]\/{}()?.\\^$|]/g, "\\$&").replace(/\*/g, ".*?").replace(/\+/g, ".+?");
    return new RegExp(`^${pattern}$`, flags);
};
const $267cced8c2e3b2eb$export$9cec7e050b1c2448 = (gradient, opacity)=>{
    try {
        const colors = gradient.match(/rgba\([^()]*\)|#\w+/g);
        colors?.forEach((color)=>{
            const [r, g, b, a] = color.split("(")[1].split(")")[0].split(",").map((c)=>c.trim());
            const alpha = +a * +opacity;
            gradient = gradient.replace(color, `rgba(${r}, ${g}, ${b}, ${Math.round(alpha * 100) / 100})`);
        });
        return gradient;
    } catch (e) {
        return gradient;
    }
};


const $01abba979bba9463$var$timeDelayToMs = (delay)=>{
    switch(delay){
        case "none":
            return 0;
        case "3sec":
            return 3000;
        case "5sec":
            return 5000;
        case "30sec":
            return 30000;
        case "1min":
            return 60000;
        case "2min":
            return 120000;
    }
};
const $01abba979bba9463$var$frequencyToMs = (delay)=>{
    switch(delay){
        case "1h":
            return 3600000;
        case "12h":
            return 43200000;
        case "1d":
            return 86400000;
        case "3d":
            return 259200000;
        case "1w":
            return 604800000;
        case "2w":
            return 1209600000;
        default:
            return 0;
    }
};
class $01abba979bba9463$export$46f4519d144a1779 {
    constructor(dataset, lastShowDate, show){
        this._shouldShowOnThisPage = ()=>{
            if (this.pageCondition === "target") {
                const urls = this.pages?.split("\n").map((sourceUrl)=>{
                    try {
                        return new URL(sourceUrl);
                    } catch (e) {
                        return false;
                    }
                }).filter(Boolean).map((url)=>url.pathname) ?? [];
                for(let i = 0; i < urls.length; i++){
                    const wildcard = urls[i];
                    if ((0, $267cced8c2e3b2eb$export$990cad246af8d401)(wildcard).test(window.location.pathname)) return true;
                }
                return false;
            }
            return true;
        };
        this.run = ()=>{
            if (!this._shouldShowOnThisPage()) return;
            if (this.frequency === "once" && this.lastShowDate) return;
            if (this.frequency !== "unlimited" && this.lastShowDate && Date.now() - $01abba979bba9463$var$frequencyToMs(this.frequency) < this.lastShowDate.getTime()) return;
            this.startDate = new Date();
            this.timerRef = window.setInterval(()=>{
                this._tick();
            }, 1000);
            this._tick();
            if (this.exitIntent && !(0, $336348f90f7c8f21$export$e7a5aad9bb00dd62)()) document.addEventListener("mouseout", this._handleMouseLeave);
            if (this.pageScroll) {
                window.addEventListener("scroll", this._handleWindowScroll);
                this._handleWindowScroll();
            }
        };
        this._tick = ()=>{
            if (this.whenShow === "immediately") {
                this._show();
                return;
            }
            if (this.timeDelay) {
                if (Date.now() - $01abba979bba9463$var$timeDelayToMs(this.timeDelay) >= this.startDate.getTime()) this._show();
            }
        };
        this._handleWindowScroll = ()=>{
            const scrollTop = window.scrollY;
            const docHeight = document.body.offsetHeight;
            const winHeight = window.innerHeight;
            const scrollPercent = docHeight === winHeight ? 1 : scrollTop / (docHeight - winHeight);
            const scrollPercentRounded = Math.round(scrollPercent * 100);
            if (scrollPercentRounded >= +this.pageScroll) this._show();
        };
        this._handleMouseLeave = (e)=>{
            if (!e.toElement && !e.relatedTarget) this._show();
        };
        this._show = ()=>{
            this.showCallback();
            this.cleanup();
        };
        this.cleanup = ()=>{
            clearInterval(this.timerRef);
            if (this.pageScroll) window.removeEventListener("scroll", this._handleWindowScroll);
            if (this.exitIntent && !(0, $336348f90f7c8f21$export$e7a5aad9bb00dd62)()) document.removeEventListener("mouseout", this._handleMouseLeave);
        };
        this.showCallback = show;
        this.pageCondition = dataset.pageCondition ?? "all";
        this.whenShow = dataset.whenShow ?? "immediately";
        this.pages = dataset.pages;
        this.timeDelay = dataset.timeDelay === "none" ? null : dataset.timeDelay;
        this.pageScroll = dataset.pageScroll === "none" ? null : dataset.pageScroll;
        this.exitIntent = (dataset.exitIntent === "true") ?? false;
        this.frequency = dataset.frequency ?? "unlimited";
        this.lastShowDate = lastShowDate;
    }
}



class $4e5612c0c84a14f8$export$576e8554a9c69ee4 extends (0, $1eaff675051c24fc$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._handleBlockSelect = ({ detail: { blockId: blockId } })=>{
            if (this.dataset.blockId === blockId) this.show();
        };
        this._handleBlockDeselect = ({ detail: { blockId: blockId } })=>{
            if (this.dataset.blockId === blockId) this.hide();
        };
        this.prepareGradient = (gradient, opacity)=>{
            try {
                const colors = gradient.match(/rgba\([^()]*\)|#\w+/g);
                colors?.forEach((color)=>{
                    const [r, g, b, a] = color.split("(")[1].split(")")[0].split(",").map((c)=>c.trim());
                    const alpha = +a * +opacity;
                    gradient = gradient.replace(color, `rgba(${r}, ${g}, ${b}, ${Math.round(alpha * 100) / 100})`);
                });
                return gradient;
            } catch (e) {
                return gradient;
            }
        };
        this.onVerify = ()=>{
            if (!this.isEditorMode) this.storage.saveData({
                type: (0, $98b47ffe6bc86618$export$9656cfe2bd6e411f).AgeVerifier,
                verified: true
            });
            this._verifyBtn?.removeEventListener("click", this.onVerify);
            this.hide();
        };
        this.storage = new (0, $fd81f36af47c5c32$export$b0ae89502bf0ca38)(this.dataset.blockId ?? this.id);
    }
    connectedCallback() {
        const data = this.storage.loadData();
        if (this.isEditorMode) {
            this.editor.subscribe("BLOCK_SELECT", this._handleBlockSelect);
            this.editor.subscribe("BLOCK_DESELECT", this._handleBlockDeselect);
            return;
        }
        if (!data || data.type === (0, $98b47ffe6bc86618$export$9656cfe2bd6e411f).AgeVerifier && !data.verified) {
            this.conditionRuntime = new (0, $01abba979bba9463$export$46f4519d144a1779)(this.dataset, null, this.show);
            this.conditionRuntime.run();
        }
    }
    disconnectedCallback() {
        if (this.isEditorMode) this.editor.destroy();
        this.conditionRuntime?.cleanup();
    }
    async show() {
        const withGradient = !!this.dataset.overlayGradient;
        const background = withGradient ? this.prepareGradient(this.dataset.overlayGradient, this.dataset.overlayOpacity) : `color-mix(in srgb, ${this.dataset.overlaySolid} ${this.dataset.overlayOpacity * 100}%, transparent)`;
        (0, $339187790c656b4d$export$e1122b4c4bd5b838).showOverlay(this.id, {
            zIndex: 5,
            background: background,
            backdropFilter: `blur(${this.dataset.overlayBlur}px)`,
            transitionDuration: "0s"
        });
        await super.show();
        this.classList.add((0, $e6c2f4a84ed4ff08$export$a1f9d7c8b7a8d094).active);
        this._verifyBtn?.addEventListener("click", this.onVerify);
    }
    async hide() {
        (0, $339187790c656b4d$export$e1122b4c4bd5b838).hideOverlay(this.id);
        this.conditionRuntime?.cleanup();
        this.classList.remove((0, $e6c2f4a84ed4ff08$export$a1f9d7c8b7a8d094).active);
        this.classList.add((0, $e6c2f4a84ed4ff08$export$a1f9d7c8b7a8d094).closing);
        await super.hide();
        this.classList.remove((0, $e6c2f4a84ed4ff08$export$a1f9d7c8b7a8d094).closing);
    }
    get _verifyBtn() {
        if (!this.isOpen) return null;
        return this.querySelector("[data-verify-btn]");
    }
}



class $21c681715ceb08f5$export$b0f79784774faef3 extends (0, $1eaff675051c24fc$export$2e2bcd8739ae039) {
    connectedCallback() {
        if (this.isEditorMode) {
            this.editor.subscribe("BLOCK_SELECT", this._handleBlockSelect);
            this.editor.subscribe("BLOCK_DESELECT", this._handleBlockDeselect);
            return;
        }
        window.Shopify.loadFeatures?.([
            {
                name: "consent-tracking-api",
                version: "0.1"
            }
        ], (error)=>{
            if (error) throw error;
            const userCanBeTracked = window.Shopify.customerPrivacy?.userCanBeTracked();
            const userTrackingConsent = window.Shopify.customerPrivacy?.getTrackingConsent();
            if (!userCanBeTracked && userTrackingConsent === "no_interaction") this.show();
        });
    }
    disconnectedCallback() {
        if (this.isEditorMode) this.editor.destroy();
    }
    selectBtn(type) {
        if (!this.isOpen) return null;
        return this.querySelector(`[data-${type}-btn]`);
    }
    constructor(...args){
        super(...args);
        this._handleBlockSelect = ({ detail: { blockId: blockId } })=>{
            if (this.dataset.blockId === blockId) this.show();
        };
        this._handleBlockDeselect = ({ detail: { blockId: blockId } })=>{
            if (this.dataset.blockId === blockId) this.hide();
        };
        this.show = async ()=>{
            await super.show();
            this.selectBtn("accept")?.addEventListener("click", this.onAccept);
            this.selectBtn("decline")?.addEventListener("click", this.onDecline);
            this.selectBtn("close")?.addEventListener("click", this.onDecline);
        };
        this.hide = async ()=>{
            this.selectBtn("accept")?.removeEventListener("click", this.onAccept);
            this.selectBtn("decline")?.removeEventListener("click", this.onDecline);
            this.selectBtn("close")?.removeEventListener("click", this.onDecline);
            await super.hide();
        };
        this.onAccept = ()=>{
            if (this.isEditorMode) {
                this.hide();
                return;
            }
            window.Shopify.customerPrivacy?.setTrackingConsent(true, this.hide);
        };
        this.onDecline = ()=>{
            if (this.isEditorMode) {
                this.hide();
                return;
            }
            window.Shopify.customerPrivacy?.setTrackingConsent(false, this.hide);
        };
    }
}









class $bbf5569e170cadac$export$56d476a7c0dda510 extends (0, $1eaff675051c24fc$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._handleBlockSelect = ({ detail: { blockId: blockId } })=>{
            if (this.dataset.blockId === blockId) this.show();
        };
        this._handleBlockDeselect = ({ detail: { blockId: blockId } })=>{
            if (this.dataset.blockId === blockId) this.hide();
        };
        this.show = async ()=>{
            if (this.variant === "lightbox") {
                const withGradient = !!this.dataset.overlayGradient;
                const background = withGradient ? (0, $267cced8c2e3b2eb$export$9cec7e050b1c2448)(this.dataset.overlayGradient, this.dataset.overlayOpacity) : `color-mix(in srgb, ${this.dataset.overlaySolid} ${this.dataset.overlayOpacity * 100}%, transparent)`;
                (0, $339187790c656b4d$export$e1122b4c4bd5b838).showOverlay(this.id, {
                    zIndex: 15,
                    background: background,
                    backdropFilter: `blur(${this.dataset.overlayBlur}px)`,
                    transitionDuration: "750ms"
                });
            }
            await super.show();
            if (this.variant === "lightbox") this.classList.add((0, $e6c2f4a84ed4ff08$export$a1f9d7c8b7a8d094).active);
            this.selectBtn("close")?.addEventListener("click", this.hide);
            this.selectBtn("close-small")?.addEventListener("click", this.hide);
            this.selectBtn("promo")?.addEventListener("click", this.onTouch);
        };
        this.hide = async ()=>{
            this.onTouch();
            if (this.variant === "lightbox") (0, $339187790c656b4d$export$e1122b4c4bd5b838).hideOverlay(this.id);
            this.conditionRuntime?.cleanup();
            this.selectBtn("close")?.removeEventListener("click", this.hide);
            this.selectBtn("close-small")?.removeEventListener("click", this.hide);
            this.selectBtn("promo")?.removeEventListener("click", this.onTouch);
            if (this.variant === "lightbox") {
                this.classList.remove((0, $e6c2f4a84ed4ff08$export$a1f9d7c8b7a8d094).active);
                this.classList.add((0, $e6c2f4a84ed4ff08$export$a1f9d7c8b7a8d094).closing);
            }
            await super.hide();
            this.classList.remove((0, $e6c2f4a84ed4ff08$export$a1f9d7c8b7a8d094).closing);
        };
        this.onTouch = ()=>{
            this.storage.saveData({
                type: (0, $98b47ffe6bc86618$export$9656cfe2bd6e411f).Promo,
                lastShow: new Date()
            });
        };
        this.storage = new (0, $fd81f36af47c5c32$export$b0ae89502bf0ca38)(this.dataset.blockId ?? this.id);
        this.variant = this.dataset.variant;
    }
    connectedCallback() {
        if (this.isEditorMode) {
            this.editor.subscribe("BLOCK_SELECT", this._handleBlockSelect);
            this.editor.subscribe("BLOCK_DESELECT", this._handleBlockDeselect);
            return;
        }
        const data = this.storage.loadData();
        if (!data || data.type === (0, $98b47ffe6bc86618$export$9656cfe2bd6e411f).Promo) {
            if (data?.lastShow) try {
                data.lastShow = new Date(data.lastShow);
            } catch  {
                data.lastShow = null;
            }
            this.conditionRuntime = new (0, $01abba979bba9463$export$46f4519d144a1779)(this.dataset, data?.lastShow ?? null, this.show);
            this.conditionRuntime.run();
        }
    }
    disconnectedCallback() {
        if (this.isEditorMode) this.editor.destroy();
        this.conditionRuntime?.cleanup();
    }
    selectBtn(type) {
        if (!this.isOpen) return null;
        return this.querySelector(`[data-${type}-btn]`);
    }
}









class $59f1fa1105bdfb44$export$6b6838ec3a562952 extends (0, $1eaff675051c24fc$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._handleBlockSelect = ({ detail: { blockId: blockId } })=>{
            if (this.dataset.blockId === blockId) this.show();
        };
        this._handleBlockDeselect = ({ detail: { blockId: blockId } })=>{
            if (this.dataset.blockId === blockId) this.hide();
        };
        this.show = async ()=>{
            if (this.variant === "lightbox") {
                const withGradient = !!this.dataset.overlayGradient;
                const background = withGradient ? (0, $267cced8c2e3b2eb$export$9cec7e050b1c2448)(this.dataset.overlayGradient, this.dataset.overlayOpacity) : `color-mix(in srgb, ${this.dataset.overlaySolid} ${this.dataset.overlayOpacity * 100}%, transparent)`;
                (0, $339187790c656b4d$export$e1122b4c4bd5b838).showOverlay(this.id, {
                    zIndex: 15,
                    background: background,
                    backdropFilter: `blur(${this.dataset.overlayBlur}px)`,
                    transitionDuration: "750ms"
                });
            }
            await super.show();
            if (this.variant === "lightbox") this.classList.add((0, $e6c2f4a84ed4ff08$export$a1f9d7c8b7a8d094).active);
            this.selectBtn("close")?.addEventListener("click", this.hide);
            this.selectBtn("close-small")?.addEventListener("click", this.hide);
            this.selectBtn("submit")?.addEventListener("click", this.onTouch);
        };
        this.hide = async ()=>{
            this.storage.saveData({
                type: (0, $98b47ffe6bc86618$export$9656cfe2bd6e411f).Signup,
                lastShow: new Date()
            });
            if (this.variant === "lightbox") (0, $339187790c656b4d$export$e1122b4c4bd5b838).hideOverlay(this.id);
            this.conditionRuntime?.cleanup();
            this.selectBtn("close")?.removeEventListener("click", this.hide);
            this.selectBtn("close-small")?.removeEventListener("click", this.hide);
            this.selectBtn("submit")?.removeEventListener("click", this.onTouch);
            if (this.variant === "lightbox") {
                this.classList.remove((0, $e6c2f4a84ed4ff08$export$a1f9d7c8b7a8d094).active);
                this.classList.add((0, $e6c2f4a84ed4ff08$export$a1f9d7c8b7a8d094).closing);
            }
            await super.hide();
            this.classList.remove((0, $e6c2f4a84ed4ff08$export$a1f9d7c8b7a8d094).closing);
        };
        this.onTouch = ()=>{
            // for success page detection
            window.sessionStorage.setItem("customer-posted-block-id", this.dataset.blockId);
        };
        this.storage = new (0, $fd81f36af47c5c32$export$b0ae89502bf0ca38)(this.dataset.blockId ?? this.id);
        this.variant = this.dataset.variant;
    }
    connectedCallback() {
        if (this.isEditorMode) {
            this.editor.subscribe("BLOCK_SELECT", this._handleBlockSelect);
            this.editor.subscribe("BLOCK_DESELECT", this._handleBlockDeselect);
            return;
        }
        const data = this.storage.loadData();
        // don't show on captcha page
        if (window.location.pathname.includes("challenge")) return;
        // handle success message
        if (this.dataset.showSuccessMessage === "true" && window.location.search.includes("customer_posted") && window.sessionStorage.getItem("customer-posted-block-id") === this.dataset.blockId) {
            this.show();
            window.sessionStorage.removeItem("customer-posted-block-id");
            this.classList.add((0, $e6c2f4a84ed4ff08$export$a1f9d7c8b7a8d094).success);
            return;
        }
        if (!data || data.type === (0, $98b47ffe6bc86618$export$9656cfe2bd6e411f).Signup) {
            if (data?.lastShow) try {
                data.lastShow = new Date(data.lastShow);
            } catch  {
                data.lastShow = null;
            }
            this.conditionRuntime = new (0, $01abba979bba9463$export$46f4519d144a1779)(this.dataset, data?.lastShow ?? null, this.show);
            this.conditionRuntime.run();
        }
    }
    disconnectedCallback() {
        if (this.isEditorMode) this.editor.destroy();
        this.conditionRuntime?.cleanup();
    }
    selectBtn(type) {
        if (!this.isOpen) return null;
        return this.querySelector(`[data-${type}-btn]`);
    }
}







class $e87e857eb108e17f$var$Lookbook extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handlePinEnter = ()=>{
            this.setAnimationPausedState(true);
        };
        this.handlePinLeave = ()=>{
            if (this.highlightedBlockId) return;
            this.setAnimationPausedState(false);
        };
        this.handleResize = (0, $adb0a393977b573d$exports.debounce)(()=>{
            this.showBlockById(this.highlightedBlockId);
        }, 500);
        this.handlePinClick = (event)=>{
            const pin = event.target;
            const blockId = pin.dataset.blockId;
            this.showBlockById(blockId);
            window.addEventListener("click", this.handleOutsideClick);
        };
        this.handleOutsideClick = (event)=>{
            const pin = event.target.closest(this.pinSelector);
            if (pin) return;
            this.showBlockById();
            window.removeEventListener("click", this.handleOutsideClick);
        };
        this.pinSelector = "[data-lookbook-pin]";
        this.blockSelector = "[data-lookbook-block]";
        this.modalSelector = "[data-lookbook-modal]";
        this.carouselSelector = "[data-lookbook-carousel]";
        this.desktopContentSelector = "[data-lookbook-desktop-content]";
        this.mobileContentSelector = "[data-lookbook-mobile-content]";
        this.animationPausedAttribute = "animation-paused";
        this.notHighlightedAttribute = "not-highlighted";
        this.desktopContent = this.querySelector(this.desktopContentSelector);
        this.mobileContent = this.querySelector(this.mobileContentSelector);
        this.pins = [
            ...this.querySelectorAll(this.pinSelector)
        ];
        this.resizeObserver = new ResizeObserver(this.handleResize);
    }
    connectedCallback() {
        this.pins.forEach((pin)=>{
            pin.addEventListener("mouseenter", this.handlePinEnter);
            pin.addEventListener("mouseleave", this.handlePinLeave);
            pin.addEventListener("click", this.handlePinClick);
        });
        this.resizeObserver.observe(this);
    }
    disconnectedCallback() {
        this.pins.forEach((pin)=>{
            pin.removeEventListener("mouseenter", this.handlePinEnter);
            pin.removeEventListener("mouseleave", this.handlePinLeave);
            pin.removeEventListener("click", this.handlePinClick);
        });
        this.resizeObserver.disconnect();
        window.removeEventListener("click", this.handleOutsideClick);
    }
    showBlockById(blockId) {
        this.updateSelectedStateForPins(blockId);
        if (blockId) {
            this.setHighlightBlockById(blockId);
            this.setAnimationPausedState(true);
        } else {
            this.resetHighlight();
            this.setAnimationPausedState(false);
        }
        this.highlightedBlockId = blockId;
    }
    updateSelectedStateForPins(blockId) {
        this.pins.forEach((pin)=>{
            const isSelectedPin = pin.dataset.blockId === blockId;
            pin.toggleAttribute("is-selected", isSelectedPin);
        });
    }
    setAnimationPausedState(isAnimationPaused) {
        this.toggleAttribute(this.animationPausedAttribute, isAnimationPaused);
    }
    setHighlightBlockById(blockId) {
        this.blocks.forEach((block, index)=>{
            const isHighlighted = block.dataset.blockId === blockId;
            if (isHighlighted) this.scrollToProductByIndex(index);
            block.toggleAttribute(this.notHighlightedAttribute, !isHighlighted);
        });
    }
    scrollToProductByIndex(index) {
        const block = this.blocks[index];
        const carousel = block.closest(this.carouselSelector);
        if (carousel) carousel.scrollToIndex(index);
        else block.scrollIntoView({
            behavior: "smooth",
            block: "center"
        });
    }
    resetHighlight() {
        this.blocks.forEach((block)=>{
            block.removeAttribute(this.notHighlightedAttribute);
        });
    }
    get blocks() {
        const isMobile = (0, $336348f90f7c8f21$export$e7a5aad9bb00dd62)();
        const content = isMobile ? this.mobileContent : this.desktopContent;
        const modal = content.querySelector(this.modalSelector);
        const node = modal ? modal.element : content;
        const blocks = [
            ...node.querySelectorAll(this.blockSelector)
        ];
        return blocks;
    }
}
var $e87e857eb108e17f$export$2e2bcd8739ae039 = $e87e857eb108e17f$var$Lookbook;



class $4257fca18b01033f$var$LookbookModal extends (0, $1eaff675051c24fc$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.lookbookSelector = "lookbook-component";
        this.lookbook = this.closest(this.lookbookSelector);
    }
    async show() {
        await super.show();
        if (!this.lookbook) return;
        const highlightedBlockId = this.lookbook.highlightedBlockId;
        this.lookbook.showBlockById(highlightedBlockId);
    }
}
var $4257fca18b01033f$export$2e2bcd8739ae039 = $4257fca18b01033f$var$LookbookModal;



class $e362cbb2395cfaff$var$StoreLocator extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.generateLocationsData = ()=>{
            const locationsData = this.stores.map((store)=>({
                    coordinates: store.getAttribute(this.storeCoordinatesSelector),
                    id: store.getAttribute(this.storeIdSelector)
                }));
            return locationsData;
        };
        this.handleMarkerClick = ({ markerId: markerId })=>{
            const storeToScrollTo = this.stores.find((store)=>store.dataset.blockId === markerId);
            storeToScrollTo?.scrollIntoView({
                behavior: "smooth",
                block: "center"
            });
            storeToScrollTo?.show();
            this.toggleStoreVisibility(markerId);
        };
        this.handleStoreClick = (event)=>{
            const storeId = event.currentTarget.getAttribute(this.storeIdSelector);
            this.toggleStoreVisibility(storeId);
        };
        this.toggleStoreVisibility = (id)=>{
            this.toggleStoreExpanded(id);
            this.toggleMarkerHighlighted(id);
        };
        this.toggleStoreExpanded = (id)=>{
            this.stores.forEach((store)=>{
                if (store.dataset.blockId !== id && store.isExpanded) store.hide();
            });
        };
        this.toggleMarkerHighlighted = (id)=>{
            const isAnyStoreExpanded = this.stores.find((store)=>store.isExpanded);
            if (isAnyStoreExpanded) this.map?.highlightMarker(id);
            else this.map?.highlightMarker(null);
        };
        this.setDefaultImage = ()=>{
            const image = this.querySelector(`[${this.defaultImageSelector}]`)?.content;
            this.map?.replaceWith(image);
        };
        this.handleMapError = ()=>{
            this.setDefaultImage();
        };
        this.mapSelector = "#map";
        this.storeElementSelector = "data-store";
        this.storeIdSelector = "data-block-id";
        this.storeNameSelector = "data-name";
        this.storeCoordinatesSelector = "data-coordinates";
        this.defaultImageSelector = "map-default-image";
        this.map = this.querySelector(this.mapSelector);
        this.stores = Array.from(this.querySelectorAll(`[${this.storeElementSelector}]`));
    }
    connectedCallback() {
        if (this.map) {
            this.map.locationsData = this.generateLocationsData();
            this.map.initMap();
            this.map.subscribe("markerClick", this.handleMarkerClick);
            this.map.subscribe("mapError", this.handleMapError);
        }
        this.stores.forEach((store)=>{
            store.addEventListener("click", this.handleStoreClick);
        });
    }
    disconnectedCallback() {
        if (this.map) {
            this.map.unsubscribe("markerClick", this.handleMarkerClick);
            this.map.unsubscribe("mapError", this.handleMapError);
        }
        this.stores.forEach((store)=>{
            store.removeEventListener("click", this.handleStoreClick);
        });
    }
}
var $e362cbb2395cfaff$export$2e2bcd8739ae039 = $e362cbb2395cfaff$var$StoreLocator;



/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $52e0f4f68419e215$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
// do not edit .js files directly - edit src/index.jst
var $52e0f4f68419e215$var$fastDeepEqual = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};
/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at.
 *
 *      Http://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $52e0f4f68419e215$export$19fc78b4b5aa5d0d = "__googleMapsScriptId";
/**
 * The status of the [[Loader]].
 */ var $52e0f4f68419e215$export$406cfe323c8bb8e4;
(function(LoaderStatus) {
    LoaderStatus[LoaderStatus["INITIALIZED"] = 0] = "INITIALIZED";
    LoaderStatus[LoaderStatus["LOADING"] = 1] = "LOADING";
    LoaderStatus[LoaderStatus["SUCCESS"] = 2] = "SUCCESS";
    LoaderStatus[LoaderStatus["FAILURE"] = 3] = "FAILURE";
})($52e0f4f68419e215$export$406cfe323c8bb8e4 || ($52e0f4f68419e215$export$406cfe323c8bb8e4 = {}));
/**
 * [[Loader]] makes it easier to add Google Maps JavaScript API to your application
 * dynamically using
 * [Promises](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
 * It works by dynamically creating and appending a script node to the the
 * document head and wrapping the callback function so as to return a promise.
 *
 * ```
 * const loader = new Loader({
 *   apiKey: "",
 *   version: "weekly",
 *   libraries: ["places"]
 * });
 *
 * loader.load().then((google) => {
 *   const map = new google.maps.Map(...)
 * })
 * ```
 */ class $52e0f4f68419e215$export$3b0d6d7590275603 {
    /**
     * Creates an instance of Loader using [[LoaderOptions]]. No defaults are set
     * using this library, instead the defaults are set by the Google Maps
     * JavaScript API server.
     *
     * ```
     * const loader = Loader({apiKey, version: 'weekly', libraries: ['places']});
     * ```
     */ constructor({ apiKey: apiKey, authReferrerPolicy: authReferrerPolicy, channel: channel, client: client, id: id = $52e0f4f68419e215$export$19fc78b4b5aa5d0d, language: language, libraries: libraries = [], mapIds: mapIds, nonce: nonce, region: region, retries: retries = 3, url: url = "https://maps.googleapis.com/maps/api/js", version: version }){
        this.callbacks = [];
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.apiKey = apiKey;
        this.authReferrerPolicy = authReferrerPolicy;
        this.channel = channel;
        this.client = client;
        this.id = id || $52e0f4f68419e215$export$19fc78b4b5aa5d0d; // Do not allow empty string
        this.language = language;
        this.libraries = libraries;
        this.mapIds = mapIds;
        this.nonce = nonce;
        this.region = region;
        this.retries = retries;
        this.url = url;
        this.version = version;
        if ($52e0f4f68419e215$export$3b0d6d7590275603.instance) {
            if (!$52e0f4f68419e215$var$fastDeepEqual(this.options, $52e0f4f68419e215$export$3b0d6d7590275603.instance.options)) throw new Error(`Loader must not be called again with different options. ${JSON.stringify(this.options)} !== ${JSON.stringify($52e0f4f68419e215$export$3b0d6d7590275603.instance.options)}`);
            return $52e0f4f68419e215$export$3b0d6d7590275603.instance;
        }
        $52e0f4f68419e215$export$3b0d6d7590275603.instance = this;
    }
    get options() {
        return {
            version: this.version,
            apiKey: this.apiKey,
            channel: this.channel,
            client: this.client,
            id: this.id,
            libraries: this.libraries,
            language: this.language,
            region: this.region,
            mapIds: this.mapIds,
            nonce: this.nonce,
            url: this.url,
            authReferrerPolicy: this.authReferrerPolicy
        };
    }
    get status() {
        if (this.errors.length) return $52e0f4f68419e215$export$406cfe323c8bb8e4.FAILURE;
        if (this.done) return $52e0f4f68419e215$export$406cfe323c8bb8e4.SUCCESS;
        if (this.loading) return $52e0f4f68419e215$export$406cfe323c8bb8e4.LOADING;
        return $52e0f4f68419e215$export$406cfe323c8bb8e4.INITIALIZED;
    }
    get failed() {
        return this.done && !this.loading && this.errors.length >= this.retries + 1;
    }
    /**
     * CreateUrl returns the Google Maps JavaScript API script url given the [[LoaderOptions]].
     *
     * @ignore
     * @deprecated
     */ createUrl() {
        let url = this.url;
        url += `?callback=__googleMapsCallback`;
        if (this.apiKey) url += `&key=${this.apiKey}`;
        if (this.channel) url += `&channel=${this.channel}`;
        if (this.client) url += `&client=${this.client}`;
        if (this.libraries.length > 0) url += `&libraries=${this.libraries.join(",")}`;
        if (this.language) url += `&language=${this.language}`;
        if (this.region) url += `&region=${this.region}`;
        if (this.version) url += `&v=${this.version}`;
        if (this.mapIds) url += `&map_ids=${this.mapIds.join(",")}`;
        if (this.authReferrerPolicy) url += `&auth_referrer_policy=${this.authReferrerPolicy}`;
        return url;
    }
    deleteScript() {
        const script = document.getElementById(this.id);
        if (script) script.remove();
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     * @deprecated, use importLibrary() instead.
     */ load() {
        return this.loadPromise();
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     *
     * @ignore
     * @deprecated, use importLibrary() instead.
     */ loadPromise() {
        return new Promise((resolve, reject)=>{
            this.loadCallback((err)=>{
                if (!err) resolve(window.google);
                else reject(err.error);
            });
        });
    }
    importLibrary(name) {
        this.execute();
        return google.maps.importLibrary(name);
    }
    /**
     * Load the Google Maps JavaScript API script with a callback.
     * @deprecated, use importLibrary() instead.
     */ loadCallback(fn) {
        this.callbacks.push(fn);
        this.execute();
    }
    /**
     * Set the script on document.
     */ setScript() {
        var _a, _b;
        if (document.getElementById(this.id)) {
            // TODO wrap onerror callback for cases where the script was loaded elsewhere
            this.callback();
            return;
        }
        const params = {
            key: this.apiKey,
            channel: this.channel,
            client: this.client,
            libraries: this.libraries.length && this.libraries,
            v: this.version,
            mapIds: this.mapIds,
            language: this.language,
            region: this.region,
            authReferrerPolicy: this.authReferrerPolicy
        };
        // keep the URL minimal:
        Object.keys(params).forEach(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (key)=>!params[key] && delete params[key]);
        if (!((_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.maps) === null || _b === void 0 ? void 0 : _b.importLibrary)) // tweaked copy of https://developers.google.com/maps/documentation/javascript/load-maps-js-api#dynamic-library-import
        // which also sets the base url, the id, and the nonce
        /* eslint-disable */ ((g)=>{
            // @ts-ignore
            let h, a, k, p = "The Google Maps JavaScript API", c = "google", l = "importLibrary", q = "__ib__", m = document, b = window;
            // @ts-ignore
            b = b[c] || (b[c] = {});
            // @ts-ignore
            const d = b.maps || (b.maps = {}), r = new Set(), e = new URLSearchParams(), u = ()=>// @ts-ignore
                h || (h = new Promise((f, n)=>$52e0f4f68419e215$var$__awaiter(this, void 0, void 0, function*() {
                        var _a;
                        yield a = m.createElement("script");
                        a.id = this.id;
                        e.set("libraries", [
                            ...r
                        ] + "");
                        // @ts-ignore
                        for(k in g)e.set(k.replace(/[A-Z]/g, (t)=>"_" + t[0].toLowerCase()), g[k]);
                        e.set("callback", c + ".maps." + q);
                        a.src = this.url + `?` + e;
                        d[q] = f;
                        a.onerror = ()=>h = n(Error(p + " could not load."));
                        // @ts-ignore
                        a.nonce = this.nonce || ((_a = m.querySelector("script[nonce]")) === null || _a === void 0 ? void 0 : _a.nonce) || "";
                        m.head.append(a);
                    })));
            // @ts-ignore
            d[l] ? console.warn(p + " only loads once. Ignoring:", g) : d[l] = (f, ...n)=>r.add(f) && u().then(()=>d[l](f, ...n));
        })(params);
        // While most libraries populate the global namespace when loaded via bootstrap params,
        // this is not the case for "marker" when used with the inline bootstrap loader
        // (and maybe others in the future). So ensure there is an importLibrary for each:
        const libraryPromises = this.libraries.map((library)=>this.importLibrary(library));
        // ensure at least one library, to kick off loading...
        if (!libraryPromises.length) libraryPromises.push(this.importLibrary("core"));
        Promise.all(libraryPromises).then(()=>this.callback(), (error)=>{
            const event = new ErrorEvent("error", {
                error: error
            }); // for backwards compat
            this.loadErrorCallback(event);
        });
    }
    /**
     * Reset the loader state.
     */ reset() {
        this.deleteScript();
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.onerrorEvent = null;
    }
    resetIfRetryingFailed() {
        if (this.failed) this.reset();
    }
    loadErrorCallback(e) {
        this.errors.push(e);
        if (this.errors.length <= this.retries) {
            const delay = this.errors.length * Math.pow(2, this.errors.length);
            console.error(`Failed to load Google Maps script, retrying in ${delay} ms.`);
            setTimeout(()=>{
                this.deleteScript();
                this.setScript();
            }, delay);
        } else {
            this.onerrorEvent = e;
            this.callback();
        }
    }
    callback() {
        this.done = true;
        this.loading = false;
        this.callbacks.forEach((cb)=>{
            cb(this.onerrorEvent);
        });
        this.callbacks = [];
    }
    execute() {
        this.resetIfRetryingFailed();
        if (this.done) this.callback();
        else {
            // short circuit and warn if google.maps is already loaded
            if (window.google && window.google.maps && window.google.maps.version) {
                console.warn("Google Maps already loaded outside @googlemaps/js-api-loader.This may result in undesirable behavior as options and script parameters may not match.");
                this.callback();
                return;
            }
            if (this.loading) ;
            else {
                this.loading = true;
                this.setScript();
            }
        }
    }
}


const $2c264d4f20c47043$export$4666c3e3e4694e19 = {
    silver: [
        {
            elementType: "geometry",
            stylers: [
                {
                    color: "#f5f5f5"
                }
            ]
        },
        {
            elementType: "labels.icon",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        },
        {
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#616161"
                }
            ]
        },
        {
            elementType: "labels.text.stroke",
            stylers: [
                {
                    color: "#f5f5f5"
                }
            ]
        },
        {
            featureType: "administrative.land_parcel",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#bdbdbd"
                }
            ]
        },
        {
            featureType: "poi",
            elementType: "geometry",
            stylers: [
                {
                    color: "#eeeeee"
                }
            ]
        },
        {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#757575"
                }
            ]
        },
        {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [
                {
                    color: "#e5e5e5"
                }
            ]
        },
        {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#9e9e9e"
                }
            ]
        },
        {
            featureType: "road",
            elementType: "geometry",
            stylers: [
                {
                    color: "#ffffff"
                }
            ]
        },
        {
            featureType: "road.arterial",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#757575"
                }
            ]
        },
        {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [
                {
                    color: "#dadada"
                }
            ]
        },
        {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#616161"
                }
            ]
        },
        {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#9e9e9e"
                }
            ]
        },
        {
            featureType: "transit.line",
            elementType: "geometry",
            stylers: [
                {
                    color: "#e5e5e5"
                }
            ]
        },
        {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [
                {
                    color: "#eeeeee"
                }
            ]
        },
        {
            featureType: "water",
            elementType: "geometry",
            stylers: [
                {
                    color: "#c9c9c9"
                }
            ]
        },
        {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#9e9e9e"
                }
            ]
        }
    ],
    retro: [
        {
            elementType: "geometry",
            stylers: [
                {
                    color: "#ebe3cd"
                }
            ]
        },
        {
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#523735"
                }
            ]
        },
        {
            elementType: "labels.text.stroke",
            stylers: [
                {
                    color: "#f5f1e6"
                }
            ]
        },
        {
            featureType: "administrative",
            elementType: "geometry.stroke",
            stylers: [
                {
                    color: "#c9b2a6"
                }
            ]
        },
        {
            featureType: "administrative.land_parcel",
            elementType: "geometry.stroke",
            stylers: [
                {
                    color: "#dcd2be"
                }
            ]
        },
        {
            featureType: "administrative.land_parcel",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#ae9e90"
                }
            ]
        },
        {
            featureType: "landscape.natural",
            elementType: "geometry",
            stylers: [
                {
                    color: "#dfd2ae"
                }
            ]
        },
        {
            featureType: "poi",
            elementType: "geometry",
            stylers: [
                {
                    color: "#dfd2ae"
                }
            ]
        },
        {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#93817c"
                }
            ]
        },
        {
            featureType: "poi.park",
            elementType: "geometry.fill",
            stylers: [
                {
                    color: "#a5b076"
                }
            ]
        },
        {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#447530"
                }
            ]
        },
        {
            featureType: "road",
            elementType: "geometry",
            stylers: [
                {
                    color: "#f5f1e6"
                }
            ]
        },
        {
            featureType: "road.arterial",
            elementType: "geometry",
            stylers: [
                {
                    color: "#fdfcf8"
                }
            ]
        },
        {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [
                {
                    color: "#f8c967"
                }
            ]
        },
        {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [
                {
                    color: "#e9bc62"
                }
            ]
        },
        {
            featureType: "road.highway.controlled_access",
            elementType: "geometry",
            stylers: [
                {
                    color: "#e98d58"
                }
            ]
        },
        {
            featureType: "road.highway.controlled_access",
            elementType: "geometry.stroke",
            stylers: [
                {
                    color: "#db8555"
                }
            ]
        },
        {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#806b63"
                }
            ]
        },
        {
            featureType: "transit.line",
            elementType: "geometry",
            stylers: [
                {
                    color: "#dfd2ae"
                }
            ]
        },
        {
            featureType: "transit.line",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#8f7d77"
                }
            ]
        },
        {
            featureType: "transit.line",
            elementType: "labels.text.stroke",
            stylers: [
                {
                    color: "#ebe3cd"
                }
            ]
        },
        {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [
                {
                    color: "#dfd2ae"
                }
            ]
        },
        {
            featureType: "water",
            elementType: "geometry.fill",
            stylers: [
                {
                    color: "#b9d3c2"
                }
            ]
        },
        {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#92998d"
                }
            ]
        }
    ],
    dark: [
        {
            elementType: "geometry",
            stylers: [
                {
                    color: "#212121"
                }
            ]
        },
        {
            elementType: "labels.icon",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        },
        {
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#757575"
                }
            ]
        },
        {
            elementType: "labels.text.stroke",
            stylers: [
                {
                    color: "#212121"
                }
            ]
        },
        {
            featureType: "administrative",
            elementType: "geometry",
            stylers: [
                {
                    color: "#757575"
                }
            ]
        },
        {
            featureType: "administrative.country",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#9e9e9e"
                }
            ]
        },
        {
            featureType: "administrative.land_parcel",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        },
        {
            featureType: "administrative.locality",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#bdbdbd"
                }
            ]
        },
        {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#757575"
                }
            ]
        },
        {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [
                {
                    color: "#181818"
                }
            ]
        },
        {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#616161"
                }
            ]
        },
        {
            featureType: "poi.park",
            elementType: "labels.text.stroke",
            stylers: [
                {
                    color: "#1b1b1b"
                }
            ]
        },
        {
            featureType: "road",
            elementType: "geometry.fill",
            stylers: [
                {
                    color: "#2c2c2c"
                }
            ]
        },
        {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#8a8a8a"
                }
            ]
        },
        {
            featureType: "road.arterial",
            elementType: "geometry",
            stylers: [
                {
                    color: "#373737"
                }
            ]
        },
        {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [
                {
                    color: "#3c3c3c"
                }
            ]
        },
        {
            featureType: "road.highway.controlled_access",
            elementType: "geometry",
            stylers: [
                {
                    color: "#4e4e4e"
                }
            ]
        },
        {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#616161"
                }
            ]
        },
        {
            featureType: "transit",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#757575"
                }
            ]
        },
        {
            featureType: "water",
            elementType: "geometry",
            stylers: [
                {
                    color: "#000000"
                }
            ]
        },
        {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#3d3d3d"
                }
            ]
        }
    ],
    night: [
        {
            elementType: "geometry",
            stylers: [
                {
                    color: "#242f3e"
                }
            ]
        },
        {
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#746855"
                }
            ]
        },
        {
            elementType: "labels.text.stroke",
            stylers: [
                {
                    color: "#242f3e"
                }
            ]
        },
        {
            featureType: "administrative.locality",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#d59563"
                }
            ]
        },
        {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#d59563"
                }
            ]
        },
        {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [
                {
                    color: "#263c3f"
                }
            ]
        },
        {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#6b9a76"
                }
            ]
        },
        {
            featureType: "road",
            elementType: "geometry",
            stylers: [
                {
                    color: "#38414e"
                }
            ]
        },
        {
            featureType: "road",
            elementType: "geometry.stroke",
            stylers: [
                {
                    color: "#212a37"
                }
            ]
        },
        {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#9ca5b3"
                }
            ]
        },
        {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [
                {
                    color: "#746855"
                }
            ]
        },
        {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [
                {
                    color: "#1f2835"
                }
            ]
        },
        {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#f3d19c"
                }
            ]
        },
        {
            featureType: "transit",
            elementType: "geometry",
            stylers: [
                {
                    color: "#2f3948"
                }
            ]
        },
        {
            featureType: "transit.station",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#d59563"
                }
            ]
        },
        {
            featureType: "water",
            elementType: "geometry",
            stylers: [
                {
                    color: "#17263c"
                }
            ]
        },
        {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#515c6d"
                }
            ]
        },
        {
            featureType: "water",
            elementType: "labels.text.stroke",
            stylers: [
                {
                    color: "#17263c"
                }
            ]
        }
    ],
    aubergine: [
        {
            elementType: "geometry",
            stylers: [
                {
                    color: "#1d2c4d"
                }
            ]
        },
        {
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#8ec3b9"
                }
            ]
        },
        {
            elementType: "labels.text.stroke",
            stylers: [
                {
                    color: "#1a3646"
                }
            ]
        },
        {
            featureType: "administrative.country",
            elementType: "geometry.stroke",
            stylers: [
                {
                    color: "#4b6878"
                }
            ]
        },
        {
            featureType: "administrative.land_parcel",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#64779e"
                }
            ]
        },
        {
            featureType: "administrative.province",
            elementType: "geometry.stroke",
            stylers: [
                {
                    color: "#4b6878"
                }
            ]
        },
        {
            featureType: "landscape.man_made",
            elementType: "geometry.stroke",
            stylers: [
                {
                    color: "#334e87"
                }
            ]
        },
        {
            featureType: "landscape.natural",
            elementType: "geometry",
            stylers: [
                {
                    color: "#023e58"
                }
            ]
        },
        {
            featureType: "poi",
            elementType: "geometry",
            stylers: [
                {
                    color: "#283d6a"
                }
            ]
        },
        {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#6f9ba5"
                }
            ]
        },
        {
            featureType: "poi",
            elementType: "labels.text.stroke",
            stylers: [
                {
                    color: "#1d2c4d"
                }
            ]
        },
        {
            featureType: "poi.park",
            elementType: "geometry.fill",
            stylers: [
                {
                    color: "#023e58"
                }
            ]
        },
        {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#3C7680"
                }
            ]
        },
        {
            featureType: "road",
            elementType: "geometry",
            stylers: [
                {
                    color: "#304a7d"
                }
            ]
        },
        {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#98a5be"
                }
            ]
        },
        {
            featureType: "road",
            elementType: "labels.text.stroke",
            stylers: [
                {
                    color: "#1d2c4d"
                }
            ]
        },
        {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [
                {
                    color: "#2c6675"
                }
            ]
        },
        {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [
                {
                    color: "#255763"
                }
            ]
        },
        {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#b0d5ce"
                }
            ]
        },
        {
            featureType: "road.highway",
            elementType: "labels.text.stroke",
            stylers: [
                {
                    color: "#023e58"
                }
            ]
        },
        {
            featureType: "transit",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#98a5be"
                }
            ]
        },
        {
            featureType: "transit",
            elementType: "labels.text.stroke",
            stylers: [
                {
                    color: "#1d2c4d"
                }
            ]
        },
        {
            featureType: "transit.line",
            elementType: "geometry.fill",
            stylers: [
                {
                    color: "#283d6a"
                }
            ]
        },
        {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [
                {
                    color: "#3a4762"
                }
            ]
        },
        {
            featureType: "water",
            elementType: "geometry",
            stylers: [
                {
                    color: "#0e1626"
                }
            ]
        },
        {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#4e6d70"
                }
            ]
        }
    ]
};


class $4e15f28b3067a105$var$Map extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.initMap = async ()=>{
            try {
                await new (0, $52e0f4f68419e215$export$3b0d6d7590275603)({
                    apiKey: this.api_key,
                    version: "weekly"
                }).load();
                this.locations = this.generateMapLocations();
                this.calcMapCenter();
                this.setMap();
                this.setMarkers();
            } catch (error) {
                this.handleErrors(error);
            }
        };
        this.generateMapLocations = ()=>{
            const data = [];
            for (const store of this.locationsData){
                const { id: id, coordinates: coordinates } = store;
                const location = this.generateCoordinatesFromString(coordinates);
                if (location) data.push({
                    id: id,
                    location: location
                });
            }
            return data;
        };
        this.setMap = ()=>{
            const map = new google.maps.Map(this, {
                zoom: this.locations.length > 0 ? this.zoom : 0,
                center: this.center,
                styles: this.mapCustomStyle ?? (0, $2c264d4f20c47043$export$4666c3e3e4694e19)[this.mapStyle]
            });
            this.map = map;
        };
        this.setMarkers = ()=>{
            if (this.locations.length === 0) return;
            this.locations.map((location)=>{
                const marker = new google.maps.Marker({
                    map: this.map,
                    position: location.location,
                    id: location.id
                });
                if (this.locations.length > 1) marker.addListener("click", (event)=>{
                    this.emit("markerClick", {
                        markerId: location.id
                    });
                });
                this.markers.push(marker);
            });
        };
        this.generateCoordinatesFromString = (string)=>{
            const array = string.split(",");
            const lat = +array[0];
            const lng = +array[1];
            if (!lat || !lng) return;
            return {
                lat: lat,
                lng: lng
            };
        };
        this.toJSON = (str)=>{
            try {
                const json = JSON.parse(str);
                return json;
            } catch (e) {
                return null;
            }
        };
        this.handleErrors = (error)=>{
            console.log(error);
            this.emit("mapError", {});
        };
        this.styleAttribute = "data-map-style";
        this.customStyleAttribute = "data-map-custom-style";
        this.zoomAttribute = "data-map-zoom";
        this.defaultZoom = 10;
        this.api_key = this.dataset.key;
        this.locationsData = [];
        this.locations = [];
        this.center = {
            lat: 0,
            lng: 0
        };
        this.markers = [];
        this.mapStyle = this.getAttribute(this.styleAttribute);
        this.mapCustomStyle = this.toJSON(this.getAttribute(this.customStyleAttribute));
        this.zoom = +this.getAttribute(this.zoomAttribute) || this.defaultZoom;
    }
    async connectedCallback() {
        window.gm_authFailure = this.handleErrors;
        if (this.locationsData.length > 0) await this.initMap();
    }
    disconnectedCallback() {
        window.gm_authFailure = null;
    }
    calcMapCenter() {
        const locationsLength = this.locations.length;
        if (locationsLength > 0) {
            const center = {
                lat: 0,
                lng: 0
            };
            this.locations.forEach((location)=>{
                center.lat = center.lat + location.location.lat;
                center.lng = center.lng + location.location.lng;
            });
            center.lat = center.lat / locationsLength;
            center.lng = center.lng / locationsLength;
            this.center = center;
        }
    }
    highlightMarker(id) {
        this.markers.forEach((marker)=>{
            if (!id) {
                marker.setOpacity(1);
                return;
            }
            if (marker.id === id) marker.setOpacity(1);
            else marker.setOpacity(0.5);
        });
    }
}
var $4e15f28b3067a105$export$2e2bcd8739ae039 = $4e15f28b3067a105$var$Map;




class $0a559addefa16a79$var$ProductContent extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleVariantChange = ({ variant: variant, optionChanged: optionChanged })=>{
            if (optionChanged !== this.optionToTrack) return;
            const option = variant[this.optionPosition].toLowerCase();
            this.setImages(option);
            this.variantPicker.updateFirstMediaByVariant(variant);
            if (this.modal) this.setModal(option);
            this.currentVariant = variant;
        };
        this.setImages = (option)=>{
            const divsToPaste = this.templates.find((template)=>template.dataset.templateForOption === option)?.content.querySelectorAll(`[${this.imagesContainerAttribute}]`);
            this.containers.forEach((container, index)=>{
                const clone = divsToPaste[index].cloneNode(true);
                container.replaceWith(clone);
            });
            this.containers = this.querySelectorAll(`[${this.imagesContainerAttribute}]`);
            this.carousels = [
                ...this.querySelectorAll("carousel-component, carousel-dots")
            ];
        };
        this.setModal = (option)=>{
            const modalToPaste = this.modalTemplates.find((template)=>template.dataset.templateForModalOption === option)?.content.firstElementChild;
            const clone = modalToPaste?.cloneNode(true);
            this.modal?.replaceWith(clone);
            this.modal = this.querySelector(this.modalSelector) ?? document.querySelector(this.modalSelector);
        };
        this.reInitCarousels = ()=>{
            this.carousels.filter((carousel)=>carousel.clientWidth > 0).forEach((carousel)=>{
                carousel.reInit();
            });
        };
        this.handleResize = ()=>{
            const currentView = (0, $336348f90f7c8f21$export$e7a5aad9bb00dd62)();
            if (currentView !== this.initialView) {
                this.handleVariantChange({
                    variant: this.currentVariant,
                    optionChanged: this.optionToTrack
                });
                this.reInitCarousels();
                this.initialView = currentView;
            }
        };
        this.templateImagesAttribute = "data-template-for-option";
        this.templateModalAttribute = "data-template-for-modal-option";
        this.imagesContainerAttribute = "data-product-media-container";
        this.modalSelector = "product-modal";
        this.variantPicker = this.querySelector("variant-picker");
        this.optionToTrack = this.getAttribute("data-option-to-track");
        this.optionPosition = this.getAttribute("data-option-position");
        this.templates = [
            ...this.querySelectorAll(`[${this.templateImagesAttribute}]`)
        ];
        this.modalTemplates = [
            ...this.querySelectorAll(`[${this.templateModalAttribute}]`)
        ];
        this.containers = this.querySelectorAll(`[${this.imagesContainerAttribute}]`);
        this.modal = this.querySelector(this.modalSelector) ?? document.querySelector(this.modalSelector);
        this.carousels = [
            ...this.querySelectorAll("carousel-component, carousel-dots")
        ];
        this.initialView = (0, $336348f90f7c8f21$export$e7a5aad9bb00dd62)();
        this.resizeObserver = new ResizeObserver(this.handleResize);
        this.resizeObserver.observe(this);
    }
    connectedCallback() {
        customElements.whenDefined("variant-picker").then(()=>{
            this.handleVariantChange({
                variant: this.variantPicker.variant,
                optionChanged: this.optionToTrack
            });
            this.variantPicker.subscribe("variantChange", this.handleVariantChange);
            this.currentVariant = this.variantPicker.variant;
        }).catch((error)=>{
            console.log(error);
        });
    }
    disconnectedCallback() {
        this.variantPicker.unsubscribe("variantChange", this.handleVariantChange);
    }
}
var $0a559addefa16a79$export$2e2bcd8739ae039 = $0a559addefa16a79$var$ProductContent;





class $d7c2558e0f0700b7$var$ProductDetails extends (0, $f02dc8681ee02b75$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleTabSelect = ()=>{
            this.scrollToActiveTab();
        };
        this.handleResize = (0, $adb0a393977b573d$exports.debounce)(()=>{
            const isMobile = (0, $336348f90f7c8f21$export$e7a5aad9bb00dd62)();
            if (isMobile !== this.isMobile) this.isMobile = isMobile;
            if (isMobile) this.scrollToActiveTab();
        }, 300);
        this.scrollToActiveTab = ()=>{
            const tabs = this.tabsComponent.tabNames.filter((tab)=>tab.clientWidth > 0);
            const activeTab = tabs.findIndex((tab)=>tab.dataset.id === this.tabsComponent.dataset.selectedTabId);
            this.carousel?.scrollToIndex(activeTab);
        };
        this.tabsComponentSelector = "tabs-component";
        this.carouselSelector = "carousel-component";
        this.tabsComponent = this.querySelector(this.tabsComponentSelector);
        this.carousel = this.querySelector(this.carouselSelector);
        this.isMobile = (0, $336348f90f7c8f21$export$e7a5aad9bb00dd62)();
        this.resizeObserver = new ResizeObserver(this.handleResize);
        this.resizeObserver.observe(this.carousel);
    }
    connectedCallback() {
        customElements.whenDefined(this.tabsComponentSelector).then(()=>{
            this.tabsComponent?.subscribe("selectTab", this.handleTabSelect);
        }).catch((error)=>{
            console.log(error);
        });
    }
    disconnectedCallback() {
        this.tabsComponent?.unsubscribe("selectTab", this.handleTabSelect);
        this.resizeObserver.disconnect();
    }
}
var $d7c2558e0f0700b7$export$2e2bcd8739ae039 = $d7c2558e0f0700b7$var$ProductDetails;


const $420fda1748c94186$var$components = [
    {
        tag: "login-component",
        component: (0, $a87b8ad43c6d62c5$export$2e2bcd8739ae039)
    },
    {
        tag: "register-component",
        component: (0, $8ff44a91d1a822ea$export$2e2bcd8739ae039)
    },
    {
        tag: "back-to-top-button",
        component: (0, $81fabf043eeb4cb2$export$2e2bcd8739ae039)
    },
    {
        tag: "sticky-cart-button",
        component: (0, $30afc5db428ab66d$export$2e2bcd8739ae039)
    },
    {
        tag: "quantity-component",
        component: (0, $e6fc11d3bb369f03$export$2e2bcd8739ae039)
    },
    {
        tag: "quantity-btn",
        component: (0, $303f56e60938fd90$export$2e2bcd8739ae039)
    },
    {
        tag: "localization-selector",
        component: (0, $51c5cbd0597e116c$export$2e2bcd8739ae039)
    },
    {
        tag: "notification-component",
        component: (0, $79116199a8de4067$export$2e2bcd8739ae039)
    },
    {
        tag: "tabs-component",
        component: (0, $732e7110f4e35980$export$2e2bcd8739ae039)
    },
    {
        tag: "tab-component",
        component: (0, $1f039782252bfa34$export$2e2bcd8739ae039)
    },
    {
        tag: "list-component",
        component: (0, $c6ed359ffece050f$export$2e2bcd8739ae039)
    },
    {
        tag: "list-btn",
        component: (0, $7f4718d930c61166$export$2e2bcd8739ae039)
    },
    {
        tag: "float-element",
        component: (0, $0d174bbf17ec5209$export$2e2bcd8739ae039)
    },
    {
        tag: "hotspots-float-element",
        component: (0, $ca59d86b67377171$export$2e2bcd8739ae039)
    },
    {
        tag: "float-element-btn",
        component: (0, $b787065192d2690f$export$2e2bcd8739ae039)
    },
    {
        tag: "dropdown-opener",
        component: (0, $85330901f46d46b4$export$2e2bcd8739ae039)
    },
    {
        tag: "tooltip-trigger",
        component: (0, $c1acfb98f6a83318$export$2e2bcd8739ae039)
    },
    {
        tag: "accordeon-container",
        component: (0, $f2cf88e0e56b20c4$export$2e2bcd8739ae039)
    },
    {
        tag: "accordeon-component",
        component: (0, $05a8bfacff3e547e$export$2e2bcd8739ae039)
    },
    {
        tag: "accordeon-btn",
        component: (0, $2710c8cc8c44fd68$export$2e2bcd8739ae039)
    },
    {
        tag: "product-media-tabs",
        component: (0, $3af822ddcc0df1de$export$2e2bcd8739ae039)
    },
    {
        tag: "color-swatches",
        component: (0, $4d09379d3f950286$export$2e2bcd8739ae039)
    },
    {
        tag: "modal-component",
        component: (0, $1eaff675051c24fc$export$2e2bcd8739ae039)
    },
    {
        tag: "password-modal",
        component: (0, $41c33abd6aa351e9$export$2e2bcd8739ae039)
    },
    {
        tag: "cart-notification-popup",
        component: (0, $7f0e8e1e1a260e5d$export$2e2bcd8739ae039)
    },
    {
        tag: "modal-opener",
        component: (0, $90627309f9e09618$export$2e2bcd8739ae039)
    },
    {
        tag: "password-modal-opener",
        component: (0, $c3ad08cea9273c7d$export$2e2bcd8739ae039)
    },
    {
        tag: "modal-close-btn",
        component: (0, $1b92c34bc5eaadc5$export$2e2bcd8739ae039)
    },
    {
        tag: "sidebar-button",
        component: (0, $acdb0ba51c71b753$export$2e2bcd8739ae039)
    },
    {
        tag: "sidebar-component",
        component: (0, $a31366d6d865bd48$export$2e2bcd8739ae039)
    },
    {
        tag: "search-sidebar",
        component: (0, $b02959299c5ae1fb$export$2e2bcd8739ae039)
    },
    {
        tag: "quick-view",
        component: (0, $3cd23536a2e700ff$export$2e2bcd8739ae039)
    },
    {
        tag: "carousel-component",
        component: (0, $5553604b15244d84$export$2e2bcd8739ae039)
    },
    {
        tag: "carousel-play-button",
        component: (0, $0e9fbda6d500f52a$export$2e2bcd8739ae039)
    },
    {
        tag: "carousel-dots",
        component: (0, $28307c828f23ed7f$export$2e2bcd8739ae039)
    },
    {
        tag: "carousel-dot",
        component: (0, $d3cd6a32dd3f9b39$export$2e2bcd8739ae039)
    },
    {
        tag: "carousel-btn",
        component: (0, $86ad8436c7a8eff7$export$2e2bcd8739ae039)
    },
    {
        tag: "carousel-progress",
        component: (0, $d07817196a087230$export$2e2bcd8739ae039)
    },
    {
        tag: "header-component",
        component: (0, $02b57f4d670da284$export$2e2bcd8739ae039)
    },
    {
        tag: "drawer-menu",
        component: (0, $bedbe0d090f2b54b$export$2e2bcd8739ae039)
    },
    {
        tag: "drawer-menu-page",
        component: (0, $ff43ca58ad1a35b0$export$2e2bcd8739ae039)
    },
    {
        tag: "drawer-menu-page-link",
        component: (0, $46bdfac96ac457a6$export$2e2bcd8739ae039)
    },
    {
        tag: "pagination-component",
        component: (0, $d452cbb331ba5fd0$export$2e2bcd8739ae039)
    },
    {
        tag: "pagination-load-button",
        component: (0, $793284be4b91206d$export$2e2bcd8739ae039)
    },
    {
        tag: "pagination-link",
        component: (0, $136d61ced317755a$export$2e2bcd8739ae039)
    },
    {
        tag: "pagination-infinite-scroll",
        component: (0, $3a486be31b563d39$export$2e2bcd8739ae039)
    },
    {
        tag: "deferred-media",
        component: (0, $f6cd4dce23a584d0$export$2e2bcd8739ae039)
    },
    {
        tag: "pickup-availability",
        component: (0, $107617871cb58ad4$export$2e2bcd8739ae039)
    },
    {
        tag: "product-form",
        component: (0, $1f317d8f16a4f7fb$export$2e2bcd8739ae039)
    },
    {
        tag: "product-form-button",
        component: (0, $aed5447d179a13f9$export$2e2bcd8739ae039)
    },
    {
        tag: "product-details",
        component: (0, $d7c2558e0f0700b7$export$2e2bcd8739ae039)
    },
    {
        tag: "product-block",
        component: (0, $10a1c0df1ee7ad84$export$2e2bcd8739ae039)
    },
    {
        tag: "product-model",
        component: (0, $910c02f4e66f28fc$export$2e2bcd8739ae039)
    },
    {
        tag: "cart-item",
        component: (0, $6a7882e68e66864e$export$2e2bcd8739ae039)
    },
    {
        tag: "cart-page",
        component: (0, $9cd57d8ee4ebf51c$export$2e2bcd8739ae039)
    },
    {
        tag: "cart-drawer",
        component: (0, $287a1f0af5f6b4fe$export$2e2bcd8739ae039)
    },
    {
        tag: "free-shipping-bar",
        component: (0, $afe431fb3d0d9679$export$2e2bcd8739ae039)
    },
    {
        tag: "product-content",
        component: (0, $0a559addefa16a79$export$2e2bcd8739ae039)
    },
    {
        tag: "product-media",
        component: (0, $cd220d380db8039c$export$2e2bcd8739ae039)
    },
    {
        tag: "product-media-carousel",
        component: (0, $2a3f92ba81d32d00$export$2e2bcd8739ae039)
    },
    {
        tag: "variant-picker",
        component: (0, $772275475650e7af$export$2e2bcd8739ae039)
    },
    {
        tag: "color-swatches-picker",
        component: (0, $8779fa52f03f70cd$export$2e2bcd8739ae039)
    },
    {
        tag: "product-modal",
        component: (0, $416dc6426d2e3160$export$2e2bcd8739ae039)
    },
    {
        tag: "product-modal-image-wrap",
        component: (0, $83ddc8473eeccce4$export$2e2bcd8739ae039)
    },
    {
        tag: "product-modal-opener",
        component: (0, $5c029bc4f95f822b$export$2e2bcd8739ae039)
    },
    {
        tag: "product-recommendations",
        component: (0, $345f814d0df47536$export$2e2bcd8739ae039)
    },
    {
        tag: "product-related-block",
        component: (0, $cc81f5a00925e941$export$2e2bcd8739ae039)
    },
    {
        tag: "cart-drawer-related-products",
        component: (0, $1297e6521f2e1bff$export$2e2bcd8739ae039)
    },
    {
        tag: "recently-viewed",
        component: (0, $86cd3420253cdced$export$2e2bcd8739ae039)
    },
    {
        tag: "search-sidebar-form-wrapper",
        component: (0, $ed7630b6475693b2$export$2e2bcd8739ae039)
    },
    {
        tag: "cart-remove-button",
        component: (0, $7e9166cddce9e186$export$2e2bcd8739ae039)
    },
    {
        tag: "clipboard-button",
        component: (0, $c1a5360a95e3ad18$export$2e2bcd8739ae039)
    },
    {
        tag: "clipboard-button-tooltip",
        component: (0, $454301f39b303a98$export$2e2bcd8739ae039)
    },
    {
        tag: "product-card",
        component: (0, $9ad483dc02354acb$export$2e2bcd8739ae039)
    },
    {
        tag: "horizontal-product-card",
        component: (0, $a56acb4f3ca968ab$export$2e2bcd8739ae039)
    },
    {
        tag: "vertical-product-card",
        component: (0, $e628b66f290b10fb$export$2e2bcd8739ae039)
    },
    {
        tag: "max-lines-component",
        component: (0, $ee33f956d661ebdb$export$2e2bcd8739ae039)
    },
    {
        tag: "country-selector",
        component: (0, $ed74028c1311c05e$export$2e2bcd8739ae039)
    },
    {
        tag: "search-field",
        component: (0, $4c99f7b6b20d5804$export$2e2bcd8739ae039)
    },
    {
        tag: "password-field",
        component: (0, $c9dfc4882548cf20$export$2e2bcd8739ae039)
    },
    {
        tag: "zoom-cursor",
        component: (0, $82a6b2eb57d7ff00$export$2e2bcd8739ae039)
    },
    {
        tag: "shop-component",
        component: (0, $f86b6c4dd05ec780$export$2e2bcd8739ae039)
    },
    {
        tag: "shop-active-filters",
        component: (0, $c96c6a8307311b94$export$2e2bcd8739ae039)
    },
    {
        tag: "sidebar-filters-desktop",
        component: (0, $3bd3d3cd1c8b6535$export$2e2bcd8739ae039)
    },
    {
        tag: "sidebar-filters-mobile",
        component: (0, $d0dbb720f185ae36$export$2e2bcd8739ae039)
    },
    {
        tag: "filter-remove-btn",
        component: (0, $f111209aa1d37420$export$2e2bcd8739ae039)
    },
    {
        tag: "sort-list",
        component: (0, $f09e1e1cab3acf53$export$2e2bcd8739ae039)
    },
    {
        tag: "price-range",
        component: (0, $085c732c29c95db8$export$2e2bcd8739ae039)
    },
    {
        tag: "column-switcher",
        component: (0, $c7792eb8ec3a4fe1$export$2e2bcd8739ae039)
    },
    {
        tag: "filters-submit-btn",
        component: (0, $1c203727e41c1ba2$export$2e2bcd8739ae039)
    },
    {
        tag: "before-after-images",
        component: (0, $fd0203a38c9fb9e2$export$2e2bcd8739ae039)
    },
    {
        tag: "countdown-timer",
        component: (0, $2e33d2093da83dd1$export$2e2bcd8739ae039)
    },
    {
        tag: "product-information-drawer",
        component: (0, $377bad8f45fc260d$export$2e2bcd8739ae039)
    },
    {
        tag: "sidebar-filters-sticky-mobile-button",
        component: (0, $e26046236c7b85ae$export$2e2bcd8739ae039)
    },
    {
        tag: "recipient-form",
        component: (0, $9f019d2059cd198c$export$2e2bcd8739ae039)
    },
    {
        tag: "collection-card",
        component: (0, $9bfba46bfd4ec803$export$2e2bcd8739ae039)
    },
    {
        tag: "article-card",
        component: (0, $f0997b6c3261fdfe$export$2e2bcd8739ae039)
    },
    {
        tag: "shape-swatch",
        component: (0, $888e7b8fcdc7f3c5$export$2e2bcd8739ae039)
    },
    {
        tag: "addresses-component",
        component: (0, $43d7dd945c60db1a$export$2e2bcd8739ae039)
    },
    {
        tag: "tab-with-dynamic-height",
        component: (0, $c38fa6c1258ee087$export$2e2bcd8739ae039)
    },
    {
        tag: "video-banner",
        component: (0, $54c3517ce53a9699$export$2e2bcd8739ae039)
    },
    {
        tag: "cart-drawer-items-block",
        component: (0, $ff4cdf815295c02e$export$2e2bcd8739ae039)
    },
    {
        tag: "cart-drawer-in-cart-banner-block",
        component: (0, $cd2aa49f18bbc679$export$2e2bcd8739ae039)
    },
    {
        tag: "cart-drawer-related-products-block",
        component: (0, $03b515c4ee477a83$export$2e2bcd8739ae039)
    },
    {
        tag: "cart-drawer-timer-block",
        component: (0, $79942e84011d359f$export$2e2bcd8739ae039)
    },
    {
        tag: "cart-drawer-header",
        component: (0, $abef8efddcc95b0a$export$2e2bcd8739ae039)
    },
    {
        tag: "cart-drawer-footer",
        component: (0, $30815dc769e7bb58$export$2e2bcd8739ae039)
    },
    {
        tag: "cart-items-block",
        component: (0, $835cc83ad3e6e844$export$2e2bcd8739ae039)
    },
    {
        tag: "cart-buttons-block",
        component: (0, $d1d79df3e61148ca$export$2e2bcd8739ae039)
    },
    {
        tag: "cart-countdown-block",
        component: (0, $d5135c49284e3adc$export$2e2bcd8739ae039)
    },
    {
        tag: "cart-related-products-block",
        component: (0, $a34378d0e5ffadd9$export$2e2bcd8739ae039)
    },
    {
        tag: "cart-order-notes-block",
        component: (0, $cd78aa261dafac9f$export$2e2bcd8739ae039)
    },
    {
        tag: "cart-note",
        component: (0, $24cc6098f6bcd310$export$2e2bcd8739ae039)
    },
    {
        tag: "cart-app-block",
        component: (0, $84abd37f87689b92$export$2e2bcd8739ae039)
    },
    {
        tag: "cart-subtotal-block",
        component: (0, $1f825532668d5d2d$export$2e2bcd8739ae039)
    },
    {
        tag: "cart-in-cart-banner-block",
        component: (0, $de10742ef32b76c2$export$2e2bcd8739ae039)
    },
    {
        tag: "cart-free-shipping-bar-block",
        component: (0, $1a9e13162d1f3522$export$2e2bcd8739ae039)
    },
    {
        tag: "cart-count",
        component: (0, $f975bfd7b0d53173$export$2e2bcd8739ae039)
    },
    {
        tag: "cart-drawer-free-shipping-bar-block",
        component: (0, $4588122c4bdbd54f$export$2e2bcd8739ae039)
    },
    {
        tag: "cart-drawer-buttons-block",
        component: (0, $239dc695a17fb6b4$export$2e2bcd8739ae039)
    },
    {
        tag: "cart-related-products",
        component: (0, $808a521a7221a6b5$export$2e2bcd8739ae039)
    },
    {
        tag: "share-wrapper",
        component: (0, $4cb96661e6799c90$export$2e2bcd8739ae039)
    },
    {
        tag: "share-component",
        component: (0, $64c5fbccb7ea5232$export$2e2bcd8739ae039)
    },
    {
        tag: "scrolling-text",
        component: (0, $dfa45174aa0ae021$export$2e2bcd8739ae039)
    },
    {
        tag: "scrolling-text-line",
        component: (0, $c114d569c007c240$export$2e2bcd8739ae039)
    },
    {
        tag: "hotspots-component",
        component: (0, $94131d7037328e3c$export$2e2bcd8739ae039)
    },
    {
        tag: "collapsed-tags",
        component: (0, $aa487af407119233$export$2e2bcd8739ae039)
    },
    {
        tag: "article-tags",
        component: (0, $d78102815606377f$export$2e2bcd8739ae039)
    },
    {
        tag: "popup-age-verifier",
        component: (0, $4e5612c0c84a14f8$export$576e8554a9c69ee4)
    },
    {
        tag: "popup-cookie",
        component: (0, $21c681715ceb08f5$export$b0f79784774faef3)
    },
    {
        tag: "popup-promo",
        component: (0, $bbf5569e170cadac$export$56d476a7c0dda510)
    },
    {
        tag: "popup-signup",
        component: (0, $59f1fa1105bdfb44$export$6b6838ec3a562952)
    },
    {
        tag: "lookbook-component",
        component: (0, $e87e857eb108e17f$export$2e2bcd8739ae039)
    },
    {
        tag: "lookbook-modal",
        component: (0, $4257fca18b01033f$export$2e2bcd8739ae039)
    },
    {
        tag: "map-component",
        component: (0, $4e15f28b3067a105$export$2e2bcd8739ae039)
    },
    {
        tag: "store-locator",
        component: (0, $e362cbb2395cfaff$export$2e2bcd8739ae039)
    }
];
// @ts-expect-error
window.recentlyViewed = (0, $86cd3420253cdced$export$2e2bcd8739ae039);
const $420fda1748c94186$var$defineComponents = ()=>{
    $420fda1748c94186$var$components.forEach(({ tag: tag, component: component })=>{
        customElements.define(tag, component);
    });
};
var $420fda1748c94186$export$2e2bcd8739ae039 = $420fda1748c94186$var$defineComponents;




(0, $420fda1748c94186$export$2e2bcd8739ae039)();
window.bodyElement = (0, $339187790c656b4d$export$e1122b4c4bd5b838);
window.auroraTheme = {
    ...window.auroraTheme,
    theme_version: "2.4.0",
    id: window.Shopify.theme.id,
    storeId: window.Shopify.theme.theme_store_id,
    isLicenseTheme: !!window.Shopify.theme.theme_store_id
};
window.addEventListener("shopify:section:load", ()=>{
    (0, $899a0db0f252532f$export$80e34e3edbb862ab)({
        lazyClass: "yall-video-lazy"
    });
});
window.addEventListener("load", ()=>{
    (0, $899a0db0f252532f$export$80e34e3edbb862ab)({
        lazyClass: "yall-video-lazy"
    });
    const { observedVideos: observedVideos, observer: observer } = (0, $6de5ff37caa957d8$export$8040e5ab996cd2a)();
    document.body.addEventListener("touchstart", ()=>(0, $6de5ff37caa957d8$export$4ac303db914d5b8)({
            observedVideos: observedVideos,
            observer: observer
        }));
});

})();
//# sourceMappingURL=index.js.map
